{
  "match.modal.ownerCreatedBy": "Eigentümer:in · erstellt von",
  "match.project.shortDescription": "Kurzbeschreibung",
  "match.createProject": "Als Projekt anlegen",
  "match.project.open": "Projekt öffnen",
  "match.project.documentsFailed": "Das Projekt ist angelegt. Nicht alle Dokumente konnten übernommen werden. Du kannst fehlende Dokumente im Projekt ergänzen. {message}",
  "match.project.linkFailed": "Das Projekt ist angelegt, konnte aber nicht mit diesem Match verknüpft werden. {message}",
  "admin.access.pendingAction": "Vorgemerkte Änderung: {action}",
  "admin.groups.sharingPolicyTitle": "Standardfreigabe für Beiträge und Projekte",
  "admin.groups.sharingPolicyGlobal": "Gilt für alle Benutzer, unabhängig von der ausgewählten Personengruppe.",
  "admin.groups.sharingPolicyDetails": "Was bewirkt diese Einstellung?",
  "admin.groups.defaultRecipientGroups": "Festgelegte Personengruppen: {groups}",
  "admin.groups.requireDefaultRecipientsOff": "Aus: Benutzer wählen selbst, mit wem sie teilen, und können Inhalte privat halten.",
  "admin.groups.requireDefaultRecipientsOn": "An: Diese Gruppen erhalten automatisch Zugriff. Benutzer können weitere Empfänger hinzufügen, die festgelegten Gruppen aber nicht weglassen.",
  "share.create.privateHint": "Nur du kannst diesen Inhalt lesen.",
  "admin.groups.requireDefaultRecipients": "Sollen Beiträge und Projekte immer mit den festgelegten Personengruppen geteilt werden?",
  "admin.groups.requireDefaultRecipientsHint": "Gilt beim Erstellen oder Ändern einer Freigabe. Bestehende Freigaben bleiben beim Umschalten unverändert. Unternehmensinhalte folgen eigenen Regeln.",
  "admin.roles.impactTitle": "Rollenänderungen prüfen",
  "admin.roles.trustedAdmin": "Zugriffsadministratoren können jede unterstützte Berechtigung vergeben, auch Administration und Zugriff für ihre eigene Gruppe. Administration allein gewährt keinen Zugriff auf persönliche Daten.",
  "admin.roles.impactHint": "Diese Änderungen betreffen nach dem Speichern alle aktuellen Rolleninhaber. Andere Gruppen oder Rollen können eine entfernte Berechtigung weiterhin gewähren. Der Server prüft die aktuellen Zuordnungen beim Speichern erneut.",
  "admin.roles.impactAdded": "Hinzugefügte Berechtigungen",
  "admin.roles.impactRemoved": "Entfernte Berechtigungen",
  "admin.roles.impactNone": "Keine",
  "admin.roles.impactGroups": "Betroffene Gruppen",
  "admin.roles.impactPeople": "Betroffene Personen auf dieser Seite",
  "admin.roles.impactPeopleHint": "Namen und Bilder werden angezeigt, soweit du auf die Personendaten zugreifen darfst.",
  "admin.roles.impactNext": "Nächste Seite",
  "admin.roles.impactSave": "Rollenänderungen übernehmen",
  "admin.roles.impactCancelled": "Die Rollenänderungen wurden nicht gespeichert.",
  "admin.roles.impactIncompatible": "Diese Änderung ist nicht möglich: Die Rolle ist geschützt, ein Geltungsbereich passt nicht oder der Administratorengruppe würde „Zugriff verwalten“ fehlen. Passe vor dem Speichern die Berechtigungen oder Zuordnungen an.",
  "admin.roles.editAffectsHolders": "Speichern aktualisiert diese Rolle für alle aktuellen Rolleninhaber. Vor dem Übernehmen prüfst du die Auswirkungen.",
  "account.label": "Konto",
  "admin.access.openRoles": "Berechtigungen & Rollen öffnen",
  "admin.addAnswer": "Antwort",
  "admin.addQuestion": "Frage hinzufügen",
  "admin.addToGroupLabel": "Fragebogen hinzufügen",
  "admin.addToGroupPlaceholder": "Fragebogen wählen",
  "admin.answerPlaceholder": "Antwortoption",
  "admin.applyPosition": "Übernehmen",
  "admin.assignmentImmediateHint": "Änderungen hier wirken sofort, unabhängig vom Speichern.",
  "admin.changesSaved": "Änderungen gespeichert.",
  "admin.collapseList": "Liste einklappen",
  "admin.confirmDeleteQ": "Fragebogen löschen?",
  "admin.confirmRemoveFromGroup": "Aus der Gruppe entfernen? Er verliert seine Position, und seine Antworten zählen nicht mehr in die Auswertung dieser Gruppe.",
  "admin.defaultPowerLabel": "Standard-Power (optional)",
  "admin.deleteGroup": "Gruppe löschen",
  "admin.deleteGroupMessage": "Löscht nur die Gruppe. {count, plural, =0 {Sie enthält keine Fragebögen.} one {Ihr # Fragebogen bleibt erhalten und verliert Gruppe und Position.} other {Ihre # Fragebögen bleiben erhalten und verlieren Gruppe und Position.}} Bereits gegebene Antworten bleiben unberührt.",
  "admin.deleteGroupTitle": "„{name}“ löschen?",
  "admin.expandListNamed": "{title} anzeigen",
  "admin.groupAssignmentTitle": "Zuordnung",
  "admin.groupDescriptionDeLabel": "Beschreibung (Deutsch)",
  "admin.groupDescriptionEnLabel": "Beschreibung (Englisch)",
  "admin.groupDescriptionHint": "Steht in Grow auf der Kachel und über der Gruppe. Die Kachel schneidet den Text ab, ziele also auf etwa {max} Zeichen.",
  "admin.groupImageAlt": "Kachelbild der Gruppe",
  "admin.groupImageDrop": "Bild hierher ziehen oder klicken",
  "admin.groupImageHint": "Etwa 16:10, flächiges Motiv, kein Text und keine feinen Details. Die Kachel zeigt es klein und scharf.",
  "admin.groupImageLabel": "Kachelbild",
  "admin.groupImageLimit": "Max. {max} MB, PNG, JPEG, GIF, BMP, TIFF oder WebP",
  "admin.groupImageRemove": "Bild entfernen",
  "admin.groupImageRemoveConfirm": "Bild entfernen? Die Kachel fällt auf die generierte Grafik zurück.",
  "admin.groupImageReplace": "Ersetzen",
  "admin.groupImageTooLarge": "Zu groß (max. {max} MB): {name}",
  "admin.groupImageUnsupported": "Dateityp nicht unterstützt: {name}",
  "admin.groupItemCount": "{count, plural, one {# Frage} other {# Fragen}}",
  "admin.groupLabel": "Gruppe",
  "admin.groupLimitReached": "Sie haben die maximale Anzahl von {limit} Gruppen erreicht.",
  "admin.groupMembersTitle": "Fragebögen in dieser Gruppe",
  "admin.groupNameDeLabel": "Name (Deutsch)",
  "admin.groupNameEnLabel": "Name (Englisch)",
  "admin.groupNamePlaceholder": "z.B. Power Quiz",
  "admin.groupNoMembers": "Noch kein Fragebogen zugeordnet.",
  "admin.groupPositionHint": "Wo die Gruppe selbst in Grow · Play steht.",
  "admin.groupPositionLabel": "Position in Grow · Play",
  "admin.groupSaveFailed": "Die Gruppe konnte nicht gespeichert werden.",
  "admin.groupValidationHint": "Ein Name auf Deutsch und Englisch ist erforderlich.",
  "admin.inGroupOption": "{name} (in {group})",
  "admin.instructionsLabel": "Instruktionen (optional)",
  "admin.instructionsPlaceholder": "Hinweis für die ausfüllende Person",
  "admin.memberPositionLabel": "Position in der Gruppe",
  "admin.moveDown": "Nach unten",
  "admin.moveUp": "Nach oben",
  "admin.nameLabel": "Name",
  "admin.namePlaceholder": "z.B. Empathie-Check",
  "admin.newGroup": "+ Neue Gruppe",
  "admin.newGroupTitle": "Neue Gruppe",
  "admin.newQuestionnaire": "+ Neuer Fragebogen",
  "admin.noQuestionnaires": "Noch keine Fragebögen.",
  "admin.nonePlaceholder": "Keine",
  "admin.notVisibleInGrow": "Nicht im Grow-Play-Katalog.",
  "admin.publishAnyway": "Trotzdem veröffentlichen",
  "admin.publishEmptyMessage": "Diese Gruppe hat keinen aktiven Fragebogen. Auch nach dem Veröffentlichen hat der Katalog keine Kachel zu zeigen.",
  "admin.publishEmptyTitle": "Ohne aktiven Fragebogen veröffentlichen?",
  "admin.publishGroup": "Veröffentlichen",
  "admin.qTitle": "Fragebögen",
  "admin.questionPlaceholder": "Frage / Aussage",
  "admin.referenceData.saveFailed": "Der Eintrag konnte nicht gespeichert werden.",
  "admin.rehomeConfirm": "Umhängen",
  "admin.rehomeFromMessage": "„{name}“ wandert aus „{from}“ nach „{to}“, ans Ende der Reihenfolge. Bereits gegebene Antworten wandern mit und zählen ab sofort in die Auswertung von „{to}“.",
  "admin.rehomeMessage": "„{name}“ wird ans Ende von „{to}“ gestellt. Bereits gegebene Antworten zählen ab sofort in die Auswertung von „{to}“.",
  "admin.rehomeTitle": "„{name}“ umhängen?",
  "admin.removeAnswer": "Antwort entfernen",
  "admin.removeQuestion": "Frage entfernen",
  "admin.roles.addRole": "+ Neue Rolle",
  "admin.roles.assignPermissions": "Was darf diese Rolle?",
  "admin.roles.assignments": "Zuordnungen",
  "admin.roles.assignmentsHint": "Die Rolle gilt über diese Gruppen. Die Gesamtzahl zählt gespeicherte Mitglieder jeweils einmal. Zuordnungen lassen sich hier noch nicht ändern.",
  "admin.roles.clearSearch": "Suche zurücksetzen",
  "admin.roles.created": "Rolle erstellt. Die zugewiesenen Berechtigungen sind gespeichert.",
  "admin.roles.customRoles": "Eigene Rollen",
  "admin.roles.delete": "Rolle löschen",
  "admin.roles.deleteConfirm": "„{name}“ unwiderruflich löschen? Die Rolle ist keinem Grant zugeordnet. Die Berechtigungen im Katalog bleiben erhalten.",
  "admin.roles.deleting": "Wird gelöscht …",
  "admin.roles.description": "Beschreibung (optional)",
  "admin.roles.descriptionPlaceholder": "Wofür ist diese Rolle gedacht?",
  "admin.roles.details": "Rollendetails",
  "admin.roles.edit": "Rolle bearbeiten",
  "admin.roles.empty": "Noch keine Rollen vorhanden. Erstelle eine Rolle mit den benötigten Berechtigungen.",
  "admin.roles.existing": "Vorhandene Rollen",
  "admin.roles.intro": "Eine Rolle bündelt Berechtigungen für eine Aufgabe. Hier siehst du vorhandene Rollen und kannst eigene Rollen zusammenstellen.",
  "admin.roles.invalidFields": "Gib einen Rollennamen mit höchstens 120 Zeichen ein. Die Beschreibung darf höchstens 2.000 Zeichen enthalten.",
  "admin.roles.listTitle": "Rollen",
  "admin.roles.loading": "Rollen und Berechtigungen werden geladen…",
  "admin.roles.membersIn": "Personen in {name}",
  "admin.roles.membersLoading": "Personen werden geladen …",
  "admin.roles.name": "Rollenname",
  "admin.roles.namePlaceholder": "z. B. HR-Profilpflege",
  "admin.roles.new": "Neue Rolle erstellen",
  "admin.roles.noAssignments": "Noch keiner Gruppe zugeordnet.",
  "admin.roles.noMembers": "Keine gespeicherten Mitglieder vorhanden.",
  "admin.roles.noResults": "Keine passende Berechtigung gefunden. Deine Auswahl bleibt erhalten.",
  "admin.roles.noRoleResults": "Keine Berechtigungen für diese Ansicht gefunden.",
  "admin.roles.peopleCount": "{count, plural, one {# Person} other {# Personen}}",
  "admin.roles.permissions": "Berechtigungen",
  "admin.roles.permissionsRequired": "Wähle vor dem Speichern mindestens eine verfügbare Berechtigung aus.",
  "admin.roles.readOnly": "Nur Ansicht",
  "admin.roles.resumeDraft": "Entwurf fortsetzen",
  "admin.roles.retry": "Erneut versuchen",
  "admin.roles.scope": "Geltungsbereich: {name}",
  "admin.roles.search": "Berechtigungen durchsuchen",
  "admin.roles.selected": "{count, plural, one {# Berechtigung ausgewählt} other {# Berechtigungen ausgewählt}}",
  "admin.roles.shown": "{shown} von {total} Berechtigungen",
  "admin.roles.systemProtected": "Diese Rolle wird vom System bereitgestellt. Name und Berechtigungen sind festgelegt. Sie kann hier nicht bearbeitet oder gelöscht werden.",
  "admin.roles.systemRoles": "Systemrollen",
  "admin.roles.title": "Berechtigungen & Rollen",
  "admin.roles.unassigned": "Die Rolle ist zunächst niemandem zugewiesen. Gruppe und Geltungsbereich werden später festgelegt.",
  "admin.roles.unnamedPerson": "Person ohne Namen",
  "admin.selectOrCreate": "Wähle links eine Gruppe oder einen Fragebogen oder lege etwas Neues an.",
  "admin.selectPower": "Power wählen",
  "admin.selectionGone": "Dieser Eintrag existiert nicht mehr. Wähle links einen anderen.",
  "admin.statusActive": "Aktiv",
  "admin.statusDeleted": "Gelöscht",
  "admin.statusDraft": "Entwurf",
  "admin.statusInactive": "Inaktiv",
  "admin.statusLabel": "Status",
  "admin.statusPublished": "Veröffentlicht",
  "admin.toggleGroupCollapsed": "{state, select, collapsed {{name} ausklappen} other {{name} einklappen}}",
  "admin.ungroupMessage": "„{name}“ verlässt „{from}“ und verliert seine Position. Seine Antworten zählen nicht mehr in die Auswertung von „{from}“.",
  "admin.ungroupTitle": "„{name}“ aus der Gruppe entfernen?",
  "admin.ungrouped": "Ohne Gruppe",
  "admin.unpublishGroup": "Zurückziehen",
  "admin.unpublishMessage": "Die Gruppe verschwindet aus dem Grow-Play-Katalog. Bereits gegebene Antworten bleiben erhalten und zählen weiter in die Auswertung.",
  "admin.unpublishTitle": "„{name}“ zurückziehen?",
  "admin.validationHint": "Name, je Frage Text + Power und je Antwort Text erforderlich.",
  "admin.weightLabel": "Gewicht",
  "admin.yesDelete": "Ja, löschen",
  "admin.yesRemove": "Ja, entfernen",
  "adminSettings.appearance.accentHint": "Accent · Buttons, Highlights",
  "adminSettings.appearance.accentLabel": "Signalfarbe",
  "adminSettings.appearance.bgHint": "Basis · Page",
  "adminSettings.appearance.bgLabel": "Hintergrund",
  "adminSettings.appearance.openPicker": "Color-Picker öffnen",
  "adminSettings.appearance.presetsFor": "Presets für {label}",
  "adminSettings.appearance.reset": "↺ Auf Default zurücksetzen",
  "adminSettings.appearance.sub": "Hintergrund, Boxen und Signalfarbe steuern die App. Schrift, Abstufungen und Buttons werden daraus abgeleitet und bleiben lesbar (WCAG AA).",
  "adminSettings.appearance.previewShow": "Vorschau anzeigen",
  "adminSettings.appearance.previewHide": "Vorschau ausblenden",
  "adminSettings.appearance.previewSub": "So wirkt die Palette im System. Jede Farbe hier ist aus den drei oben abgeleitet.",
  "adminSettings.appearance.preview.pageAction": "Sichtbarkeiten bearbeiten",
  "adminSettings.appearance.preview.pageSecondary": "Organisationsakte",
  "adminSettings.appearance.preview.cardTitle": "Visitenkarte",
  "adminSettings.appearance.preview.tabPersonal": "Persönlich",
  "adminSettings.appearance.preview.tabCompany": "Unternehmen",
  "adminSettings.appearance.preview.fieldLabel": "Nationalität",
  "adminSettings.appearance.preview.placeholder": "z. B. deutsch",
  "adminSettings.appearance.preview.cardText": "Nebentext, Metadaten und Platzhalter bleiben auf jeder Palette lesbar.",
  "adminSettings.appearance.preview.open": "Öffnen ↗",
  "adminSettings.appearance.preview.share": "↗ Teilen",
  "adminSettings.appearance.preview.chip": "Neu",
  "adminSettings.appearance.preview.bars": "Power-Balken, der gewählte in der Signalfarbe",
  "adminSettings.appearance.preview.toast": "Ungespeicherte Änderungen",
  "adminSettings.appearance.preview.save": "Speichern",
  "adminSettings.appearance.preview.hintButtonsPage": "Buttons auf Boxen nutzen die Hintergrundfarbe, weil sie sich genug von den Boxen abhebt.",
  "adminSettings.appearance.preview.hintButtonsInk": "Buttons auf Boxen sind {colour}: Hintergrund und Boxen unterscheiden sich nur mit {ratio}:1, für Buttons in der Hintergrundfarbe braucht es 4,5:1.",
  "adminSettings.appearance.preview.black": "schwarz",
  "adminSettings.appearance.preview.white": "weiß",
  "adminSettings.appearance.preview.hintAccent": "Als Schrift auf Boxen wird die Signalfarbe durch die Tinte ersetzt, wo sie nicht lesbar wäre.",
  "adminSettings.appearance.surfaceHint": "Karten · Surfaces",
  "adminSettings.appearance.surfaceLabel": "Boxen",
  "adminSettings.appearance.title": "Palette",
  "adminSettings.branding.appName": "App-Name",
  "adminSettings.branding.appNameHint": "Wird oben links angezeigt. Leer fällt auf „smycles“ zurück.",
  "adminSettings.branding.appNamePlaceholder": "smycles",
  "adminSettings.branding.linkPicker.displayText": "Anzeigetext",
  "adminSettings.branding.linkPicker.insert": "Einfügen",
  "adminSettings.branding.linkPicker.page.growPlay": "Grow · Play",
  "adminSettings.branding.linkPicker.page.home": "Home",
  "adminSettings.branding.linkPicker.page.match": "Match",
  "adminSettings.branding.linkPicker.page.share": "Share",
  "adminSettings.branding.linkPicker.searchPlaceholder": "Nach Name suchen …",
  "adminSettings.branding.linkPicker.shareItem": "Bestimmtes Share-Item …",
  "adminSettings.branding.linkPicker.trigger": "Link einfügen",
  "adminSettings.branding.linkPicker.unnamedShareItem": "Unbenanntes Share-Item",
  "adminSettings.branding.logo": "Logo",
  "adminSettings.branding.logoChange": "Logo ändern",
  "adminSettings.branding.logoChangeHover": "Logo ändern",
  "adminSettings.branding.logoChoose": "Logo hochladen",
  "adminSettings.branding.logoEmpty": "Kein Logo",
  "adminSettings.branding.logoHint": "Wird oben links statt des App-Namens angezeigt. PNG, JPEG, GIF, BMP, TIFF oder WebP bis {max, number} MB, wird auf das Sidebar-Format 4:1 zugeschnitten; ein transparenter Hintergrund wirkt am besten.",
  "adminSettings.branding.logoRefusedTooLarge": "Das Logo wurde abgelehnt: das zugeschnittene Bild ist immer noch zu groß.",
  "adminSettings.branding.logoRefusedUnsupported": "Das Logo wurde abgelehnt: es ist kein PNG, JPEG, GIF, BMP, TIFF oder WebP.",
  "adminSettings.branding.logoRemove": "Logo entfernen",
  "adminSettings.branding.logoTooLarge": "{name} ist zu groß. Das Logo darf höchstens {max, number} MB haben.",
  "adminSettings.branding.logoTooManyPixels": "Dieses Bild ist zu groß zum Zuschneiden. Nutze eines unter {max} Megapixel.",
  "adminSettings.branding.logoUnreadable": "Diese Datei konnte nicht gelesen werden. Wähle sie noch einmal aus.",
  "adminSettings.branding.logoUnsupported": "{name} kann nicht als Logo verwendet werden. Wähle ein PNG, JPEG, GIF, BMP, TIFF oder WebP.",
  "adminSettings.branding.paletteNote": "Die Palette unten wird live übernommen; ungespeicherte Änderungen erscheinen im Speichern-Balken und werden beim Speichern plattformweit übernommen.",
  "adminSettings.branding.sub": "App-Name, Logo und Farbpalette. Gilt plattformweit.",
  "adminSettings.branding.title": "Branding",
  "adminSettings.branding.welcomeMessage": "Welcome-Hinweis",
  "adminSettings.branding.welcomeMessageHint": "Unterstützt Links: [Text](/pfad). Alles andere wird als reiner Text angezeigt.",
  "adminSettings.branding.welcomeMessagePlaceholder": "Erscheint beim nächsten Besuch der Home-Seite als Pop-up und bleibt dort als schließbarer Hinweis stehen.",
  "adminSettings.emailTemplates.body": "Inhalt",
  "adminSettings.emailTemplates.defaultActive": "Aktuell ist der Standard aktiv.",
  "adminSettings.emailTemplates.empty": "Es sind keine E-Mail-Vorlagen verfügbar.",
  "adminSettings.emailTemplates.kind.INVITATION": "Einladung",
  "adminSettings.emailTemplates.loading": "Wird geladen…",
  "adminSettings.emailTemplates.placeholderRequired": "{token} (erforderlich)",
  "adminSettings.emailTemplates.placeholders": "Verfügbare Platzhalter: {tokens}",
  "adminSettings.emailTemplates.previewApproximationHint": "Diese Vorschau ist eine Annäherung. Das endgültige Erscheinungsbild bestimmen Keycloak und das E-Mail-Programm des Empfängers.",
  "adminSettings.emailTemplates.previewEmptyBody": "Kein Inhalt.",
  "adminSettings.emailTemplates.previewEmptySubject": "Kein Betreff.",
  "adminSettings.emailTemplates.previewLabel": "E-Mail-Vorschau",
  "adminSettings.emailTemplates.previewLink": "Individueller Einladungslink",
  "adminSettings.emailTemplates.realmWideHint": "Dieser Text gilt für alle Keycloak-Aktionsmails im Realm, auch für Zurücksetzungen von Zugangsdaten aus der Admin Console.",
  "adminSettings.emailTemplates.reset": "Standard verwenden",
  "adminSettings.emailTemplates.storageDisabled": "Die Bearbeitung von E-Mail-Vorlagen ist auf diesem Server nicht aktiviert. Die Vorlage wird nur angezeigt.",
  "adminSettings.emailTemplates.storageUnavailable": "Der Vorlagenspeicher ist derzeit nicht erreichbar. Die Vorlage wird nur angezeigt, gespeicherte Änderungen sind möglicherweise nicht sichtbar.",
  "adminSettings.emailTemplates.sub": "Betreff und Inhalt für die nächste System-Mail.",
  "adminSettings.emailTemplates.subject": "Betreff",
  "adminSettings.emailTemplates.title": "E-Mail-Vorlagen",
  "adminSettings.emailTemplates.validation.applicationNameSingleLine": "Der App-Name muss aus genau einer Zeile bestehen. Ändere ihn in den Systemeinstellungen.",
  "adminSettings.emailTemplates.validation.bodyTooLong": "Der Inhalt darf nach dem Einsetzen des App-Namens höchstens {max} Zeichen enthalten.",
  "adminSettings.emailTemplates.validation.linkInSubject": "Der Platzhalter {token} ist im Betreff nicht erlaubt.",
  "adminSettings.emailTemplates.validation.requiredPlaceholder": "Der Inhalt muss den erforderlichen Platzhalter {token} enthalten.",
  "adminSettings.emailTemplates.validation.reservedSequence": "Die Vorlage enthält eine nicht unterstützte Steuersequenz.",
  "adminSettings.emailTemplates.validation.subjectSingleLine": "Der Betreff muss aus genau einer Zeile bestehen.",
  "adminSettings.emailTemplates.validation.subjectTooLong": "Der Betreff darf nach dem Einsetzen des App-Namens höchstens {max} Zeichen enthalten.",
  "adminSettings.emailTemplates.validation.unknownPlaceholder": "Der Platzhalter {token} wird nicht unterstützt.",
  "adminSettings.emailTemplates.viewEditor": "Editor",
  "adminSettings.emailTemplates.viewLabel": "Vorlagenansicht",
  "adminSettings.emailTemplates.viewPreview": "Vorschau",
  "adminSettings.hrPrompt.defaultActive": "Aktuell ist der Genesis-Standard aktiv.",
  "adminSettings.hrPrompt.hint": "Der Platzhalter '{{responseLanguage}}' wird automatisch ersetzt. Eine Match-Ergänzung steht im kombinierten Prompt zuletzt und hat bei Konflikten Vorrang.",
  "adminSettings.hrPrompt.label": "Globaler HR-Basis-Prompt",
  "adminSettings.hrPrompt.reset": "Genesis-Standard verwenden",
  "adminSettings.hrPrompt.sub": "Zentrale Recruiter-Anweisung für alle Prüf-Matches. Match-spezifische Ergänzungen werden danach angefügt.",
  "adminSettings.hrPrompt.title": "HR-Prompt",
  "agent.attach.button": "Dokument anhängen",
  "agent.attach.cancel": "Abbrechen",
  "agent.attach.drop": "Zum Anhängen an diesen Chat ablegen",
  "agent.attach.prompt": "„{name}“ anhängen?",
  "agent.attach.remove": "Anhang entfernen",
  "agent.attach.status.error": "Upload fehlgeschlagen",
  "agent.attach.status.failed": "fehlgeschlagen",
  "agent.attach.status.pending": "in Warteschlange",
  "agent.attach.status.processing": "wird verarbeitet…",
  "agent.attach.status.ready": "bereit",
  "agent.attach.status.uploading": "wird hochgeladen…",
  "agent.attach.textOnly": "Hochladen (nur Text)",
  "agent.attach.unavailable": "Für das aktuelle Modell nicht verfügbar",
  "agent.attach.unavailableHint": "Nicht für das aktive Modell eingebettet. Entfernen und erneut hochladen, um es zu nutzen.",
  "agent.attach.withImages": "Mit Bildern hochladen",
  "agent.attach.withoutImages": "Ohne Bilder hochladen",
  "agent.back": "Zurück zu Chats",
  "agent.chatOpenError": "Dieser Chat konnte nicht geladen werden. Bitte erneut versuchen.",
  "agent.chatsEmpty": "Noch keine Chats. Starte oben einen neuen.",
  "agent.chatsError": "Chats konnten nicht geladen werden.",
  "agent.chatsLoading": "Lädt…",
  "agent.close": "Schließen",
  "agent.closeImage": "Bild schließen",
  "agent.contextBreak": "Neues Kontextfenster",
  "agent.deleteChat": "Chat löschen",
  "agent.deleteMessage": "Diese Unterhaltung wird dauerhaft gelöscht.",
  "agent.deleteTitle": "Chat löschen?",
  "agent.empty": "Frag den Assistenten zu Personen, Profilen und mehr.",
  "agent.error": "Assistent nicht erreichbar. Bitte erneut versuchen.",
  "agent.expandImage": "In voller Größe anzeigen",
  "agent.externalContentNotice": "Enthält externe Inhalte aus dem Web. KI kann Fehler machen, bitte Quellen prüfen.",
  "agent.input": "Assistenten-Eingabe",
  "agent.jumpToLatest": "Zum Neuesten springen",
  "agent.newChat": "Neuer Chat",
  "agent.page.edit": "In den Stammdaten bearbeiten",
  "agent.page.notFound": "KI-Agent nicht gefunden",
  "agent.page.notFoundHint": "Diesen KI-Agenten gibt es nicht oder nicht mehr.",
  "agent.personInfo.heading": "Profil",
  "agent.personChoice.label": "Personen zur Auswahl",
  "agent.personChosen": "Gemeint ist {person}, die Person im System.",
  "agent.personInfo.label": "Vollständiges Profil laden",
  "agent.placeholder": "Frag den Assistenten…",
  "agent.send": "Senden",
  "agent.stop": "Stopp",
  "agent.starters.growth.0": "Welche Fähigkeiten sollte ich als Nächstes entwickeln?",
  "agent.starters.growth.1": "Welche Rollen passen zu meiner Erfahrung?",
  "agent.starters.growth.2": "Wohin kann ich mich von hier entwickeln?",
  "agent.starters.growth.3": "Welche Erfahrung fehlt mir für Senior-Rollen?",
  "agent.starters.growth.4": "Schlage mir einen Lernpfad vor",
  "agent.starters.growth.5": "Welche Fähigkeiten sind am gefragtesten?",
  "agent.starters.growth.6": "Auf welche Stärken kann ich aufbauen?",
  "agent.starters.growth.7": "Vergleiche mein Profil mit einer Zielrolle",
  "agent.starters.growth.8": "Welche Lücken halten mich zurück?",
  "agent.starters.growth.9": "Empfiehl nächste Schritte für meine Karriere",
  "agent.starters.match.0": "Zeig meine letzten Matches",
  "agent.starters.match.1": "Welche Suchoptionen gibt es?",
  "agent.starters.match.2": "Zeig Details meines neuesten Matches",
  "agent.starters.match.3": "Zähle meine Matches",
  "agent.starters.match.4": "Finde ein Match nach Namen",
  "agent.starters.match.5": "Welches Match habe ich zuletzt aktualisiert?",
  "agent.starters.match.6": "Suche nach einer Person",
  "agent.starters.match.7": "Zeig die Kandidaten meines neuesten Matches",
  "agent.starters.match.8": "Wonach kann ich suchen?",
  "agent.starters.match.9": "Liste Matches aus diesem Monat auf",
  "agent.starters.save.0": "Zeig mein Profil",
  "agent.starters.save.1": "Welche Fähigkeiten stehen in meinem Profil?",
  "agent.starters.save.2": "Welche Sprachen habe ich?",
  "agent.starters.save.3": "Welche Erfahrung steht in meinem Profil?",
  "agent.starters.save.4": "Fasse mein Profil zusammen",
  "agent.starters.save.5": "Was ist meine aktuelle Position?",
  "agent.starters.save.6": "Liste meine Ausbildung auf",
  "agent.starters.save.7": "Bei welchen Unternehmen habe ich gearbeitet?",
  "agent.starters.save.8": "Was ist mein stärkster Kompetenzbereich?",
  "agent.starters.save.9": "Zeig meine Kontaktdaten",
  "agent.starters.share.0": "Liste meine geteilten Inhalte auf",
  "agent.starters.share.1": "Zeig meinen neuesten Share",
  "agent.starters.share.2": "Fasse meine geteilten Projekte zusammen",
  "agent.starters.share.3": "Zeig meine öffentlichen Shares",
  "agent.starters.share.4": "Zeig meine privaten Shares",
  "agent.starters.share.5": "Liste auf, was ich diesen Monat geteilt habe",
  "agent.starters.share.6": "Zeig Details meines neuesten Shares",
  "agent.starters.share.7": "Finde einen geteilten Inhalt nach Namen",
  "agent.starters.share.8": "Liste mit dem Team geteilte Inhalte auf",
  "agent.starters.share.9": "Liste meine geteilten Projekte auf",
  "agent.title": "Assistent",
  "agent.progress.resolvingCondition": "Bedingung {index} von {total}: {condition}",
  "agent.progress.conditionReworded": "Gespeichert ist stattdessen ''{value}''",
  "agent.progress.conditionUnrecorded": "Feld ''{field}'' ist kaum gefüllt, nutze stattdessen ''{insteadField}''",
  "agent.progress.conditionAbsent": "In den Daten gibt es nichts zu ''{field}''",
  "agent.progress.combining": "Setze zusammen: {filter}",
  "agent.progress.logic.and": "und",
  "agent.progress.logic.or": "oder",
  "agent.progress.op.eq": "ist genau",
  "agent.progress.op.ne": "ist nicht",
  "agent.progress.op.contains": "wie",
  "agent.progress.op.startsWith": "beginnt mit",
  "agent.progress.op.endsWith": "endet mit",
  "agent.progress.op.in": "in",
  "agent.progress.op.notIn": "nicht in",
  "agent.progress.op.lt": "ist kleiner als",
  "agent.progress.op.lte": "ist höchstens",
  "agent.progress.op.gt": "ist größer als",
  "agent.progress.op.gte": "ist mindestens",
  "agent.progress.op.any": "ist gesetzt",
  "agent.progress.counting": "Ermittle Personen mit {filter}",
  "agent.progress.countingAll": "Ermittle alle Personen",
  "agent.progress.listing": "Suche Personen mit {filter}",
  "agent.progress.listingAll": "Suche Personen",
  "agent.progress.tallying": "Ermittle Feld ''{field}'' mit {filter}",
  "agent.progress.tallyingAll": "Ermittle Feld ''{field}'' über alle Personen",
  "agent.progress.considering": "Überlege",
  "agent.progress.searchingAlternatives": "Nichts gefunden, starte eine tiefere Suche",
  "agent.progress.alternativeFound": "Gefunden unter \"{term}\"",
  "agent.progress.nothingFound": "Bestätigt: es gibt nichts in dieser Art",
  "agent.progress.working": "Arbeite daran",
  "agent.progress.counting.companies": "Ermittle Unternehmen mit {filter}",
  "agent.progress.countingAll.companies": "Ermittle alle Unternehmen",
  "agent.progress.listing.companies": "Suche Unternehmen mit {filter}",
  "agent.progress.listingAll.companies": "Suche Unternehmen",
  "agent.progress.planningSearch": "Überlege, wo ich suche",
  "agent.progress.planningSearchRoute": "{route, select, label {Suche in den Fachgebieten} description {Lese die Unternehmensbeschreibungen} description_and_label {Suche in den Fachgebieten und den Beschreibungen} named {Lese die genannten Unternehmen} field {Suche in den Fachgebieten} rag {Lese die Unternehmensbeschreibungen} both {Suche in den Fachgebieten und den Beschreibungen} record {Lese die genannten Unternehmen} other {Überlege, wo ich suche ({route})}}",
  "agent.progress.searchingFields": "Prüfe die Fachgebiete auf \"{terms}\"",
  "agent.progress.embeddingLabels": "Lese die Fachgebiete, Unternehmen {company} von {companies}",
  "agent.progress.indexingSummaries": "Erstelle Index über die Unternehmensbeschreibungen",
  "agent.progress.searchingSummaries": "Durchsuche die Beschreibungen nach \"{query}\"",
  "agent.progress.chosenCell": "{selected} ausgewählt",
  "agent.progress.ofPool": "{count} von {candidates}",
  "agent.progress.searchingSummariesTable": "Durchsuche die Beschreibungen nach:",
  "agent.progress.searchingSummariesTableEach": "Durchsuche die Beschreibungen nach – jeweils {each}:",
  "agent.progress.summariesMatched": "{count, plural, one {# Unternehmen} other {# Unternehmen}} anhand der Beschreibung gefunden",
  "agent.progress.summariesMatchedNone": "Kein Unternehmen beschreibt sich so",
  "agent.progress.searchingWeb": "Durchsuche das Web nach \"{query}\"",
  "agent.progress.searchingWebAll": "Durchsuche das Web",
  "agent.thinking.show": "Zeigen, was zu dieser Antwort geführt hat",
  "agent.thinking.hide": "Ausblenden, was zu dieser Antwort geführt hat",
  "agent.progress.weighingHits": "Lese die {hits} Kandidaten und wäge sie ab",
  "agent.progress.weighingHitsExplained": "Lese die {hits} Kandidaten und wäge sie ab – {returned} Treffer aus {searches} Suchen, insgesamt {hits} einzigartig",
  "agent.progress.resultCandidates": "{count, plural, =0 {keine Kandidaten} one {# Kandidat} other {# Kandidaten}}",
  "agent.progress.resultCandidatesCut": "die {count} nächsten von {candidates}",
  "agent.progress.resultSelected": "{selected, plural, =0 {davon keiner ausgewählt} one {# ausgewählt} other {# ausgewählt}}",
  "agent.progress.resultFound": "{count, plural, =0 {nichts gefunden} other {# gefunden}}",
  "agent.progress.resultFoundOfMatched": "{count} von {matched} gefunden",
  "agent.progress.locatingPlace": "Schlage nach, wo {place} liegt",
  "agent.progress.locatingPlaceIn": "Schlage nach, ob {place} in {area} liegt",
  "agent.progress.field.name": "Name",
  "agent.progress.field.name.family": "Nachname",
  "agent.progress.field.name.given": "Vorname",
  "agent.progress.field.formattedName": "Name",
  "agent.progress.field.id": "ID",
  "agent.progress.field.jobTitle": "Jobtitel",
  "agent.progress.field.profession": "Beruf",
  "agent.progress.field.currentEmployer": "Arbeitgeber",
  "agent.progress.field.city": "Stadt",
  "agent.progress.field.country": "Land",
  "agent.progress.field.countryState": "Bundesland",
  "agent.progress.field.nationality": "Nationalität",
  "agent.progress.field.citizenships": "Staatsangehörigkeit",
  "agent.progress.field.gender": "Geschlecht",
  "agent.progress.field.ageInYears": "Alter",
  "agent.progress.field.birthDate": "Geburtsdatum",
  "agent.progress.field.languageSkills": "Sprachen",
  "agent.progress.field.expertises": "Expertise",
  "agent.progress.field.experiences": "Erfahrung",
  "agent.progress.field.educations": "Ausbildung",
  "agent.progress.field.industry": "Branche",
  "agent.progress.field.employeeCount": "Mitarbeiterzahl",
  "agent.progress.field.summary": "Beschreibung",
  "agent.progress.field.competencyFieldName": "Expertise",
  "agent.tour.back": "Zurück",
  "agent.tour.buttonHint.back": "Zurück: zeigt den vorherigen Schritt noch einmal.",
  "agent.tour.buttonHint.next": "Weiter: springt sofort zum nächsten Schritt.",
  "agent.tour.buttonHint.pause": "Pause: hält die Tour an, Fragen sind willkommen.",
  "agent.tour.buttonHint.skipSection": "Bereich überspringen: wechselt zum nächsten Bereich.",
  "agent.tour.buttonHint.stop": "Tour beenden oder Esc: beendet die Tour.",
  "agent.tour.chipHome": "Hauptseite",
  "agent.tour.continue": "Fortsetzen",
  "agent.tour.escHint": "_Nutze die Buttons unter dem Chat: zurück, Pause, weiter und Bereich überspringen. Drücke jederzeit **Esc** oder den Stopp-Button, um die Tour zu beenden._",
  "agent.tour.finished": "Das war das Ende der Tour. Frag mich gern alles zu dem, was du gesehen hast!",
  "agent.tour.mobileNotice": "Touren heben Elemente auf der Seite neben dem Chat hervor und brauchen dafür einen größeren Bildschirm. Probiere es bitte in einem Desktop-Fenster.",
  "agent.tour.modeActive": "Tour-Modus",
  "agent.tour.modeFinished": "Tour beendet. Klicke einen Abschnitt oder gehe zurück zum Ansehen; Stopp beendet.",
  "agent.tour.modePaused": "Tour pausiert. Du kannst jetzt Fragen stellen.",
  "agent.tour.next": "Weiter",
  "agent.tour.next.heading": "Jetzt probiere es selbst aus:",
  "agent.tour.next.linkedin": "Importiere deine Daten über LinkedIn",
  "agent.tour.next.match": "Erstelle ein Match",
  "agent.tour.next.profile": "Fülle dein Profil aus",
  "agent.tour.next.project": "Erstelle ein Projekt",
  "agent.tour.next.quiz": "Mache ein Power-Quiz",
  "agent.tour.noTour": "Für diese Seite gibt es noch keine Tour.",
  "agent.tour.pause": "Pause",
  "agent.tour.pillar.grow": "GROW ist dein Power-Spielplatz: Schätze deine 30 Powers ein, schau Lerninhalte und spiele dich zu einem schärferen Profil.",
  "agent.tour.pillar.home": "Das Smycles-Logo bringt dich immer zur Hauptseite: deinem Dashboard mit den aktuellen Zahlen aus allen Bereichen.",
  "agent.tour.pillar.match": "MATCH baut Teams: Du definierst die Anforderungen, der Solver findet die passenden Leute.",
  "agent.tour.pillar.save": "SAVE ist dein persönlicher Datentresor: dein Profil, deine Lebenslauf-Einträge, Dokumente, Kontakte und deine Pinnwand.",
  "agent.tour.pillar.share": "SHARE ist der Community-Feed: Veröffentliche Projekte und Beiträge, gewinne Interessierte und sammle Feedback.",
  "agent.tour.questionContinue": "Alles zeigen",
  "agent.tour.questionFinish": "Tour beenden",
  "agent.tour.sectionQuestion": "Soll ich dir zuerst einen Bereich zeigen? Wähle ihn unter dem Chat aus, sonst stelle ich die Hauptseite und jeden Bereich der Reihe nach vor.",
  "agent.tour.sectionQuestionNext": "Dieser Bereich ist fertig. Soll ich dir noch einen zeigen? Wähle ihn unter dem Chat aus, sonst endet die Tour hier.",
  "agent.tour.sectionsIntro": "Ich zeige dir kurz die Bereiche, bevor wir ins Detail gehen.",
  "agent.tour.skipSection": "Bereich überspringen",
  "agent.tour.starterChip": "Zeig mir diese Seite",
  "agent.tour.starterChipAll": "Zeig mir die App",
  "agent.tour.stop": "Tour beenden",
  "agent.tour.topbar.assistant": "Der KI-Assistent: Dieser Button öffnet und schließt den Chat, den du gerade liest.",
  "agent.tour.topbar.chat": "Nachrichten: Direkte Chats mit deinen Kontakten.",
  "agent.tour.topbar.notifications": "Benachrichtigungen: Einladungen, Updates und Aktivität rund um dich landen hier.",
  "agent.tour.topbar.search": "Die globale Suche: Finde Personen, Projekte und Beiträge von überall in der App.",
  "agent.tour.topbar.user": "Dein Konto: Klick auf deinen Namen für Profilmenü, Einstellungen und Logout.",
  "agent.tour.welcome": "Willkommen im Smycles System. Diese Tour stellt die wichtigen Funktionalitäten vor. Die Knöpfe unter dem Chat steuern die Tour. Du kannst auch jeden Chat-Schnipsel anklicken, um zu seiner Stelle zurückzuspringen.",
  "agent.untitled": "Unbenannter Chat",
  "auth.redirecting": "Weiterleitung zum Login…",
  "auth.sessionExpired.body": "Sie wurden abgemeldet, weil die Sitzung ihr Zeitlimit erreicht hat. Änderungen werden nicht mehr gespeichert. Melden Sie sich erneut an, um dort weiterzumachen, wo Sie aufgehört haben.",
  "auth.sessionExpired.bodyTokensLost": "Sie wurden abgemeldet. Änderungen werden nicht mehr gespeichert. Melden Sie sich erneut an, um dort weiterzumachen, wo Sie aufgehört haben.",
  "auth.sessionExpired.signIn": "Erneut anmelden",
  "auth.sessionExpired.title": "Sitzung beendet",
  "chat.closeChat": "Chat schließen",
  "chat.deleteChat": "Chat löschen",
  "chat.deleteChatConfirm": "Diese Unterhaltung wirklich löschen?",
  "chat.liveUpdatesUnavailable": "Live-Updates nicht verfügbar",
  "chat.messageInput": "Nachrichteneingabe",
  "chat.messages": "Nachrichten",
  "chat.minimize": "Minimieren",
  "chat.more": "Mehr",
  "chat.newConversation": "Neue Unterhaltung",
  "chat.noConversationsYet": "Noch keine Unterhaltungen",
  "chat.online": "Online",
  "chat.openMessages": "Nachrichten",
  "chat.searchChats": "Chats durchsuchen…",
  "chat.searchEnd": "{count} Ergebnisse",
  "chat.searchHint": "Mindestens {n} Zeichen eingeben",
  "chat.searchPeople": "Personen suchen…",
  "chat.seen": "Gesehen",
  "chat.sendMessage": "Nachricht senden",
  "chat.typing": "tippt…",
  "chat.unreadMessages": "{count} ungelesen",
  "chat.writeMessage": "Nachricht schreiben…",
  "chat.you": "Du",
  "cockpit.dismiss": "Verwerfen",
  "cockpit.dismissAll": "Alle verwerfen",
  "cockpit.dismissAllMessage": "Das leert deine Benachrichtigungen und kann nicht rückgängig gemacht werden. Benachrichtigungen, die noch auf deine Antwort warten, bleiben erhalten.",
  "cockpit.dismissAllTitle": "Alle Benachrichtigungen verwerfen?",
  "cockpit.jobActive": "Aktiv",
  "cockpit.noNotifications": "Keine Benachrichtigungen",
  "cockpit.notifications": "Benachrichtigungen",
  "cockpit.showMoreDocuments": "{count} weitere anzeigen",
  "cockpit.unread": "ungelesen",
  "comments.delete.body": "Der Kommentar wird endgültig entfernt. Das lässt sich nicht rückgängig machen.",
  "comments.delete.title": "Kommentar löschen?",
  "comments.discard.body": "Die ungespeicherten Änderungen an diesem Kommentar verwerfen?",
  "common.add": "Hinzufügen",
  "common.back": "Zurück",
  "common.cancel": "Abbrechen",
  "common.close": "Schließen",
  "common.comingSoon": "Demnächst verfügbar",
  "common.confirm": "Bestätigen",
  "common.create": "Erstellen",
  "common.delete": "Löschen",
  "common.discard": "Verwerfen",
  "common.duplicateName": "Es existiert bereits ein Eintrag mit diesem Namen. Bitte einen anderen Namen wählen.",
  "common.edit": "Bearbeiten",
  "common.errorWithMessage": "Fehler: {message}",
  "common.fileDrop.overlay": "Zum Hochladen ablegen …",
  "common.fileDrop.zone": "Datei hier ablegen oder klicken",
  "common.forbidden": "Dir fehlen die erforderlichen Berechtigungen für diese Aktion.",
  "common.forbiddenWithCode": "Dir fehlen die erforderlichen Berechtigungen für diese Aktion. (Fehlercode {code})",
  "common.loadMore": "Mehr laden",
  "common.loading": "Laden…",
  "common.loadingMore": "Lädt…",
  "common.next": "Weiter",
  "common.nextPage": "Weiter",
  "common.noBackend": "Kein Backend-Endpunkt",
  "common.noResults": "Keine Ergebnisse gefunden",
  "common.notFound": "Nicht gefunden",
  "common.notFoundBody": "Die gesuchte Seite existiert nicht.",
  "common.pageOf": "Seite {page} von {total}",
  "common.prevPage": "Zurück",
  "common.remove": "Entfernen",
  "common.reset": "Zurücksetzen",
  "common.save": "Speichern",
  "common.saveFailed": "Speichern fehlgeschlagen.",
  "common.saving": "Speichern…",
  "common.search": "Suchen",
  "common.serverError": "Etwas ist schiefgelaufen. Bitte versuch es erneut.",
  "common.serverErrorWithCode": "Etwas ist schiefgelaufen. Bitte versuch es erneut. (Fehlercode {code})",
  "common.share.ariaActive": "Teilen aktiv",
  "common.share.ariaInactive": "Nicht teilen",
  "common.share.off": "Privat",
  "common.share.on": "Teilen",
  "common.tryAgain": "Erneut versuchen",
  "common.undo": "Rückgängig",
  "common.unsavedChanges": "Nicht gespeicherte Änderungen",
  "community.tour.contacts.desc": "{count} Kontakte in der aktuellen Ansicht. Klicke eine Karte, um das Profil zu öffnen, nutze „+ Hinzufügen“, um sie in Communities einzuordnen, oder ziehe sie links auf eine Community.",
  "community.tour.contacts.title": "Deine Kontakte",
  "community.tour.controls.desc": "Suche Kontakte nach Namen, ändere die Sortierung oder filtere auf Kontakte, die noch in keiner Community sind.",
  "community.tour.controls.title": "Suchen & Sortieren",
  "community.tour.groups.desc": "{count} Communities, um deine Kontakte zu gruppieren. Klicke eine an, um ihre Mitglieder zu sehen, lege neue über „+ Community“ an und ziehe eine Kontaktkarte auf eine Community, um sie hinzuzufügen.",
  "community.tour.groups.title": "Deine Communities",
  "community.tour.label": "Save Community",
  "community.tour.summary": "Das ist deine Community-Seite: {contacts} Kontakte, organisiert in {groups} Communities.",
  "company.admin.competencies.blank": "Eine Fachkompetenz braucht einen Namen. Gib ihr einen oder entferne sie.",
  "company.admin.competencies.duplicate": "Dieses Unternehmen listet die Fachkompetenz „{label}“ bereits.",
  "company.admin.competencies.editLabel": "Fachkompetenz bearbeiten",
  "company.admin.competencies.label": "Fachkompetenz",
  "company.admin.competencies.labelPlaceholder": "z. B. Regulatory Affairs",
  "company.admin.competencies.listFull": "Dieses Unternehmen listet bereits {max, number} Fachkompetenzen; mehr sind nicht möglich. Entferne eine, um eine weitere hinzuzufügen.",
  "company.admin.competencies.none": "Noch keine Fachkompetenzen gelistet.",
  "company.admin.competencies.pendingAddNamed": "„{label}“ wird beim Speichern hinzugefügt.",
  "company.admin.competencies.pendingEditNamed": "„{label}“ wird beim Speichern neu geschrieben.",
  "company.admin.competencies.pendingRemoveNamed": "„{label}“ wird beim Speichern entfernt.",
  "company.admin.competencies.stagedList": "Ausstehende Änderungen an Fachkompetenzen",
  "company.admin.competencies.tooLong": "Eine Fachkompetenz darf höchstens {max, number} Zeichen lang sein.",
  "company.admin.done": "Bearbeitung beenden",
  "company.admin.edit": "Unternehmen bearbeiten",
  "company.admin.error.alreadyMember": "Diese Person ist bereits bei diesem Unternehmen eingetragen.",
  "company.admin.error.cannotAdminister": "Das Konto dieser Person ist nicht aktiv, daher kann sie kein Unternehmen verwalten. Wähle jemanden mit einem aktiven Konto.",
  "company.admin.error.employeeCount": "Die Mitarbeitendenzahl muss eine ganze Zahl ab 0 sein.",
  "company.admin.error.expertiseAlreadyListed": "„{label}“ ist bereits gelistet und kann kein zweites Mal hinzugefügt werden.",
  "company.admin.error.expertiseListFull": "Dieses Unternehmen listet bereits {max, number} Fachkompetenzen; mehr sind nicht möglich. Entferne eine, um eine weitere hinzuzufügen.",
  "company.admin.error.expertiseTooLong": "Eine Fachkompetenz darf höchstens {max, number} Zeichen lang sein. Kürze sie und füge sie erneut hinzu.",
  "company.admin.error.lastAdmin": "Ein Unternehmen braucht mindestens eine Administration. Mache zuerst jemand anderen zur Administration.",
  "company.admin.error.logoRefused": "Das Logo wurde abgelehnt. Es muss ein PNG-, JPEG-, GIF-, BMP-, TIFF- oder WebP-Bild von höchstens {max, number} MB sein.",
  "company.admin.error.nameRequired": "Ein Unternehmensname ist erforderlich.",
  "company.admin.error.nameTooLong": "Der Unternehmensname darf höchstens {max, number} Zeichen lang sein.",
  "company.admin.error.notAdmin": "Du verwaltest dieses Unternehmen nicht mehr. Lade die Seite neu, um zu sehen, was du noch tun kannst.",
  "company.admin.error.saveProfile": "Das Unternehmen konnte nicht gespeichert werden.",
  "company.admin.error.summaryTooLong": "Der Text unter Über uns darf höchstens {max, number} Zeichen lang sein.",
  "company.admin.error.tooManyContactPersons": "Ein Unternehmen kann höchstens {max, number} Ansprechpartner:innen haben. Jemand anderes hat gerade den letzten Platz belegt. Entferne eine Markierung, um diese Person zu markieren.",
  "company.admin.field.employeeCount": "Mitarbeitende",
  "company.admin.field.industry": "Branche",
  "company.admin.field.industryNoResults": "Keine Branche passt",
  "company.admin.field.industryPlaceholder": "Keine Branche",
  "company.admin.field.industrySearch": "Branchen suchen",
  "company.admin.field.name": "Name",
  "company.admin.field.summary": "Über uns",
  "company.admin.logo.change": "Unternehmenslogo ändern",
  "company.admin.logo.changeHover": "Logo ändern",
  "project.access.count": "Zugriff · {count}",
  "project.access.hint": "Wer hier steht, sieht das Projekt. Kandidaten sind etwas anderes: sie werden gefragt und haben keinen Zugriff.",
  "project.access.none": "Niemand hat Zugriff. Unten Person hinzufügen.",
  "project.access.roleAdmin": "Verwalten",
  "project.access.roleReader": "Sehen",
  "project.activity.anlass": "Anlass ergänzt",
  "project.activity.empty": "Noch nichts passiert. Hier landet, was am Projekt geschieht.",
  "project.activity.showAll": "{count} weitere anzeigen",
  "project.anlass.placeholder": "Anlass wählen",
  "project.candidates.allContacts": "Alle",
  "project.candidates.existingMatchDesc": "Ein früheres Match-Ergebnis als Ausgangspunkt übernehmen.",
  "project.candidates.existingMatchLabel": "Deine bisherigen Matches",
  "project.candidates.existingMatchTitle": "Ich habe schon ein Match",
  "project.candidates.knownDesc": "Aus deiner Community oder über die Suche.",
  "project.candidates.knownTitle": "Aus Community hinzufügen",
  "project.candidates.linkedTitle": "Matches dieses Projekts",
  "project.candidates.matchDesc": "Direkt in MATCH, mit den Requirements aus diesem Projekt.",
  "project.candidates.matchTitle": "Ich will matchen",
  "project.candidates.noLinked": "Zu diesem Projekt gibt es noch kein Match.",
  "project.candidates.noMatches": "Kein Match mit Ergebnis. Schalte den Filter aus, um alle zu sehen.",
  "project.candidates.onlyWithResult": "Nur mit Ergebnis",
  "project.candidates.openMatch": "Ansehen",
  "project.candidates.pick": "Hinzufügen",
  "project.candidates.picked": "Hinzugefügt",
  "project.candidates.pickedNote": "Gefragte bekommen noch keinen Zugriff aufs Projekt, lassen sich aber schon für Aufgaben einplanen.",
  "project.candidates.remove": "Entfernen",
  "project.candidates.resultCount": "{count, plural, =0 {kein Ergebnis} one {1 Ergebnis} other {# Ergebnisse}}",
  "project.candidates.unlink": "Verbindung lösen",
  "project.candidates.unlinkBody": "„{name}“ gehört dann nicht mehr zu diesem Projekt. Das Match selbst bleibt mit Kandidaten und Ergebnissen erhalten.",
  "project.candidates.unlinkTitle": "Verbindung zum Projekt lösen",
  "project.create.contextSub": "Wenn du schon etwas hast, nimm es gleich mit. Der Assistent liest daraus Anlass, Anforderungen und erste Rollen. Ohne geht es genauso.",
  "project.create.contextTitle": "Kontext mitgeben",
  "project.create.descLabel": "Beschreibung",
  "project.create.descPlaceholder": "Worum geht es? Zwei Sätze reichen, der Rest wächst mit dem Projekt.",
  "project.create.dropHint": "max. 10 MB pro Datei",
  "project.create.dropLabel": "Datei hier ablegen oder klicken",
  "project.create.eyebrow": "Erstellen",
  "project.create.fromDocuments": "Aus meinen Dokumenten",
  "project.create.generate": "Für mich generieren",
  "project.create.generatePrompt": "Leite aus Titel, Beschreibung und den mitgegebenen Unterlagen Anlass, Aufteilung und erste Rollen ab.",
  "project.create.importLabel": "Import aus",
  "project.create.sub": "Titel genügt. Alles Weitere ist freiwillig und lässt sich später im Projekt ergänzen.",
  "project.create.submit": "Projekt anlegen",
  "project.create.submitting": "Wird angelegt …",
  "project.create.title": "Neues Projekt",
  "project.create.actingAsCompany": "Du legst das Projekt als {company} an. Verlasse den Unternehmenskontext, um es als du selbst anzulegen.",
  "project.create.titleLabel": "Titel",
  "project.create.titlePlaceholder": "Wofür brauchst du Leute?",
  "project.create.uploadLabel": "Unterlagen",
  "project.data.service.asana.desc": "Tasks als Kontext",
  "project.data.service.asana.title": "Asana",
  "project.data.service.jira.desc": "Tickets als Kontext",
  "project.data.service.jira.title": "Jira",
  "project.data.service.monday.desc": "Boards als Kontext",
  "project.data.service.monday.title": "Monday",
  "project.data.service.trello.desc": "Karten als Kontext",
  "project.data.service.trello.title": "Trello",
  "project.delete.confirm": "Dieses Projekt endgültig löschen? Verknüpfte Matches bleiben bestehen.",
  "project.delete.title": "Projekt löschen",
  "project.documents.ariaLabel": "Dokumente hinzufügen",
  "project.documents.dropHint": "max. 10 MB pro Datei, landet auch in deinen Dokumenten",
  "project.documents.dropLabel": "Datei hier ablegen oder klicken",
  "project.documents.empty": "Noch keine Dokumente.",
  "project.documents.tooLarge": "Zu groß (max. {max} MB pro Datei): {names}",
  "project.event.date": "Datum",
  "project.event.kind": "Art",
  "project.event.kind.deadline": "Frist",
  "project.event.kind.meeting": "Termin",
  "project.event.kind.milestone": "Meilenstein",
  "project.event.title": "Termin",
  "project.facet.ablauf.add": "Aktivität verfolgen",
  "project.facet.ablauf.label": "Aktivität",
  "project.facet.anlass.label": "Anlass",
  "project.facet.aufteilen.add": "Ablauf planen",
  "project.facet.aufteilen.label": "Ablauf",
  "project.facet.bewerbungen.label": "Bewerbungen",
  "project.facet.bilder.add": "Bilder hinzufügen",
  "project.facet.bilder.label": "Bilder",
  "project.facet.dokumente.add": "Dokumente hinzufügen",
  "project.facet.dokumente.label": "Dokumente",
  "project.facet.kandidaten.add": "Menschen suchen",
  "project.facet.kandidaten.label": "Match",
  "project.facet.mitglieder.add": "Team anzeigen",
  "project.facet.mitglieder.label": "Team",
  "project.facet.team.add": "Anforderungen hinzufügen",
  "project.facet.team.label": "Anforderungen",
  "project.guided.anlass.aufgabe.desc": "Etwas Abgegrenztes, das getan werden muss. Klein und schnell.",
  "project.guided.anlass.aufgabe.title": "Aufgabe",
  "project.guided.anlass.auftrag.desc": "Ein Kunde, ein vereinbartes Ergebnis, ein Preis.",
  "project.guided.anlass.auftrag.title": "Auftrag",
  "project.guided.anlass.ausschreibung.desc": "Ein formales Verfahren mit Frist, Formvorgaben und Wertung.",
  "project.guided.anlass.ausschreibung.title": "Ausschreibung",
  "project.guided.anlass.initiative.desc": "Etwas, das du anstoßen willst, ohne dass jemand es bestellt hat.",
  "project.guided.anlass.initiative.title": "Initiative",
  "project.guided.anlass.planvorstellung.desc": "Noch eine Idee, aber schon erzählbar. Zahlen sind geschätzt.",
  "project.guided.anlass.planvorstellung.title": "Planvorstellung",
  "project.guided.anlass.programm.desc": "Etwas Größeres mit Etappen, das in Teile zerfällt.",
  "project.guided.anlass.programm.title": "Programm",
  "project.guided.aufteilen.addEvent": "+ Termin",
  "project.guided.aufteilen.addSection": "+ Aufgabenpaket",
  "project.guided.aufteilen.autosaved": "Automatisch gespeichert",
  "project.guided.aufteilen.newSectionName": "Aufgabenpaket {n}",
  "project.guided.aufteilen.newTaskName": "Neue Aufgabe",
  "project.guided.aufteilen.sub": "Aufgabenpakete mit Zeitraum, darin die Aufgaben, dazwischen die Termine. Vier bis acht Pakete reichen.",
  "project.guided.team.expertiseTitle": "Benötigte Fachkompetenzen (mind.)",
  "project.guided.team.powersSub": "Klick eine Gruppe an, um ihre fünf Powers zu gewichten.",
  "project.guided.team.powersTitle": "Power-Scorecard",
  "project.guided.team.profileName": "Individuell",
  "project.guided.team.sub": "Gesucht werden Fähigkeiten, nicht Namen. Was hier steht, ist dasselbe Profil, mit dem später ein Match rechnet.",
  "project.import.notLinked": "{service} ist aktuell nicht verlinkt",
  "project.lanes.collapseLane": "Spur zuklappen",
  "project.lanes.collapsedCount": "{count, plural, one {1 Eintrag} other {# Einträge}}",
  "project.lanes.empty": "Noch keine Aufgabenpakete mit Zeitraum.",
  "project.lanes.expandLane": "Spur aufklappen",
  "project.lanes.scaleCompact": "Klein",
  "project.lanes.scaleDetail": "Groß",
  "project.lanes.scaleLabel": "Skalierung",
  "project.lanes.scaleNormal": "Mittel",
  "project.lanes.unassigned": "Ohne Zuweisung",
  "project.meta.owner": "Verantwortlich",
  "project.meta.status": "Status",
  "project.meta.tags": "Tags",
  "project.notFound": "Projekt nicht gefunden",
  "project.plan.addTask": "Aufgabe hinzufügen",
  "project.plan.addTaskHere": "Aufgabe zu diesem Aufgabenpaket hinzufügen",
  "project.plan.assignee": "Zuständig",
  "project.plan.collapsePackage": "Aufgaben verbergen",
  "project.plan.deleteEvent": "Termin löschen",
  "project.plan.deleteEventConfirm": "Termin löschen?",
  "project.plan.deletePackage": "Aufgabenpaket löschen",
  "project.plan.deletePackageConfirm": "{count, plural, =0 {Aufgabenpaket löschen?} one {Mit einer Aufgabe löschen?} other {Mit # Aufgaben löschen?}}",
  "project.plan.done": "Fertig",
  "project.plan.editRow": "Bearbeiten",
  "project.plan.empty": "Noch keine Aufgabenpakete. Ein Aufgabenpaket ist ein Stück Arbeit mit Zeitraum, darin stehen die Aufgaben.",
  "project.plan.end": "Ende",
  "project.plan.event": "Termin",
  "project.plan.expandPackage": "Aufgaben zeigen",
  "project.plan.lanes.weekRange": "KW {week}: {from} bis {to}",
  "project.plan.newEventName": "Neuer Termin",
  "project.plan.order.label": "Sortieren",
  "project.plan.order.newest": "Neueste zuerst",
  "project.plan.order.oldest": "Älteste zuerst",
  "project.plan.package": "Aufgabenpaket",
  "project.plan.packageTitle": "Aufgabenpaket",
  "project.plan.removeTask": "Aufgabe löschen",
  "project.plan.removeTaskConfirm": "Aufgabe löschen?",
  "project.plan.selectHint": "Klick einen Balken an, um ihn hier zu ändern.",
  "project.plan.start": "Beginn",
  "project.plan.taskCount": "{count, plural, one {1 Aufgabe} other {# Aufgaben}}",
  "project.plan.taskTitle": "Aufgabe",
  "project.plan.unnamed": "Ohne Namen",
  "project.readOnlyBanner": "Du kannst dieses Projekt nur ansehen. Bitte die Eigentümer:in um Schreibrechte.",
  "project.readOnlyAskCompanyAdmin": "Du kannst dieses Projekt nur ansehen. Bitte eine Administration von {company} um Schreibrechte.",
  "project.readOnlyNeedsCompanyContext": "Gehört {company}. Wechsle in den Unternehmenskontext, um es zu bearbeiten.",
  "project.readOnlyLeaveCompanyContext": "Du handelst gerade als {company}. Verlasse den Unternehmenskontext, um dein Projekt zu bearbeiten.",
  "project.results.candidates": "{count, plural, one {1 Kandidat} other {# Kandidaten}}",
  "project.results.close": "Schliessen",
  "project.results.hide": "Personen verbergen",
  "project.results.loading": "Ergebnisse werden geladen …",
  "project.results.noPersons": "In diesem Ergebnis steht niemand.",
  "project.results.none": "Dieses Match hat noch kein Ergebnis.",
  "project.results.show": "Personen zeigen",
  "project.results.unnamed": "Ergebnis",
  "project.service.importTags": "Import · Kontext",
  "project.service.importTitle": "Kontext holen",
  "project.settings.heading": "Name, Status & Zugriff",
  "project.settings.noWriteRights": "Du hast keine Schreibrechte auf diese Projekt-Einstellungen.",
  "project.settings.title": "Projekt-Einstellungen",
  "project.status.active": "In Umsetzung",
  "project.status.cancelled": "Abgebrochen",
  "project.status.done": "Abgeschlossen",
  "project.status.funding": "Finanzierung",
  "project.status.idea": "Idee",
  "project.status.paused": "Pausiert",
  "project.status.scaling": "Skalierung",
  "project.status.seed": "Seed",
  "project.tags.add": "Tag",
  "project.tags.empty": "Noch keine Tags. Sie helfen später beim Finden ähnlicher Projekte.",
  "project.tags.new": "Neues Tag",
  "project.tags.placeholder": "Tag und Enter",
  "project.tags.remove": "{tag} entfernen",
  "project.team.addMore": "Weitere suchen",
  "project.team.asked": "Gefragt",
  "project.team.askedNote": "Gefragte sehen das Projekt noch nicht, lassen sich aber schon für Aufgaben einplanen.",
  "project.team.badgeMember": "Im Projekt",
  "project.team.empty": "Noch niemand sonst dabei. Über Match findest du Menschen aus deiner Community, aus einem früheren Match oder über eine neue Suche.",
  "project.team.members": "Mit Zugriff",
  "project.team.toMatch": "Menschen suchen",
  "project.team.toNewMatch": "Ich will matchen",
  "project.timeline.focusPerson": "Personfokus",
  "project.timeline.focusProject": "Projektfokus",
  "project.toMatch.copyNote": "Übernommen wird eine Kopie: was du im Match änderst, ändert das Projekt nicht. Verbunden bleiben beide trotzdem, das Match erscheint danach im Projekt.",
  "project.toMatch.creating": "Match wird angelegt …",
  "project.toMatch.description": "Beschreibung",
  "project.toMatch.documentBack": "Doch mitnehmen",
  "project.toMatch.documents": "Dokumente",
  "project.toMatch.documentsDetail": "{count, plural, =0 {Noch nichts hinterlegt} one {Ein Dokument} other {# Dokumente}}",
  "project.toMatch.go": "Match anlegen und öffnen",
  "project.toMatch.nothingYet": "Noch nichts hinterlegt",
  "project.toMatch.openPartial": "Match öffnen",
  "project.toMatch.orphaned": "Das Match ist angelegt, ließ sich aber nicht mit dem Projekt verknüpfen. Du findest es unter MATCH.",
  "project.toMatch.partial": "Das Match ist angelegt und mit dem Projekt verknüpft, aber {missing, select, people {die Personen} documents {die Dokumente} other {die Personen und die Dokumente}} ließen sich nicht übernehmen. Du kannst sie im Match nachtragen.",
  "project.toMatch.people": "Personen",
  "project.toMatch.peopleDetail": "{count, plural, =0 {Noch niemand im Projekt} one {Eine Person aus dem Projekt} other {# Personen aus dem Projekt}}",
  "project.toMatch.peopleDropped": "Bleibt hier",
  "project.toMatch.peopleTaken": "Geht mit",
  "project.toMatch.requirements": "Anforderungen",
  "project.toMatch.requirementsDetail": "{count, plural, =0 {Noch nichts hinterlegt} one {Eine Fachkompetenz} other {# Fachkompetenzen}}",
  "project.toMatch.scorecard": "Power-Scorecard",
  "project.toMatch.scorecardSet": "Gewichtung übernehmen",
  "project.toMatch.sub": "Das Match startet nicht bei null. Wähle, was aus dem Projekt mitgeht.",
  "project.toMatch.takeTitle": "Was mitgeht",
  "project.workspace.activity": "Letzte Aktivität",
  "project.workspace.description": "Beschreibung",
  "project.workspace.descriptionEmpty": "Noch keine Beschreibung.",
  "project.workspace.documents": "Dokumente",
  "project.workspace.metaCreated": "Angelegt am {date} von {person}",
  "project.workspace.metaCreatedForCompany": "Angelegt am {date} für {company} von {person}",
  "project.workspace.overview": "Übersicht",
  "project.workspace.renameLabel": "Projekt umbenennen",
  "project.workspace.typeBadge": "Projekt",
  "project.workspace.untitled": "Unbenanntes Projekt",
  "company.admin.logo.choose": "Unternehmenslogo hochladen",
  "company.admin.logo.saved": "Logo gespeichert.",
  "company.admin.logo.tooLarge": "{name} ist zu groß. Ein Logo darf höchstens {max, number} MB haben.",
  "company.admin.logo.tooManyPixels": "Dieses Bild ist zu groß zum Zuschneiden. Nutze eines unter {max} Megapixel.",
  "company.admin.logo.unreadable": "Diese Datei konnte nicht gelesen werden. Wähle sie noch einmal aus.",
  "company.admin.logo.unsupported": "{name} kann nicht als Logo verwendet werden. Wähle ein PNG-, JPEG-, GIF-, BMP-, TIFF- oder WebP-Bild.",
  "company.admin.members.add": "Zum Unternehmen hinzufügen",
  "company.admin.members.addHint": "Setzt eine bestehende Person auf die Liste. Sie wird nicht vorher gefragt, und gespeichert wird erst beim Speichern.",
  "company.admin.members.addTitle": "Person hinzufügen",
  "company.admin.members.contactPerson": "Ansprechpartner:in",
  "company.admin.members.contactPersonLimit": "Alle {max, number} Ansprechpartner:innen sind markiert. Entferne eine Markierung, um jemand anderen zu markieren.",
  "company.admin.members.noPeople": "Niemand passt, der nicht schon eingetragen ist.",
  "company.admin.members.pendingAdd": "Wird beim Speichern hinzugefügt.",
  "company.admin.members.pendingContact": "Die Markierung als Ansprechpartner:in gilt ab dem Speichern.",
  "company.admin.members.pendingRemove": "Wird beim Speichern entfernt.",
  "company.admin.members.pendingRole": "Die neue Rolle gilt ab dem Speichern.",
  "company.admin.members.remove": "Entfernen",
  "company.admin.members.roleAdmin": "Administration",
  "company.admin.members.roleMember": "Mitglied",
  "company.admin.members.searchPlaceholder": "Personen nach Namen suchen",
  "company.admin.members.searching": "Personen werden gesucht",
  "company.admin.members.soleAdmin": "Die einzige Administration. Mache zuerst jemand anderen zur Administration, um das zu ändern oder zu entfernen.",
  "company.admin.profile.saved": "Gespeichert.",
  "company.admin.status.confirm": "Beim Deaktivieren verschwindet dieses Unternehmen aus beiden Suchen, und seine Posts und Projekte werden eingefroren: sie lassen sich dann weder veröffentlichen noch bearbeiten oder löschen. Gelöscht wird nichts, und beim Reaktivieren ist alles wieder da.",
  "company.admin.status.deactivate": "Unternehmen deaktivieren",
  "company.admin.status.deactivateConfirm": "Deaktivieren",
  "company.admin.status.inactive": "Dieses Unternehmen ist deaktiviert. Es ist aus beiden Suchen verschwunden, und in seinem Namen lässt sich nichts veröffentlichen oder ändern.",
  "company.admin.status.label": "Status des Unternehmens",
  "company.admin.status.reactivate": "Unternehmen reaktivieren",
  "company.context.acting": "Du handelst als {name}.",
  "company.context.actingAsCompanyOnOwnContent": "Dieser Inhalt gehört dir selbst; ihn zu ändern heißt, den Unternehmenskontext zu verlassen. Wähle „Unternehmenskontext verlassen“ und versuche es erneut.",
  "company.context.current": "Du handelst als dieses Unternehmen",
  "company.context.enter": "Als dieses Unternehmen handeln",
  "company.context.enterNamed": "Als {name} handeln",
  "company.context.landmark": "Unternehmenskontext",
  "company.context.leave": "Unternehmenskontext verlassen",
  "company.context.notActingAsCompany": "Dieser Inhalt gehört einem Unternehmen; ihn zu ändern heißt, als dieses Unternehmen zu handeln. Öffne die Unternehmensseite, wähle „Als dieses Unternehmen handeln“ und versuche es erneut.",
  "company.context.scopeAdmin": "Du kannst dieses Unternehmen ansehen und bearbeiten, seine Personen verwalten und in seinem Namen veröffentlichen.",
  "company.context.unsavedBody": "Beim Wechsel des Unternehmenskontexts wird alles auf dem Bildschirm neu geladen. Nicht gespeicherte Änderungen gehen verloren.",
  "company.create.failed": "Das Unternehmen konnte nicht angelegt werden.",
  "company.create.submit": "Unternehmen anlegen",
  "company.inactive.frozen": "Dieses Unternehmen ist inaktiv, seine Inhalte sind deshalb eingefroren. Reaktiviere das Unternehmen, um in seinem Namen etwas zu veröffentlichen oder zu ändern.",
  "company.inactive.frozenReader": "Dieses Unternehmen ist inaktiv, seine Inhalte sind deshalb eingefroren.",
  "company.mine.empty": "Du bist noch bei keinem Unternehmen eingetragen. Eine Administration eines Unternehmens kann dich hinzufügen.",
  "company.mine.emptyWithCreate": "Du bist noch bei keinem Unternehmen eingetragen. Lege eines an, um zu starten.",
  "company.mine.intro": "Die Unternehmen, bei denen du eingetragen bist. Öffne eines, um seine Seite zu sehen.",
  "company.mine.loading": "Deine Unternehmen werden geladen",
  "company.mine.new": "Neues Unternehmen",
  "company.mine.title": "Meine Unternehmen",
  "company.page.about.empty": "Dieses Unternehmen hat sich noch nicht beschrieben.",
  "company.page.about.title": "Über uns",
  "company.page.card.title": "Unternehmenskarte",
  "company.page.competencies.empty": "Noch keine Fachkompetenzen erfasst.",
  "company.page.competencies.noCapability": "Keine Ausprägung",
  "company.page.competencies.title": "Fachkompetenzen",
  "company.page.contacts.hint": "Die von diesem Unternehmen benannten Ansprechpartner:innen. Öffne ein Profil, um Kontakt aufzunehmen.",
  "company.page.contacts.title": "Ansprechpartner:innen",
  "company.page.employeeCount": "{count, plural, one {# Mitarbeitende:r} other {# Mitarbeitende}}",
  "company.page.employeeCount.unit": "{count, plural, one {Mitarbeitende:r} other {Mitarbeitende}}",
  "company.page.employeeCount.unset": "Anzahl",
  "company.page.industry.unset": "Branche nicht angegeben",
  "company.page.loading": "Unternehmen wird geladen",
  "company.page.members.count": "{count, plural, one {# Person} other {# Personen}}",
  "company.page.members.countPartial": "{shown} von {total} Personen angezeigt",
  "company.page.members.empty": "Noch niemand eingetragen.",
  "company.page.members.loadingMore": "Personen werden geladen",
  "company.page.members.showMore": "Weitere Personen anzeigen",
  "company.page.members.title": "Personen",
  "company.page.notFound": "Unternehmen nicht gefunden",
  "company.page.notFoundHint": "Dieses Unternehmen existiert nicht oder ist für dich nicht sichtbar.",
  "company.page.stopEditingUnsavedBody": "Beim Verlassen des Bearbeitungsmodus geht alles verloren, was noch nicht gespeichert ist: das Profil, das Logo und alle hinzugefügten oder entfernten Personen und Fachkompetenzen.",
  "company.page.work.title": "Beiträge und Projekte",
  "company.validation.alreadyExists": "{field} ist bereits vergeben. Wähle einen anderen Wert.",
  "company.validation.formatError": "{field} hat einen unerwarteten Wert. Prüfe die Eingabe und speichere erneut.",
  "company.validation.isMandatory": "{field} ist erforderlich.",
  "companyFilter.heading": "Unternehmens-Filter{count, plural, =0 {} other { · # aktiv}}",
  "cv.color": "Farbe",
  "cv.createFailed": "CV-Anlage fehlgeschlagen.",
  "cv.createTitle": "Lebenslauf erstellen",
  "cv.download": "Download",
  "cv.downloadFailed": "Download fehlgeschlagen.",
  "cv.editTitle": "Lebenslauf bearbeiten",
  "cv.error.nameRequired": "Ein Name ist erforderlich.",
  "cv.field.address": "Ort",
  "cv.field.birthDate": "Geburtstag",
  "cv.field.drivingLicence": "Führerschein",
  "cv.field.email": "E-Mail",
  "cv.field.nationality": "Nationalität",
  "cv.field.phone": "Telefon",
  "cv.field.web": "Web",
  "cv.generator": "CV-Generator",
  "cv.name": "Name",
  "cv.notSignedIn": "Nicht angemeldet?",
  "cv.personal.born": "geb. {date}",
  "cv.personal.licence": "Führerschein {value}",
  "cv.previewTitle": "CV-Vorschau",
  "cv.reallyDelete": "Wirklich löschen",
  "cv.saveCv": "CV Speichern",
  "cv.section.certifications": "Zertifikate",
  "cv.section.education": "Ausbildung",
  "cv.section.experience": "Berufserfahrung",
  "cv.section.expertise": "Fachkompetenzen",
  "cv.section.languages": "Sprachen",
  "cv.section.summary": "Profil",
  "cv.sectionCertifications": "Zertifikate",
  "cv.sectionEducation": "Ausbildung",
  "cv.sectionExperience": "Berufserfahrung",
  "cv.sectionExpertise": "Fachkompetenzen",
  "cv.sectionLanguages": "Sprachen",
  "cv.sectionProfile": "Profil",
  "cv.sections": "Sektionen",
  "cv.sidebarContact": "Kontakt",
  "cv.sliderHeadingSize": "Überschriftgröße",
  "cv.sliderIndentation": "Einrückung",
  "cv.sliderSectionMargin": "Sektionsrand",
  "cv.sliderSpacing": "Abstand",
  "cv.sliderTextSize": "Textgröße",
  "cv.template": "Template",
  "cv.template.comic.tagline": "DER BESTE LEBENSLAUF ALLER ZEITEN!!!",
  "cv.template.contact": "Kontakt",
  "cv.updateFailed": "CV-Update fehlgeschlagen.",
  "cv.variant": "Variante {n}",
  "design.addEntry": "Eintrag hinzufügen",
  "design.apply": "Übernehmen",
  "design.booleanYes": "Ja",
  "design.cardComments": "Kommentare",
  "design.cardRating": "Bewertung",
  "design.cardViews": "Aufrufe",
  "design.chipCommented": "Kommentiert",
  "design.chipCreated": "Erstellt",
  "design.chipInterested": "Interessent",
  "design.chipRated": "Bewertet",
  "design.chipWatched": "Beobachtet",
  "design.chooseLevel": "Stufe wählen.",
  "design.clearValue": "Wert löschen",
  "design.copied": "Kopiert",
  "design.copy": "Kopieren",
  "design.cropPhoto": "Foto zuschneiden",
  "design.cropLogo": "Logo zuschneiden",
  "design.filterPlaceholder": "Tippen zum Filtern …",
  "design.monthPlaceholder": "Monat",
  "design.numberStepperDecrease": "{noun} verringern",
  "design.numberStepperFallbackNoun": "Wert",
  "design.numberStepperIncrease": "{noun} erhöhen",
  "design.removeTask": "Aufgabe entfernen",
  "design.requiredField": "Pflichtfeld",
  "design.selectPlaceholder": "Auswählen …",
  "design.selfAssessmentDone": "Selbstbewertung abgeschlossen",
  "design.shareLink": "Link teilen",
  "design.shareTitle": "Teilen",
  "design.shareWithArrow": "↗ Teilen",
  "design.stepChainFailed": "Fehlgeschlagen",
  "design.stepChainRunning": "Läuft",
  "design.stepChainStateActive": "läuft",
  "design.stepChainStateDone": "erledigt",
  "design.stepChainStateFailed": "fehlgeschlagen",
  "design.stepChainStatePending": "ausstehend",
  "design.stepChainStateSkipped": "übersprungen",
  "design.stillFillIn": "Bitte noch ausfüllen: {fields}",
  "design.yearPlaceholder": "Jahr",
  "design.zoom": "Zoom",
  "documents.nameTooLong": "Der Dokumentname darf höchstens 255 Zeichen lang sein.",
  "error.route.body": "Etwas in dieser Ansicht konnte nicht gelesen werden. Deine Daten sind unverändert. Du kannst zurückgehen und eine andere Seite öffnen.",
  "error.route.reload": "Seite neu laden",
  "error.route.title": "Diese Seite konnte nicht angezeigt werden",
  "grow.answer.leadIn": "Zu deiner Selbsteinschätzung:",
  "grow.answer.growthAreas": "Entwicklungsfelder",
  "grow.answer.example": "Beispiel",
  "grow.answer.situation": "Situation",
  "grow.answer.approach": "Vorgehensweise",
  "grow.answer.outcome": "Ergebnis",
  "grow.answer.assessmentName": "Vertiefende Selbsteinschätzung",
  "grow.answer.saveHint": "Arbeite an deinen Entwicklungsfeldern und speichere dir das Ergebnis in Studio, das dich dabei unterstützt, deine Powers auszubauen und zu meistern.",
  "grow.answer.saveHintIncomplete": "Speichere dir das Ergebnis in Studio, das dich dabei unterstützt, deine Powers auszubauen und zu meistern.",
  "grow.ask.improveAsk": "Wie kann ich {name} entwickeln?",
  "grow.ask.improveBrief": "Zeig mir {examples, plural, one {ein konkretes Beispiel} other {# konkrete Beispiele}} aus meinem Arbeitsalltag, wie ich {name} entwickeln kann, und schließ mit einer kurzen Zusammenfassung ab. Berücksichtige dabei mein Profil und meine Entwicklungsfelder. Antworte auf Deutsch, auch wo mein Profil oder das Referenzwerk in einer anderen Sprache ist.",
  "grow.ask.improveBriefIncomplete": "Zeig mir {examples, plural, one {ein konkretes Beispiel} other {# konkrete Beispiele}} aus meinem Arbeitsalltag, wie ich {name} entwickeln kann, und schließ mit einer kurzen Zusammenfassung ab. Berücksichtige dabei mein Profil. Antworte auf Deutsch, auch wo mein Profil oder das Referenzwerk in einer anderen Sprache ist.",
  "grow.assessment.allAnswered": "Alle Fragen beantwortet",
  "grow.assessment.askAria": "Den Assistenten zu dieser Aussage fragen",
  "grow.assessment.boxAriaLabel": "Zu Frage {index}",
  "grow.assessment.boxTitle": "Frage {index}",
  "grow.assessment.boxTitleAnswered": "Frage {index} · beantwortet",
  "grow.assessment.enterToContinue": "Enter für weiter",
  "grow.assessment.keyboardHint": "Tasten 1–{max} oder ←/→ zum Auswählen",
  "grow.assessment.progress": "Frage {index} / {total} · {answered} beantwortet",
  "grow.assessment.saveFailed": "Konnte nicht speichern.",
  "grow.assessment.skip": "Überspringen",
  "grow.assessment.zoneHint": "↑/↓ wechselt die Zeile (Fragen · Bewertung · Navigation)",
  "grow.assessmentSubtitle": "Bewerte, wie stark jede Aussage auf dich zutrifft.",
  "grow.elementAssessment.askIntro.0": "Ich bewerte gerade die Aussage: „{statement}“. Hilf mir zu verstehen, was sie bedeutet und wie ich sie für mich einschätzen soll.",
  "grow.elementAssessment.askIntro.1": "Hilf mir, diese Aussage zu verstehen: „{statement}“. Was bedeutet sie und wie soll ich sie bewerten?",
  "grow.elementAssessment.askIntro.2": "Ich bin unsicher, wie ich „{statement}“ bewerten soll. Kannst du mir helfen, sie zu deuten und einzuschätzen?",
  "grow.elementAssessment.askIntro.3": "Worauf zielt die Aussage „{statement}“ eigentlich ab, und wie bewerte ich sie für mich?",
  "grow.elementAssessment.askIntro.4": "Führe mich durch die Aussage „{statement}“ und zeig mir, wie ich sie ehrlich bewerte.",
  "grow.elementAssessment.askIntro.5": "Hilf mir, über „{statement}“ nachzudenken – was bedeutet sie und wie schätze ich sie ein?",
  "grow.elementAssessment.askIntro.6": "Wie sollte ich über die Aussage „{statement}“ nachdenken, wenn ich mich selbst bewerte?",
  "grow.elementAssessment.askIntro.7": "Erläutere „{statement}“ und hilf mir zu entscheiden, wie sehr sie auf mich zutrifft.",
  "grow.elementAssessment.askIntro.8": "Ich bewerte „{statement}“. Was bedeutet sie, und wie gehe ich bei der Bewertung am besten vor?",
  "grow.elementAssessment.askIntro.9": "Erkläre „{statement}“ und hilf mir herauszufinden, wie ich sie bewerten soll.",
  "grow.elementAssessment.notSaved": "nicht gespeichert",
  "grow.elementAssessment.savedStatus": "gespeichert",
  "grow.elementAssessment.savingStatus": "speichert…",
  "grow.elementAssessment.statementLabel": "Aussage {index}",
  "grow.elementAssessment.toEvaluation": "Zur Auswertung",
  "grow.elementResult.answeredCount": "{answered}/{total} beantwortet",
  "grow.elementResult.askButton": "Ergebnis besprechen",
  "grow.elementResult.evaluation": "Auswertung",
  "grow.elementResult.fullyAnswered": "Vollständig beantwortet",
  "grow.elementResult.lastEvaluatedOn": "Zuletzt ausgewertet: {date}",
  "grow.elementResult.reassess": "Nochmal bewerten",
  "grow.elementResult.selfAssessmentCompleted": "Alle Aussagen bewertet",
  "grow.elementResult.toPower": "Zur Power",
  "grow.elementResult.toPowerMap": "Zur Power Map",
  "grow.elementResult.unknownElement": "Unbekanntes Element",
  "grow.elementResult.yourScore": "Dein Score",
  "grow.followUp.longTerm": "Zeig mir Ziele für die nächsten 6 bis 12 Monate",
  "grow.followUp.saveStudio": "Speichere das Ergebnis in Studio",
  "grow.followUp.savedStudio": "In Studio gespeichert",
  "grow.games.group.progress": "{done} von {total} Listen fertig",
  "grow.games.groups.top10.description": "Zeig anderen, was du magst, und finde leichter Gemeinsamkeiten. Stell deine Top 10 zusammen – von Filmen bis Musik.",
  "grow.games.groups.top10.title": "Top 10",
  "grow.games.toplist.books.description": "Welche Bücher haben dich am meisten bewegt?",
  "grow.games.toplist.books.title": "Bücher",
  "grow.games.toplist.cities.description": "In welche Städte zieht es dich am meisten?",
  "grow.games.toplist.cities.title": "Reiseziele",
  "grow.games.toplist.dishes.description": "Welche Gerichte isst du am liebsten?",
  "grow.games.toplist.dishes.title": "Gerichte",
  "grow.games.toplist.catalogueTooSmall": "Für dieses Spiel gibt es noch nicht genug Einträge.",
  "grow.games.toplist.hobbies.description": "Womit verbringst du deine freie Zeit am liebsten?",
  "grow.games.toplist.hobbies.title": "Hobbys",
  "grow.games.toplist.movies.description": "Welche Filme liebst du am meisten?",
  "grow.games.toplist.movies.title": "Filme",
  "grow.games.toplist.music.description": "Welche Musikerinnen, Musiker und Bands hörst du am liebsten?",
  "grow.games.toplist.music.title": "Musik",
  "grow.games.toplist.result.again": "Nochmal",
  "grow.games.toplist.result.apply": "Übernehmen",
  "grow.games.toplist.result.discardMessage": "Deine Top {count} wird nicht in dein Profil übernommen.",
  "grow.games.toplist.result.discardTitle": "Rangliste verwerfen?",
  "grow.games.toplist.result.saved": "In deinem Profil gespeichert.",
  "grow.games.toplist.result.title": "Deine Top {count}",
  "grow.games.toplist.result.toProfile": "Zum Profil",
  "grow.games.toplist.series.description": "Welche Serien liebst du am meisten?",
  "grow.games.toplist.series.title": "Serien",
  "grow.games.toplist.sports.description": "Welche Sportarten begeistern dich am meisten?",
  "grow.games.toplist.sports.title": "Sportarten",
  "grow.games.toplist.yearBc": "{year} v. Chr.",
  "grow.games.unknown": "Dieses Spiel gibt es hier nicht.",
  "grow.play.game.kind": "Spiel",
  "profile.sidebars.favorites.empty": "Deine Top-10-Listen erscheinen hier, sobald du sie in Grow · Play gespielt hast.",
  "profile.sidebars.favorites.play": "Spielen",
  "profile.sidebars.favorites.playAgain": "Neu spielen",
  "profile.sidebars.favorites.remove": "{title} entfernen",
  "profile.sidebars.favorites.title": "Meine Top 10",
  "profile.sidebars.favorites.titleOther": "Top 10",
  "grow.mediaKind.podcast": "Podcast",
  "grow.mediaKind.script": "Script",
  "grow.mediaKind.video": "Video",
  "grow.noQuestions": "Für dieses Element sind keine Fragen verfügbar.",
  "grow.notebook.name": "{name} entwickeln · {date} {time}",
  "grow.notebook.definition": "Definition",
  "grow.notebook.summary": "Zusammenfassung",
  "grow.notebook.saveFailed": "Das Notizbuch konnte nicht angelegt werden. Bitte versuche es noch einmal.",
  "grow.notebook.saveUnavailable": "Das Ergebnis konnte von hier aus nicht in Studio gespeichert werden.",
  "grow.notebook.brief": "Schreib die Teile meiner Studio-Notiz zu {name}, die von dir kommen: was das Referenzwerk über {name} sagt, worauf meine Entwicklungsfelder hinauslaufen, {count, plural, one {das eine Beispiel aus deiner Antwort unten in sechs Teilen, ein Ziel für die nächsten 6 bis 12 Monate, ebenfalls in sechs Teilen, einen Satz, warum dieses Beispiel der leichte Einstieg ist} =2 {die zwei Beispiele aus deiner Antwort unten in sechs Teilen, zwei Ziele für die nächsten 6 bis 12 Monate, ebenfalls in sechs Teilen, einen Satz, mit welchem der zwei Beispiele ich anfangen soll und warum es der leichte Einstieg ist} other {die drei Beispiele aus deiner Antwort unten in sechs Teilen, drei Ziele für die nächsten 6 bis 12 Monate, ebenfalls in sechs Teilen, einen Satz, mit welchem der drei Beispiele ich anfangen soll und warum es der leichte Einstieg ist}}, und die Titel der Werke, auf die sich die Notiz stützt. Schreib alles auf Deutsch, auch wo deine Antwort unten, mein Profil oder das Referenzwerk in einer anderen Sprache ist.",
  "grow.notebook.briefIncomplete": "Schreib die Teile meiner Studio-Notiz zu {name}, die von dir kommen: was das Referenzwerk über {name} sagt, {count, plural, one {das eine Beispiel aus deiner Antwort unten in sechs Teilen, ein Ziel für die nächsten 6 bis 12 Monate, ebenfalls in sechs Teilen, einen Satz, warum dieses Beispiel der leichte Einstieg ist} =2 {die zwei Beispiele aus deiner Antwort unten in sechs Teilen, zwei Ziele für die nächsten 6 bis 12 Monate, ebenfalls in sechs Teilen, einen Satz, mit welchem der zwei Beispiele ich anfangen soll und warum es der leichte Einstieg ist} other {die drei Beispiele aus deiner Antwort unten in sechs Teilen, drei Ziele für die nächsten 6 bis 12 Monate, ebenfalls in sechs Teilen, einen Satz, mit welchem der drei Beispiele ich anfangen soll und warum es der leichte Einstieg ist}}, und die Titel der Werke, auf die sich die Notiz stützt. Schreib alles auf Deutsch, auch wo deine Antwort unten, mein Profil oder das Referenzwerk in einer anderen Sprache ist.",
  "grow.notebook.goal": "Langfristiges Ziel",
  "grow.notebook.part.hack": "Der Hack",
  "grow.notebook.part.howTo": "Umsetzung",
  "grow.notebook.part.tools": "Tools",
  "grow.notebook.part.firstStep": "Erster Schritt",
  "grow.notebook.part.result": "Erreichbares Ergebnis",
  "grow.notebook.part.whyItWorks": "Warum der Hack wirkt",
  "grow.notebook.notWritten": "Die ausführlichen Teile dieser Notiz konnten nicht geschrieben werden.",
  "grow.notebook.writing": "Ausführliche Fassung",
  "grow.notebook.sources": "Quellen",
  "grow.play.group.kind": "Fragebogen",
  "grow.play.group.missing": "Dieser Fragebogen ist auf dieser Umgebung nicht verfügbar.",
  "grow.play.quiz.continue": "Weiter mit Teil {index}",
  "grow.play.quiz.eyebrow": "Grow · Play",
  "grow.play.quiz.partAnswered": "beantwortet",
  "grow.play.quiz.partLabel": "Teil {index}",
  "grow.play.quiz.partOpen": "offen",
  "grow.play.quiz.partsProgress": "{answered} von {total} Teilen beantwortet",
  "grow.play.quiz.result.backToParts": "Zurück zu den Teilen",
  "grow.play.quiz.result.empty": "Noch keine Powers vorhanden.",
  "grow.play.quiz.result.error": "Das Ergebnis konnte nicht geladen werden: {message}",
  "grow.play.quiz.result.firstValue": "erster Selbstbewertungs-Wert",
  "grow.play.quiz.result.locked": "Das Ergebnis öffnet sich, sobald alle Teile beantwortet sind.",
  "grow.play.quiz.result.noQuizItems": "vom Quiz nicht abgedeckt",
  "grow.play.quiz.result.openPower": "Diese Power öffnen",
  "grow.play.quiz.result.quizAlone": "Quiz allein: {score}{band, select, none {} other { · {band}}}{items, select, none {} other {, aus {answered} von {total} Items}}.",
  "grow.play.quiz.result.quizOnlySource": "Allein aus dem Quiz{items, select, none {} other {, {answered} von {total} Items}}.",
  "grow.play.quiz.result.subtitle": "Wie die beantworteten Teile deine Powers verschoben haben. Sie zählen in deine Selbstbewertung, gewichtet nach der Anzahl ihrer Items.",
  "grow.play.quiz.result.title": "Dein Ergebnis",
  "grow.play.quiz.result.unchanged": "unverändert",
  "grow.play.quiz.showResult": "Ergebnis anzeigen",
  "grow.play.quiz.start": "Quiz starten",
  "grow.assess.all": "Alle",
  "grow.assess.analyseDocuments": "Dokumente analysieren",
  "grow.assess.choose": "Schau genauer hin",
  "grow.assess.completed": "Abgeschlossen",
  "grow.assess.continue": "Fragebogen fortsetzen",
  "grow.assess.documentsCount": "{count, plural, one {# Dokument analysiert} other {# Dokumente analysiert}}",
  "grow.assess.documentsError": "Analysierte Dokumente konnten nicht geladen werden.",
  "grow.assess.documentsLoading": "Analysierte Dokumente werden geladen",
  "grow.assess.documentInsights": "Erkenntnisse aus Dokumenten",
  "grow.assess.guided": "Geführter Fragebogen",
  "grow.assess.inProgress": "In Bearbeitung",
  "grow.assess.intro": "Lerne deine <concept>Powers</concept> mit Fragebögen, Selbsteinschätzungen und Dokumentanalysen kennen. Wähle, wo du starten oder weitermachen möchtest.",
  "grow.assess.loadError": "Die Bewertungen konnten nicht geladen werden.",
  "grow.assess.noMatches": "Keine Bewertungen passen zu diesem Filter.",
  "grow.assess.notStarted": "Nicht begonnen",
  "grow.assess.partsProgress": "{done} / {total} {total, plural, one {Teil} other {Teile}}",
  "grow.assess.powerJourney": "Power Journey",
  "grow.assess.powersMeasured": "Powers mit Wert",
  "grow.assess.progress": "Dein Fortschritt",
  "grow.assess.selfAssessmentKind": "Selbstbewertung",
  "grow.assess.smartAnalysisDocuments": "Smart Analyse Dokumente",
  "grow.assess.smartDescription": "Die KI liest Dokumente, die dich beschreiben, und analysiert, wie stark deine Powers sind.",
  "grow.assess.review": "Fragebogen ansehen",
  "grow.assess.start": "Fragebogen starten",
  "grow.assess.title": "Verstehe dein Power-Profil",
  "grow.assess.tour": "Wähle einen Fragebogen oder eine Power zur Bewertung.",
  "grow.assess.tourFeatured": "Öffne diesen Fragebogen, um ihn zu beantworten oder fortzusetzen.",
  "grow.assess.uploadDocuments": "Dokumente hochladen",
  "grow.roleplay.backToPlay": "Zurück zu Play",
  "grow.roleplay.bars.mark": "Die Linie markiert {percent} %.",
  "grow.roleplay.bars.pending": "wird aktualisiert",
  "grow.roleplay.bars.percent": "{percent} %",
  "grow.roleplay.bars.reached": "genug Aussagen beantwortet",
  "grow.roleplay.bars.statementAnswered": "beantwortet",
  "grow.roleplay.bars.statements": "Fragen aus dem Fragebogen",
  "grow.roleplay.bars.statementsToggle": "Fragen aus dem Fragebogen",
  "grow.roleplay.bars.title": "Fortschritt",
  "grow.roleplay.card.continue": "Weiterspielen",
  "grow.roleplay.card.description": "Spiele die Geschichte im Flugzeug. Deine Powers wählst du, bevor die Geschichte beginnt.",
  "grow.roleplay.card.expires": "Dein offenes Spiel läuft am {date} ab",
  "grow.roleplay.card.eyebrow": "Eine Geschichte spielen",
  "grow.roleplay.card.loadError": "Das Rollenspiel konnte nicht geladen werden.",
  "grow.roleplay.card.start": "Spielen",
  "grow.roleplay.dialog.replaceNotice": "Ein neues Spiel verwirft dein unfertiges Spiel.",
  "grow.roleplay.dialog.resumeTitle": "Dein unfertiges Spiel",
  "grow.roleplay.dialog.scenariosTitle": "Szenarien",
  "grow.roleplay.cast.changed": "Neu bei den Figuren: {names}",
  "grow.roleplay.cast.empty": "Du hast noch niemanden kennengelernt.",
  "grow.roleplay.cast.heardOf": "vom Hörensagen",
  "grow.roleplay.cast.items": "Gegenstände: {items}",
  "grow.roleplay.cast.itemsMoreUnknown": "Gegenstände: {items}, weitere: unbekannt",
  "grow.roleplay.cast.itemsNone": "Trägt nichts bei sich",
  "grow.roleplay.cast.itemsUnknown": "Gegenstände: unbekannt",
  "grow.roleplay.cast.new": "neu",
  "grow.roleplay.cast.shownMood": "Wirkt {mood}",
  "grow.roleplay.cast.title": "Figuren",
  "grow.roleplay.cast.unavailable": "nicht mehr verfügbar",
  "grow.roleplay.category.container": "Behälter",
  "grow.roleplay.category.device": "Gerät",
  "grow.roleplay.category.drink": "Getränk",
  "grow.roleplay.category.food": "Essen",
  "grow.roleplay.category.other": "Sonstiges",
  "grow.roleplay.category.tool": "Werkzeug",
  "grow.roleplay.closed": "Dieses Spiel ist geschlossen.",
  "grow.roleplay.condition.foodPoisoning": "Lebensmittelvergiftung",
  "grow.roleplay.condition.unknown": "Beeinträchtigt",
  "grow.roleplay.conditions.title": "Dein Zustand",
  "grow.roleplay.end.abandoned": "Dieses Spiel wurde durch einen Neustart ersetzt.",
  "grow.roleplay.end.evaluating": "Die Auswertung läuft …",
  "grow.roleplay.end.notCounted": "Zu wenig Hinweise für einen Wert",
  "grow.roleplay.end.scores": "Deine Power-Werte",
  "grow.roleplay.expired": "Dieses Spiel ist abgelaufen, weil es zu lange nicht gespielt wurde.",
  "grow.roleplay.fact.age": "Alter",
  "grow.roleplay.fact.hobby": "Hobby",
  "grow.roleplay.fact.mood": "Stimmung",
  "grow.roleplay.fact.name": "Name",
  "grow.roleplay.fact.profession": "Beruf",
  "grow.roleplay.fact.relationship": "Beziehung zu dir",
  "grow.roleplay.fact.trait": "Eigenschaft",
  "grow.roleplay.fact.unknown": "Angabe",
  "grow.roleplay.freshness.normal": "frisch",
  "grow.roleplay.freshness.questionable": "fragwürdig",
  "grow.roleplay.freshness.spoiled": "verdorben",
  "grow.roleplay.goals.added": "{count, plural, one {Neues Ziel: {goals}} other {Neue Ziele: {goals}}}",
  "grow.roleplay.goals.changed": "Deine Ziele haben sich geändert.",
  "grow.roleplay.goals.new": "neu",
  "grow.roleplay.goals.or": "oder",
  "grow.roleplay.goals.reached": "erreicht",
  "grow.roleplay.goals.title": "Ziele",
  "grow.roleplay.goals.unreachable": "nicht mehr möglich",
  "grow.roleplay.input.counter": "{count} / {max} Zeichen",
  "grow.roleplay.input.label": "Was tust du?",
  "grow.roleplay.input.placeholder": "Beschreibe, wie du dich fühlst, was du denkst und was du tust, und warum.",
  "grow.roleplay.input.pickFirst": "Wähle bei einer Handlungsmöglichkeit aus, wie du sie umsetzt. Im Feld kannst du dann beschreiben, wie und warum du es tust und wie es dir dabei geht.",
  "grow.roleplay.input.poles": "Mögliche Handlungsmöglichkeiten",
  "grow.roleplay.input.send": "Senden",
  "grow.roleplay.input.templateInserted": "Der Anfang deines Zugs steht jetzt im Feld.",
  "grow.roleplay.input.tooLong": "Höchstens {max} Zeichen.",
  "grow.roleplay.intro.back": "Zurück",
  "grow.roleplay.intro.cast": "Hier stehen alle, die du triffst oder von denen du hörst. Anfangs weißt du wenig über sie. Indem du mit ihnen sprichst und sie beobachtest, erfährst du ihren Namen, ihre Stimmung, ihre Beziehung zu dir und was sie bei sich tragen. Wie jemand wirkt, muss nicht heißen, dass es ihm auch so geht.",
  "grow.roleplay.intro.castEmpty": "Noch hast du niemanden kennengelernt, aber das ändert sich im Lauf der Geschichte.",
  "grow.roleplay.intro.example.heardPlaceholder": "der Mann aus Reihe 12",
  "grow.roleplay.intro.example.knifeDescription": "Lässt sich immer wieder benutzen, rostet aber mit der Zeit und wird durch Gebrauch stumpf.",
  "grow.roleplay.intro.example.knifeName": "Taschenmesser",
  "grow.roleplay.intro.example.metAge": "etwa 30",
  "grow.roleplay.intro.example.metItem": "Wasserflasche",
  "grow.roleplay.intro.example.metMood": "freundlich",
  "grow.roleplay.intro.example.metName": "Lena",
  "grow.roleplay.intro.example.metPlaceholder": "die Frau am Gang",
  "grow.roleplay.intro.example.metProfession": "Krankenpflegerin",
  "grow.roleplay.intro.example.metRelationship": "freundlich gesinnt",
  "grow.roleplay.intro.example.phoneDescription": "Jede Nutzung kostet Akku. Wo es Strom gibt, kannst du es wieder aufladen.",
  "grow.roleplay.intro.example.phoneName": "Smartphone",
  "grow.roleplay.intro.example.plasterDescription": "Klebt nur einmal.",
  "grow.roleplay.intro.example.plasterName": "Pflaster",
  "grow.roleplay.intro.example.rollDescription": "Lag zu lange vergessen in deiner Tasche.",
  "grow.roleplay.intro.example.rollName": "Belegtes Brötchen",
  "grow.roleplay.intro.exampleLabel": "Beispiel",
  "grow.roleplay.intro.goals": "Oben stehen deine zwei großen Ziele für den ganzen Flug. Erreichst du eines davon, ist das Spiel zu Ende. Die kleineren Ziele darunter helfen dir bei der Orientierung. Je nachdem, was du tust und sagst, kommen Ziele hinzu, werden erreicht oder fallen weg.",
  "grow.roleplay.intro.inventory.lead": "So könnte dein Inventar aussehen. Hier steht alles, was du bei dir trägst. Je nach Art hat ein Gegenstand einen Zustand:",
  "grow.roleplay.intro.inventory.state1": "Lebensmittel sind frisch, fragwürdig oder verdorben.",
  "grow.roleplay.intro.inventory.state2": "Ein Gerät hat einen Akku, den du aufladen kannst, wo es Strom gibt.",
  "grow.roleplay.intro.inventory.state3": "Manches kannst du nur noch ein paar Mal benutzen.",
  "grow.roleplay.intro.inventory.state4": "Anderes nutzt sich durch Gebrauch und mit der Zeit ab, von gut über abgenutzt bis kaputt. Kaputt kannst du es nicht mehr benutzen.",
  "grow.roleplay.intro.inventory.way1": "Manche hast du von Anfang an.",
  "grow.roleplay.intro.inventory.way2": "Andere gibt dir eine Figur.",
  "grow.roleplay.intro.inventory.way3": "Manche nimmst du dir selbst.",
  "grow.roleplay.intro.inventory.way4": "Du kannst einer Figur auch etwas wegnehmen. Das bleibt allerdings selten ohne Folgen.",
  "grow.roleplay.intro.inventory.waysLead": "Gegenstände bekommst du auf vier Wegen:",
  "grow.roleplay.intro.inventoryEmpty": "Dein eigenes Inventar ist noch leer, aber das kann sich im Lauf der Geschichte ändern.",
  "grow.roleplay.intro.progress": "Unsere KI wertet deine Antworten aus. Die Balken zeigen für jede gewählte Power, wie viele Fragen deine Antworten schon abgedeckt haben. Powers mit genügend Hinweisen bekommen nach der Geschichte einen Wert in deiner Smart Analyse.",
  "grow.roleplay.intro.situation": "Das ist deine Situation. Lies in Ruhe, wo du bist und wer um dich herum ist.",
  "grow.roleplay.intro.situationTelling": "Deine Situation wird gerade erzählt …",
  "grow.roleplay.intro.start": "Los geht's",
  "grow.roleplay.intro.toCast": "Zu den Figuren",
  "grow.roleplay.intro.toGoals": "Zu den Zielen",
  "grow.roleplay.intro.toInventory": "Zum Inventar",
  "grow.roleplay.intro.toProgress": "Zum Fortschritt",
  "grow.roleplay.intro.toSituation": "Zur Situation",
  "grow.roleplay.intro.toSuggestions": "Zu den Handlungsmöglichkeiten",
  "grow.roleplay.intro.toTurn": "Zu deinem Zug",
  "grow.roleplay.intro.turn": "Vor jeder Entscheidung siehst du {count, plural, one {eine Handlungsmöglichkeit} =2 {zwei Handlungsmöglichkeiten} other {# Handlungsmöglichkeiten}}, wie es in der Geschichte weitergehen kann. {count, plural, one {Sie ist nur ein Vorschlag} other {Sie sind nur Vorschläge}} zur Orientierung: Du bist nicht an sie gebunden und kannst tun, was du möchtest. Beschreib im Feld, wie du dich in der Situation fühlst, was du denkst und was du tust, und jeweils warum.",
  "grow.roleplay.intro.turnKeys": "Deinen Zug schickst du mit „Senden“ ab.",
  "grow.roleplay.intro.turnNoPoles": "Vor jeder Entscheidung beschreibst du im Feld, wie du dich in der Situation fühlst, was du denkst und was du tust, und jeweils warum.",
  "grow.roleplay.intro.turnOptions": "Vor jeder Entscheidung siehst du Handlungsmöglichkeiten. Wähl eine aus und dann, wie du sie umsetzt; das schreibt den Anfang deines Zugs ins Feld. „Zurück“ bei den Handlungsmöglichkeiten nimmt deine Wahl zurück. Im Feld beschreibst du, wie und warum du es tust und wie es dir dabei geht.",
  "grow.roleplay.intro.turnTry": "Probier es aus: Öffne eine Handlungsmöglichkeit und wähl, wie du sie umsetzt.",
  "grow.roleplay.intro.welcome": "{named, select, yes {Hey {name},} other {Hey,}} das ist das Rollenspiel von Grow. In dieser Geschichte im Flugzeug entscheidest du, was du tust und sagst. Deine Powers hast du vor Beginn gewählt.",
  "grow.roleplay.inventory.battery": "Akku {percent} %",
  "grow.roleplay.inventory.changed": "Neu in deinem Inventar: {items}",
  "grow.roleplay.inventory.charge": "Ladung {charge}",
  "grow.roleplay.inventory.empty": "Du trägst nichts bei dir.",
  "grow.roleplay.inventory.new": "neu",
  "grow.roleplay.inventory.title": "Inventar",
  "grow.roleplay.inventory.usesLeft": "{count, plural, one {einmal verwendbar} other {# Mal verwendbar}}",
  "grow.roleplay.newGame": "Neues Spiel starten",
  "grow.roleplay.scenario.plane.title": "Das schreiende Baby",
  "grow.roleplay.notYetAvailable": "noch nicht verfügbar",
  "grow.roleplay.notice.checkFailed": "Wir konnten nicht prüfen, ob dein Zug angekommen ist.",
  "grow.roleplay.notice.notResponding": "Der Server antwortet nicht. Wir konnten nicht prüfen, ob dein Zug angekommen ist.",
  "grow.roleplay.notice.movedOn": "Das Spiel ist inzwischen weitergegangen. Dein Text ist noch da.",
  "grow.roleplay.notice.narrationFailed": "Die Geschichte stockt gerade.",
  "grow.roleplay.notice.narratorFailed": "Die Geschichte konnte nicht weitergehen. Versuch es bitte noch einmal.",
  "grow.roleplay.notice.narratorRefused": "Die Geschichte konnte so nicht weitergehen. Beschreib deinen Zug bitte etwas anders.",
  "grow.roleplay.notice.notFound": "Dieses Spiel gibt es nicht, oder es gehört nicht dir.",
  "grow.roleplay.notice.notPlayable": "Dieses Spiel kann gerade nicht gespielt werden.",
  "grow.roleplay.notice.notStored": "Dein Zug wurde nicht gespeichert. Schick ihn bitte noch einmal.",
  "grow.roleplay.notice.notSupported": "Das Rollenspiel ist hier noch nicht verfügbar.",
  "grow.roleplay.notice.suspended": "Dieses Spiel ist vorübergehend nicht verfügbar.",
  "grow.roleplay.notice.textRequired": "Ein Zug braucht deinen Text. Schreib ins Feld, wie du dich fühlst, was du denkst und was du tust.",
  "grow.roleplay.notice.unavailable": "Das Spiel ist gerade nicht erreichbar. Versuch es bitte später noch einmal.",
  "grow.roleplay.notice.updateNeeded": "Diese Seite ist veraltet. Bitte lade sie neu.",
  "grow.roleplay.options.back": "Zurück",
  "grow.roleplay.options.label": "Handlungsmöglichkeiten",
  "grow.roleplay.planeGame.title": "Das schreiende Baby",
  "grow.roleplay.powers.add": "Power hinzufügen",
  "grow.roleplay.powers.beginStory": "Geschichte beginnen",
  "grow.roleplay.powers.chooseOne": "Wähle mindestens eine Power, um die Geschichte zu beginnen.",
  "grow.roleplay.powers.chosen": "Deine Powers ({count} von {max})",
  "grow.roleplay.powers.deselect": "{name} abwählen",
  "grow.roleplay.powers.failed": "Die Powers konnten nicht geändert werden. Bitte versuch es noch einmal.",
  "grow.roleplay.powers.loadFailed": "Die Power-Auswahl konnte nicht geladen werden.",
  "grow.roleplay.powers.others": "Alle Powers",
  "grow.roleplay.powers.remove": "Entfernen",
  "grow.roleplay.powers.setupTitle": "Wähle deine Powers",
  "grow.roleplay.powers.startFailed": "Die Geschichte konnte nicht gestartet werden. Versuch es noch einmal.",
  "grow.roleplay.reload": "Neu laden",
  "grow.roleplay.restart.button": "Neu starten",
  "grow.roleplay.restart.confirmMessage": "Dein Fortschritt in diesem Spiel geht verloren. Werte aus früheren Spielen bleiben.",
  "grow.roleplay.restart.finishedMessage": "Dein abgeschlossenes Ergebnis bleibt gespeichert. Du spielst diese Geschichte noch einmal von Anfang an.",
  "grow.roleplay.restart.evaluatingMessage": "Die Auswertung läuft. Neu starten kannst du, sobald sie fertig ist.",
  "grow.roleplay.restart.unavailableMessage": "Dieses Spiel lässt sich nicht mehr neu starten.",
  "grow.roleplay.restart.confirmTitle": "Dieses Spiel neu starten?",
  "grow.roleplay.story.checking": "Wir prüfen, wo die Geschichte steht …",
  "grow.roleplay.story.clock": "Zeit in der Geschichte",
  "grow.roleplay.story.begins": "Die Geschichte beginnt …",
  "grow.roleplay.story.goesOn": "Die Geschichte geht weiter …",
  "grow.roleplay.story.label": "Geschichte",
  "grow.roleplay.story.truncated": "Frühere Teile der Geschichte werden nicht mehr angezeigt.",
  "grow.roleplay.story.unsent": "Nicht gespeichert",
  "grow.roleplay.story.turn": "Zug {n}",
  "grow.roleplay.story.turnNewName": "Zug {n}, neu",
  "grow.roleplay.story.new": "Neu",
  "grow.roleplay.story.move": "„{text}“",
  "grow.roleplay.story.updatingBars": "Dein Fortschritt wird aktualisiert …",
  "grow.roleplay.tour.skip": "Tour überspringen",
  "grow.roleplay.title": "Rollenspiel",
  "grow.roleplay.wear.broken": "kaputt",
  "grow.roleplay.wear.good": "gut",
  "grow.roleplay.wear.worn": "abgenutzt",
  "grow.powerDetail.askButton": "{name} verstehen",
  "grow.powerDetail.askImproveButton": "Wie verbessere ich {name}?",
  "grow.powerDetail.askIntro.0": "Gib mir anhand des Referenzmaterials eine Einführung zu {name} und erzähl mir mehr darüber.",
  "grow.powerDetail.askIntro.1": "Stell mir {name} anhand des Referenzmaterials vor – worum geht es dabei?",
  "grow.powerDetail.askIntro.2": "Erkläre mir {name} auf Basis des Referenzmaterials.",
  "grow.powerDetail.askIntro.3": "Was sagt das Referenzmaterial über {name}? Gib mir einen Überblick.",
  "grow.powerDetail.askIntro.4": "Gib mir eine leicht verständliche Einführung zu {name}, gestützt auf das Referenzmaterial.",
  "grow.powerDetail.askIntro.5": "Führe mich anhand des Referenzmaterials durch {name}.",
  "grow.powerDetail.askIntro.6": "Fasse aus dem Referenzmaterial zusammen, was {name} ist und warum es wichtig ist.",
  "grow.powerDetail.askIntro.7": "Hilf mir, {name} zu verstehen – nutze das Referenzmaterial für eine Einführung.",
  "grow.powerDetail.askIntro.8": "Erkläre mir {name} aus dem Referenzmaterial, als wäre ich neu darin.",
  "grow.powerDetail.askIntro.9": "Was sollte ich laut Referenzmaterial über {name} wissen?",
  "grow.powerDetail.confidence": "Konfidenz: {percent}%",
  "grow.powerDetail.combinedScore": "Dein kombinierter Power-Wert",
  "grow.powerDetail.continueSelfAssessment": "Vertiefende Selbsteinschätzung fortsetzen",
  "grow.powerDetail.evidenceTitle": "Belege",
  "grow.powerDetail.eyebrow": "Power · {abbr}",
  "grow.powerDetail.noAnalysis": "Noch keine Analyse",
  "grow.powerDetail.noScore": "Noch kein Power-Wert",
  "grow.powerDetail.noScoreHint": "Bewerte Aussagen zu dieser Power oder analysiere deine Arbeitsdokumente.",
  "grow.powerDetail.noScoreHintNoUpload": "Bewerte Aussagen zu dieser Power, um zu beginnen.",
  "grow.powerDetail.notStarted": "Vertiefung nicht begonnen",
  "grow.powerDetail.openDocumentNamed": "Dokument {name} öffnen",
  "grow.powerDetail.page": "Seite {number}",
  "grow.powerDetail.loadError": "Dein Power-Ergebnis konnte nicht geladen werden.",
  "grow.powerDetail.rationaleNoConfidence": "Die gefundenen Belege reichen für eine verlässliche Bewertung dieser Power nicht aus.",
  "grow.powerDetail.rationaleNoEvidence": "In deinen Dokumenten wurden keine Belege für diese Power gefunden.",
  "grow.powerDetail.rationaleScoringFailed": "Diese Power konnte nicht analysiert werden. Starte die Analyse noch einmal.",
  "grow.powerDetail.repeatSelfAssessment": "Vertiefende Selbsteinschätzung ansehen",
  "grow.powerDetail.selfAssessment": "Selbstbewertung",
  "grow.powerDetail.smartAnalysis": "Smart Analyse",
  "grow.powerDetail.stanceContra": "Contra",
  "grow.powerDetail.stancePro": "Pro",
  "grow.powerDetail.startSelfAssessment": "Vertiefende Selbsteinschätzung starten",
  "grow.powerDetail.tour.label": "Grow Power",
  "grow.powerDetail.tour.summaryStatus": "Du hast {answered} von {total} vertiefenden Aussagen bewertet.",
  "grow.powerDetail.whatSmartFound": "Was Smart Analyse gefunden hat",
  "grow.powerDetail.yourScore": "Dein Power-Wert",
  "grow.powerLibrary.all": "Alle",
  "grow.powerLibrary.askButton": "Meine Powers verstehen",
  "grow.powerLibrary.askIntro.0": "Lies meine Power Map – wo liegen meine Stärken und Lücken, und worauf sollte ich mich konzentrieren?",
  "grow.powerLibrary.askIntro.1": "Gib mir einen Überblick über meine Powers: was stark ist, was schwach, und wo ich wachsen kann.",
  "grow.powerLibrary.askIntro.2": "Deute mein Power-Profil – die Höhen, die Tiefen und einen Fokusvorschlag.",
  "grow.powerLibrary.askIntro.3": "Welche Muster siehst du auf Basis meiner Powers und des Referenzmaterials?",
  "grow.powerLibrary.askIntro.4": "Hilf mir, mein gesamtes Power-Profil zu verstehen und wo ich investieren sollte.",
  "grow.powerLibrary.askIntro.5": "Was sagen meine stärksten und schwächsten Powers über mich aus?",
  "grow.powerLibrary.askIntro.6": "Fasse meine Power-Landschaft zusammen und empfiehl einen Wachstumsfokus.",
  "grow.powerLibrary.askIntro.7": "Wo liegen meine größten Chancen über alle Powers hinweg?",
  "grow.powerLibrary.askIntro.8": "Führe mich durch meine Power Map und schlag vor, woran ich zuerst arbeite.",
  "grow.powerLibrary.askIntro.9": "Gib mir einen Gesamtüberblick über meine Powers und einen Startpunkt.",
  "grow.powerLibrary.clearSearch": "Suche leeren",
  "grow.powerLibrary.heading": "{count} Powers",
  "grow.powerLibrary.journeyTooltip": "Der ganze Weg: Aussage für Aussage entsteht ein sehr genaues, stabiles Bild. Unterwegs lernst du dich kennen.",
  "grow.powerLibrary.noResults": "Keine Power gefunden für „{query}\".",
  "grow.powerLibrary.onlyUnrated": "Unbewertete",
  "grow.powerLibrary.openPower": "{name} öffnen",
  "grow.powerLibrary.powerQuizTooltip": "Verschafft dir mit wenigen Fragen einen echten Überblick über alle {count} Powers.",
  "grow.powerLibrary.powerScore": "Power Score",
  "grow.powerLibrary.quizUnavailable": "noch nicht verfügbar",
  "grow.powerLibrary.searchPlaceholder": "Suchen nach Name oder Kürzel",
  "grow.powerLibrary.sourceCombined": "Kombiniert",
  "grow.powerLibrary.sourceSelf": "Selbstbewertung",
  "grow.powerLibrary.sourceSmart": "Smart Analyse",
  "grow.powerLibrary.subheading": "Das vollständige Vokabular: {clusters} Cluster, {powers} Powers.",
  "grow.powerLibrary.tour.filters.desc": "Suche Powers nach Name oder Kürzel, oder tippe auf Unbewertet, um nur die {unrated} Powers zu sehen, deren Aussagen noch offen sind.",
  "grow.powerLibrary.tour.filters.title": "Suchen & Filtern",
  "grow.powerLibrary.tour.grid.desc": "Alle {total} Powers, gruppiert in {clusters} Cluster. Klicke eine Kachel, um die Power zu öffnen. Medaille und Bild erscheinen, sobald alle ihre Aussagen bewertet sind; {completed} bisher geschafft.",
  "grow.powerLibrary.tour.grid.title": "Die Power-Kacheln",
  "grow.powerLibrary.tour.label": "Grow Map",
  "grow.powerLibrary.tour.scoreSource.desc": "Stelle um, welche Bewertung die Zahlen auf allen Kacheln zeigen. Wähle Selbstbewertung, um die Werte aus deinen eigenen Bewertungen zu sehen.",
  "grow.powerLibrary.tour.scoreSource.title": "Bewertungsquelle",
  "grow.powerLibrary.tour.summary": "Das ist die Power Map: alle {total} Powers im Periodensystem-Stil. {completed} von {total} hast du bisher vollständig selbst eingeschätzt.",
  "grow.powerProfilePdf.basedOn": "Einschätzung auf Basis: {source}",
  "grow.powerProfilePdf.coverage": "{source}: {measured}/{total}",
  "grow.powerProfilePdf.details": "Power-Details",
  "grow.powerProfilePdf.download": "PDF herunterladen",
  "grow.powerProfilePdf.downloadFailed": "Download fehlgeschlagen.",
  "grow.powerProfilePdf.exportTitle": "Power-Profil exportieren",
  "grow.powerProfilePdf.fileNamePrefix": "Power-Profil",
  "grow.powerProfilePdf.footer": "Power-Niveaus (0–100) beschreiben dein aktuelles Power-Profil: Selbstbewertung aus deinen eigenen Antworten, Smart Analyse als KI-Auswertung deiner Dokumente, Kombiniert als Mittel aus beiden. Grundlage: Power Matrix v26.2. Kein validierter Eignungstest.",
  "grow.powerProfilePdf.map": "Power Map",
  "grow.powerProfilePdf.notMeasured": "nicht erhoben",
  "grow.powerProfilePdf.previewTitle": "Vorschau Power-Profil-PDF",
  "grow.powerProfilePdf.sections": "Abschnitte",
  "grow.powerProfilePdf.sources": "Quellen",
  "grow.powerProfilePdf.sourceShort.combined": "Komb.",
  "grow.powerProfilePdf.sourceShort.self": "Selbst",
  "grow.powerProfilePdf.sourceShort.smart": "Smart",
  "grow.powerProfilePdf.title": "Power-Profil",
  "grow.powerQuestionnaires.answer": "Beantworten",
  "grow.powerQuestionnaires.completed": "abgeschlossen",
  "grow.powerQuestionnaires.empty": "Noch keine Fragebögen zu „{powerName}“ hinterlegt.",
  "grow.powerQuestionnaires.heading": "Fragebögen",
  "grow.powerQuestionnaires.loading": "lädt…",
  "grow.powerQuestionnaires.repeat": "Wiederholen",
  "grow.questionnaire.eyebrow": "Grow · Fragebogen",
  "grow.questionnaire.fallbackName": "Fragebogen",
  "grow.questionnaire.noQuestions": "Keine Fragen in diesem Fragebogen.",
  "grow.questionnaire.questionLabel": "Frage {position}",
  "grow.questionnaire.submit": "Absenden",
  "grow.questionnaire.unknownElement": "Unbekanntes Element",
  "grow.title": "Wachsen",
  "grow.unknownElement": "Unbekanntes Element",
  "grow.watch.contentCount": "{count} Inhalte",
  "grow.watch.emptyContent": "Noch keine Inhalte hinterlegt. Sobald Videos, Podcasts oder Scripts vorliegen, erscheinen sie hier.",
  "grow.watch.filterAll": "Alle",
  "grow.watch.intro": "Inhalte zum Konsumieren rund um deine Powers: Videos, Podcasts und Scripts. Setze dich hin, schau zu, hör rein und lies nach.",
  "grow.watch.loadingContent": "Inhalte werden geladen …",
  "grow.watch.title": "Watch",
  "grow.watch.tour.content.desc": "{count} Inhalte, jeweils mit Power und Cluster markiert. Klicke eine Karte, um den Inhalt anzusehen.",
  "grow.watch.tour.content.emptyDesc": "Noch sind keine Inhalte verfügbar. Sobald es Videos, Podcasts oder Skripte gibt, erscheinen sie hier als Karten zum Öffnen.",
  "grow.watch.tour.content.title": "Der Katalog",
  "grow.watch.tour.emptySummary": "Das ist Watch: Lerninhalte rund um deine Powers als Videos, Podcasts und Skripte. Im Moment ist hier noch nichts.",
  "grow.watch.tour.filters.desc": "Grenze den Katalog nach Format ein (Videos, Podcasts oder Skripte), oder wähle Alle für alles.",
  "grow.watch.tour.filters.title": "Inhalts-Filter",
  "grow.watch.tour.label": "Grow Watch",
  "grow.watch.tour.summary": "Das ist Watch: Lerninhalte rund um deine Powers als Videos, Podcasts und Skripte. Im Moment gibt es hier {count} Inhalte.",
  "home.allAssessmentsDone": "alle Aussagen bewertet",
  "home.allMatches": "Alle Matches ↗",
  "home.candidatesCount": "{count, plural, one {# Kandidat} other {# Kandidaten}}",
  "home.carouselNext": "Weiter",
  "home.carouselPrevious": "Zurück",
  "home.carouselSlide": "Folie {number}",
  "home.certificate": "Zertifikat",
  "home.communitiesSub": "{count, plural, one {# Community} other {# Communities}}",
  "home.community": "Community",
  "home.contacts": "Kontakte",
  "home.continueQuiz": "Quiz fortsetzen",
  "home.documents": "Dokumente",
  "home.education": "Bildung",
  "home.entries": "Einträge",
  "home.greeting": "Schön, dass du da bist.",
  "home.inComparison": "Im Vergleich · Community",
  "home.lastVisitor": "zuletzt: {name}",
  "home.myPosts": "Meine Beiträge ↗",
  "home.noCommunity": "Noch keine Community.",
  "home.noContacts": "noch keine Kontakte",
  "home.noMatches": "Keine Matches",
  "home.noOwnPosts": "Noch keine eigenen Beiträge",
  "home.noOwnPostsHint": "erstelle ein Projekt oder einen Post",
  "home.noQuizYet": "noch kein Quiz verfügbar",
  "home.noVisitsYet": "noch keine Besuche",
  "home.notRatedYet": "noch nicht bewertet",
  "home.openProfileOf": "{name} öffnen",
  "home.profile": "Profil",
  "home.profileEmpty": "noch nichts erfasst",
  "home.profileFallback": "Profil",
  "home.profileVisitors": "Profilbesucher",
  "home.ratePowers": "Powers bewerten",
  "home.reviewQuiz": "Quiz ansehen",
  "home.roomToGrow": "Ausbaufähig",
  "home.service": "Dokumente",
  "home.serviceEmpty": "noch nichts abgelegt",
  "home.strengths": "Stärken",
  "home.tour.grow.desc": "Wie weit Power Quiz und Power Journey sind, deine stärksten Powers und was als Nächstes offen ist.",
  "home.tour.grow.title": "Grow",
  "home.tour.label": "Hauptseite",
  "home.tour.match.desc": "Deine Matches. Klicke eines an, um dort weiterzumachen, wo du warst.",
  "home.tour.match.title": "Match",
  "home.tour.save.desc": "Deine Profil-Einträge, Dokumente, Kontakte und Pins, mit Schnellaktionen zum Anlegen.",
  "home.tour.save.title": "Save",
  "home.tour.share.desc": "Deine Beiträge und Projekte und was rund um sie passiert.",
  "home.tour.share.title": "Share",
  "home.tour.summary": "Das ist die Hauptseite: die wichtigsten Zahlen aus allen Bereichen auf einen Blick. Jede Kachel führt zu ihrer Stelle in der App.",
  "home.unnamedMatch": "Unbenanntes Match",
  "home.upNext": "Als Nächstes",
  "home.upNextFirst": "als nächstes: {name}",
  "home.uploadFile": "Datei hochladen",
  "home.viewAll": "Alle ansehen ↗",
  "home.viewCommunities": "Communities ansehen",
  "home.viewResult": "Ergebnis ansehen",
  "home.viewRoomToGrow": "Ausbaufähig ansehen",
  "home.viewStrengths": "Stärken ansehen",
  "home.welcomeDialog.acknowledge": "Verstanden",
  "home.welcomeDialog.acknowledgeIn": "Verstanden ({seconds})",
  "home.welcomeDialog.title": "Willkommen",
  "home.welcomeHint.dismiss": "Schließen",
  "home.workExperience": "Berufserfahrung",
  "invite.conflict": "Diese Adresse hat bereits Zugang, es wurde keine Einladung gesendet.",
  "invite.created": "Einladung gesendet.",
  "invite.emailLabel": "E-Mail-Adresse",
  "invite.emailPlaceholder": "name@partner.example",
  "invite.eyebrow": "Zugang · Einladung",
  "invite.heading": "Externe Person einladen",
  "invite.intro": "Sie erhält einen Zugangslink, der 72 Stunden gültig ist, und setzt dort ihr eigenes Passwort. Der Link funktioniert einmalig und nur für diese Adresse.",
  "invite.invalidEmail": "Bitte gib eine gültige E-Mail-Adresse ein.",
  "invite.resent": "Diese Person war bereits eingeladen. Der Zugangslink wurde erneut gesendet.",
  "invite.sending": "Wird gesendet…",
  "invite.submit": "Einladung senden",
  "likert.1": "Trifft nicht zu",
  "likert.2": "Trifft eher nicht zu",
  "likert.3": "Teils / teils",
  "likert.4": "Trifft eher zu",
  "likert.5": "Trifft voll zu",
  "linkedin.error.authorize_denied": "Die LinkedIn-Autorisierung wurde abgebrochen.",
  "linkedin.error.cancelled": "Du hast die LinkedIn-Verbindung abgebrochen. Du kannst dich jederzeit erneut verbinden.",
  "linkedin.error.import_failed": "Der Import ist fehlgeschlagen. Bitte versuche es später erneut.",
  "linkedin.error.not_configured": "Der LinkedIn-Import ist nicht konfiguriert. Bitte wende dich an deine Administration.",
  "linkedin.error.reconnect": "Deine LinkedIn-Sitzung ist abgelaufen oder der Zugriff war unvollständig. Bitte verbinde dich erneut.",
  "linkedin.error.snapshotNotReady": "LinkedIn hat noch keine Daten geliefert. Wahrscheinlich ist dein Datenexport noch nicht fertig: Wir haben ihn gerade über den LinkedIn-Import angefragt, LinkedIn braucht dafür bis zu 10 Minuten. Versuche es gleich erneut oder komm später wieder.",
  "linkedin.error.stillImporting": "Der Import dauert länger als erwartet. Er läuft weiter – aktualisiere die Seite gleich, um das Ergebnis zu sehen.",
  "linkedin.error.temporary": "LinkedIn hat nicht rechtzeitig geantwortet. Bitte versuche es gleich noch einmal.",
  "linkedin.error.unavailable": "Der LinkedIn-Import ist derzeit nicht verfügbar. Bitte wende dich an deine Administration.",
  "linkedin.error.unexpected": "Beim Import ist etwas schiefgelaufen. Bitte versuche es später erneut.",
  "linkedin.import.abort": "Import abbrechen",
  "linkedin.import.abortTip": "Der Import läuft noch – du kannst weiter warten oder ihn abbrechen und von vorne neu starten. Gespeichert wurde noch nichts.",
  "linkedin.import.alreadyUpToDate": "Alles, was LinkedIn ergänzen könnte, ist bereits in deinem Profil vorhanden.",
  "linkedin.import.close": "Schließen",
  "linkedin.import.comeBackLater": "Später wiederkommen",
  "linkedin.import.connect": "Mit LinkedIn verbinden",
  "linkedin.import.dialogTitle": "LinkedIn-Import",
  "linkedin.import.elapsed": "Verstrichene Zeit: {time}",
  "linkedin.import.field.bio": "Bio",
  "linkedin.import.field.currentEmployer": "Arbeitgeber",
  "linkedin.import.field.dateOfBirth": "Geburtstag",
  "linkedin.import.field.degree": "Abschluss",
  "linkedin.import.field.description": "Beschreibung",
  "linkedin.import.field.email": "E-Mail",
  "linkedin.import.field.employer": "Arbeitgeber",
  "linkedin.import.field.endDate": "Ende",
  "linkedin.import.field.fieldOfStudy": "Studienfach",
  "linkedin.import.field.institution": "Institution",
  "linkedin.import.field.issued": "Ausgestellt",
  "linkedin.import.field.jobTitle": "Jobtitel",
  "linkedin.import.field.language": "Sprache",
  "linkedin.import.field.level": "Niveau",
  "linkedin.import.field.location": "Ort",
  "linkedin.import.field.name": "Name",
  "linkedin.import.field.period": "Zeitraum",
  "linkedin.import.field.phone": "Telefon",
  "linkedin.import.field.profession": "Beruf",
  "linkedin.import.field.skill": "Skill",
  "linkedin.import.field.startDate": "Beginn",
  "linkedin.import.field.street": "Straße",
  "linkedin.import.field.title": "Position",
  "linkedin.import.field.zipCode": "PLZ",
  "linkedin.import.importing": "Deine LinkedIn-Daten werden importiert – das kann bis zu einer Minute dauern …",
  "linkedin.import.intro": "Verbinde dein LinkedIn-Konto, um Profil, Positionen und Fähigkeiten zu importieren. Vor dem Speichern prüfst du, was übernommen oder ersetzt wird.",
  "linkedin.import.loadingResult": "Import wird abgeschlossen…",
  "linkedin.import.openingReview": "Dein Profil wird geöffnet, um die Änderungen zu prüfen…",
  "linkedin.import.regionBlocked": "LinkedIn erlaubt diese Einwilligung nur Mitgliedern aus dem Europäischen Wirtschaftsraum. Du kannst dein Profil stattdessen aus deinem Lebenslauf füllen – lade ihn unter Service hoch, wir lesen Positionen und Fähigkeiten daraus aus.",
  "linkedin.import.regionBlockedTitle": "Der LinkedIn-Import geht nur innerhalb des EWR",
  "linkedin.import.regionExplain": "LinkedIn gibt Profildaten nur für Mitglieder im Europäischen Wirtschaftsraum an andere Anwendungen weiter (EU-Staaten sowie Island, Liechtenstein und Norwegen). Grundlage ist der Digital Markets Act der EU. Schweiz und Vereinigtes Königreich gehören nicht dazu.",
  "linkedin.import.regionNo": "Nein, außerhalb",
  "linkedin.import.regionQuestion": "Wohnst du im Europäischen Wirtschaftsraum?",
  "linkedin.import.regionYes": "Ja, im EWR",
  "linkedin.import.retry": "Erneut versuchen",
  "linkedin.import.retryIn": "Erneut versuchen ({time})",
  "linkedin.import.warning.certificateInvalidName": "Ein Zertifikat wurde übersprungen, weil sein Name ungültig war.",
  "linkedin.import.warning.certificateNameDefaulted": "Ein Zertifikat hatte keinen Namen und wurde mit einem Platzhalter importiert.",
  "linkedin.import.warning.educationInvalidStartDate": "Das Startdatum eines Bildungseintrags war nicht lesbar, der Eintrag wurde ohne Startdatum übernommen.",
  "linkedin.import.warning.educationWithoutContent": "Ein Bildungseintrag wurde übersprungen, weil er weder Fachrichtung noch Bildungseinrichtung noch einen bekannten Abschluss nennt.",
  "linkedin.import.warning.experienceInvalidJobTitle": "Eine Position wurde übersprungen, weil ihre Berufsbezeichnung ungültig war.",
  "linkedin.import.warning.experienceInvalidStartDate": "Eine Position wurde übersprungen, weil ihr Startdatum ungültig war.",
  "linkedin.import.warning.experienceJobTitleDefaulted": "Eine Position hatte keine Berufsbezeichnung und wurde mit einem Platzhalter importiert.",
  "linkedin.import.warning.experienceStartDateDefaulted": "Eine Position hatte kein Startdatum und wurde auf den aktuellen Monat gesetzt.",
  "linkedin.import.warning.languageMissingName": "Eine Sprache wurde übersprungen, weil sie keinen Namen hatte.",
  "linkedin.import.warning.languageTagTooLong": "Eine Sprache wurde übersprungen, weil ihr Name zu lang war.",
  "linkedin.import.warning.languageUnrecognizedName": "Eine Sprache wurde übersprungen, weil ihr Name nicht erkannt wurde.",
  "linkedin.import.warning.languageUnrecognizedProficiency": "Das Sprachniveau einer Sprache wurde nicht erkannt.",
  "loginAssignment.action.invite": "Einladen",
  "loginAssignment.action.pending": "Frühere Einladung ungeklärt",
  "loginAssignment.dialog.emailLabel": "Empfänger",
  "loginAssignment.dialog.eyebrow": "Zugang · Login-Zuordnung",
  "loginAssignment.dialog.inviteHeading": "Dieser Person ein Login geben",
  "loginAssignment.dialog.inviteSubmit": "An diese Adresse einladen",
  "loginAssignment.dialog.noSuggestionHint": "Für diese Person ist keine brauchbare Adresse hinterlegt. Trage die Adresse ein, an die die Einladung gehen soll.",
  "loginAssignment.dialog.resendSubmit": "An diese Adresse erneut senden",
  "loginAssignment.dialog.suggestionHint": "Aus dem Profil vorbelegt. Bitte prüfen: Eine importierte Adresse kann vorläufig sein.",
  "loginAssignment.dialog.target": "Das Login wird an {name} gebunden. Profil, Notizen und Kontakte bleiben genau dort, wo sie sind.",
  "loginAssignment.empty": "Alle haben ein Login.",
  "loginAssignment.emptySearch": "Keine Person ohne Login passt zur Suche.",
  "loginAssignment.showAssignedResults": "Treffer unter „Mit Login“ anzeigen",
  "loginAssignment.showUnassignedResults": "Treffer unter „Ohne Login“ anzeigen",
  "loginAssignment.intro": "Ordne bestehenden Profilen einen Login zu und sieh, ob eine Anmeldung erfasst wurde.",
  "loginAssignment.loading": "Wird geladen…",
  "loginAssignment.noEmail": "Keine E-Mail hinterlegt",
  "loginAssignment.openProfile": "Profil von {name} öffnen",
  "loginAssignment.outcome.accountChanged": "Das Konto hat sich zwischenzeitlich geändert. Es wurde nichts gesendet. Bitte den Status prüfen und erneut versuchen.",
  "loginAssignment.outcome.alreadyAssigned": "Diese Person hat bereits ein Login. Es wurde nichts geändert und nichts gesendet.",
  "loginAssignment.outcome.createUncertain": "Der Ausgang ist unklar: Es kann ein Konto angelegt worden sein oder auch nicht, gesendet wurde nichts. Bitte diese Person in Keycloak prüfen, bevor du es erneut versuchst.",
  "loginAssignment.outcome.emailConflict": "Ein anderes Konto nutzt diese Adresse bereits. Es wurde nichts geändert, bitte eine andere Adresse wählen.",
  "loginAssignment.outcome.invited": "Erledigt. Das Login ist an diese Person gebunden, die Einladung ist unterwegs.",
  "loginAssignment.outcome.recipientUpdated": "Die Adresse wurde korrigiert und die Einladung an die neue Adresse gesendet.",
  "loginAssignment.outcome.resent": "Die Einladung wurde erneut an dieselbe Adresse gesendet.",
  "loginAssignment.outcome.sendFailed": "Die Mail wurde abgelehnt und nicht zugestellt. Das Login bleibt gebunden, erneutes Senden ist unbedenklich.",
  "loginAssignment.outcome.sendUncertain": "Das Login ist gebunden, ob die Mail rausging, ist unklar. Sie kann angekommen sein, deshalb bitte nicht erneut senden.",
  "share.listings.access.loading": "Zugang wird geladen…",
  "share.listings.access.assigned": "Login vorhanden",
  "share.listings.access.unassigned": "Noch kein Login",
  "share.listings.access.sent": "Einladung versandt",
  "share.listings.access.sendFailed": "Einladung nicht versandt",
  "share.listings.access.pending": "Einladung noch nicht abgeschlossen",
  "share.listings.access.invite": "Zum Login einladen",
  "share.listings.applicantView": "Zur Bewerberansicht",
  "share.listings.process.list": "Liste",
  "share.listings.process.view": "Prozess",
  "share.listings.process.exited": "Ausgeschieden",
  "share.listings.process.settings": "Prozess einstellen",
  "share.listings.process.phase": "Phase",
  "share.listings.process.phaseNumber": "Phase {number}",
  "share.listings.process.up": "Phase nach oben",
  "share.listings.process.down": "Phase nach unten",
  "share.listings.process.remove": "Phase entfernen",
  "share.listings.process.removeConfirm": "Entfernen bestätigen",
  "share.listings.process.add": "Phase hinzufügen",
  "share.listings.process.newPhase": "Weiteres Gespräch",
  "share.listings.process.quizEnabled": "Power Quiz auf Anfrage anbieten",
  "share.listings.process.loaded": "Die Phasen zeigen die {count} geladenen Bewerbungen. Weitere Bewerbungen unten laden.",
  "share.listings.quiz.sent": "Power Quiz angefragt · {date}",
  "share.listings.quiz.sending": "Power-Quiz-Anfrage wird versendet…",
  "share.listings.quiz.uncertain": "Versand der Quiz-Anfrage unklar · {date}. Vor erneutem Senden prüfen.",
  "share.listings.quiz.request": "Power Quiz anfragen",
  "share.listings.quiz.resend": "Power Quiz erneut anfragen",
  "share.listings.quiz.requestHint": "Eine freiwillige Einladung zum Power Quiz wird an die Login-Adresse versendet.",
  "share.listings.quiz.resendHint": "Es gibt bereits eine Quiz-Anfrage. Wirklich eine weitere E-Mail an die Login-Adresse senden?",
  "share.listings.quiz.send": "Anfrage senden",
  "share.listings.quiz.withInvitation": "Power Quiz zusätzlich per E-Mail anfragen",
  "adminSettings.emailTemplates.kind.LISTING_POWER_QUIZ": "Power-Quiz-Anfrage",
  "loginAssignment.searchLabel": "Nach Name oder Adresse suchen",
  "loginAssignment.searchPlaceholder": "Name oder Adresse",
  "loginAssignment.view": "Ansicht der Login-Zuordnung",
  "loginAssignment.withoutLogin": "Ohne Login",
  "loginAssignment.withLogin": "Mit Login",
  "loginAssignment.trackingHint": "Erfasst werden Anmeldungen seit Einführung dieser Funktion. Frühere Anmeldungen sind darin nicht enthalten.",
  "loginAssignment.firstAuthenticatedAt": "Erste erfasste Anmeldung am {date} um {time}",
  "loginAssignment.noAuthentication": "Noch keine Anmeldung erfasst",
  "loginAssignment.emptyAssignedSearch": "Keine Person mit Login passt zur Suche.",
  "loginAssignment.emptyAssigned": "Es wurden noch keine Logins zugeordnet.",
  "loginAssignment.title": "Login-Zuordnung",
  "match.addDocumentsAriaLabel": "Dokumente hinzufügen",
  "match.agent.add": "Hinzufügen",
  "match.agent.added": "Hinzugefügt",
  "match.agent.browse": "Agenten auswählen",
  "match.agent.catalogueEmpty": "Noch keine KI-Agenten angelegt.",
  "match.agent.catalogueEmptyAdmin": "In den Stammdaten anlegen",
  "match.agent.catalogueTitle": "Verfügbare Agenten",
  "match.agent.covers": "Deckt ab",
  "match.agent.guardrails": "Leitplanken",
  "match.agent.integrations": "Integrationen",
  "match.agent.loadMoreFailed": "Die nächsten Agenten konnten nicht geladen werden.",
  "match.agent.none": "Noch keine Agenten hinterlegt.",
  "match.agent.noneShort": "keine",
  "match.agent.recommend": "Agenten empfehlen",
  "match.agent.recommendContext": "Beantworte die Frage anhand der folgenden Angaben. Nenne zwei bis vier Agenten, jeweils mit einem Satz Begründung, und sage dazu, welche Anforderungen an die menschlichen Teammitglieder dadurch anders aussehen. Agenten sind Projekt-Kontext und nie Teammitglieder. Du kannst die Auswahl nicht selbst hinterlegen und hast dafür auch kein Werkzeug: nenne die Agenten namentlich, hinterlegen tue ich sie.\n\nProjekt:\n{project}\n\nBereits hinterlegt: {selected}\n\nVerfügbare Agenten:\n{catalogue}",
  "match.agent.recommendHint": "Öffnet den Assistenten, der aus deiner Beschreibung passende Agenten vorschlägt.",
  "match.agent.recommendPrompt": "Welche KI-Agenten passen zu diesem Projekt?",
  "match.agent.remove": "{name} entfernen",
  "match.agent.searchCount": "{count, plural, one {# Agent} other {# Agenten}}",
  "match.agent.searchCountMore": "{count}+ Agenten",
  "match.agent.searchLabel": "Agenten suchen",
  "match.agent.searchPlaceholder": "Name, Rolle, Tool …",
  "match.agent.tools": "Tools",
  "match.agenticAi": "Agentic AI",
  "match.agenticAiBoxDesc": "Sag, mit welchen KI-Agenten das Team arbeitet. Die Anforderungen werden passend dazu abgeleitet, damit das Team bereit ist, mit ihnen zu arbeiten.",
  "match.agenticAiOff": "Agentic AI aus",
  "match.agenticAiOn": "Agentic AI aktiv",
  "match.autoMatch.title": "Bewerbungen automatisch bewerten",
  "match.autoMatch.createHint": "Bewertet vorhandene und neue Bewerbungen und speichert die Rangliste automatisch.",
  "match.autoMatch.settingsHintListings": "{count, plural, =0 {Mit keiner Ausschreibung verknüpft, die du siehst.} one {Wirkt für die Ausschreibung {listings}.} other {Wirkt für die Ausschreibungen {listings}.}}",
  "match.autoMatch.savedResultHint": "Neue Bewerbungen ergänzen die aktuelle Rangliste.",
  "match.autoMatch.enabledBy": "Eingeschaltet von {name} am {date}",
  "match.autoMatch.unknownPerson": "einer unbekannten Person",
  "match.autoMatch.unnamedPerson": "Person ohne Namen",
  "match.autoMatch.runsTitle": "Automatische Bewertungen",
  "match.autoMatch.off": "Ausgeschaltet: neue Bewerbungen werden nicht mehr bewertet.",
  "match.autoMatch.noRuns": "Noch keine automatische Bewertung. Vorhandene und neue Bewerbungen werden automatisch übernommen.",
  "match.autoMatch.rematch": "Neu matchen",
  "match.autoMatch.retry": "Erneut versuchen",
  "match.autoMatch.retrying": "Läuft …",
  "match.autoMatch.retryTitle": "Läuft in deinem Namen, eine Bewertung",
  "match.autoMatch.showAll": "Alle {count} anzeigen",
  "match.autoMatch.status.stalled": "Hängt",
  "match.autoMatch.status.pending": "Wartet",
  "match.autoMatch.status.running": "Läuft",
  "match.autoMatch.status.copied": "Im Ergebnis ergänzt",
  "match.autoMatch.status.done": "Bewertet",
  "match.autoMatch.status.failed": "Fehlgeschlagen",
  "match.autoMatch.status.skipped": "Übersprungen",
  "match.autoMatch.status.withdrawn": "Bewerbung zurückgezogen",
  "match.autoMatch.status.designChanged": "Anforderungen geändert: neu matchen",
  "match.autoMatch.status.designChangedSince": "Anforderungen geändert, seitdem neu gespeichert",
  "match.autoMatch.status.unknown": "Unbekannter Zustand",
  "match.autoMatch.reason.noSavedResult": "Noch kein gespeichertes Ergebnis, die Person steht bei den Kandidaten",
  "match.autoMatch.reason.alreadyInResult": "Steht schon im Ergebnis",
  "match.autoMatch.reason.organizationalRecordMismatch": "Ergebnis und Bewertung sehen die Organisationsakte unterschiedlich",
  "match.autoMatch.reason.resultNotAppendable": "Das Ergebnis lässt sich nicht ergänzen",
  "match.autoMatch.reason.profileNotReadable": "Profil nicht lesbar",
  "match.autoMatch.reason.requesterWithoutAccess": "Wer eingeschaltet hat, sieht das Match nicht mehr oder darf die Bewerbungen der Ausschreibung nicht mehr lesen",
  "match.autoMatch.reason.error": "Die Bewertung ist fehlgeschlagen",
  "match.autoMatch.reason.dailyLimit": "Tageslimit erreicht, von Hand nachholen",
  "match.autoMatch.applicationRejected": "Bewerbung abgelehnt",
  "match.challenge.aiAssist": "KI-Unterstützung",
  "match.challenge.aiAssistHint": "KI berücksichtigt das ganze Profil und beurteilt, ob Anforderungen auch ohne expliziten Nachweis erfüllt sind. Zusätzlich erstellt sie zu jeder Person eine Einschätzung mit Score.",
  "match.challenge.aiAssistHintReduced": "KI berücksichtigt das ganze Profil und beurteilt, ob Anforderungen auch ohne expliziten Nachweis erfüllt sind.",
  "match.challenge.aiDeriveHint": "Öffnet den Assistenten, der Anforderungen aus deiner Beschreibung vorschlägt.",
  "match.challenge.aiBriefRequiredHint": "Erst Titel und Beschreibung ausfüllen.",
  "match.challenge.aiFillFirstHint": "Erst eine Beschreibung ausfüllen.",
  "match.challenge.assessmentDetail": "Ausführlichkeit",
  "match.challenge.assessmentDetailBullets": "Stichpunkte",
  "match.challenge.assessmentDetailBulletsDescription": "Kompakte Punkte mit Zeilenumbrüchen.",
  "match.challenge.assessmentDetailInfo": "Ausführlichkeit erklären",
  "match.challenge.assessmentDetailLongText": "Langtext",
  "match.challenge.assessmentDetailLongTextDescription": "Ausführliche Begründung mit konkreten Belegen.",
  "match.challenge.assessmentDetailSentences": "Sätze",
  "match.challenge.assessmentDetailSentencesDescription": "Kurze, vollständige Sätze.",
  "match.challenge.assessmentOutcomeBalanced": "Ausgewogen",
  "match.challenge.assessmentOutcomeBalancedDescription": "Stärken, Risiken und offene Fragen werden im Gesamtergebnis gleich gewichtet.",
  "match.challenge.assessmentOutcomeFocus": "Ergebnisfokus",
  "match.challenge.assessmentOutcomeFocusInfo": "Ergebnisfokus erklären",
  "match.challenge.assessmentOutcomeOpportunities": "Stärken",
  "match.challenge.assessmentOutcomeOpportunitiesDescription": "Stärken, übertragbare Fähigkeiten und realistische Einsatzmöglichkeiten werden stärker gewichtet und zuerst dargestellt.",
  "match.challenge.assessmentOutcomeRisks": "Lücken",
  "match.challenge.assessmentOutcomeRisksDescription": "Risiken, fehlende Nachweise und offene Fragen werden stärker gewichtet und zuerst dargestellt.",
  "match.challenge.assessmentStrictness": "Bewertungsmaßstab",
  "match.challenge.assessmentStrictnessExtreme": "Sehr hoch",
  "match.challenge.assessmentStrictnessExtremeDescription": "Nur explizite, rollenrelevante Belege tragen stark zur Bewertung bei; Unsicherheiten begrenzen das Ergebnis deutlich.",
  "match.challenge.assessmentStrictnessInfo": "Bewertungsmaßstab erklären",
  "match.challenge.assessmentStrictnessNormal": "Normal",
  "match.challenge.assessmentStrictnessNormalDescription": "Die drei KI-Perspektiven bewerten Evidenz und Unsicherheiten mit normaler Strenge.",
  "match.challenge.assessmentStrictnessStrict": "Hoch",
  "match.challenge.assessmentStrictnessStrictDescription": "Unklare oder nur angedeutete Erfahrung wird innerhalb der Bewertungsbandbreite vorsichtiger eingestuft.",
  "match.challenge.enterTitle": "Titel eintragen",
  "match.challenge.generateCompanyRequirementsPrompt": "Schlag mir passende Unternehmens-Anforderungen (Branche, Unternehmensgröße und Fachkompetenzen) aus Titel, Kurz- und Detailbeschreibung vor.",
  "match.challenge.generateRequirementsPrompt": "Schlag mir passende Anforderungen aus Titel, Kurz- und Detailbeschreibung vor.",
  "match.challenge.generateWithAi": "Für mich generieren",
  "match.challenge.hrPromptLabel": "Bewertungsstil",
  "match.challenge.interview.invite": "Unsicher, was rein soll? Lass dich vom Assistenten interviewen.",
  "match.challenge.interview.refine": "Mit einem Interview verfeinern",
  "match.challenge.interview.seed": "Interviewe mich zu diesem Projekt, damit wir eine gute Projektbeschreibung bekommen.",
  "match.challenge.linkBtn": "Verknüpfen",
  "match.challenge.linkProjectTitle": "Projekt mit existierendem Share-Item verknüpfen",
  "match.challenge.matchContext": "Match-Kontext",
  "match.challenge.noFilesYet": "Noch keine Dateien.",
  "match.challenge.openLinkedShare": "Verknüpftes Share-Item öffnen",
  "match.challenge.projectTitleLabel": "Projekt-Titel",
  "match.challenge.publishBtn": "Als Projekt anlegen",
  "match.company.requirementLeniencyLenientDescription": "Bei Muss und Kann berücksichtigt die KI zusätzlich den „Über uns“-Text.",
  "match.company.requirementLeniencyMustStrictDescription": "Bei Muss zählen nur die Fachkompetenzen; bei Kann berücksichtigt die KI zusätzlich den „Über uns“-Text.",
  "match.company.requirementLeniencyStrictDescription": "Bei Muss und Kann zählen nur die Fachkompetenzen. Der „Über uns“-Text wird nicht berücksichtigt.",
  "match.challenge.requirementLeniency": "Anforderungsprüfung",
  "match.challenge.requirementLeniencyInfo": "Anforderungsprüfung erklären",
  "match.challenge.requirementLeniencyLenient": "Kulant",
  "match.challenge.requirementLeniencyLenientDescription": "Die geforderte Stufe ist ein Richtwert: die vorhandene Fachkompetenz genügt.",
  "match.challenge.requirementLeniencyMustStrict": "Kulant bei Kann",
  "match.challenge.requirementLeniencyMustStrictDescription": "Bei Muss-Kriterien muss die Stufe erreicht sein, bei Kann genügt Vorhandensein.",
  "match.challenge.requirementLeniencyStrict": "Beides streng",
  "match.challenge.requirementLeniencyStrictDescription": "Die geforderte Stufe muss bei Muss und Kann erreicht sein.",
  "match.challenge.requirements": "Anforderungen",
  "match.challenge.requirementsCompanyInfo": "Bewertet werden die Angaben aus dem Unternehmensprofil.",
  "match.challenge.requirementsSharedInfo": "Berücksichtigt werden nur Profilinformationen, die Kandidat:innen geteilt haben.",
  "match.challenge.roleTitleLabel": "Rollen-Titel",
  "match.challenge.unlink": "Verbindung lösen",
  "match.challenge.unlinkTitle": "Verbindung zum Share-Item lösen",
  "match.challenge.unnamedSharedItem": "Unbenanntes Share-Item",
  "match.charsCount": "{count} Zeichen",
  "match.company.addEmployeeCount": "Größe",
  "match.company.addExpertise": "Fachkompetenz",
  "match.company.aiOffMeaning": "Ausgeschaltet zählt nur die wörtliche Übereinstimmung; alles andere bleibt nicht bewertbar.",
  "match.company.aiScope": "Die KI beurteilt ausschließlich die Fachkompetenzen, sonst nichts. Branche und Mitarbeitendenzahl werden verglichen, nicht beurteilt.",
  "match.company.aiUnassessable": "Was sie nicht beurteilen kann, zählt als nicht bewertbar und nie als nicht erfüllt.",
  "match.company.atLeast": "mindestens",
  "match.company.employeesTitle": "Unternehmensgröße",
  "match.company.employeesUnit": "Mitarbeitende",
  "match.company.expertiseTitle": "Fachkompetenz",
  "match.company.industryTitle": "Branche",
  "match.companyPool.addAllFound": "Alle {count, number} aufnehmen",
  "match.companyPool.addCapped": "Es wurden {count, number} Unternehmen aufgenommen – mehr passen nicht in den Pool.",
  "match.companyPool.addSearchCapped": "Es wurden {count, number} Unternehmen aufgenommen – die Suche hat mehr Treffer, als ein Match führen kann ({max, number}).",
  "match.companyPool.addUpTo": "Bis zu {count, number} aufnehmen",
  "match.companyPool.collectFailed": "Die Treffer konnten nicht geladen werden. Bitte versuche es noch einmal.",
  "match.companyPool.added": "Aufgenommen",
  "match.companyPool.employeesValue": "{count, number} Mitarbeitende",
  "match.companyPool.empty": "Noch keine Unternehmen – nimm links über Suche und Branche welche auf.",
  "match.companyPool.error.full": "Ein Match führt höchstens {max, number} Unternehmen. Entferne eines, um ein weiteres aufzunehmen.",
  "match.companyPool.finderTitle": "Unternehmens-Finder",
  "match.companyPool.fullNotice": "Der Pool ist mit {max, number} Unternehmen voll.",
  "match.companyPool.inactive": "inaktiv",
  "match.companyPool.industryFilter": "Branche vorfiltern …",
  "match.companyPool.industryFilterHint": "Die Branche ist beides: ein Kriterium der Bewertung und ein Vorfilter für den Pool.",
  "match.companyPool.intro": "Suche Unternehmen und nimm sie in den Pool dieses Matches auf. Bewertet wird jedes Unternehmen einzeln gegen die Kriterien aus dem Schritt Challenge.",
  "match.companyPool.noCriteriaYet": "Für dieses Match sind noch keine Unternehmens-Anforderungen gesetzt. Die Rangliste entsteht dann ohne Nachweis.",
  "match.companyPool.noIndustry": "keine Branche",
  "match.companyPool.noneFound": "Keine Unternehmen gefunden",
  "match.companyPool.poolTitle": "Unternehmens-Pool",
  "match.companyPool.readFailed": "Der Unternehmens-Pool konnte nicht geladen werden.",
  "match.companyPool.readOnly": "Du kannst diesen Pool nur ansehen. Zum Aufnehmen und Entfernen von Unternehmen brauchst du Schreibrechte auf diesem Match.",
  "match.companyPool.searchLabel": "Unternehmen suchen",
  "match.companyPool.searchPlaceholder": "Name, Fachkompetenz, Branche …",
  "match.companyPool.takeIndustriesFromCriteria": "Branchen aus den Kriterien übernehmen",
  "match.companyPool.unknownIndustry": "Branche unbekannt",
  "match.companyRanking.actualJudgedByAi": "per KI beurteilt",
  "match.companyRanking.actualNotRecorded": "vom Lauf nicht erfasst",
  "match.companyRanking.actualValue": "Ist: {value}",
  "match.companyRanking.aiCeilingExceeded": "Diese Rangliste braucht mehr KI-Urteile, als ein Lauf treffen darf. Reduziere die Fachkompetenz-Kriterien oder lass die Obergrenze anheben.",
  "match.companyRanking.bandsAreDerived": "Die Bänder A/B/C entstehen hier aus den Schwellen und werden nicht gespeichert. Die Platzierung kommt aus dem Lauf und ändert sich dabei nicht.",
  "match.companyRanking.blankExpertiseRefused": "Eine Fachkompetenz-Anforderung ist noch leer. Fülle sie aus oder entferne sie, dann läuft es erneut.",
  "match.companyRanking.companiesMeta": "{count, plural, one {# Unternehmen} other {# Unternehmen}}",
  "match.companyRanking.criteriaCompleteRow": "Anforderungen vollständig",
  "match.companyRanking.criteriaIncomplete": "{count, plural, one {# Anforderung ist unvollständig} other {# Anforderungen sind unvollständig}} – im Schritt Anforderungen ausfüllen oder entfernen, dann lässt sich ranken.",
  "match.companyRanking.criteriaMeta": "{count, plural, one {# Anforderung} other {# Anforderungen}}",
  "match.companyRanking.empty": "Der Pool dieses Matches ist leer – es gibt nichts zu ranken.",
  "match.companyRanking.historicalValueNote": "Die Ist-Werte zeigen den heutigen Stand der Unternehmen. Bewertet wurde der Stand zum Zeitpunkt des Laufs.",
  "match.companyRanking.must": "Muss",
  "match.companyRanking.needPool": "Nimm im Schritt Unternehmen mindestens ein Unternehmen in den Pool auf – ohne Pool gibt es nichts zu ranken.",
  "match.companyRanking.noCriteria": "Für dieses Match sind keine Unternehmens-Anforderungen gesetzt.",
  "match.companyRanking.noCriteriaWarning": "Ohne Unternehmens-Anforderungen entsteht eine Rangliste ohne Nachweis: jedes Unternehmen trägt dann denselben leeren Nachweis.",
  "match.companyRanking.noMatchingExpertise": "keine passende Fachkompetenz",
  "match.companyRanking.noMustHint": "Hier landen Unternehmen, die ein Muss-Kriterium verfehlen oder deren Score unter der C-Schwelle liegt.",
  "match.companyRanking.noValue": "keine Angabe",
  "match.companyRanking.notAssessable": "nicht bewertbar",
  "match.companyRanking.notAssessableTab": "Nicht bewertbar ({count})",
  "match.companyRanking.openCompany": "{name} öffnen",
  "match.companyRanking.optional": "Kann",
  "match.companyRanking.otherCriterion": "Weiteres Kriterium",
  "match.companyRanking.poolLoadedRow": "Unternehmen geladen",
  "match.companyRanking.preRunHeading": "Bewerte jedes Unternehmen im Pool einzeln gegen deine Anforderungen und erhalte eine Rangliste.",
  "match.companyRanking.readFailed": "Die Rangliste konnte nicht geladen werden.",
  "match.companyRanking.recommendAi": "{count} KI Begründungen bei {companies} Unternehmen manuell prüfen.",
  "match.companyRanking.recommendBottleneck": "{criterion} ist der stärkste Engpass; Ø Erfüllung {average}.",
  "match.companyRanking.recommendData": "Unternehmensangaben zu {criterion} nachpflegen; {missing}/{total} Werte fehlen.",
  "match.companyRanking.recommendMust": "{criterion} prüfen oder lockern; dieses Muss-Kriterium schließt {failed}/{total} Unternehmen aus.",
  "match.companyRanking.recommendNone": "Keine unmittelbare Anpassung nötig.",
  "match.companyRanking.reviewHint": "Hier landen Unternehmen, bei denen ein Kriterium nicht bewertet werden konnte, etwa eine Fachkompetenz, die das Unternehmen nicht führt. Sie sind nicht durchgefallen, sondern brauchen einen Blick.",
  "match.companyRanking.run": "Unternehmen ranken",
  "match.companyRanking.runNoRight": "Du kannst für dieses Match derzeit keine Rangliste erzeugen.",
  "match.companyRanking.running": "Ranke Unternehmen…",
  "match.companyRanking.topFiveBasis": "Kann-Mittelwert",
  "match.companyRanking.topFiveScoreLabel": "Bewertung {score} %",
  "match.companyRanking.unassessableMeta": "{count, plural, one {# Kriterium nicht bewertbar} other {# Kriterien nicht bewertbar}}",
  "match.companyRanking.verdictMet": "erfüllt",
  "match.companyRanking.verdictPartial": "teilweise erfüllt",
  "match.companyRanking.verdictUnmet": "nicht erfüllt",
  "match.companyReqsSection": "Unternehmens-Anforderungen",
  "match.detail.error": "Fehler: {message}",
  "match.detail.invalidUrl": "Ungültige Match-URL.",
  "match.detail.loading": "Lädt …",
  "match.detail.notFound": "Match nicht gefunden.",
  "match.detailedPlaceholder": "Kontext, Outcome, Constraints, Vorerfahrungen, alles was sonst relevant ist.",
  "match.docs.stillNeeded": "Noch benötigt: {requirements}",
  "match.docs.requiredTitle": "Titel",
  "match.docs.requiredDescription": "Beschreibung",
  "match.docs.retry": "↻ Erneut versuchen",
  "match.docs.tooLarge": "Zu groß (max. {max} MB pro Datei): {names}",
  "match.docs.uploadFailed": "Upload fehlgeschlagen.",
  "match.docs.uploading": "Wird hochgeladen…",
  "match.documents": "Dokumente",
  "match.editor.reset": "Zurücksetzen",
  "match.fieldDetailedDesc": "Detaillierte Beschreibung",
  "match.fieldShortDesc": "Kurzbeschreibung",
  "match.freitext.addJobTitle": "Jobtitel",
  "match.freitext.jobTitlePlaceholder": "z. B. Senior Designer, Lead Engineer",
  "match.freitext.title": "Berufserfahrung",
  "match.group.COMMUNICATION": "Kommunikationsfähigkeit",
  "match.group.FUTURE_ORIENTATION": "Zukunftsorientierung",
  "match.group.INVENTIVENESS": "Erfindungsstärke",
  "match.group.RESILIENCE": "Belastbarkeit",
  "match.group.RESULT_ORIENTATION": "Ergebnisorientierung",
  "match.group.TEAM_SPIRIT": "Teamfähigkeit",
  "match.labelLanguage": "Sprache",
  "match.landing.body": "Initiiere ein Match, definiere Anforderungen und lass den Solver Menschen und Agentic-AI zu einem optimalen Team komponieren – transparent, gewichtet, erklärbar.",
  "match.landing.candidatesCount": "{count} Kandidaten",
  "match.landing.error": "Fehler: {message}",
  "match.landing.loading": "lädt…",
  "match.landing.newMatch": "Neues Match erstellen ↗",
  "match.landing.noMatches": "Keine Matches",
  "match.landing.noMatchesHint": "… oder nicht angemeldet",
  "match.landing.resultsCount": "{count} Ergebnisse",
  "match.landing.subtitle": "Vom Teamgedanken{br}zum besten Team.",
  "match.landing.yourMatches": "Deine Matches",
  "match.matchNameLabel": "Match-Name",
  "match.modal.accessCount": "Zugriff · {count}",
  "match.modal.addPersonPlaceholder": "+ Person hinzufügen – Name suchen …",
  "match.modal.chooseShareItem": "Share-Item wählen",
  "match.modal.fillTitle": "Projekt mit dem Share-Item füllen",
  "match.modal.link": "Verknüpfen",
  "match.modal.linkOnly": "Nur verknüpfen",
  "match.modal.linkOnlyTitle": "Verknüpfen, ohne Inhalte zu kopieren",
  "match.modal.linkWithShareItem": "Mit Share-Item verknüpfen",
  "match.modal.linking": "Verknüpft …",
  "match.modal.loadingEllipsis": "lädt …",
  "match.modal.matchNotes": "Notizen zum Match",
  "match.modal.matchNotesPlaceholder": "Interne Notizen, Kontext oder offene Fragen – nicht die Projektbeschreibung.",
  "match.modal.myShareItems": "Meine Share-Items",
  "match.modal.myShareItemsCount": "Meine Share-Items · {count}",
  "match.modal.nameNotesAccess": "Name, Notizen & Zugriff",
  "match.modal.noAccessYet": "Niemand hat Zugriff. Unten Person hinzufügen.",
  "match.modal.noHits": "Keine Treffer.",
  "match.modal.noWriteRights": "Du hast keine Schreibrechte auf diese Match-Einstellungen.",
  "match.modal.overwriteTitle": "Projekt-Inhalte mit dem Share-Item überschreiben",
  "match.modal.owner": "Eigentümer:in",
  "match.modal.publishEyebrow": "Als Projekt anlegen",
  "match.modal.publishHint": "Beschreibung und Dokumente werden kopiert. Das Projekt wird mit diesem Match verknüpft und anschließend geöffnet.",
  "match.modal.publishNow": "Als Projekt anlegen",
  "match.modal.publishPublishing": "Wird angelegt …",
  "match.modal.publishQuestion": "Dieses Match als neues Projekt anlegen?",
  "match.modal.removeLink": "Verknüpfung entfernen?",
  "match.modal.roleAdmin": "Admin",
  "match.modal.roleEditor": "Bearbeiter:in",
  "match.modal.roleHintAdmin": "Alle Inhalte + Zugriff verwalten",
  "match.modal.roleHintEditor": "Inhalte bearbeiten",
  "match.modal.roleHintReader": "Nur ansehen",
  "match.modal.roleReader": "Leser:in",
  "match.modal.savingEllipsis": "Speichert …",
  "match.modal.searchByName": "Nach Name suchen …",
  "match.modal.searchingEllipsis": "sucht …",
  "match.modal.takeOver": "Übernehmen",
  "match.modal.unlinkAction": "Verbindung lösen",
  "match.modal.unlinkBody": "Die Verknüpfung zu <b>{name}</b> wird entfernt.",
  "match.modal.unlinkEyebrow": "Verbindung lösen",
  "match.modal.unlinkHint": "Die kopierten Inhalte (Titel, Beschreibung, Dokumente) bleiben erhalten – nur der Hinweis auf das Share-Item verschwindet.",
  "match.modal.unlinking": "Trennt …",
  "match.modal.unnamedShareItem": "Unbenanntes Share-Item",
  "match.modal.visibleToMe": "Sichtbar für mich",
  "match.modal.visibleToMeCount": "Sichtbar für mich · {count}",
  "match.modePicker.assessOutput": "Einschätzung + Lücken",
  "match.modePicker.assessSlogan": "Du hast bereits ein Team im Kopf und willst sehen, wie gut es passt und wo die Lücken sind.",
  "match.modePicker.assessTitle": "Team bewerten",
  "match.modePicker.optimizeOutput": "ein Team",
  "match.modePicker.optimizeSlogan": "Du hast einen Pool an Personen und willst das beste Team für ein Projekt oder eine Aufgabe zusammenstellen.",
  "match.modePicker.optimizeTitle": "Team optimieren",
  "match.modePicker.outputLabel": "Ergebnis",
  "match.modePicker.rankCompaniesOutput": "Rangliste",
  "match.modePicker.rankCompaniesSlogan": "Du hast einen Bedarf und willst Unternehmen danach sortieren, wer am besten passt.",
  "match.modePicker.rankCompaniesTitle": "Unternehmen vergleichen",
  "match.modePicker.rankOutput": "Rangliste",
  "match.modePicker.rankSlogan": "Du besetzt eine offene Stelle und willst Kandidaten danach sortieren, wer am besten passt.",
  "match.modePicker.rankTitle": "Kandidaten vergleichen",
  "match.modePicker.title": "Welche Frage soll dieses Match beantworten?",
  "match.new.accessLabel": "Zugriff",
  "match.new.create": "Erstellen",
  "match.new.creating": "Erstellt …",
  "match.new.defaultName": "Neues Match",
  "match.new.title": "Neues Match erstellen",
  "match.noMatchesEmpty": "Keine Matches",
  "match.noPeopleFound": "Keine Personen gefunden",
  "match.optChoose": "– wählen –",
  "match.people.addAll": "Alle hinzufügen ({count})",
  "match.people.addAllFromSet": "Alle {count} aus {name} hinzufügen",
  "match.people.addAllPinned": "Alle {count} Gepinnten hinzufügen",
  "match.people.addInterested": "Interessenten hinzufügen ({count})",
  "match.people.addUpTo": "Bis zu {count} passende hinzufügen",
  "match.people.added": "Hinzugefügt",
  "match.people.allPinned": "Alle Gepinnten",
  "match.people.emptyCandidates": "Noch keine Kandidaten – links über Suche oder Filter hinzufügen.",
  "match.people.evaluateLocked": "Dieses Team bewerten",
  "match.people.evaluateLockedTitle": "Dieses vollständig gesperrte Team bewerten",
  "match.people.finderTitle": "Personen finden",
  "match.people.interestedExplain": "Personen mit Interesse an diesem Projekt",
  "match.people.intro": "Suche und filtere Personen aus deinem Unternehmen und füge sie als Kandidaten hinzu.",
  "match.people.introLock": "Markiere einzelne als Fix im Team, wenn sie gesetzt sein sollen.",
  "match.people.lockAsFix": "Als Fix im Team markieren",
  "match.people.personGroups": "Gruppen",
  "match.people.pinGroups": "Pingruppen",
  "match.people.sampleNotice": "Der Kandidatenpool enthält die ersten {count} von {total} passenden Personen aus dem letzten Massen-Hinzufügen.",
  "match.people.sampleNoticeCapped": "Der Kandidatenpool enthält die ersten {count} passenden Personen; es gab mehr Treffer, als auf einmal hinzugefügt werden konnten.",
  "match.people.savedSetsPlaceholder": "Gruppen & Pins …",
  "match.people.searchPlaceholder": "Name, Jobtitel …",
  "match.people.selectedCandidates": "Ausgewählte Kandidaten",
  "match.people.unlock": "Sperrung aufheben",
  "match.placeholderCount": "Anzahl",
  "match.powerScore.edit": "Datengrundlage anpassen",
  "match.powerScore.editHint": "Nicht jede Person hat beide Erhebungen, und nicht zu jeder Power einen Wert. Diese beiden Einstellungen entscheiden, welche Werte der Lauf benutzt und wie fehlende zählen.",
  "match.powerScore.editInfo": "Datengrundlage erklären",
  "match.powerScore.missing": "Fehlende Power",
  "match.powerScore.missingNeutral": "zählt 50",
  "match.powerScore.missingZero": "zählt 0",
  "match.powerScore.source": "Power-Quelle",
  "match.preSolve.assessTeam": "Team bewerten",
  "match.preSolve.assessing": "Bewerte Team…",
  "match.preSolve.candidatesLoaded": "Kandidaten geladen",
  "match.preSolve.conditionsComplete": "Kriterien vollständig",
  "match.preSolve.conditionsIncompleteHint": "{n, plural, one {# Kriterium ohne Auswahl (z. B. Branche wählen) – ausfüllen oder entfernen} other {# Kriterien ohne Auswahl – ausfüllen oder entfernen}}",
  "match.preSolve.eyebrow": "Bereit zum Solven",
  "match.preSolve.eyebrowAssess": "Bereit zur Bewertung",
  "match.preSolve.eyebrowRank": "Bereit zum Ranking",
  "match.preSolve.fulfillFirst": "Erfülle zuerst die Anforderungen oben.",
  "match.preSolve.fullyLockedHint": "Alle {teamSize} Plätze sind durch fixierte Mitglieder belegt. Der Solver bewertet dieses Team nur, er optimiert es nicht.",
  "match.preSolve.heading": "Aus deinem Kandidatenpool ein optimales Team komponieren.",
  "match.preSolve.headingAssess": "Bewerte, wie gut dein Team die Anforderungen erfüllt.",
  "match.preSolve.headingRank": "Sortiere deine Kandidaten nach Passung zum Anforderungsprofil.",
  "match.preSolve.intro": "Der Solver verteilt deine Kandidaten auf {teamSize} Plätze und optimiert auf dein Anforderungsprofil. Du kannst die Berechnung beliebig oft wiederholen.",
  "match.preSolve.lockedExceedsBody": "{locked} Personen sind fixiert, aber das Team hat {teamSize} Plätze. Entsperre einige Mitglieder oder erhöhe die Team-Größe, bevor du solvest.",
  "match.preSolve.lockedExceedsHeading": "Es sind mehr Personen fixiert als Plätze vorhanden.",
  "match.preSolve.noSizeYet": "noch keine Größe gewählt",
  "match.preSolve.personsCount": "{n} Personen",
  "match.preSolve.poolOnly": "{n} im Pool",
  "match.preSolve.poolWithLocked": "{n} im Pool · {locked} fix",
  "match.preSolve.rankCandidates": "Kandidaten ranken",
  "match.preSolve.ranking": "Ranke…",
  "match.preSolve.solverRunning": "Solver läuft…",
  "match.preSolve.startSolver": "Solver starten",
  "match.preSolve.teamSizePlaceholder": "n",
  "match.preSolve.teamSizeSet": "Team-Größe gesetzt",
  "match.profilesLoadError": "Profile laden: {message}",
  "match.readOnlyBanner": "Du kannst dieses Match nur ansehen. Bitte einen Admin oder Eigentümer:in um Schreibrechte.",
  "match.recruiting.addBranche": "Branche",
  "match.recruiting.addCertificate": "Zertifikat",
  "match.recruiting.addEducation": "Ausbildung",
  "match.recruiting.addSkillHere": "Fachkompetenz hier hinzufügen",
  "match.recruiting.branchePlaceholder": "Branche wählen",
  "match.recruiting.certificatePlaceholder": "z. B. AWS Solutions Architect",
  "match.recruiting.educationDegreeLabel": "Benötigter Abschluss",
  "match.recruiting.educationDegreePlaceholder": "Abschluss auswählen",
  "match.recruiting.educationLevelInfo.aria": "AI-Auswertung des Abschlusses erklären",
  "match.recruiting.educationLevelInfo.body": "Ohne AI wird der ausgewählte Katalogeintrag direkt verglichen. Mit aktivierter AI erhält das Modell den Hinweis, zusätzlich gleichwertige oder eindeutig höherwertige formale Abschlüsse zu berücksichtigen.",
  "match.recruiting.educationLevelInfo.title": "Auswertung des Abschlusses",
  "match.recruiting.experienceTitle": "Benötigte Berufserfahrung",
  "match.recruiting.expertiseTitle": "Benötigte Fachkompetenzen (mind.)",
  "match.recruiting.kann.tooltip": "Kann-Kriterium: zählt in den Passungs-Score. Klicken für Muss.",
  "match.recruiting.minYears": "mind.",
  "match.recruiting.must.tooltip": "Muss-Kriterium: wer es nicht erfüllt, ist unqualifiziert. Klicken für Kann.",
  "match.recruiting.personCountLabel": "Mindestanzahl Personen",
  "match.recruiting.qualificationsTitle": "Ausbildung & Zertifikate",
  "match.recruiting.skillPlaceholder": "z. B. Wundmanagement",
  "match.recruiting.unrated": "Vorhanden",
  "match.recruiting.years": "Jahre",
  "match.recruiting.yearsUnit": "Jahre",
  "match.removeAll": "Alle entfernen",
  "match.renameLabel": "Match umbenennen",
  "match.requirements.aria.cefrLevel": "Niveau",
  "match.requirements.aria.composition": "Composition",
  "match.requirements.aria.operator": "Operator",
  "match.requirements.cefr.A1": "A1 – Anfänger",
  "match.requirements.cefr.A2": "A2 – Grundlagen",
  "match.requirements.cefr.B1": "B1 – Mittelstufe",
  "match.requirements.cefr.B2": "B2 – Selbstständig",
  "match.requirements.cefr.C1": "C1 – Fortgeschritten",
  "match.requirements.cefr.C2": "C2 – Verhandlungssicher",
  "match.requirements.cefr.NATIVE": "Muttersprache",
  "match.requirements.cityRadius": "Umkreis in Kilometern",
  "match.requirements.cityRadiusDial": "Umkreis wählen, von der Mitte nach außen ziehen",
  "match.requirements.cityRadiusHint": "Ziehen bis 100 km, größere Werte oben eintragen",
  "match.requirements.condition.annualSalary": "Jahresgehalt",
  "match.requirements.otherUnchanged": "{count, plural, one {# weitere Anforderung bleibt} other {# weitere Anforderungen bleiben}} unverändert erhalten.",
  "match.requirements.personDetails": "Personen-Details",
  "match.pdf.candidateRanking": "Kandidaten-Ranking",
  "match.pdf.companyRanking": "Unternehmens-Ranking",
  "match.pdf.assessedMembersShort": "{count} gemessen",
  "match.pdf.criteria": "Kriterien",
  "match.pdf.dataQuality.healthy": "Keine Datenqualitäts-Hinweise.",
  "match.pdf.dataQuality.noPowers": "Keine Person im Team hat gemessene Powers in diesem Ergebnis.",
  "match.pdf.dataQuality.noRequirements": "Für dieses Ergebnis wurden keine Anforderungen definiert.",
  "match.pdf.dataQuality.unknownRequirements": "Einige gespeicherte Anforderungen stammen aus einem neueren Client und werden gezählt, aber hier nicht einzeln gezeigt.",
  "match.pdf.download": "PDF herunterladen",
  "match.pdf.downloadFailed": "Download fehlgeschlagen.",
  "match.pdf.exportTitle": "PDF-Export",
  "match.pdf.exportedAt": "Exportiert am {date}",
  "match.pdf.factSkillScore": "Fachkompetenzen & Fakten",
  "match.pdf.inactive": "inaktiv",
  "match.pdf.measuredPowerMembers": "{count} von {total} Personen mit gemessenen Powers",
  "match.pdf.modeUnknown": "Match-Ergebnis",
  "match.pdf.moreRows": "+{count} weitere",
  "match.pdf.notes": "Notizen",
  "match.pdf.openExport": "PDF exportieren",
  "match.pdf.personDetails": "Personen-Details",
  "match.pdf.peopleOrCandidates": "Personen / Kandidaten",
  "match.pdf.powerFit": "Power-Fit",
  "match.pdf.powerStructure": "Power-Struktur",
  "match.pdf.powerTarget": "Soll {target} · {delta}",
  "match.pdf.powers": "Power Cluster",
  "match.pdf.powersMatrix": "Power-Scorecard-Matrix",
  "match.pdf.previewTitle": "PDF-Vorschau des Match-Ergebnisses",
  "match.pdf.rankCluster.review": "Zu prüfen",
  "match.pdf.rankCluster.unqualified": "Kriterien nicht erfüllt",
  "match.pdf.requirementFit": "Anforderungs-Fit",
  "match.pdf.requirementMatrix": "Anforderungs-Matrix",
  "match.pdf.requirements": "Anforderungen",
  "match.pdf.sections": "Abschnitte",
  "match.pdf.settings.dataQuality": "Datenqualität",
  "match.pdf.settings.matrices": "Detaillierte Matrizen",
  "match.pdf.settings.notes": "Notizen",
  "match.pdf.settings.powers": "Power Cluster",
  "match.pdf.settings.powerDetail": "Power-Struktur",
  "match.pdf.settings.ranking": "Ranking",
  "match.pdf.settings.requirements": "Anforderungen",
  "match.pdf.settings.summary": "Zusammenfassung",
  "match.pdf.settings.team": "Team",
  "match.pdf.summary": "Match-Analyse",
  "match.pdf.team": "Team",
  "match.pdf.unknownCriteria": "Unbekannte Kriterien",
  "match.pdf.rank.band": "Band",
  "match.pdf.rank.candidate": "Kandidat",
  "match.pdf.rank.candidateDetail": "Kandidaten-Detail",
  "match.pdf.rank.criteriaMatrix": "Kriterienmatrix",
  "match.pdf.rank.dataQuality": "Datenqualität: {missing} von {expected} Nachweisen fehlen",
  "match.pdf.rank.fromThreshold": "ab {value}",
  "match.pdf.rank.poolSplit": "{total} Kandidaten · A {a} · B {b} · C {c} · {review} zu prüfen · {unqualified} Kriterien nicht erfüllt",
  "match.pdf.rank.roleRequirements": "Rollenanforderungen",
  "match.pdf.rank.criterion": "Kriterium",
  "match.pdf.rank.poolDistribution": "Verteilung im Pool",
  "match.pdf.rank.companyDetail": "Unternehmens-Detail",
  "match.pdf.rank.poolSplitCompanies": "{total} Unternehmen · A {a} · B {b} · C {c} · {review} zu prüfen · {unqualified} Kriterien nicht erfüllt",
  "match.pdf.rank.candidates": "Kandidaten",
  "match.pdf.rank.notIncluded": "{count, plural, one {# Kandidat nicht enthalten} other {# Kandidaten nicht enthalten}}",
  "match.pdf.rank.selectAll": "Alle auswählen",
  "match.result.adjustRequirements": "Anforderungen anpassen",
  "match.result.adjustTeamSize": "Team-Größe",
  "match.result.age": "Alter",
  "match.result.ageRange": "{min}–{max} Jahre",
  "match.result.ageRangeAverage": "{min}–{max} Jahre (Ø {average})",
  "match.result.ageSingle": "{age} Jahre",
  "match.result.agentsIntro": "Mit diesen KI-Agenten arbeitet das Projekt. Sie sind Kontext und kein Teammitglied: das Team oben besteht ausschließlich aus Personen.",
  "match.result.agentsTitle": "Agenten",
  "match.result.analysis.carriersClose": "Knapp: {names}",
  "match.result.analysis.carriersMet": "Erfüllt von: {names}",
  "match.result.analysis.carriersNone": "Niemand im Team erfüllt das.",
  "match.result.analysis.donutFulfilled": "erfüllt",
  "match.result.analysis.extraSkills": "Stark im Team, nicht angefordert: {skills}",
  "match.result.analysis.fulfilment": "Erfüllung",
  "match.result.analysis.gaps": "Lücken",
  "match.result.analysis.metOfTotal": "{met}/{total} erfüllt",
  "match.result.analysis.moreRows": "+{count} weitere",
  "match.result.analysis.noStrengths": "Noch nichts erfüllt.",
  "match.result.analysis.recAllMet": "Alle Anforderungen erfüllt.",
  "match.result.analysis.rowClose": "{n} knapp",
  "match.result.analysis.rowCompositionAll": "alle im Team",
  "match.result.analysis.rowCompositionExact": "genau {n} im Team",
  "match.result.analysis.rowCompositionMax": "max. {n} im Team",
  "match.result.analysis.rowCompositionMin": "min. {n} im Team",
  "match.result.analysis.rowMetOf": "{met} von {total}",
  "match.result.analysis.rowToggleAria": "Träger von {label} anzeigen",
  "match.result.analysis.soleCarrier": "nur {name}",
  "match.result.analysis.strengths": "Stärken",
  "match.result.backToSelection": "← Schließen",
  "match.result.candidatesMeta": "{count, plural, one {# Kandidat} other {# Kandidaten}}",
  "match.result.condition.age": "Alter",
  "match.result.condition.annualSalary": "Gehalt",
  "match.result.condition.certificate": "Zertifikat",
  "match.result.condition.children": "Kinder",
  "match.result.condition.citizenship": "Staatsangehörigkeit",
  "match.result.condition.city": "Wohnort",
  "match.result.condition.country": "Land",
  "match.result.condition.department": "Abteilung",
  "match.result.condition.driversLicense": "Führerschein",
  "match.result.condition.education": "Ausbildung",
  "match.result.condition.exact": "{label}: {value}",
  "match.result.condition.exactNot": "{label}: nicht {value}",
  "match.result.condition.experience": "Berufserfahrung",
  "match.result.condition.expertise": "Fachkompetenz",
  "match.result.condition.gender": "Geschlecht",
  "match.result.condition.industry": "Branche",
  "match.result.condition.language": "Sprache",
  "match.result.condition.location": "Arbeitsstandort",
  "match.result.condition.maritalStatus": "Familienstand",
  "match.result.condition.nationality": "Nationalität",
  "match.result.condition.present": "{label}: Vorhanden",
  "match.result.condition.presentActual": "Vorhanden",
  "match.result.condition.threshold": "{label}: {word} {value}",
  "match.result.condition.thresholdExact": "genau",
  "match.result.condition.thresholdMax": "max.",
  "match.result.condition.thresholdMin": "mind.",
  "match.result.condition.thresholdNot": "nicht",
  "match.result.dataHint": "Datenhinweis",
  "match.result.deleteAriaLabel": "Ergebnis „{name}“ löschen",
  "match.result.deleteConfirmBody": "Das gespeicherte Ergebnis <b>„{name}“</b> wird endgültig entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
  "match.result.deleteConfirmTitle": "Ergebnis löschen?",
  "match.result.deleteFinal": "Endgültig löschen",
  "match.result.deleteTitle": "Löschen",
  "match.result.deleting": "Lösche…",
  "match.result.dept": "Abteilung",
  "match.result.detailsHeader": "Details",
  "match.result.discardUnsavedConfirm.confirm": "Verwerfen",
  "match.result.discardUnsavedConfirm.message": "Das berechnete Ergebnis wurde noch nicht gespeichert und geht beim Zurückgehen verloren.",
  "match.result.discardUnsavedConfirm.title": "Ungespeichertes Ergebnis verwerfen?",
  "match.result.elementRequirementsFulfilled": "Element Requirements · {count} erfüllt",
  "match.result.emptyHint": "Keine Daten im Ergebnis vorhanden.",
  "match.result.facts.aiMark": "KI",
  "match.result.facts.leniencyDependent": "{count, plural, one {# Anforderung gilt nur kulant als erfüllt} other {# Anforderungen gelten nur kulant als erfüllt}}: Fachkompetenz vorhanden, geforderte Stufe nicht belegt.",
  "match.result.facts.lenientMark": "Kulant",
  "match.result.facts.matchedBadge": "Trägt zu {met} von {total} Anforderungen bei",
  "match.result.facts.mustViolated": "{count, plural, one {# Muss-Kriterium ist nicht erfüllt} other {# Muss-Kriterien sind nicht erfüllt}}.",
  "match.result.factsAndSkills": "Anforderungs-Matrix",
  "match.result.gender": "Geschlecht",
  "match.result.groupBasics": "Basics",
  "match.result.groupExpertise": "Expertise",
  "match.result.groupTotal": "Total",
  "match.result.hintNoConditionsBody": "Dieses Match hat keine Anforderungen im Challenge-Schritt – Match-Analyse und Anforderungs-Matrix bleiben darum leer. Definiere Bedingungen, um zu sehen, wie das Team sie erfüllt.",
  "match.result.hintNoConditionsLabel": "Keine Anforderungen definiert",
  "match.result.hintNoDemographicsBody": "Die Personen haben keine Geburtsdaten und kein Geschlecht hinterlegt. Abteilung, Geschlecht und Alter unter dem Team bleiben darum ausgeblendet.",
  "match.result.hintNoDemographicsLabel": "Keine demografischen Daten",
  "match.result.hintNoPowersBody": "Die ausgewählten Personen haben ihre Powers nicht selbst eingeschätzt. Alle Powers-Auswertungen bleiben darum bei Null. Sobald sie Powers im Profil pflegen, füllt sich das Ergebnis automatisch.",
  "match.result.hintNoPowersLabel": "Keine Power-Self-Assessments",
  "match.result.historyLoading": "Gespeicherte Ergebnisse laden …",
  "match.result.historyTitle": "Gespeicherte Ergebnisse",
  "match.result.infeasibleBody": "Die Bedingungen widersprechen sich oder dein Kandidatenpool ist zu klein. Entferne harte Filter oder vergrößere den Pool und starte den Solver erneut.",
  "match.result.infeasibleHeading": "Der Solver konnte kein Team zusammenstellen, das alle Anforderungen erfüllt.",
  "match.result.infeasibleLockedBody": "Es sind zu viele Personen fixiert, oder die fixierten Mitglieder verletzen bereits eine Anforderung. Entsperre einige Mitglieder oder erhöhe die Team-Größe und starte den Solver erneut.",
  "match.result.infeasibleLockedHeading": "Die fixierten Mitglieder allein ergeben kein gültiges Team.",
  "match.result.infeasibleLockedTitle": "Fixierte Kandidaten blockieren die Berechnung",
  "match.result.infeasibleMet": "{met} von {target} erfüllt",
  "match.result.infeasibleOvershoot": "{over} über dem Limit von {target}",
  "match.result.infeasibleRelaxTitle": "{count, plural, one {Lockere dieses Muss-Kriterium} other {Kleinste Korrektur: lockere alle diese Muss-Kriterien}}",
  "match.result.infeasibleShortfall": "fehlt {shortfall}",
  "match.result.infeasibleTitle": "Keine Lösung gefunden",
  "match.result.insights.aiCriterionSubjects": "{count} {subject}",
  "match.result.insights.aiMetShort": "davon {count} per KI erkannt",
  "match.result.insights.aiReasons": "{count} KI Begründungen",
  "match.result.insights.aiShare": "KI-Anteil",
  "match.result.insights.averageShort": "Ø {value}",
  "match.result.insights.bottlenecks": "Top 3 Bottlenecks",
  "match.result.insights.failCount": "{failed}/{total} ausgeschlossen",
  "match.result.insights.fulfilledShort": "{met}/{total} erfüllt",
  "match.result.insights.gapShort": "{value} Lücke",
  "match.result.insights.hardestMust": "K.O.-Kriterium",
  "match.result.insights.header": "Match-Analyse",
  "match.result.insights.koPassing": "erfüllen",
  "match.result.insights.medianShort": "Median {value}",
  "match.result.insights.noAiReasons": "Keine KI Begründungen.",
  "match.result.insights.noBottleneck": "Keine auffälligen Engpässe.",
  "match.result.insights.noExclusion": "Kein Muss-Kriterium schließt aus.",
  "match.result.insights.noFulfilled": "Kein Kriterium wird erfüllt.",
  "match.result.insights.personDetailsInfoAria": "Hinweis zu Personen-Details anzeigen",
  "match.result.insights.personDetailsInfoBody": "Personen-Details werden nicht als Analyse-Verteilung dargestellt. Sie bleiben im Kandidaten-Detail sichtbar.",
  "match.result.insights.personDetailsInfoTitle": "Personen-Details",
  "match.result.insights.radius": "Umkreis",
  "match.result.insights.radiusHint": "Winkel schematisch, Distanzskala gestaucht",
  "match.result.insights.radiusInside": "{count} innerhalb",
  "match.result.insights.radiusMapAria": "Umkreis-Karte: Kandidaten nach Distanz zu {city}",
  "match.result.insights.radiusMissing": "{count} ohne Distanz",
  "match.result.insights.radiusOutside": "{count} außerhalb",
  "match.result.insights.radiusTitle": "{radius} km um {city}",
  "match.result.insights.reasonsShort": "{count, plural, one {# Begründung} other {# Begründungen}}",
  "match.result.insights.recommendAi": "{count} KI Begründungen bei {candidates} Kandidaten manuell prüfen.",
  "match.result.insights.recommendBottleneck": "{criterion} ist der stärkste Engpass; Ø Erfüllung {average}.",
  "match.result.insights.recommendData": "Profilwerte für {criterion} nachpflegen; {missing}/{total} Nachweise fehlen.",
  "match.result.insights.recommendMust": "{criterion} prüfen oder lockern; dieses Muss-Kriterium schließt {failed}/{total} Kandidaten aus.",
  "match.result.insights.recommendNone": "Keine unmittelbare Anpassung nötig.",
  "match.result.insights.recommendation": "Empfehlung",
  "match.result.insights.requiredShort": "Soll {value}",
  "match.result.insights.sdShort": "SD {value}",
  "match.result.insights.subjectCandidates": "Kandidaten",
  "match.result.insights.subjectCompanies": "Unternehmen",
  "match.result.insights.textDistribution": "häufigster Wert {value} ({count}/{present}) · {distinct} Varianten",
  "match.result.insights.topFulfilled": "Top 3 erfüllte Kriterien",
  "match.result.insights.unknownShort": "{count} nicht bewertbar",
  "match.result.loadFailed": "Ergebnis konnte nicht geladen werden (id {id}). Browser-Konsole prüfen.",
  "match.result.memberAnchorSole": "{name} (allein)",
  "match.result.memberAnchors": "Trägt: {list}",
  "match.result.memberCharacter": "Charakter",
  "match.result.memberClusterCountInfoAria": "Erklärung zu Zählung und Abstand anzeigen",
  "match.result.memberClusterCountInfoBody": "Zählung: wie viele der 5 Cluster-Powers dieser Person über {threshold} liegen – ein Mittel von 68 kann fünfmal 68 sein oder eine starke Power neben vier schwachen. Balken: er steht auf dem Cluster-Mittel des Teams – nach rechts hebt die Person das Team hier, nach links liegt sie darunter. Am Ende ihr eigenes Cluster-Mittel.",
  "match.result.memberClusterCountInfoTitle": "Zählung und Abstand",
  "match.result.memberCoverage": "{met} von {total}",
  "match.result.memberCoverageVsMedian": "{met} von {total} · Team-Median {median, number}",
  "match.result.memberCriteriaLess": "weniger anzeigen",
  "match.result.memberCriteriaMore": "alle {n} anzeigen",
  "match.result.memberCriterionMet": "erfüllt",
  "match.result.memberCriterionOpen": "nicht erfüllt",
  "match.result.memberCriterionPartial": "teilweise erfüllt",
  "match.result.memberCriterionUnrated": "nicht bewertbar",
  "match.result.memberCriticalTag": "kritisch",
  "match.result.memberLenientTag": "kulant",
  "match.result.memberNoPowers": "Keine Power-Einschätzung hinterlegt. Diese Person zählt in keinem Powers-Schnitt des Teams mit – ihr Beitrag oben steht allein auf den Anforderungen.",
  "match.result.memberOpenProfile": "Profil",
  "match.result.memberPowerFit": "Power-Fit {n}",
  "match.result.memberPowerFitInfoAria": "Erklärung zum Power-Fit dieser Person anzeigen",
  "match.result.memberPowerFitInfoBody": "Eigene Powers (0–100), gewichtet mit der Powers Scorecard. Hoch heißt: die Person ist stark genau dort, wo Gewicht liegt – unabhängig davon, wie sie im Teamvergleich steht.",
  "match.result.memberPowersRelative": "Powers im Teamvergleich",
  "match.result.memberRequirements": "Anforderungen",
  "match.result.memberSummaryCritical": "Kritisch für {list}.",
  "match.result.memberSummaryCriticalMust": "Ohne diese Person {count, plural, one {fällt das Muss} other {fallen die Muss-Kriterien}} {list}.",
  "match.result.memberSummaryExclusiveSkills": "Einzige mit {list}{rest, plural, =0 {} other { und # weiteren}} auf starker Stufe.",
  "match.result.memberSummaryNoCoverage": "Erfüllt keine Anforderung – der Beitrag liegt in den Powers, nicht in den Fachkriterien.",
  "match.result.memberSummaryNoCoverageNoPowers": "Erfüllt keine Anforderung – und ohne Power-Einschätzung ist über den Beitrag sonst nichts bekannt.",
  "match.result.memberSummaryTopCoverage": "Deckt die meisten Anforderungen im Team.",
  "match.result.memberSummaryTopPowerFit": "Höchster Power-Fit im Team.",
  "match.result.memberWhy": "Warum im Team",
  "match.result.memberWhySuited": "Warum geeignet",
  "match.result.noRequirementsEmpty": "Diese Match-Definition hat keine Anforderungen – die Anforderungs-Matrix bleibt leer.",
  "match.result.openFlag": "offen",
  "match.result.organizationalRecordBadge": "Mit Organisationsakte",
  "match.result.organizationalRecordBadgeTitle": "Nur für Akten-Berechtigte sichtbar",
  "match.result.openProfileTitle": "{name} – Profil öffnen",
  "match.result.powers.collapseClusterAria": "{cluster} einklappen",
  "match.result.powers.expandClusterAria": "{cluster} aufklappen – einzelne Powers anzeigen",
  "match.result.powers.memberBadge": "Mittel aller 30 Powers dieser Person (0–100)",
  "match.result.powers.memberBadgeUnmeasured": "Ohne Powers-Daten – zählt in keinem Schnitt mit",
  "match.result.powers.reqBadge": "Trägt zu {met} von {total} Power-Anforderungen bei",
  "match.result.powersBasis": "Basis: {measured} von {total} Personen",
  "match.result.powersColPower": "Power",
  "match.result.powersColStrong": "stark >{threshold}",
  "match.result.powersColStrongInfo": "Wie viele im Team bei dieser Power über {threshold} liegen.",
  "match.result.powersColWeight": "Gewichtung",
  "match.result.powersCoverageInfo": "Für {missing, plural, one {# Person} other {# Personen}} im Team liegt keine Power-Einschätzung vor. Alle Powers-Schnitte und -Zählungen laufen nur über die übrigen {measured}; wer fehlt, steht am Ende der Power-Scorecard-Matrix.",
  "match.result.powersCoverageInfoAria": "Erklärung zur Powers-Abdeckung anzeigen",
  "match.result.powersInTeam": "Powers im Team",
  "match.result.powersListHeader": "Top Powers",
  "match.result.powersScorecardInTeam": "Team vs Powers Scorecard",
  "match.result.powersSortScore": "Nach Team-Score",
  "match.result.powersSortWish": "Nach Gewichtung",
  "match.result.radarActual": "Team · Ist",
  "match.result.radarActualPerson": "Person · Ist",
  "match.result.radarScopeCluster": "Cluster",
  "match.result.radarKeyboardHint": "Powers-Radar – mit den Pfeiltasten die Achsen durchgehen",
  "match.result.radarScopeElement": "Alle {count} Powers",
  "match.result.radarTarget": "Powers Scorecard",
  "match.result.radarTitleActual": "Ist",
  "match.result.radarTitleUnmeasured": "{count, plural, =0 {niemand im Team eingeschätzt} one {nur # Person eingeschätzt} other {nur # Personen eingeschätzt}}",
  "match.result.radarTitleUnmeasuredPerson": "nicht bewertet",
  "match.result.radarTitleWish": "Gewichtung",
  "match.result.ranking.actualInline": "Nachweis:",
  "match.result.ranking.aiChip": "KI Begründung",
  "match.result.ranking.aiChipTitle": "Begründung aus der KI-Auswertung",
  "match.result.ranking.assessment.fazit": "Fazit",
  "match.result.ranking.assessment.interviewQuestions": "Fragen fürs Gespräch",
  "match.result.ranking.assessment.negative": "Negativ",
  "match.result.ranking.assessment.positive": "Positiv",
  "match.result.ranking.assessment.ratingHigh": "Geeignet",
  "match.result.ranking.assessment.ratingLow": "Eher ungeeignet",
  "match.result.ranking.assessment.ratingMedium": "Bedingt geeignet",
  "match.result.ranking.assessment.ratingVeryHigh": "Sehr geeignet",
  "match.result.ranking.assessment.ratingVeryLow": "Ungeeignet",
  "match.result.ranking.assessment.title": "Smycles Einschätzung",
  "match.result.ranking.collapseAll": "Alle einklappen",
  "match.result.ranking.criterionFailed": "nicht erfüllt",
  "match.result.ranking.criterionMet": "erfüllt",
  "match.result.ranking.dotFulfilled": "Erfüllt",
  "match.result.ranking.dotPartial": "Teilweise erfüllt",
  "match.result.ranking.dotUnfulfilled": "Nicht erfüllt",
  "match.result.ranking.dotUnknown": "Zu prüfen",
  "match.result.ranking.emptyFilteredTab": "Keine {requirement}-Kriterien unter „{tab}“.",
  "match.result.ranking.emptyHintLabel": "Hinweis",
  "match.result.ranking.emptyShowAll": "Alle Kriterien zeigen",
  "match.result.ranking.emptySwitchTab": "Zu „{tab}“ wechseln",
  "match.result.ranking.emptyTab": "Unter „{tab}“ gibt es keine Kriterien.",
  "match.result.ranking.expandAll": "Alle aufklappen",
  "match.result.ranking.filterAll": "Alle",
  "match.result.ranking.filterKann": "Kann",
  "match.result.ranking.filterMust": "Muss",
  "match.result.ranking.fulfilledTab": "Erfüllt ({count})",
  "match.result.ranking.kannTitle": "Kann-Kriterien",
  "match.result.ranking.kindBasics": "Personen-Details",
  "match.result.ranking.kindCertificate": "Zertifikat",
  "match.result.ranking.kindEducation": "Ausbildung",
  "match.result.ranking.kindExperience": "Berufserfahrung",
  "match.result.ranking.kindExpertise": "Fachkompetenz",
  "match.result.ranking.kindLanguage": "Sprache",
  "match.result.ranking.kindPowers": "Powers",
  "match.result.ranking.kpiPowerFit": "Power-Fit",
  "match.result.ranking.kpiSmycles": "Smycles Score",
  "match.result.ranking.lenientMatchHint": "Erfüllt per kulanter Anforderungsprüfung: Fachkompetenz vorhanden, geforderte Stufe nicht belegt.",
  "match.result.ranking.lenientTab": "Kulant erfüllt ({count})",
  "match.result.ranking.must": "Muss",
  "match.result.ranking.mustFormula": "Muss-Kriterien sind harte Gates: jedes muss erfüllt sein.",
  "match.result.ranking.mustInfoAria": "Muss-Kriterien anzeigen",
  "match.result.ranking.mustInfoTitle": "Muss-Kriterien",
  "match.result.ranking.mustMetSummary": "Erfüllt: {met}/{total}",
  "match.result.ranking.mustNone": "Keine Muss-Kriterien",
  "match.result.ranking.mustTitle": "Muss-Kriterien",
  "match.result.ranking.noAssessment": "Keine Smycles-Einschätzung vorhanden.",
  "match.result.ranking.noCriteria": "Keine Kriterien definiert",
  "match.result.ranking.noMustHint": "Hier landen Bewerber, die ein Muss-Kriterium (Schloss) verfehlen oder deren Score unter der C-Schwelle liegt.",
  "match.result.ranking.notRated": "Vorhanden · Stufe nicht bewertet",
  "match.result.ranking.openProfile": "Profil öffnen",
  "match.result.ranking.optional": "Kann",
  "match.result.ranking.powerFitClusterCompare": "Cluster im Vergleich",
  "match.result.ranking.powerFitClusterCompareExplainer": "Cluster-Werte dieser Person gegenüber dem Schnitt aller Kandidaten in dieser Rangliste.",
  "match.result.ranking.powerFitPoolCompareSummary": "{above} von {total} Clustern über dem Schnitt aller Kandidaten",
  "match.result.ranking.powerFitRadarExplainer": "Ist-Profil dieser Person gegenüber der Powers Scorecard des Matches.",
  "match.result.ranking.powerFitTiltsExplainer": "Wo diese Person zwischen den beiden Polen jeder Achse liegt.",
  "match.result.ranking.powerFitTiltsHeading": "Neigung",
  "match.result.ranking.powerFitTooltip": "Power-Fit: gewichtetes Mittel der eigenen Power-Werte dieser Person.",
  "match.result.ranking.review": "Zu prüfen",
  "match.result.ranking.reviewHint": "Hier landen Bewerber, bei denen ein Kriterium nicht bewertet werden konnte, etwa eine Fachkompetenz ohne eingestufte Stufe. Sie sind nicht durchgefallen, sondern brauchen einen Blick.",
  "match.result.ranking.reviewReasonBoth": "Muss und Kann nicht bewertbar",
  "match.result.ranking.reviewReasonKann": "Kann-Kriterien nicht bewertbar",
  "match.result.ranking.reviewReasonMust": "Muss-Kriterium nicht bewertbar",
  "match.result.ranking.scoreCoverage": "{assessable} von {defined} Kriterien bewertbar",
  "match.result.ranking.scoreCriteriaValue": "Kann-Kriterien: {criteria}",
  "match.result.ranking.scoreFormula": "Score = Durchschnitt der Kann-Kriterien.",
  "match.result.ranking.scoreInfoAria": "Rechenweg anzeigen",
  "match.result.ranking.scoreInfoTitle": "Rechenweg",
  "match.result.ranking.scoreMustGate": "Muss-Kriterien bleiben zusätzlich ein hartes Gate.",
  "match.result.ranking.scoreNotAssessable": "Kann-Kriterien: nicht bewertbar",
  "match.result.ranking.sortBy": "Sortieren nach",
  "match.result.ranking.sortPower": "Power-Fit",
  "match.result.ranking.sortRequirements": "Anforderungs-Fit",
  "match.result.ranking.sortSmycles": "Smycles",
  "match.result.ranking.tabNameFulfilled": "Erfüllt",
  "match.result.ranking.tabNameLenient": "Kulant erfüllt",
  "match.result.ranking.tabNameUnfulfilled": "Nicht erfüllt",
  "match.result.ranking.tabNameUnknown": "Zu prüfen",
  "match.result.ranking.thresholdAAria": "Schwelle zwischen A und B",
  "match.result.ranking.thresholdBAria": "Schwelle zwischen B und C",
  "match.result.ranking.thresholdCAria": "Untergrenze für C",
  "match.result.ranking.thresholdsLabel": "Schwellen",
  "match.result.ranking.toggleEvidence": "Nachweise für {name} anzeigen",
  "match.result.ranking.unfulfilledTab": "Nicht erfüllt ({count})",
  "match.result.ranking.unknownTab": "Zu prüfen ({count})",
  "match.result.ranking.unqualified": "Kriterien nicht erfüllt",
  "match.result.ranking.yearsValue": "{years, plural, one {# Jahr} other {# Jahre}}",
  "match.result.ranking.autoAdded": "Neu · automatisch bewertet am {date}",
  "match.result.rankingHeader": "Ranking",
  "match.result.requirementDiagram.axisFulfilled": "Erfüllt ↑",
  "match.result.requirementDiagram.axisUnfulfilled": "Nicht erfüllt ↓",
  "match.result.requirementDiagram.closeLabel": "Knapp",
  "match.result.requirementDiagram.noContributors": "Niemand im Team trägt das bei.",
  "match.result.requirementDiagram.personLevel": "Stufe: {level}",
  "match.result.requirementDiagram.ruleAll": "alle",
  "match.result.requirementDiagram.ruleAny": "mind. 1",
  "match.result.requirementDiagram.ruleExact": "genau {n}",
  "match.result.requirementDiagram.ruleExactUnknown": "genau ?",
  "match.result.requirementDiagram.ruleMax": "höchstens {n}",
  "match.result.requirementDiagram.ruleMaxUnknown": "höchstens ?",
  "match.result.requirementDiagram.ruleMin": "mind. {n}",
  "match.result.requirementDiagram.ruleMinUnknown": "mind. ?",
  "match.result.reviewSubtitle": "Optimiert auf dein Anforderungsprofil – transparent, erklärbar, exportierbar.",
  "match.result.riskEmptyCluster": "{count, plural, one {# Cluster ohne Träger} other {# Cluster ohne Träger}}",
  "match.result.riskSoleRequirement": "{count, plural, one {# Anforderung hängt an einer Person} other {# Anforderungen hängen an einer Person}}",
  "match.result.riskViolatedMust": "{count, plural, one {# Muss verletzt} other {# Muss verletzt}}",
  "match.result.saveResult": "Ergebnis speichern",
  "match.result.savedResultLabel": "Gespeichertes Ergebnis · {name}",
  "match.result.savedSubtitle": "Du siehst ein gespeichertes Ergebnis dieses Matches.",
  "match.result.sectionPicker.header": "Angezeigte Abschnitte",
  "match.result.sectionPicker.count": "{visible} von {total}",
  "match.result.sectionPicker.trigger": "Abschnitte",
  "match.result.sectionPicker.toggleAria": "{section} anzeigen",
  "match.result.skillMatrix": "Fachkompetenz-Matrix",
  "match.result.skillMatrixFocusSkill": "Skill Fokus",
  "match.result.skillMatrixFocusTeam": "Team Fokus",
  "match.result.skillMatrixUnrated": "vorhanden, keine Stufe",
  "match.result.skillMaxLevel": "bis {level}",
  "match.result.skillRequested": "Anforderung",
  "match.result.skillStrongHint": "stark ab {level}",
  "match.result.skillStrongOfTeam": "{n} von {total} stark",
  "match.result.skillStructureHeader": "Top Skills",
  "match.result.skillTotalAtAll": "{n} überhaupt",
  "match.result.solverErrorBody": "Genesis hat die Berechnung abgelehnt. Das passiert aktuell, wenn das Match-Design Felder enthält, die das Backend (noch) nicht kennt. Probier es nach kurzer Zeit erneut oder melde den Fall mit der unten stehenden Korrelations-ID.",
  "match.result.solverErrorHeading": "Das Backend hat den Solver nicht beendet.",
  "match.result.solverErrorTitle": "Solver-Fehler",
  "match.result.solverNotRun": "Solver noch nicht gelaufen.",
  "match.result.structureBoosters": "Booster-Deckung",
  "match.result.structureBoostersHint": "Booster sind die Powers mit der höchsten Innovationsrelevanz. Eine schwach gedeckte Zeile ist die konkrete Lücke des Teams.",
  "match.result.structureBoostersInfoAria": "Erklärung zur Booster-Deckung anzeigen",
  "match.result.structureBoostersInfoBody": "Gezeigt wird, wie viele der bewerteten Personen die Power stark mitbringen (über {threshold}). Eine solche Lücke lässt sich durch Umbesetzung schließen oder gezielt entwickeln.",
  "match.result.structureBoostersInfoTitle": "Booster und Lücken",
  "match.result.structureCarriers": "Cluster-Träger",
  "match.result.structureCarriersHint": "Träger = mindestens {min} von 5 Powers des Clusters über {threshold}; vollständig = alle 5 darüber.",
  "match.result.structureCarriersInfoAria": "Erklärung zur Zählung anzeigen",
  "match.result.structureCarriersInfoBody": "Gezählt werden die Personen mit Powers-Daten, nicht das ganze Team: „2 von 6“ heißt zwei Träger unter sechs bewerteten Personen.",
  "match.result.structureCarriersInfoTitle": "Was gezählt wird",
  "match.result.structureHeader": "Powers Profilstruktur",
  "match.result.structureOfTeam": "{n} von {total}",
  "match.result.structureSignature": "· {n} vollständig",
  "match.result.structureThresholdHint": "Powers über {threshold}",
  "match.result.suitability.basis": "AI-Gesamteinschätzung",
  "match.result.suitability.empty": "Noch keine AI-Eignungsscores vorhanden. Bitte den Match erneut ausführen.",
  "match.result.suitability.header": "Top 5 – beste Eignung",
  "match.result.suitability.openProfile": "{name} – Profil öffnen",
  "match.result.suitability.rankLabel": "Rang {rank}",
  "match.result.suitability.scoreLabel": "AI-Eignung {score} %",
  "match.result.teamHeader": "Team · {count, plural, one {# Person} other {# Personen}}",
  "match.result.teamPowers": "Power-Scorecard-Matrix",
  "match.result.teamSizeMeta": "Teamgröße {count}",
  "match.result.tilt.axis.DRIVE": "Antrieb ↔ Anziehung",
  "match.result.tilt.axis.MINDSET": "Exploit ↔ Explore",
  "match.result.tilt.balanced": "ausgeglichen",
  "match.result.tilt.bothWeak": "beidseitig schwach",
  "match.result.tilt.grade.CLEAR": "klar {side}",
  "match.result.tilt.grade.LEANS": "eher {side}",
  "match.result.tilt.grade.STRONG": "deutlich {side}",
  "match.result.tilt.info.DRIVE": "Anteil der Powers über {threshold}: Antrieb {a}%, Anziehung {b}%. Antriebskräfte treiben von innen an, Anziehungskräfte schaffen die Bedingungen, unter denen Antrieb im Team ankommt. Verglichen werden Anteile, weil Antrieb vier Cluster umfasst und Anziehung zwei.",
  "match.result.tilt.info.MINDSET": "Anteil der Powers über {threshold}, innerhalb des Antriebs: Exploit {a}%, Explore {b}%. Exploit sichert und optimiert das Bestehende, Explore öffnet das Mögliche. Teams, die beides vereinen, sind leistungsfähiger als einseitige.",
  "match.result.tilt.infoAria": "Erklärung zu den Team-Achsen anzeigen",
  "match.result.tilt.infoNoise": "Die Abstufung richtet sich danach, wie weit der Unterschied seinen eigenen Stichprobenfehler übersteigt: eher = darüber, klar = das Anderthalbfache, deutlich = das Doppelte. Mehr als diese drei Stufen wird nicht angegeben: bei dieser Teamgröße ist der genaue Unterschied nicht belastbar genug, um als Zahl zu gelten.",
  "match.result.tilt.notSignificant": "Unterschied zu klein, um ihn zu deuten",
  "match.result.tilt.side.EXPLOIT": "Exploit",
  "match.result.tilt.side.EXPLORE": "Explore",
  "match.result.tilt.side.PULL": "Anziehung",
  "match.result.tilt.side.PUSH": "Antrieb",
  "match.result.unlockMembers": "Mitglieder entsperren",
  "match.result.unnamed": "ohne Namen",
  "match.result.weightedPowersInfoAria": "Erklärung zu dieser Liste anzeigen",
  "match.result.weightedPowersInfoBody": "Alle 30 Powers des Teams, sortierbar nach Team-Score oder nach Gewichtung. Gewichtung: der Wert 0–10 aus der Powers Scorecard, mit dem die Auswahl gesteuert wurde. Ø: das Mittel des Teams bei dieser Power, 0–100.",
  "match.result.weightedPowersInfoTitle": "Was hier steht",
  "match.result.weightedPowersSoleHint": "„nur …“ heißt: einzige Person, die diese Power stark mitbringt.",
  "match.result.wishFitDelta": "{delta} gegenüber dem Schnitt über alle 30 Powers",
  "match.result.wishFitInfoAria": "Erklärung zur Gewichtung anzeigen",
  "match.result.wishFitInfoBody": "In der Powers Scorecard legst du fest, welche Powers dir wichtig sind (0–10). Die Zahl sagt, ob das Team genau dort über oder unter seinem eigenen Schnitt über alle 30 Powers liegt; Powers mit Gewichtung 0 zählen nicht mit. Eine Gewichtung ist keine Anforderung: sie lenkt die Auswahl, setzt aber keine Schwelle – deshalb gibt es hier kein Erfüllt und keine Lücke. Wer welche Power stark mitbringt, steht in „Top Powers“.",
  "match.result.wishFitInfoTitle": "Was hier verglichen wird",
  "match.result.wishFitPoolNote": "mehr gab der Kandidatenpool nicht her",
  "match.roleReqsSection": "Rollenanforderungen",
  "match.save.eyebrow": "Ergebnis speichern",
  "match.save.failed": "Speichern fehlgeschlagen",
  "match.save.modeAssess": "Bewerten",
  "match.save.modeOptimize": "Optimieren",
  "match.save.modeRank": "Rangliste",
  "match.save.modeRankCompanies": "Unternehmen vergleichen",
  "match.save.note": "Notiz",
  "match.save.sections": "Angezeigte Abschnitte",
  "match.save.notePlaceholder": "Optional – Kontext, Annahmen, nächste Schritte …",
  "match.save.off": "aus",
  "match.save.on": "ein",
  "match.save.previewAndNote": "Vorschau & Notiz",
  "match.save.resultName": "Ergebnis-Name",
  "match.save.retry": "Erneut versuchen",
  "match.save.saved": "Gespeichert",
  "match.save.saving": "Speichert…",
  "match.save.statAgenticAi": "Agentic AI",
  "match.save.statConditions": "Bedingungen",
  "match.save.statMode": "Modus",
  "match.save.statPool": "Pool",
  "match.save.statTarget": "Soll",
  "match.save.teamCount": "Team · {count, plural, one {# Person} other {# Personen}}",
  "match.settingsEyebrow": "Match-Einstellungen",
  "match.shortDescPlaceholder": "In einem Satz: was, wofür?",
  "match.step.challenge": "Challenge",
  "match.step.companies": "Unternehmen",
  "match.step.people": "Teamplayer",
  "match.step.peopleRank": "Kandidaten",
  "match.step.result": "Result",
  "match.teamPowers": "Power-Scorecard",
  "match.teamProfile": "Auswahl",
  "match.teamProfileCustom": "Individuell",
  "match.teamProfileModifiedSuffix": " · geändert",
  "match.teamReqsSection": "Teamanforderungen",
  "match.teamSizeSection": "Größe des Teams",
  "match.titlePlaceholder": "z. B. Set-Crew BTL · Q2 2026",
  "match.tour.create.desc": "Dieser Button erstellt ein neues Match und öffnet den Editor. Dort beschreibst du, was du brauchst, und der Solver schlägt das Team vor.",
  "match.tour.create.title": "Neues Match erstellen",
  "match.tour.label": "Match",
  "match.tour.list.desc": "Alle deine Matches wohnen hier. Klicke eine Karte, um sie wieder zu öffnen und weiterzumachen.{names}",
  "match.tour.list.names": "Aktuell: {list}.",
  "match.tour.list.title": "Deine Matches",
  "match.tour.summary": "Das ist der Match-Bereich: Hier stellst du Teams aus Menschen und Anforderungen zusammen. Du hast bisher {count} Matches.",
  "match.unnamedMatch": "Unbenanntes Match",
  "match.unnamedProject": "Unbenanntes Projekt",
  "match.validationRejected": "Genesis hat die Anfrage abgelehnt.",
  "match.weightInput.label": "Gewicht für {power}",
  "match.weightLevel.high": "Hoch",
  "match.weightLevel.low": "Niedrig",
  "match.weightLevel.medium": "Mittel",
  "match.weightLevel.none": "Nicht relevant",
  "match.workflow.challengeSubtitle": "Beschreibe oben dein Projekt – die KI leitet daraus Team-Größe, Anforderungen und Powers ab. Darunter kontrollierst du das Ergebnis und justierst kleine Stellschrauben.",
  "match.workflow.challengeSubtitleNoTeamSize": "Beschreibe oben dein Projekt – die KI leitet daraus Anforderungen und Powers ab. Darunter kontrollierst du das Ergebnis und justierst kleine Stellschrauben.",
  "match.workflow.challengeSubtitleRank": "Beschreibe oben die Rolle bzw. offene Stelle – die KI leitet daraus die Anforderungen ab, die ein:e Kandidat:in erfüllen soll. Darunter kontrollierst du das Ergebnis und justierst kleine Stellschrauben.",
  "match.workflow.challengeSubtitleRankCompanies": "Beschreibe oben deinen Bedarf. Darunter legst du fest, welche Anforderungen ein Unternehmen erfüllen soll.",
  "match.workflow.deleteConfirm.confirm": "Löschen",
  "match.workflow.deleteConfirm.message": "Das Match wird endgültig aus genesis entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
  "match.workflow.deleteConfirm.title": "Match löschen?",
  "match.workflow.deleteTitle": "Match löschen",
  "match.workflow.modeAssess": "Bewerten",
  "match.workflow.modeIndicatorTitle": "Modus (bei Erstellung festgelegt)",
  "match.workflow.modeOptimize": "Optimieren",
  "match.workflow.modeRank": "Rangliste",
  "match.workflow.modeRankCompanies": "Unternehmen vergleichen",
  "match.workflow.nextTo": "Weiter zu {label}",
  "match.workflow.prevTo": "Zurück zu {label}",
  "match.workflow.settingsTitle": "Match-Einstellungen",
  "match.workflow.unnamedProject": "Unbenanntes Projekt",
  "match.listing.unnamed": "Unbenannte Ausschreibung",
  "matchDetail.tour.label": "Match Detail",
  "matchDetail.tour.summary": "Du bearbeitest das Match „{name}“, gerade im Workflow-Schritt „{step}“ mit {candidates} Kandidaten und {results} gespeicherten Ergebnissen. Arbeite die Schritte von den Anforderungen bis zum fertigen Team durch.",
  "matchDetail.tour.untitled": "unbenanntes Match",
  "model.connected": "Verbunden",
  "model.docs.cancel": "Abbrechen",
  "model.docs.cancelKeep": "Weiter verarbeiten",
  "model.docs.cancelMessage": "„{title}“ wird nicht weiter verarbeitet und entfernt.",
  "model.docs.cancelReprocessConfirm": "Neuverarbeitung stoppen",
  "model.docs.cancelReprocessMessage": "„{title}“ bleibt unverändert. Die laufende Verarbeitung wird verworfen.",
  "model.docs.cancelReprocessTitle": "Neuverarbeitung stoppen?",
  "model.docs.cancelTitle": "Verarbeitung abbrechen?",
  "model.docs.delete": "Löschen",
  "model.docs.deleteMessage": "„{title}“ und der extrahierte Inhalt werden entfernt.",
  "model.docs.deleteTitle": "Dokument löschen?",
  "model.docs.descLabel": "Dokumentbeschreibung",
  "model.docs.descPlaceholder": "Worum es geht (optional)",
  "model.docs.download": "Herunterladen",
  "model.docs.dropHint": "PDF, Word, PowerPoint und mehr, bis zu 50 MB",
  "model.docs.dropLabel": "Dokument hierher ziehen oder zum Auswählen klicken",
  "model.docs.duplicate": "Dieses Dokument wurde bereits hochgeladen.",
  "model.docs.empty": "Noch keine Dokumente.",
  "model.docs.enabledLabel": "Aktiviert",
  "model.docs.failedHint": "Verarbeitung fehlgeschlagen. Erneut verarbeiten oder das Dokument neu hochladen.",
  "model.docs.loadError": "Dokumente konnten nicht geladen werden.",
  "model.docs.needFile": "Zum Hochladen ein Dokument auswählen.",
  "model.docs.needSections": "Mindestens einen Bereich auswählen.",
  "model.docs.needTitle": "Titel angeben.",
  "model.docs.reprocess": "Neu verarbeiten",
  "model.docs.sectionGlobal": "Globale Dokumente",
  "model.docs.sectionUploaded": "Hochgeladene Dokumente",
  "model.docs.status.failed": "Fehlgeschlagen",
  "model.docs.status.pending": "Ausstehend",
  "model.docs.status.processing": "In Bearbeitung",
  "model.docs.status.processingFor": "In Bearbeitung ({provider})",
  "model.docs.status.ready": "Bereit",
  "model.docs.status.reembedRequired": "Neue Verarbeitung erforderlich ({provider})",
  "model.docs.sub": "Dokumente, die der Assistent durchsuchen kann. Uploads werden im Hintergrund verarbeitet.",
  "model.docs.textOnly": "Nur Text",
  "model.docs.textOnlyForced": "Aus diesem Dateityp können keine Bilder extrahiert werden; er wird als Text indexiert.",
  "model.docs.textOnlyHint": "Bilder überspringen für schnellere Verarbeitung; Text bleibt durchsuchbar.",
  "model.docs.title": "Wissensdokumente",
  "model.docs.titleLabel": "Dokumenttitel",
  "model.docs.titlePlaceholder": "Titel (erforderlich)",
  "model.docs.unavailableHint": "Nicht für den aktuellen Anbieter eingebettet. Neu einbetten, um es durchsuchbar zu machen.",
  "model.docs.upload": "Hochladen und verarbeiten ({provider})",
  "model.docs.uploadBlocked": "Warten, bis der Anbieterwechsel wirksam ist… ({seconds}s)",
  "model.docs.uploadError": "Upload fehlgeschlagen – bitte erneut versuchen.",
  "model.docs.uploadedAt": "Hochgeladen am {date}",
  "model.docs.worksWith": "Funktioniert mit diesem Anbieter",
  "model.keyAriaLabel": "{provider} API-Schlüssel",
  "model.providerSub": "Der zugrunde liegende Modell-Stack. Modellarten werden auf die konkreten Modelle dieses Anbieters aufgelöst.",
  "model.providerSwitchHint": "Der Wechsel zu {provider} ändert das Embedding-Modell ({from} → {to}). Möglicherweise müssen die Dokumente nach dem Speichern erneut verarbeitet werden, damit sie durchsuchbar bleiben.",
  "model.providerTitle": "Anbieter",
  "model.providerUnavailable": "Noch nicht verfügbar",
  "model.resolvedModels": "Aufgelöste Modelle",
  "model.saveError": "Modelleinstellungen konnten nicht gespeichert werden – bitte erneut versuchen.",
  "model.saveError.apiKeyRequired": "Vor dem Aktivieren einen API-Schlüssel für diesen Anbieter hinterlegen.",
  "model.saveError.forbidden": "Für Änderungen an der Modellkonfiguration sind Administratorrechte erforderlich.",
  "model.saveError.notConfigured": "Die Modellkonfiguration ist auf diesem Server nicht aktiviert.",
  "model.saveError.providerNotServable": "Dieser Anbieter wird noch nicht unterstützt – bitte einen anderen wählen.",
  "model.saveError.unauthorized": "Ihre Sitzung ist abgelaufen – bitte erneut anmelden.",
  "model.saveError.upstream": "Der Konfigurationsspeicher ist nicht erreichbar – bitte erneut versuchen.",
  "model.saved": "Einstellungen gespeichert – die Änderung kann bis zu 30 Sekunden dauern.",
  "model.sources.keyLabel": "API-Schlüssel",
  "model.sources.pubmed.hint": "Fachartikel und Abstracts aus PubMed über die NCBI E-utilities. Ohne Schlüssel bis zu 3 Anfragen pro Sekunde, mit Schlüssel 10.",
  "model.sources.pubmed.keyLink": "Schlüssel im NCBI-Konto anlegen",
  "model.sources.pubmed.keyPlaceholder": "Ihr NCBI-API-Schlüssel",
  "model.sources.pubmed.offer": "Im Studio anbieten",
  "model.sources.pubmed.publisher": "NCBI · U.S. National Library of Medicine",
  "model.sources.sub": "Fachdatenbanken, die der Assistent zusätzlich zum Web durchsuchen darf.",
  "model.sources.title": "Recherchequellen",
  "model.webSearch.hint": "Recherche im öffentlichen Web über {provider}, kostenpflichtig pro Suche. Premium ergänzt geprüfte Nachrichtenquellen.",
  "model.webSearch.label": "Websuche",
  "model.webSearch.off": "Aus",
  "model.webSearch.premium": "Premium",
  "model.webSearch.standard": "Standard",
  "model.webSearch.unavailable": "Für diesen Anbieter nicht verfügbar.",
  "nav.community": "Community",
  "nav.inviteOutsider": "Externe Person einladen",
  "nav.logout": "Abmelden",
  "nav.mainLandmark": "Hauptnavigation",
  "nav.map": "Map",
  "nav.myCompanies": "Meine Unternehmen",
  "nav.newCompany": "Neues Unternehmen",
  "nav.openMenu": "Menü öffnen",
  "nav.pins": "Pins",
  "nav.play": "Play",
  "nav.profile": "Profil",
  "nav.service": "Dokumente",
  "nav.settings": "Einstellungen",
  "nav.studio": "Studio",
  "nav.watch": "Watch",
  "organizationalRecord.backToProfile": "Zum Profil",
  "organizationalRecord.comments.newest": "Neueste zuerst",
  "organizationalRecord.comments.oldest": "Älteste zuerst",
  "organizationalRecord.contentField": "Inhalt",
  "organizationalRecord.create": "Organisationsakte anlegen",
  "organizationalRecord.deleteDocument": "Dokument löschen?",
  "organizationalRecord.deleteEntry": "Eintrag löschen?",
  "organizationalRecord.deleteEntryHelp": "Die Kommentare zu diesem Eintrag werden ebenfalls gelöscht.",
  "organizationalRecord.globalDescription": "Organisationsinterne Unterlagen {subject, select, company {zu diesem Unternehmen} other {zu dieser Person}}. Ihr Aktenzugriff gilt global, auch außerhalb Ihrer Abteilung und Bewerbungen.",
  "organizationalRecord.description": "{subject, select, company {Interne Dokumente und Diskussionen der Organisation zu diesem Unternehmen.} other {Interne Dokumente und Diskussionen der Organisation zu dieser Person.}}",
  "organizationalRecord.discussion": "Allgemeine Diskussion",
  "organizationalRecord.documents": "Dokumente",
  "organizationalRecord.documentsHint": "{subject, select, company {Dokumente in der Organisationsakte dieses Unternehmens.} other {Dokumente in der Organisationsakte dieser Person.}}",
  "organizationalRecord.powerAnalysisDesc": "Ermittelt die Powers der Person aus Dokumenten ihrer Akte. Du prüfst das Ergebnis, bevor es ins Profil geht.",
  "organizationalRecord.powerAnalysisNeedsDocument": "Lade zuerst ein Dokument in die Akte, dann lässt sich die Power-Analyse starten.",
  "organizationalRecord.download": "Herunterladen",
  "organizationalRecord.drafts.discardEntry": "Die ungespeicherten Änderungen an dieser Notiz oder diesem Bericht einschließlich der Verlinkungen verwerfen?",
  "organizationalRecord.drafts.invalid": "Vervollständige Titel und Inhalt deiner Notizen oder Berichte und prüfe die Textlänge. Kommentare benötigen Text (bis zu 4.096 Zeichen); Notizen und Berichte erlauben 255 Zeichen im Titel und 65.535 im Inhalt.",
  "organizationalRecord.editEntry": "Eintrag bearbeiten",
  "organizationalRecord.empty": "{subject, select, company {Für dieses Unternehmen wurde noch keine Organisationsakte angelegt.} other {Für diese Person wurde noch keine Organisationsakte angelegt.}}",
  "organizationalRecord.entries": "Notizen & Berichte",
  "organizationalRecord.heading": "Organisationsakte",
  "organizationalRecord.kind": "Art",
  "organizationalRecord.links.add": "{title} verknüpfen ({kind})",
  "organizationalRecord.links.comment": "Diskussionskommentar",
  "organizationalRecord.links.details": "Details & Verknüpfungen",
  "organizationalRecord.links.downloaded": "Die Datei wurde heruntergeladen, da dieses Format keine Vorschau unterstützt.",
  "organizationalRecord.links.label": "Verknüpft",
  "organizationalRecord.links.noMatches": "Keine passenden Dokumente oder Einträge.",
  "organizationalRecord.links.remove": "Verknüpfung zu {title} entfernen",
  "organizationalRecord.links.search": "Dokumente und Einträge dieser Organisationsakte suchen …",
  "organizationalRecord.links.select": "Dokument oder Eintrag verknüpfen",
  "organizationalRecord.links.unavailable": "Dieser Inhalt ist in dieser Organisationsakte nicht mehr verfügbar.",
  "organizationalRecord.links.unused": "Noch keine Verweise auf diesen Inhalt.",
  "organizationalRecord.links.usedIn": "Verwendet in",
  "organizationalRecord.newEntry": "Notiz / Bericht anlegen",
  "organizationalRecord.noAccess": "Für diesen Bereich benötigst du die Organisationsrolle Manager/HR.",
  "organizationalRecord.noDocuments": "Noch keine Dokumente.",
  "organizationalRecord.noEntries": "Noch keine Notizen oder Berichte.",
  "organizationalRecord.note": "Notiz",
  "organizationalRecord.preview": "Vorschau",
  "organizationalRecord.rename": "Umbenennen",
  "organizationalRecord.report": "Bericht",
  "organizationalRecord.titleField": "Titel",
  "organizationalRecord.updated": "Bearbeitet von {name} am {date}",
  "organizationalRecord.upload": "Dokument hochladen",
  "organizationalRecord.uploadHelp": "PDF, Office, Text oder Bilder · maximal 10 MB pro Datei",
  "organizationalRecord.uploadRejected": "Bitte wähle eine unterstützte, nicht leere Datei mit maximal 10 MB.",
  "person.email.missing": "Keine E-Mail hinterlegt",
  "personFilter.addFilter": "+ Filter hinzufügen",
  "personFilter.allFilters": "Alle Filter",
  "personFilter.frequent": "Häufig",
  "personFilter.heading": "Teamplayer-Filter{count, plural, =0 {} other { · # aktiv}}",
  "pinboard.tour.controls.desc": "Suche Pins nach Namen, ändere die Sortierung oder filtere auf Pins, die noch in keiner Gruppe sind.",
  "pinboard.tour.controls.title": "Suchen & Sortieren",
  "pinboard.tour.grid.desc": "{count} {typeLabel} in der aktuellen Ansicht. Klicke eine Karte, um sie zu öffnen, nutze „+ Hinzufügen“ für Gruppen oder das Papierkorb-Symbol zum Entpinnen.",
  "pinboard.tour.grid.title": "Deine gepinnten Einträge",
  "pinboard.tour.label": "Save Pins",
  "pinboard.tour.sidebar.desc": "Wechsle zwischen deinen gepinnten Personen ({people}), Beiträgen ({posts}) und Projekten ({projects}) und wähle darunter eine Pin-Gruppe. Ziehe eine Karte auf eine Gruppe, um sie dort abzulegen.",
  "pinboard.tour.sidebar.title": "Typen & Gruppen",
  "pinboard.tour.summary": "Das ist deine Pinnwand mit allem, was du gespeichert hast: {people} Personen, {posts} Beiträge und {projects} Projekte.",
  "power.instrument.journey": "Power Journey",
  "power.instrument.parts": "{answered} / {total} Teile",
  "power.instrument.quiz": "Power Quiz",
  "power.instrument.inDepthStatements": "{answered} / {total} vertiefende Aussagen",
  "power.name.Abs": "Abstraktion",
  "power.name.Ada": "Adaption",
  "power.name.Agg": "Aggression",
  "power.name.Aut": "Autonomie",
  "power.name.Awe": "Selbstwahrnehmung",
  "power.name.Cha": "Charisma",
  "power.name.Con": "Konzentration",
  "power.name.Cou": "Mut",
  "power.name.Cur": "Neugierde",
  "power.name.Dil": "Sorgfalt",
  "power.name.Emp": "Empathie",
  "power.name.Exp": "Expression",
  "power.name.Fai": "Glaube",
  "power.name.Fid": "Treue",
  "power.name.Fns": "Fairness",
  "power.name.Hum": "Humor",
  "power.name.Ima": "Imagination",
  "power.name.Imp": "Improvisation",
  "power.name.Ins": "Inspiration",
  "power.name.Int": "Intention",
  "power.name.Inu": "Intuition",
  "power.name.Joy": "Freude",
  "power.name.Lan": "Sprache",
  "power.name.Min": "Achtsamkeit",
  "power.name.Pas": "Passion",
  "power.name.Per": "Wahrnehmung",
  "power.name.Psc": "Ausdauer",
  "power.name.Rpy": "Verantwortung",
  "power.name.Str": "Strategie",
  "power.name.Tol": "Toleranz",
  "power.tag.Co": "Kommunikationsfähigkeit",
  "power.tag.Co.description": "Das Erfassen und Vermitteln. Diese Powers verwandeln inneres Erleben in geteilte Wahrnehmung, Sprache und Ausdruck.",
  "power.tag.Fo": "Zukunftsorientierung",
  "power.tag.Fo.description": "Richtung auf das Ungewisse. Diese Powers geben dem Team die Kraft, über das Bestehende hinauszudenken und ins Offene zu gehen.",
  "power.tag.In": "Erfindungsstärke",
  "power.tag.In.description": "Das Erschließen des Neuen. Diese Powers öffnen den Raum jenseits des Bekannten und halten das Team lernfähig.",
  "power.tag.Re": "Belastbarkeit",
  "power.tag.Re.description": "Stabilität unter Last. Diese Powers halten das Team handlungsfähig, wenn Druck, Dauer und Widerstand zunehmen.",
  "power.tag.Ro": "Ergebnisorientierung",
  "power.tag.Ro.description": "Verbindlichkeit im Ergebnis. Diese Powers verwandeln Absicht in verlässlich vollendete, wirksame Arbeit.",
  "power.tag.Ts": "Teamfähigkeit",
  "power.tag.Ts.description": "Der Kitt der Gemeinschaft. Diese Powers machen aus Einzelnen ein tragfähiges, vielfältiges und belastbares Miteinander.",
  "profile.fields.addCountry": "+ Land",
  "profile.fields.avatarAlt": "Avatar",
  "profile.fields.changePhoto": "Foto ändern",
  "profile.fields.removePhoto": "Foto entfernen",
  "profile.merge.add": "Hinzufügen",
  "profile.merge.badge.conflict": "Weicht ab",
  "profile.merge.badge.new": "Neu",
  "profile.merge.bar.allReviewed": "Alle Änderungen geprüft",
  "profile.merge.bar.aria": "Importänderungen",
  "profile.merge.bar.next": "Weiter",
  "profile.merge.bar.open": "{count, plural, one {# Feld zu prüfen} other {# Felder zu prüfen}}",
  "profile.merge.bar.previous": "Zurück",
  "profile.merge.cefr.native": "Muttersprachler",
  "profile.merge.chooseAria": "Eigenen Wert behalten oder den importierten verwenden",
  "profile.merge.date.beforeBirth": "Dieses Datum liegt vor dem Geburtsdatum.",
  "profile.merge.date.format": "Verwende ein Datum wie JJJJ, JJJJ-MM oder JJJJ-MM-TT.",
  "profile.merge.date.future": "Dieses Datum darf nicht in der Zukunft liegen.",
  "profile.merge.date.range": "Das Enddatum muss am oder nach dem Startdatum liegen.",
  "profile.merge.dateBlocked": "Einige Daten müssen vor dem Speichern korrigiert werden.",
  "profile.merge.editAria.existing": "Deinen Wert bearbeiten",
  "profile.merge.editAria.incoming": "Importierten Wert bearbeiten",
  "profile.merge.field.childCountMax": "Die Anzahl der Kinder darf {max} nicht überschreiten.",
  "profile.merge.field.childCountNegative": "Die Anzahl der Kinder darf nicht negativ sein.",
  "profile.merge.field.invalidEmail": "Bitte eine gültige E-Mail-Adresse eingeben.",
  "profile.merge.field.invalidPhone": "Bitte eine gültige Telefonnummer eingeben.",
  "profile.merge.field.invalidUrl": "Bitte eine gültige Webadresse eingeben.",
  "profile.merge.field.tooLong": "Bitte auf höchstens {max} Zeichen kürzen.",
  "profile.merge.fieldBlocked": "Einige Werte müssen vor dem Speichern korrigiert werden.",
  "profile.merge.guide.review": "Prüfen",
  "profile.merge.guide.step": "{current, number} von {total, number}",
  "profile.merge.incomingLabel": "Importiert",
  "profile.merge.keep": "Meine behalten",
  "profile.merge.keepAll": "Alle meine behalten",
  "profile.merge.language.unknown": "„{value}“ ist keine erkennbare Sprache. Bitte die richtige wählen oder den Eintrag überspringen.",
  "profile.merge.languageBlocked": "Bitte eine echte Sprache für den importierten Eintrag wählen oder ihn überspringen.",
  "profile.merge.replacesSaved": "Ersetzt deinen gespeicherten Wert",
  "profile.merge.replacesSavedRow": "Ersetzt deinen gespeicherten Eintrag",
  "profile.merge.reset.existing": "Auf deinen gespeicherten Wert zurücksetzen",
  "profile.merge.reset.incoming": "Auf den importierten Wert zurücksetzen",
  "profile.merge.reviewBlocked": "Prüfe jede Änderung vor dem Speichern.",
  "profile.merge.save": "Änderungen speichern",
  "profile.merge.saveFailed": "Diese Änderung konnte nicht gespeichert werden.",
  "profile.merge.savePartial": "{count, plural, one {# Änderung konnte nicht gespeichert werden. Bitte erneut versuchen.} other {# Änderungen konnten nicht gespeichert werden. Bitte erneut versuchen.}}",
  "profile.merge.saving": "Wird gespeichert…",
  "profile.merge.showLess": "Weniger anzeigen",
  "profile.merge.showMore": "Mehr anzeigen",
  "profile.merge.side.existing": "Dein Wert",
  "profile.merge.skills.importAllAria": "Alle Kenntnisse importieren",
  "profile.merge.skip": "Überspringen",
  "profile.merge.status.add": "Wird hinzugefügt",
  "profile.merge.status.keep": "Dein Wert bleibt",
  "profile.merge.status.skip": "Übersprungen",
  "profile.merge.status.use": "Importierter Wert wird verwendet",
  "profile.merge.use": "Übernehmen",
  "profile.merge.useAll": "Alle importierten übernehmen",
  "profile.page.add.certificate": "Zertifikat hinzufügen",
  "profile.page.add.education": "Ausbildung hinzufügen",
  "profile.page.add.experience": "Berufserfahrung hinzufügen",
  "profile.page.add.expertise": "Skill hinzufügen",
  "profile.page.add.language": "Sprache hinzufügen",
  "profile.page.addToCommunity": "Community",
  "profile.page.addToPins": "Pins",
  "profile.page.ageSuffix": "{age} Jahre",
  "profile.page.avatar.notAnImage": "Wähle eine Bilddatei.",
  "profile.page.avatar.notReadable": "Diese Datei konnte nicht als Bild gelesen werden.",
  "profile.page.avatar.tooLarge": "Wähle ein Bild mit maximal {max} MB.",
  "profile.page.avatar.tooManyPixels": "Dieses Bild ist zu groß zum Zuschneiden. Nutze eines unter {max} Megapixel.",
  "profile.page.businessCard": "Visitenkarte",
  "profile.page.businessCardRoleHint": "Übernommen aus Details › Unternehmen › Berufsbezeichnung",
  "profile.page.details": "Details",
  "profile.page.details.company": "Unternehmen",
  "profile.page.details.personal": "Persönlich",
  "profile.page.editVisibility": "Sichtbarkeiten bearbeiten",
  "profile.page.empty.certificates": "Keine Zertifikate",
  "profile.page.empty.education": "Keine Ausbildung",
  "profile.page.empty.experience": "Keine Berufserfahrung",
  "profile.page.empty.expertise": "Keine Skills",
  "profile.page.empty.languages": "Keine Sprachen",
  "profile.page.error.certificateNameRequired": "Name ist erforderlich.",
  "profile.page.error.educationContentRequired": "Gib eine Fachrichtung, eine Bildungseinrichtung oder einen Abschluss an.",
  "profile.page.error.invalidFields": "{count, plural, one {Ein Feld muss noch korrigiert werden} other {# Felder müssen noch korrigiert werden}}, bevor gespeichert werden kann.",
  "profile.page.error.jobTitleRequired": "Stellenbezeichnung ist erforderlich.",
  "profile.page.error.languageLevelRequired": "Bitte ein Niveau für die Fremdsprache wählen.",
  "profile.page.error.nameRequired": "Vorname und Nachname sind erforderlich.",
  "profile.page.error.saveCertificate": "Das Zertifikat konnte nicht gespeichert werden.",
  "profile.page.error.saveEducation": "Die Ausbildung konnte nicht gespeichert werden.",
  "profile.page.error.saveEntriesFailedCount": "{count, plural, one {# Eintrag konnte nicht gespeichert werden.} other {# Einträge konnten nicht gespeichert werden.}}",
  "profile.page.error.saveExperience": "Die Erfahrung konnte nicht gespeichert werden.",
  "profile.page.error.saveLanguage": "Die Sprache konnte nicht gespeichert werden.",
  "profile.page.error.savePerson": "Person konnte nicht gespeichert werden",
  "profile.page.error.saveSkill": "Die Fachkompetenz konnte nicht gespeichert werden.",
  "profile.page.error.skillNameRequired": "Ein Name ist erforderlich.",
  "profile.page.error.startDateRequired": "Startdatum ist erforderlich.",
  "profile.page.error.tooManyActivities": "Nicht mehr als {max} Einträge.",
  "profile.page.familyName.placeholder": "Nachname",
  "profile.page.field.activities.counter": "{count} von {max}",
  "profile.page.field.activities.label": "Hauptaufgaben",
  "profile.page.field.activities.placeholder": "z. B. Code-Reviews",
  "profile.page.field.cefr": "Niveau (CEFR)",
  "profile.page.field.certificateName.label": "Bezeichnung",
  "profile.page.field.certificateName.placeholder": "z. B. AWS Solutions Architect",
  "profile.page.field.country": "Land",
  "profile.page.field.degree.label": "Abschluss",
  "profile.page.field.degree.none": "Kein Abschluss ausgewählt",
  "profile.page.field.degree.placeholder": "Abschluss auswählen",
  "profile.page.field.degree.search": "Abschluss suchen",
  "profile.page.field.department": "Abteilung",
  "profile.page.field.employer.label": "Arbeitgeber",
  "profile.page.field.employer.placeholder": "z. B. Smycles GmbH",
  "profile.page.field.expertiseName.label": "Bezeichnung",
  "profile.page.field.expertiseName.placeholder": "z. B. Kubernetes",
  "profile.page.field.field.label": "Fachrichtung",
  "profile.page.field.field.placeholder": "z. B. Informatik",
  "profile.page.field.from": "Von",
  "profile.page.field.industry": "Branche",
  "profile.page.field.institution": "Bildungseinrichtung",
  "profile.page.field.issueDate": "Ausstellungsdatum",
  "profile.page.field.jobTitle.label": "Stellenbezeichnung",
  "profile.page.field.jobTitle.placeholder": "z. B. Softwareentwickler",
  "profile.page.field.language.label": "Sprache",
  "profile.page.field.language.placeholder": "Sprache wählen",
  "profile.page.field.level": "Stufe",
  "profile.page.field.location": "Ort",
  "profile.page.field.nativeSpeaker.label": "Muttersprache",
  "profile.page.field.nativeSpeaker.placeholder": "Muttersprache",
  "profile.page.field.to": "Bis",
  "profile.page.givenName.placeholder": "Vorname",
  "profile.page.hideVisibility": "Sichtbarkeiten ausblenden",
  "profile.page.inCommunity": "In Community",
  "profile.page.inPins": "In Pins",
  "profile.page.label.apartment": "Wohnung",
  "profile.page.label.birthday": "Geburtstag",
  "profile.page.label.childCount": "Anzahl Kinder",
  "profile.page.label.citizenship": "Staatsangehörigkeit",
  "profile.page.label.city": "Wohnort",
  "profile.page.label.contractType": "Vertragsart",
  "profile.page.label.country": "Land",
  "profile.page.label.countryState": "Bundesland / State",
  "profile.page.label.currentActivity": "Aktuelle Tätigkeit",
  "profile.page.label.currentEmployer": "Arbeitgeber",
  "profile.page.label.currentTasks": "Hauptaufgaben",
  "profile.page.label.drivingLicence": "Führerschein",
  "profile.page.label.email": "E-Mail",
  "profile.page.label.gender": "Geschlecht",
  "profile.page.label.houseNumber": "Hausnummer",
  "profile.page.label.jobDepartment": "Abteilung",
  "profile.page.label.jobLocation": "Arbeitsstandort",
  "profile.page.label.jobTitle": "Berufsbezeichnung",
  "profile.page.label.maritalStatus": "Familienstand",
  "profile.page.label.miscellaneous": "Sonstiges",
  "profile.page.label.nationality": "Nationalität",
  "profile.page.label.phone": "Telefon",
  "profile.page.label.profession": "Beruf",
  "profile.page.label.street": "Straße",
  "profile.page.label.website": "Website",
  "profile.page.label.workingTimeModel": "Arbeitszeitmodell",
  "profile.page.label.zipCode": "PLZ",
  "profile.page.loadFailed": "Profil konnte nicht geladen werden",
  "profile.page.loadFailedHint": "Bitte lade die Seite neu oder melde dich erneut an.",
  "profile.page.notFound": "Profil nicht gefunden",
  "profile.page.notFoundHint": "Dieses Profil existiert nicht oder ist nicht für dich freigegeben.",
  "profile.page.openChat": "Chat öffnen",
  "profile.page.section.certificates": "Zertifikate",
  "profile.page.section.education": "Ausbildung",
  "profile.page.section.experience": "Berufserfahrung",
  "profile.page.section.expertise": "Fachkompetenzen",
  "profile.page.section.languages": "Sprachen",
  "profile.page.serviceMenu": "Service",
  "profile.page.sharedItems": "Share",
  "profile.page.sharedItemsNone": "Keine Beiträge zu sehen",
  "profile.page.startChat": "Nachricht schreiben",
  "profile.page.summary": "Summary",
  "profile.rows.done": "Fertig",
  "profile.rows.level": "Stufe: {level}",
  "profile.rows.nativeSpeaker": "Muttersprache",
  "profile.rows.noLevel": "Kein Niveau",
  "profile.rows.today": "heute",
  "profile.rows.until": "bis {date}",
  "profile.sidebars.closeCluster": "Schließen",
  "profile.sidebars.combined": "Kombiniert",
  "profile.sidebars.errorPrefix": "Fehler: {message}",
  "profile.sidebars.loading": "lädt…",
  "profile.sidebars.noEvaluation": "Noch nicht bewertet.",
  "profile.sidebars.openClusterFor": "Auswertung zu {power} anzeigen",
  "profile.sidebars.powerMap": "Power Map",
  "profile.sidebars.powersNotAssessed": "Diese Person wurde noch nicht bewertet.",
  "profile.sidebars.powersNotShared": "Diese Person hat ihre Powers nicht geteilt.",
  "profile.sidebars.powersTitle": "Powers",
  "profile.sidebars.selfAssessment": "Selbstbewertung",
  "profile.sidebars.smartAnalysis": "Smart Analyse",
  "profile.skills.addAtLevel": "Fachkompetenz auf dieser Stufe hinzufügen",
  "profile.skills.unrated": "Unbewertet",
  "profile.skills.viewDiagram": "Modern",
  "profile.skills.viewList": "Klassisch",
  "profile.tour.about.desc": "Dein Zusammenfassungstext, deine persönlichen und beruflichen Details und deine {languages} Sprachen. Klicke ein Feld an, um es direkt zu bearbeiten.",
  "profile.tour.about.title": "Zusammenfassung, Details und Sprachen",
  "profile.tour.card.desc": "Klicke ein beliebiges Feld (Name, Telefon, E-Mail, Land, Stadt) und bearbeite es direkt; Änderungen werden gesammelt und über die Speicherleiste gesichert.{missing}",
  "profile.tour.card.missingHint": "Einige deiner Kontaktfelder sind noch leer.",
  "profile.tour.card.title": "Deine Visitenkarte",
  "profile.tour.cv.desc": "{experiences} Berufserfahrungen, {educations} Ausbildungen, {skills} Skills und {certificates} Zertifikate. Lege hier neue Einträge an oder klicke einen bestehenden, um ihn zu bearbeiten.",
  "profile.tour.cv.title": "Deine Lebenslauf-Einträge",
  "profile.tour.label": "Save Profil",
  "profile.tour.powers.desc": "Deine stärksten Powers auf einen Blick. Klicke eine an für ihre Detailseite, oder schätze weitere drüben in Grow ein.",
  "profile.tour.powers.title": "Deine Powers",
  "profile.tour.service.desc": "KI-Helfer und Datenservices für dein Profil: Powers und Skills ermitteln, einen Lebenslauf oder dein LinkedIn-Profil importieren, einen Lebenslauf erzeugen und deine Daten exportieren.",
  "profile.tour.service.title": "Servicemenü",
  "profile.tour.summary": "Das ist dein eigenes Profil mit {count} Lebenslauf-Einträgen. Fast jedes Feld ist direkt auf der Seite bearbeitbar.",
  "profile.tour.visibility.desc": "Dieser Schalter blendet neben jedem Feld und Eintrag einen Freigabe-Schalter ein. So bestimmst du genau, was andere von deinem Profil sehen.",
  "profile.tour.visibility.title": "Sichtbarkeit bearbeiten",
  "profileExtraction.abort": "Extraktion abbrechen",
  "profileExtraction.abortTip": "Die Extraktion läuft noch - du kannst weiter warten oder abbrechen und es mit demselben Dokument erneut versuchen. Gespeichert wurde noch nichts.",
  "profileExtraction.alreadyInDocuments": "Existiert bereits in Documents - wird nicht erneut gespeichert.",
  "profileExtraction.analysing": "Profildaten werden aus deinem Dokument extrahiert - das kann bis zu zwei Minuten dauern...",
  "profileExtraction.documentUnavailable": "Das Dokument konnte nicht geladen werden.",
  "profileExtraction.dropZone": "Dokument hierher ziehen oder zum Hochladen klicken",
  "profileExtraction.dropZoneHint": "Lebenslauf, LinkedIn-Export, Bewerbung … · PDF, DOC, DOCX, TXT, RTF, HTML, Bild · max. 10 MB",
  "profileExtraction.elapsed": "Verstrichene Zeit: {time}",
  "profileExtraction.fileTooLarge": "Datei ist zu groß (max. 10 MB).",
  "profileExtraction.noResult": "Das Dokument konnte nicht analysiert werden.",
  "profileExtraction.nothingNew": "Nichts Neues gefunden – dein Profil deckt dieses Dokument bereits ab.",
  "profileExtraction.ready": "Wir haben Details zum Überprüfen in {file} gefunden.",
  "profileExtraction.review": "Änderungen prüfen",
  "profileExtraction.saveFailed": "Die Datei konnte nicht in Documents gespeichert werden.",
  "profileExtraction.timeout": "Die Analyse dauert zu lange. Bitte versuche es erneut.",
  "profileExtraction.title": "CV Extractor",
  "profileExtraction.unsupportedType": "Nicht unterstützter Dateityp.",
  "progress.counter.generic": "{done} von {total}",
  "progress.counter.matchAssessment": "{done} von {total} Bewertungen beendet",
  "progress.counter.matchCriteria": "{done} von {total} Prüfungen",
  "progress.detail.matchAssessmentsFailed": "davon {count} fehlgeschlagen",
  "progress.detail.matchCandidatesLoaded": "{count, plural, one {# Kandidat} other {# Kandidaten}} geladen",
  "progress.detail.matchCompaniesLoaded": "{count, plural, one {# Unternehmen} other {# Unternehmen}} geladen",
  "progress.detail.matchChecksWithAi": "davon {count} mit KI",
  "progress.detail.matchCriteriaActive": "{count, plural, one {# Kriterium} other {# Kriterien}} aktiv",
  "progress.detail.matchLocationsResolved": "{count} von {total} Wohnorten gefunden",
  "progress.elapsedMinutes": "{minutes} min {seconds} s",
  "progress.elapsedSeconds": "{seconds} s",
  "progress.label": "Fortschritt",
  "progress.stage.matchAssessment": "Kandidaten bewerten",
  "progress.stage.matchCriteria": "Kriterien prüfen",
  "progress.stage.matchFinalize": "Ergebnis erstellen",
  "progress.stage.matchPrepare": "Vorbereiten",
  "progress.stage.matchSolve": "Teams zusammenstellen",
  "progress.stage.unknown": "Wird bearbeitet",
  "progress.waiting": "Wird gestartet …",
  "referenceData.add": "Hinzufügen",
  "referenceData.cancel": "Abbrechen",
  "referenceData.confirmDelete.message": "Der Eintrag wird endgültig entfernt und steht in Profilen und Match-Anforderungen nicht mehr zur Auswahl.",
  "referenceData.confirmDelete.title": "„{label}“ löschen?",
  "referenceData.contractType.add": "Neue Vertragsart",
  "referenceData.contractType.empty": "Noch keine Vertragsarten angelegt.",
  "referenceData.contractType.sub": "Verwaltete Liste der Vertragsarten.",
  "referenceData.contractType.title": "Vertragsarten",
  "referenceData.degree.add": "Neuer Abschluss",
  "referenceData.degree.empty": "Noch keine Abschlüsse angelegt.",
  "referenceData.degree.sub": "Verwaltete Liste der Abschlüsse für Ausbildungseinträge.",
  "referenceData.degree.title": "Abschlüsse",
  "referenceData.delete": "Löschen",
  "referenceData.duplicate": "Diesen Eintrag gibt es bereits.",
  "referenceData.edit": "Bearbeiten",
  "referenceData.gender.add": "Neues Geschlecht",
  "referenceData.gender.empty": "Keine Einträge.",
  "referenceData.gender.sub": "Verwaltete Liste der Geschlechter.",
  "referenceData.gender.title": "Geschlechter",
  "referenceData.industry.add": "Neue Branche",
  "referenceData.industry.empty": "Noch keine Branchen angelegt.",
  "referenceData.industry.sub": "Verwaltete Liste der Branchen für Profile und Match-Anforderungen.",
  "referenceData.industry.title": "Branchen",
  "referenceData.jobDepartment.add": "Neue Abteilung",
  "referenceData.jobDepartment.empty": "Noch keine Abteilungen angelegt.",
  "referenceData.jobDepartment.sub": "Verwaltete Liste der Abteilungen für Profile und Match-Anforderungen.",
  "referenceData.jobDepartment.title": "Abteilungen",
  "referenceData.jobLocation.add": "Neuer Arbeitsstandort",
  "referenceData.jobLocation.empty": "Noch keine Arbeitsstandorte angelegt.",
  "referenceData.jobLocation.sub": "Verwaltete Liste der Arbeitsstandorte für Profile und Match-Anforderungen.",
  "referenceData.jobLocation.title": "Arbeitsstandorte",
  "referenceData.loading": "Lädt…",
  "referenceData.maritalStatus.add": "Neuer Familienstand",
  "referenceData.maritalStatus.empty": "Keine Einträge.",
  "referenceData.maritalStatus.sub": "Verwaltete Liste der Familienstände.",
  "referenceData.maritalStatus.title": "Familienstände",
  "referenceData.save": "Speichern",
  "referenceData.workingTimeModel.add": "Neues Arbeitszeitmodell",
  "referenceData.workingTimeModel.empty": "Noch keine Arbeitszeitmodelle angelegt.",
  "referenceData.workingTimeModel.sub": "Verwaltete Liste der Arbeitszeitmodelle.",
  "referenceData.workingTimeModel.title": "Arbeitszeitmodelle",
  "save.addToCollection.adding": "Fügt hinzu…",
  "save.addToCollection.doneInGroup": "<nm>{name}</nm> wurde zu <b>{target}</b> in <b>{group}</b> hinzugefügt.",
  "save.addToCollection.doneNoGroup": "<nm>{name}</nm> wurde zu <b>{target}</b> (ohne Gruppe) hinzugefügt.",
  "save.addToCollection.error": "Konnte nicht hinzufügen. Bitte erneut versuchen.",
  "save.addToCollection.goToTarget": "Zu {target}",
  "save.addToCollection.groupLabel": "Gruppe",
  "save.addToCollection.noGroupPlaceholder": "Ohne Gruppe",
  "save.addToCollection.personFallback": "Person",
  "save.addToCollection.title": "{name} zu {target} hinzufügen",
  "save.careerGraph.active": "Aktiv",
  "save.careerGraph.done": "Fertig",
  "save.careerGraph.emptyLabel": "Keine Karriere-/Bildungseinträge",
  "save.careerGraph.mainTasks": "Hauptaufgaben",
  "save.careerGraph.modeGraph": "Modern",
  "save.careerGraph.modeList": "Klassisch",
  "save.careerGraph.showMainTasks": "Hauptaufgaben anzeigen",
  "save.careerGraph.title": "Career & Education",
  "save.careerGraph.today": "heute",
  "save.careerGraph.todayMarker": "HEUTE",
  "save.careerGraph.visibilityPrivate": "Privat",
  "save.careerGraph.visibilityPublic": "Öffentlich",
  "save.careerGraph.visibilityShared": "Geteilt",
  "save.collection.addToGroup": "Zu „{name}\" hinzufügen",
  "save.collection.allGroups": "Alle",
  "save.collection.allLabel": "Alle",
  "save.collection.deleteGroup": "Gruppe löschen",
  "save.collection.errorPrefix": "Fehler: {message}",
  "save.collection.nameLabel": "Name",
  "save.collection.openItem": "{title} öffnen",
  "save.collection.removeFromGroup": "Aus „{name}\" entfernen",
  "save.collection.rename": "Umbenennen",
  "save.collection.renameGroup": "Gruppe umbenennen",
  "save.collection.searchPlaceholder": "Suchen…",
  "save.community.addCommunity": "+ Community",
  "save.community.addTrigger": "+ Hinzufügen",
  "save.community.createError": "Community konnte nicht angelegt werden.",
  "save.community.dailyQuotaExceeded": "Tageslimit erreicht. Bitte später erneut versuchen.",
  "save.community.deleteCommunity": "Community löschen",
  "save.community.deleteCompletely": "Komplett löschen",
  "save.community.deleteConfirm": "„{name}\" löschen? Die Kontakte bleiben erhalten, nur die Gruppierung wird entfernt.",
  "save.community.deleteContactPrompt": "„{name}\" aus deinen Kontakten und allen Communities löschen?",
  "save.community.description": "Gruppiere deine Kontakte. Wähle links eine Community und ziehe Kontakte hinein oder füge sie per „Hinzufügen\" zu einer oder mehreren Communities hinzu.",
  "save.community.emptyAllGrouped": "Alle Kontakte sind in Communities.",
  "save.community.emptyCommunity": "Noch niemand in dieser Community. Zieh Kontakte hierher oder nutze „Hinzufügen“.",
  "save.community.emptyNoContacts": "Noch keine Kontakte.",
  "save.community.headerCount": "{count, plural, one {# Kontakt} other {# Kontakte}}",
  "save.community.limitReached": "Sie haben die maximale Anzahl von {limit} Communitys erreicht.",
  "save.community.namePlaceholder": "Community-Name …",
  "save.community.newCommunity": "Neue Community",
  "save.community.removeContact": "Kontakt entfernen",
  "save.community.removeFromCommunityPrompt": "„{name}\" aus „{community}\" entfernen (bleibt dein Kontakt und in anderen Communities) oder komplett aus deinen Kontakten und allen Communities löschen?",
  "save.community.removeFromGroup": "Aus Gruppe entfernen",
  "save.community.renameCommunity": "Community umbenennen",
  "save.community.renameError": "Community konnte nicht umbenannt werden.",
  "save.community.title": "Community",
  "save.community.ungroupedLabel": "Kontakte ohne Community",
  "save.extraction.analysing": "Analysiert …",
  "save.extraction.analysisComplete": "Analyse abgeschlossen.",
  "save.extraction.analysisFailed": "Analyse fehlgeschlagen.",
  "save.extraction.analysisFailedWithReason": "Analyse fehlgeschlagen ({reason}).",
  "save.extraction.count.alreadyAnalysed": "{count} bereits analysiert",
  "save.extraction.count.analysed": "{count} analysiert",
  "save.extraction.count.failed": "{count} fehlgeschlagen",
  "save.extraction.count.nothingFound": "{count} nichts gefunden",
  "save.extraction.count.unreadable": "{count} nicht lesbar",
  "save.extraction.done": "Fertig",
  "save.extraction.dropZone": "Datei hierher ziehen oder klicken zum Hochladen",
  "save.extraction.dropZoneHint": "PDF, Word, Excel, Bilder · max. 10 MB pro Datei",
  "save.extraction.documentsLoadError": "Gespeicherte Dokumente konnten nicht geladen werden. Du kannst weiterhin eine neue Datei hochladen.",
  "save.extraction.duplicateWarning": "Existiert bereits in Documents - das gespeicherte Dokument wird analysiert, kein erneuter Upload.",
  "save.extraction.fileTooLarge": "„{name}\" ist zu groß (max. 10 MB pro Datei).",
  "save.extraction.fromDocuments": "Aus Documents",
  "save.extraction.guidePowersAboutYou": "Es geht um dich. Belege, die die Analyse dir nicht zuordnen kann, fallen weg, und was gefunden wird, landet in deinem Profil.",
  "save.extraction.guidePowersConcrete": "Es beschreibt, wie du arbeitest: Zeugnisse, Beurteilungen, Feedback, Projekt- und Rollenbeschreibungen. Eine Jobbezeichnung oder eine reine Skill-Liste liefert keine verwertbaren Belege.",
  "save.extraction.guideSkillsAboutYou": "Lade nur Dokumente hoch, die über dich handeln.",
  "save.extraction.guideSkillsConcrete": "Je konkreter die Erfahrung beschrieben ist, desto höher die Einstufung. Eine reine Stichwortliste bleibt auf der untersten Stufe.",
  "save.extraction.guideSkillsSuitable": "Geeignet ist alles, was etwas über deine Berufs- und Projekterfahrung oder deine Kompetenzen aussagt: Lebenslauf, Zertifikate, Weiterbildungen, Projektdokumentation, Arbeitszeugnisse.",
  "save.extraction.guideTitle": "Welche Dokumente sich eignen",
  "save.extraction.loadingDocuments": "Dokumente werden geladen …",
  "save.extraction.newFile": "Neue Datei",
  "save.extraction.newSkillsHeading": "Neu erkannte Fachkompetenzen{count, plural, =0 {} other { (#)}}",
  "save.extraction.noAnalyzableDocuments": "Keines deiner Dokumente lässt sich analysieren.",
  "save.extraction.noDocuments": "Keine Dokumente vorhanden.",
  "save.extraction.noFolder": "Ohne Ordner",
  "save.extraction.noMatches": "Keine Treffer",
  "save.extraction.noNewSkills": "Keine neuen Einträge - vermutlich war alles bereits in deinen Fachkompetenzen vorhanden.",
  "save.extraction.noPowerChanges": "Keine Änderungen – kein Power-Wert hat sich verändert.",
  "save.extraction.nothingFoundHint": "Probier es mit Zeugnissen, Beurteilungen oder Feedback – Texte, die beschreiben, wie du arbeitest.",
  "save.extraction.notAnalysedChip": "{count} nicht analysiert",
  "save.extraction.notSignedIn": "Nicht angemeldet - Upload nicht möglich.",
  "save.extraction.nothingSelected": "Nichts ausgewählt",
  "save.extraction.outcome.alreadyAnalysed": "Bereits analysiert",
  "save.extraction.outcome.analysed": "Analysiert",
  "save.extraction.outcome.failed": "Analyse fehlgeschlagen",
  "save.extraction.outcome.nothingFound": "Analysiert – nichts gefunden",
  "save.extraction.outcome.unreadable": "Kein Text erkennbar",
  "save.extraction.persistUploads": "Hochgeladene Dateien in Documents speichern",
  "save.extraction.poweredBy": "Powered by smycles AI",
  "save.extraction.powersNoIndication": "{count, plural, one {# Power ohne Indikation.} other {# Powers ohne Indikation.}}",
  "save.extraction.powersUpdatedHeading": "Powers aktualisiert{count, plural, =0 {} other { (#)}}",
  "save.extraction.reopen.expired": "Dieses Analyseergebnis ist nicht mehr verfügbar. Ergebnisse bleiben 30 Tage lang abrufbar.",
  "save.extraction.reopen.startedAt": "Gestartet am {date}",
  "save.extraction.reopen.title": "Dokumentanalyse",
  "save.extraction.runningInBackground": "Läuft im Hintergrund - du kannst dies schließen und weiterarbeiten. Du wirst benachrichtigt, sobald es fertig ist.",
  "save.extraction.searchDocuments": "Dokumente durchsuchen",
  "save.extraction.selectAllInGroup": "Alle in {group} auswählen",
  "save.extraction.selectedCount": "{total, plural, one {# Dokument ausgewählt} other {# Dokumente ausgewählt}}",
  "save.extraction.startAnalysis": "Analyse starten",
  "save.extraction.stillRunning": "Die Analyse dauert etwas länger und läuft im Hintergrund weiter. Du erhältst eine Benachrichtigung, sobald sie fertig ist.",
  "save.extraction.tooMany": "Es können höchstens {max} Dokumente auf einmal analysiert werden.",
  "save.extraction.toggleCollapse": "Auf-/Zuklappen",
  "save.extraction.unsupportedType": "„{name}“ wird nicht analysiert. Unterstützt: PDF, Word, Excel und Bilder.",
  "save.extraction.uploadFailedDuplicate": "Upload fehlgeschlagen. Vermutlich existiert bereits ein Dokument mit diesem Namen.",
  "save.pinGroupDialog.createFailed": "Gruppe konnte nicht angelegt werden.",
  "save.pinGroupDialog.invalidName": "Ungültiger Name.",
  "save.pinGroupDialog.limitReached": "Sie haben die maximale Anzahl von {limit} Gruppen erreicht.",
  "save.pinGroupDialog.placeholder": "z. B. Mentoren",
  "save.pinGroupDialog.renameFailed": "Gruppe konnte nicht umbenannt werden.",
  "save.pinGroupDialog.submitCreate": "Anlegen",
  "save.pinGroupDialog.titleCreate": "Neue Gruppe",
  "save.pinGroupDialog.titleRename": "Gruppe umbenennen",
  "save.pinGroupDialog.tryAgain": "Bitte erneut versuchen.",
  "save.pinGroupSidebar.addGroup": "+ Gruppe",
  "save.pinGroupSidebar.deleteMessage": "„{name}\" löschen? Die Pins bleiben erhalten, nur die Gruppierung wird entfernt.",
  "save.pinGroupSidebar.deleteTitle": "Gruppe löschen",
  "save.pinGroupSidebar.tabPerson": "Personen",
  "save.pinGroupSidebar.tabPost": "Posts",
  "save.pinGroupSidebar.tabProject": "Projekte",
  "save.pinboardPage.description": "Ziehe eine Karte auf eine Gruppe links oder füge sie per „Hinzufügen\" zu einer oder mehreren Gruppen hinzu. Ziehen auf „Alle\" entfernt sie aus der aktuellen Gruppe.",
  "save.pinboardPage.emptyAllGrouped": "Alle gepinnten {typeLabel} sind in Gruppen.",
  "save.pinboardPage.emptyNoneInView": "Keine gepinnten {typeLabel} in dieser Ansicht.",
  "save.pinboardPage.itemFallback": "Eintrag",
  "save.pinboardPage.openItem": "{name} öffnen",
  "save.pinboardPage.removeFromGroup": "Aus Gruppe entfernen",
  "save.pinboardPage.removeFromGroupMessage": "„{title}\" aus „{group}\" entfernen (bleibt gepinnt und in anderen Gruppen) oder komplett entpinnen?",
  "save.pinboardPage.removePin": "Pin entfernen",
  "save.pinboardPage.title": "Pins",
  "save.pinboardPage.typePersons": "Personen",
  "save.pinboardPage.typePosts": "Posts",
  "save.pinboardPage.typeProjects": "Projekte",
  "save.pinboardPage.ungroupedLabel": "Pins ohne Gruppe",
  "save.pinboardPage.unpin": "Entpinnen",
  "save.pinboardPage.unpinCompletely": "Komplett entpinnen",
  "save.pinboardPage.unpinMessage": "„{title}\" entpinnen?",
  "search.activeCount": "{count} aktiv",
  "search.addTermPlaceholder": "Begriff eingeben, dann Enter",
  "search.allFiltersAdded": "Alle Filter hinzugefügt",
  "search.any": "Beliebig",
  "search.chipType": "Typ",
  "search.clear": "Suche löschen",
  "search.confirmRemoveFromGroup": "Entfernen?",
  "search.discoverHeading": "Discover",
  "search.done": "Fertig",
  "search.either": "Egal",
  "search.errorPrefix": "Fehler: {message}",
  "search.extended": "Erweiterte Suche",
  "search.eyebrow": "Suche",
  "search.fieldAge": "Alter",
  "search.fieldChildren": "Anzahl Kinder",
  "search.fieldCitizenship": "Staatsangehörigkeit",
  "search.fieldCity": "Wohnort",
  "search.fieldCompanySize": "Größe (Mitarbeitende)",
  "search.fieldCountry": "Land",
  "search.fieldDepartment": "Abteilung",
  "search.fieldExpertise": "Expertise",
  "search.fieldFirstName": "Vorname",
  "search.fieldGender": "Geschlecht",
  "search.fieldIndustry": "Branche",
  "search.fieldJobTitle": "Stellenbezeichnung",
  "search.fieldLanguages": "Sprachen",
  "search.fieldLastName": "Nachname",
  "search.fieldLocation": "Arbeitsstandort",
  "search.fieldMaritalStatus": "Familienstand",
  "search.fieldNationality": "Nationalität",
  "search.filterHeading": "{type}-Filter",
  "search.flagCommented": "Kommentiert",
  "search.flagOwner": "Eigentümer",
  "search.flagPinned": "Gepinnt",
  "search.flagRated": "Bewertet",
  "search.flagSignedUp": "Interessiert",
  "search.groupAgents": "KI-Agenten",
  "search.groupCompanies": "Unternehmen",
  "search.groupPosts": "Posts",
  "search.groupProjects": "Projekte",
  "search.groupTeamplayers": "Teamplayer",
  "search.hide": "Ausblenden ▴",
  "search.no": "Nein",
  "search.noFilters": "Keine Filter gesetzt.",
  "search.noResults": "Keine Treffer",
  "search.openChat": "Chat öffnen",
  "search.pin": "Pinnen",
  "search.pinInto": "In „{name}“ pinnen",
  "search.pinNoGroup": "Pinnen (ohne Gruppe)",
  "search.placeholder": "Suche nach Teamplayern, Projekten, Posts …",
  "search.placeholderCompany": "Unternehmensname, Fachkompetenz, Branche …",
  "search.placeholderPerson": "Name, Jobtitel …",
  "search.placeholderShared": "Titel, Beschreibung …",
  "search.publisher": "Veröffentlicht von",
  "search.publisherCompany": "Unternehmen",
  "search.publisherPerson": "Personen",
  "search.queryLabel": "Suchbegriff",
  "search.rangeTo": "bis",
  "search.removeFieldLabel": "{field} entfernen",
  "search.removeFromGroup": "Aus „{name}“ entfernen",
  "search.removeTermLabel": "{term} entfernen",
  "search.reset": "Zurücksetzen",
  "search.resultCount": "{count} {type}",
  "search.resultCountMore": "{count}+ {type}",
  "search.resultCountOf": "{count} von {total} {type}",
  "search.search": "Suchen",
  "search.searching": "Suche läuft …",
  "search.show": "Anzeigen ▾",
  "search.tabCompany": "Unternehmen",
  "search.tabShare": "Share",
  "search.tabTeamplayer": "Teamplayer",
  "search.tour.filters.desc": "Baue hier strukturierte Filter und kombiniere sie mit dem Freitext-Suchbegriff oben, dann drücke Suchen. Gerade sind {count} Filter aktiv.",
  "search.tour.filters.emptyDesc": "Baue hier strukturierte Filter und kombiniere sie mit dem Freitext-Suchbegriff oben, dann drücke Suchen. Gerade ist kein Filter gesetzt.",
  "search.tour.filters.title": "Filter",
  "search.tour.label": "Suche",
  "search.tour.results.desc": "Hier erscheinen die Treffer, aktuell {summary}. Klicke ein Ergebnis, um es zu öffnen; beim Scrollen lädt mehr nach.",
  "search.tour.results.title": "Ergebnisse",
  "search.tour.summary": "Das ist die erweiterte Suche. Finde Menschen, Unternehmen oder geteilte Projekte und Beiträge. Du suchst gerade nach {type}.",
  "search.tour.typeToggle.desc": "Wechsle die Suchkategorie: Teamplayer findet Menschen, Unternehmen findet Unternehmen über Name, Fachkompetenz oder Branche, und Share findet Projekte und Beiträge.",
  "search.tour.typeToggle.title": "Was suchen",
  "search.typeAll": "Alle",
  "search.typePosts": "Posts",
  "search.typeProjects": "Projekte",
  "search.unpin": "Entpinnen",
  "search.useExtended": "Erweiterte Suche verwenden",
  "search.writeMessage": "Nachricht schreiben",
  "search.yes": "Ja",
  "secretInput.hide": "Wert verbergen",
  "secretInput.show": "Wert anzeigen",
  "service.docItemRow.download": "Herunterladen",
  "service.docItemRow.newBadge": "Neu",
  "service.docItemRow.open": "Öffnen",
  "service.docItemRow.rename": "Zum Umbenennen klicken",
  "service.docItemRow.selectAriaLabel": "{name} auswählen",
  "service.docItemRow.sourceLabel": "Quelle: {source}",
  "service.docPreviewCard.cvGeneratorDraft": "CV-Generator Entwurf",
  "service.docPreviewCard.download": "Herunterladen",
  "service.docPreviewCard.newBadge": "Neu",
  "service.docPreviewCard.open": "Öffnen",
  "service.docPreviewCard.rename": "Zum Umbenennen klicken",
  "service.docPreviewCard.selectAriaLabel": "{name} auswählen",
  "service.error.nameRequired": "Ein Name ist erforderlich.",
  "service.extRename.ariaLabel": "Umbenennen",
  "service.filterBuilder.addFilter": "+ Filter hinzufügen",
  "service.filterBuilder.all": "Alle",
  "service.filterBuilder.allFiltersAdded": "Alle Filter hinzugefügt",
  "service.filterBuilder.clear": "Leeren",
  "service.filterBuilder.done": "Fertig",
  "service.filterBuilder.removeFilterLabel": "{label} entfernen",
  "service.folderRow.deleteFolder": "Ordner löschen",
  "service.folderRow.deleteFolderAria": "Ordner {name} löschen",
  "service.folderRow.deleteFolderOnlyHint": "Nur den Ordner löschen: {count, plural, one {# Datei wandert} other {# Dateien wandern}} zu „Unsortiert“",
  "service.folderRow.deleteLabel": "Löschen:",
  "service.folderRow.deleteWithFilesHint": "Ordner samt {count, plural, one {# Datei} other {# Dateien}} endgültig löschen",
  "service.folderRow.folderNamePlaceholder": "Ordnername …",
  "service.folderRow.folderOnly": "Nur Ordner",
  "service.folderRow.newFolder": "Neuer Ordner",
  "service.folderRow.renameFolder": "Ordner umbenennen",
  "service.folderRow.toggleHint": "Auf-/Zuklappen (Doppelklick: umbenennen)",
  "service.folderRow.withFiles": "Mit Dateien",
  "service.folderRow.withFilesLoadingHint": "Verfügbar, sobald alle Dokumente geladen sind",
  "service.page.allInFolders": "Alles in Ordnern abgelegt",
  "service.page.bulkCv.addMore": "Dateien hinzufügen",
  "service.page.bulkCv.addToCommunity": "Community",
  "service.page.bulkCv.addedToCommunity": "{n} zu {names} hinzugefügt",
  "service.page.bulkCv.analysePowers": "Powers analysieren",
  "service.page.bulkCv.communitySubject": "{n} importierte Personen",
  "service.page.bulkCv.desc": "Mehrere Lebensläufe ablegen, um die zugehörigen Profile anzulegen oder zu aktualisieren. Bestehende Profile werden nur dort ergänzt, wo Felder leer sind – nichts wird überschrieben.",
  "service.page.bulkCv.dupWarning": "Lebensläufe ohne E-Mail-Adresse erzeugen bei jedem Lauf ein neues Profil. Dieselben Dateien nicht erneut importieren.",
  "service.page.bulkCv.hint": "PDF, DOC, DOCX, TXT, RTF, HTML, Bilder · max. 10 MB pro Datei · bis zu 25 Dateien",
  "service.page.bulkCv.importBtn": "{n, plural, one {# Lebenslauf} other {# Lebensläufe}} importieren",
  "service.page.bulkCv.importPhoto": "Foto importieren",
  "service.page.bulkCv.importing": "Importiere {done}/{total} …",
  "service.page.bulkCv.openProfile": "Profil",
  "service.page.bulkCv.outcomeCreated": "Neu",
  "service.page.bulkCv.outcomeFailed": "Import fehlgeschlagen",
  "service.page.bulkCv.outcomeUpdated": "Aktualisiert",
  "service.page.bulkCv.powerApplied": "{n, plural, one {# Power übernommen} other {# Powers übernommen}}",
  "service.page.bulkCv.powerApply": "Ausgewählte ins Profil übernehmen ({n})",
  "service.page.bulkCv.powerApplying": "Wird übernommen …",
  "service.page.bulkCv.powerDetails": "Details",
  "service.page.bulkCv.powerEmpty": "Keine Powers erkannt",
  "service.page.bulkCv.powerFailed": "Power-Analyse fehlgeschlagen",
  "service.page.bulkCv.powerFiling": "Wird in der Organisationsakte abgelegt …",
  "service.page.bulkCv.powerHideDetails": "Details ausblenden",
  "service.page.bulkCv.powerKeepOpen": "Lass diese Seite offen, bis die Power-Analysen fertig sind. Übernehmen lassen sich die Vorschläge nur hier.",
  "service.page.bulkCv.powerQueued": "Power-Analyse wartet",
  "service.page.bulkCv.powerReady": "{n, plural, one {# Power vorgeschlagen} other {# Powers vorgeschlagen}}",
  "service.page.bulkCv.powerRunning": "Power-Analyse läuft …",
  "service.page.bulkCv.powerSelect": "Power-Vorschlag für {name} auswählen",
  "service.page.bulkCv.powerSelectAll": "Alle Vorschläge auswählen",
  "service.page.bulkCv.powerUnsupported": "Keine Power-Analyse: Dateityp nicht unterstützt",
  "service.page.bulkCv.rejected": "Einige Dateien wurden übersprungen (zu groß oder nicht unterstützter Typ).",
  "service.page.bulkCv.summary": "{created} angelegt, {updated} aktualisiert, {failed} fehlgeschlagen",
  "service.page.bulkCv.title": "Profile importieren",
  "service.page.bulkCv.tooMany": "Es können höchstens {max} Dateien auf einmal importiert werden.",
  "service.page.bulkCv.willAddToCommunity": "Neue Importe werden hinzugefügt zu: {names}",
  "service.page.bulkCv.willAnalysePowers": "Nach dem Import wird jeder Lebenslauf in der Organisationsakte der Person abgelegt und auf Powers analysiert (nur PDF, DOCX und Bilder).",
  "service.page.bulkCv.zone": "Lebensläufe hierher ziehen oder klicken zum Hinzufügen",
  "service.page.bulkYaml.actionDry": "Validieren",
  "service.page.bulkYaml.actionLabel": "Modus",
  "service.page.bulkYaml.actionReal": "Import",
  "service.page.bulkYaml.background": "Läuft im Hintergrund",
  "service.page.bulkYaml.batchDone": "Alle {n, number} Dateien sind hochgeladen. Die Verarbeitung läuft im Hintergrund - du kannst die Seite verlassen.",
  "service.page.bulkYaml.batchFailed": "Fehlgeschlagen",
  "service.page.bulkYaml.batchHide": "Ergebnis ausblenden",
  "service.page.bulkYaml.batchLimit": "Pro Stapel können höchstens {max, number} Dateien gestartet werden. Teile größere Auswahlen auf mehrere Stapel auf.",
  "service.page.bulkYaml.batchMixed": "Teilweise erfolgreich",
  "service.page.bulkYaml.batchOpen": "Ergebnis anzeigen",
  "service.page.bulkYaml.batchPending": "Ausstehend",
  "service.page.bulkYaml.batchSuccess": "Erfolgreich",
  "service.page.bulkYaml.batchUploading": "Datei {n, number} wird hochgeladen … ({done, number} gestartet)",
  "service.page.bulkYaml.capacityRejected": "Die Datei konnte nicht gestartet werden, weil alle Importplätze belegt waren. Sie wurde noch nicht geprüft.",
  "service.page.bulkYaml.completedAt": "Abgeschlossen am {date}",
  "service.page.bulkYaml.desc": "Importiere eine YAML-Datei mit mehreren Dokumenten oder lege ein PDF bzw. einen Lebenslauf zur Profil-Extraktion ab. Der Job läuft weiter, wenn du die Seite verlässt.",
  "service.page.bulkYaml.documentsFound": "{n, plural, one {# Dokument} other {# Dokumente}} gefunden",
  "service.page.bulkYaml.downloadSchema": "JSON-Schema herunterladen",
  "service.page.bulkYaml.downloadYaml": "YAML-Beispiel herunterladen",
  "service.page.bulkYaml.dryRunAtomicNote": "Eine Validierung erfasst immer die ganze Datei auf einmal. Einzelne Einheiten werden dabei nicht isoliert.",
  "service.page.bulkYaml.dryRunNoSave": "Es wurden keine Daten gespeichert. Die Transaktion wurde bewusst zurückgerollt.",
  "service.page.bulkYaml.dryRunSuccessTitle": "Validierung erfolgreich",
  "service.page.bulkYaml.dryRunSummary": "{n, plural, one {# Zeile} other {# Zeilen}} wären betroffen",
  "service.page.bulkYaml.extractionDone": "Extraktion abgeschlossen",
  "service.page.bulkYaml.extractionFailed": "Extraktion fehlgeschlagen.",
  "service.page.bulkYaml.extractionOpen": "Ergebnis öffnen",
  "service.page.bulkYaml.extractionResultHint": "Die extrahierten Powers und Skills stehen in deinem eigenen Profil.",
  "service.page.bulkYaml.extractionRunning": "Powers und Skills werden extrahiert …",
  "service.page.bulkYaml.failedPartial": "Import fehlgeschlagen. Bereits übernommene Einheiten wurden behalten.",
  "service.page.bulkYaml.forbidden": "Dir fehlt eine Berechtigung für diesen Import. Du brauchst Importzugriff; enthält die Datei Personen oder Referenzdaten, sind zusätzlich die entsprechenden Bearbeitungsrechte erforderlich.",
  "service.page.bulkYaml.formatKindLabel": "Beispiele für",
  "service.page.bulkYaml.formatLimits": "Format {version} · höchstens {docs, number} Dokumente pro Datei · Genesis-Formatlimit {size}.",
  "service.page.bulkYaml.formatLoadFailed": "Die Formatbeschreibung konnte nicht geladen werden.",
  "service.page.bulkYaml.formatLoading": "Format wird geladen …",
  "service.page.bulkYaml.formatTitle": "Format und Beispiele",
  "service.page.bulkYaml.formatUnavailable": "Der eingesetzte Importer beschreibt diese Art nicht.",
  "service.page.bulkYaml.formatUploadLimit": "Spark-Uploadlimit: {size} pro Datei. Größere Dateien werden vor dem Import abgewiesen.",
  "service.page.bulkYaml.hideYaml": "YAML ausblenden",
  "service.page.bulkYaml.hint": "YAML, PDF oder DOCX · jede Datei wird ein eigener Import-Job",
  "service.page.bulkYaml.importBtn": "Import starten",
  "service.page.bulkYaml.importBtnMany": "Import für {n, number} Dateien starten",
  "service.page.bulkYaml.indexing": "Datei wird geprüft …",
  "service.page.bulkYaml.jobIdHint": "Job-ID, für den Support",
  "service.page.bulkYaml.leaveHint": "Du kannst diese Seite verlassen. Eine Benachrichtigung führt zurück zu diesem Ergebnis.",
  "service.page.bulkYaml.limitsNote": "Maximal {docs, number} Datensätze pro Import · bis zu {files, number} Dateien pro Stapel · höchstens {size} pro Datei.",
  "service.page.bulkYaml.limitsNoteSizeOnly": "Bis zu {files, number} Dateien pro Stapel · höchstens {size} pro Datei.",
  "service.page.bulkYaml.modeAllOrNothing": "Vollständig abbrechen",
  "service.page.bulkYaml.modeKeepSuccessful": "Erfolgreiche übernehmen",
  "service.page.bulkYaml.modeLabel": "Bei Fehlern",
  "service.page.bulkYaml.newRun": "Neue Datei auswählen",
  "service.page.bulkYaml.personActionsTitle": "Personen-Änderungen",
  "service.page.bulkYaml.personCreate": "Anlegen",
  "service.page.bulkYaml.personCreated": "Neues Profil angelegt",
  "service.page.bulkYaml.personDelete": "Löschen",
  "service.page.bulkYaml.personDeleted": "Profil gelöscht",
  "service.page.bulkYaml.personExisting": "Bestehend",
  "service.page.bulkYaml.personIdGenerated": "Die UUID wird beim Import erzeugt.",
  "service.page.bulkYaml.personIdWasGenerated": "Die UUID wurde beim Import erzeugt.",
  "service.page.bulkYaml.personIncoming": "Import",
  "service.page.bulkYaml.personMismatchNotice": "{n, plural, one {Beim Import wird die bestehende Person mit dieser UUID aktualisiert. Falls das nicht gewollt ist, korrigiere vorher die UUID in der Datei.} other {Beim Import werden die bestehenden Personen mit diesen UUIDs aktualisiert. Falls das nicht gewollt ist, korrigiere vorher die UUIDs in der Datei.}}",
  "service.page.bulkYaml.personMismatchText": "Name und primäre E-Mail unterscheiden sich beide von der gespeicherten Person. Der Import aktualisiert die bestehende Person mit dieser UUID.",
  "service.page.bulkYaml.personMismatchTitle": "Möglicherweise falsche Person-ID",
  "service.page.bulkYaml.personRestore": "Wiederherstellen",
  "service.page.bulkYaml.personRestoreNotice": "{n, plural, one {Beim Import wird dieses gelöschte Profil wiederhergestellt. Falls das nicht gewollt ist, entferne vorher die UUID aus der Datei.} other {Beim Import werden diese gelöschten Profile wiederhergestellt. Falls das nicht gewollt ist, entferne vorher die UUIDs aus der Datei.}}",
  "service.page.bulkYaml.personRestoreResultText": "Das Profil wurde mit den in der YAML enthaltenen Daten wiederhergestellt. Nicht in der YAML enthaltene Daten wurden nicht wiederhergestellt.",
  "service.page.bulkYaml.personRestoreResultTitle": "Gelöschtes Profil wurde wiederhergestellt",
  "service.page.bulkYaml.personRestoreValidationText": "Diese UUID gehört zu einer gelöschten Person. Beim Import werden die in der YAML enthaltenen Profildaten wiederhergestellt. Nicht in der YAML enthaltene Daten werden nicht wiederhergestellt.",
  "service.page.bulkYaml.personRestoreValidationTitle": "Gelöschtes Profil wird wiederhergestellt",
  "service.page.bulkYaml.personRestored": "Gelöschtes Profil wiederhergestellt",
  "service.page.bulkYaml.personRiskNotice": "Beim Import werden die gezeigten Aktualisierungen angewendet und die gelöschten Profile wiederhergestellt. Falls das nicht gewollt ist, korrigiere vorher die UUIDs in der Datei.",
  "service.page.bulkYaml.personRowLabel": "Person {n}: {action}",
  "service.page.bulkYaml.personUpdate": "Aktualisieren",
  "service.page.bulkYaml.personUpdated": "Bestehendes Profil aktualisiert",
  "service.page.bulkYaml.personWillBeCreated": "Neues Profil wird angelegt",
  "service.page.bulkYaml.personWillBeUpdated": "Bestehendes Profil wird aktualisiert",
  "service.page.bulkYaml.pipelineLabel": "Import-Schritte",
  "service.page.bulkYaml.problemDependency": "Dieses Dokument wurde übersprungen, weil ein referenziertes Dokument fehlgeschlagen ist.",
  "service.page.bulkYaml.problemDependencyFix": "Behebe das zuerst fehlgeschlagene Dokument. Danach kann dieses abhängige Dokument automatisch importiert werden.",
  "service.page.bulkYaml.problemDocumentation": "Format- und Beispieldokumentation öffnen ↓",
  "service.page.bulkYaml.problemDuplicate": "Die ID oder ein anderer eindeutiger Wert existiert bereits.",
  "service.page.bulkYaml.problemDuplicateFix": "Nutze merge, um den Eintrag zu aktualisieren. Für einen neuen Eintrag lässt du die content.id des Dokuments weg oder vergibst eine neue.",
  "service.page.bulkYaml.problemFix": "So behebst du es",
  "service.page.bulkYaml.problemInvalidFormat": "Die YAML-Syntax oder Dokumentstruktur ist ungültig.",
  "service.page.bulkYaml.problemInvalidFormatFix": "Prüfe Einrückung, Dokumenthülle, Werttypen und Pflichtblöcke anhand eines Beispiels.",
  "service.page.bulkYaml.problemInvalidReference": "Ein referenzierter Eintrag wurde nicht gefunden.",
  "service.page.bulkYaml.problemInvalidReferenceFix": "Nutze die UUID eines vorhandenen Eintrags oder referenziere ein Dokument dieser Datei über dessen metadata.name.",
  "service.page.bulkYaml.problemInvalidReferenceValue": "Der referenzierte Eintrag „{value}“ wurde nicht gefunden.",
  "service.page.bulkYaml.problemInvalidValue": "Der Wert „{value}“ ist ungültig.",
  "service.page.bulkYaml.problemInvalidValueFix": "Nutze den dokumentierten Typ, die richtige Schreibweise und den erlaubten Wertebereich.",
  "service.page.bulkYaml.problemInvalidValueGeneric": "Ein Wert fehlt, ist ungültig oder liegt außerhalb des erlaubten Bereichs.",
  "service.page.bulkYaml.problemInvalidValueSuggestion": "Nutze stattdessen „{value}“.",
  "service.page.bulkYaml.problemLocation": "Im Dokument nahe Zeile {line}",
  "service.page.bulkYaml.problemLocationColumn": "Im Dokument nahe Zeile {line}, Spalte {column}",
  "service.page.bulkYaml.problemMissing": "Das Pflichtfeld „{field}“ fehlt.",
  "service.page.bulkYaml.problemMissingAlternative": "Mindestens eines dieser Felder ist erforderlich: {expected}.",
  "service.page.bulkYaml.problemMissingAlternativeFix": "Ergänze mindestens eines der aufgeführten Felder mit einem nicht leeren Wert.",
  "service.page.bulkYaml.problemMissingFix": "Ergänze das Feld mit einem Wert des in der Formatdokumentation angegebenen Typs.",
  "service.page.bulkYaml.problemPersistence": "Die Datenbank konnte dieses ansonsten gültige Dokument nicht speichern.",
  "service.page.bulkYaml.problemPersistenceFix": "Versuche es einmal erneut. Schlägt es wieder fehl, gib dem Support die oben angezeigte Job-ID.",
  "service.page.bulkYaml.problemUnexpected": "Der Import ist aus einem unerwarteten technischen Grund fehlgeschlagen.",
  "service.page.bulkYaml.problemUnexpectedFix": "Versuche es einmal erneut. Schlägt es wieder fehl, gib dem Support die oben angezeigte Job-ID.",
  "service.page.bulkYaml.problemUnknown": "Das Feld „{field}“ wird hier nicht unterstützt.",
  "service.page.bulkYaml.problemUnknownField": "ein Pflichtfeld",
  "service.page.bulkYaml.problemUnknownFix": "Benenne das Feld um oder entferne es und vergleiche das Dokument mit dem Formatbeispiel.",
  "service.page.bulkYaml.problemUnknownFixExpected": "Benenne es um oder entferne es. Unterstützte Felder sind unter anderem: {expected}.",
  "service.page.bulkYaml.problemPermissionDenied": "Dir fehlt die Berechtigung zum Importieren dieses Unternehmens.",
  "service.page.bulkYaml.problemPermissionDeniedFix": "Für ein neues Unternehmen brauchst du das Recht, Unternehmen anzulegen. Für Änderungen brauchst du eine aktive Admin-Mitgliedschaft in diesem Unternehmen. Lass deine Zugriffsrechte von einem Administrator prüfen.",
  "service.page.bulkYaml.problemUnsupported": "Diese Operation oder Feldänderung wird für diesen Dokumenttyp nicht unterstützt.",
  "service.page.bulkYaml.problemUnsupportedFix": "Nutze eine der für diesen Typ aufgeführten Operationen und lasse unveränderliche Felder unverändert.",
  "service.page.bulkYaml.problemWhat": "Was fehlt oder nicht stimmt",
  "service.page.bulkYaml.progress": "{done} von {total} Dokumenten verarbeitet{kind, select, none {} other { · {kind}}}",
  "service.page.bulkYaml.queued": "Wartet auf Verarbeitung",
  "service.page.bulkYaml.rejectedTooLarge": "Zu groß (über {max} pro Datei): {names}",
  "service.page.bulkYaml.rejectedType": "Nicht unterstützter Dateityp ({names}). Nutze .yaml oder .yml.",
  "service.page.bulkYaml.retryBtn": "Datei korrigieren und erneut versuchen",
  "service.page.bulkYaml.retryFile": "Erneut versuchen",
  "service.page.bulkYaml.retrying": "Wird erneut versucht …",
  "service.page.bulkYaml.rolledBack": "Import fehlgeschlagen; alle Datenbankänderungen wurden zurückgerollt.",
  "service.page.bulkYaml.routeExtraction": "CV- und PDF-Extraktion",
  "service.page.bulkYaml.routeYaml": "YAML-Import",
  "service.page.bulkYaml.routingHint": "PDF- und DOCX-Dateien gehen an die Lebenslauf-Extraktion. Validierung und Teilimport gibt es nur für YAML.",
  "service.page.bulkYaml.runBadgeDry": "Validierung · {mode}",
  "service.page.bulkYaml.runBadgeReal": "Import · {mode}",
  "service.page.bulkYaml.showYaml": "YAML anzeigen",
  "service.page.bulkYaml.stageFile": "Datei",
  "service.page.bulkYaml.stageImport": "Import",
  "service.page.bulkYaml.stageQueue": "Warteschlange",
  "service.page.bulkYaml.stageResult": "Ergebnis",
  "service.page.bulkYaml.startDry": "Validierung starten",
  "service.page.bulkYaml.startDryMany": "Validierung für {n, number} Dateien starten",
  "service.page.bulkYaml.starting": "Wird gestartet …",
  "service.page.bulkYaml.stepStateActive": "in Bearbeitung",
  "service.page.bulkYaml.stepStateDone": "abgeschlossen",
  "service.page.bulkYaml.stepStateFailed": "fehlgeschlagen",
  "service.page.bulkYaml.stepStatePending": "noch nicht gestartet",
  "service.page.bulkYaml.successTitle": "Import erfolgreich",
  "service.page.bulkYaml.summary": "{n, plural, one {# Zeile} other {# Zeilen}} betroffen",
  "service.page.bulkYaml.title": "Datei-Import",
  "service.page.bulkYaml.unitDeleteAria": "{id} löschen",
  "service.page.bulkYaml.unitDeletePersonMessage": "„{id}“ wird endgültig gelöscht, mit allen Profildaten. Das entfernt die ganze Person, nicht nur die importierten Änderungen.",
  "service.page.bulkYaml.unitDeletePersonTitle": "Person löschen?",
  "service.page.bulkYaml.unitDeleteSharedItemMessage": "„{id}“ wird endgültig gelöscht, mit allen Kommentaren. Das entfernt den ganzen Beitrag, nicht nur die importierten Änderungen.",
  "service.page.bulkYaml.unitDeleteSharedItemTitle": "Beitrag löschen?",
  "service.page.bulkYaml.unitDeleted": "Gelöscht",
  "service.page.bulkYaml.unitDependencyFailed": "Nicht versucht, weil eine benötigte Einheit nicht erfolgreich war.",
  "service.page.bulkYaml.unitDuplicate": "Dieser Eintrag existiert bereits. Nutze „merge“ statt „insert“, um ihn zu aktualisieren, oder lösche ihn vorher.",
  "service.page.bulkYaml.unitInvalidInput": "Das Dokument wurde abgelehnt: ungültige oder fehlende Werte.",
  "service.page.bulkYaml.unitInvalidReference": "Eine Referenz im Dokument existiert nicht.",
  "service.page.bulkYaml.unitPersistenceError": "Die Datenbank hat diesen Schreibvorgang abgelehnt.",
  "service.page.bulkYaml.unitTechnicalId": "Technische ID",
  "service.page.bulkYaml.unitTechnicalIdAria": "Technische ID für {label} anzeigen",
  "service.page.bulkYaml.unitUnexpectedError": "Unerwarteter Fehler beim Import dieser Einheit.",
  "service.page.bulkYaml.unitsFailed": "{n} fehlgeschlagen",
  "service.page.bulkYaml.unitsFailedGroup": "Fehlgeschlagene Einheiten",
  "service.page.bulkYaml.unitsSkipped": "{n} übersprungen",
  "service.page.bulkYaml.unitsSkippedGroup": "Übersprungene Einheiten",
  "service.page.bulkYaml.unitsSucceeded": "{n} erfolgreich",
  "service.page.bulkYaml.unitsSucceededGroup": "Erfolgreiche Einheiten",
  "service.page.bulkYaml.warningBlobCleanup": "{n, plural, one {# hochgeladene Datei konnte nicht wieder entfernt werden und bleibt gespeichert.} other {# hochgeladene Dateien konnten nicht wieder entfernt werden und bleiben gespeichert.}}",
  "service.page.bulkYaml.warningBlobCleanupHint": "Ein Operator kann sie anhand dieser Storage-IDs von Hand entfernen.",
  "service.page.bulkYaml.zone": "Ziehe YAML-, PDF- oder Lebenslauf-Dateien hierher oder klicke zum Hinzufügen",
  "service.page.cardCvExtractorDesc": "Parst Lebensläufe und übernimmt Stationen, Skills und Daten strukturiert.",
  "service.page.cardCvExtractorTitle": "CV-Extractor",
  "service.page.cardCvGeneratorDesc": "Erzeugt aus Profil-Daten einen Lebenslauf - landet rechts in DOCUMENTS.",
  "service.page.cardCvGeneratorTitle": "CV-Generator",
  "service.page.cardDatatransferDesc": "Exportiert deine Profil- und Grow-Daten als JSON-Datei (DSGVO Art. 20) - landet in DOCUMENTS und wird sofort heruntergeladen.",
  "service.page.cardDatatransferTitle": "Datentransfer",
  "service.page.cardHardskillDesc": "Erkennt fachliche Hard Skills und Tools aus deinem Profil und bewertet ihr Niveau.",
  "service.page.cardHardskillTitle": "Hardskill-Analyse",
  "service.page.cardLinkedinDesc": "Übernimmt Profil, Stationen und Skills direkt aus deinem LinkedIn-Account.",
  "service.page.cardLinkedinTitle": "LinkedIn-Import",
  "service.page.cardPowerProfilePdfDesc": "Exportiert dein Power-Profil als PDF, mit den Quellen deiner Wahl nebeneinander.",
  "service.page.cardPowerProfilePdfTitle": "Power-Profil",
  "service.page.cardPowerDesc": "Identifiziert Powers, Skills und Erfahrung aus Free-Text und Selbstbeschreibung.",
  "service.page.cardPowerTitle": "Power-Analyse",
  "service.page.cardYamlExportDesc": "Exportiert dein komplettes Profil inkl. Fotos und Dokumenten als YAML-Datei, die sich wieder importieren lässt.",
  "service.page.cardYamlExportTitle": "Komplettes Profil",
  "service.page.clearSelection": "Auswahl aufheben",
  "service.page.confirmDelete": "Wirklich löschen?",
  "service.page.cvFallbackName": "Lebenslauf",
  "service.page.cvNotMovable": "CV-Entwürfe können nicht in Ordner verschoben werden",
  "service.page.documentDeleteBlocked": "Dieses Dokument wird noch in geteilten Beiträgen verwendet. Entferne es zuerst dort:",
  "service.page.documentsCount": "{total, plural, one {# Dokument} other {# Dokumente}}",
  "service.page.documentsHint": "Alle Dateien, die du hochgeladen oder über die Profil-Services erzeugt hast.",
  "service.page.documentsTitle": "Dokumente",
  "service.page.dropIntoFolder": "Hier ablegen, in diesen Ordner hochladen",
  "service.page.emptyDropHint": "Dateien hierher ziehen oder klicken zum Hochladen",
  "service.page.errExportSave": "Export konnte nicht gespeichert werden.",
  "service.page.errFolderCreate": "Ordner konnte nicht angelegt werden.",
  "service.page.errFolderLimit": "Du hast die maximale Anzahl von {limit} Ordnern erreicht.",
  "service.page.errFolderRename": "Ordner konnte nicht umbenannt werden.",
  "service.page.errMove": "Verschieben fehlgeschlagen.",
  "service.page.errNoContent": "Kein Inhalt vorhanden.",
  "service.page.errNotSignedInExport": "Nicht angemeldet - Export nicht möglich.",
  "service.page.errNotSignedInUpload": "Nicht angemeldet - Upload nicht möglich.",
  "service.page.errProfileLoad": "Profildaten konnten nicht geladen werden.",
  "service.page.errRename": "Umbenennen fehlgeschlagen.",
  "service.page.errUploadDuplicate": "Upload fehlgeschlagen. Vermutlich existiert bereits ein Dokument mit diesem Namen.",
  "service.page.errUploadNameTaken": "Schon in Dokumente vorhanden, nicht erneut hochgeladen: {names}.",
  "service.page.errUploadTooLarge": "Zu groß (max. {max} pro Datei): {names}.",
  "service.page.error": "Fehler: {message}",
  "service.page.exporting": "Exportiert …",
  "service.page.filterFileType": "Dateityp",
  "service.page.filterPlaceholder": "Filtere deine verfügbaren Dokumente …",
  "service.page.filterSource": "Quelle",
  "service.page.folderDeleteIncomplete": "{deleted, plural, =0 {Kein Dokument gelöscht} one {# Dokument gelöscht} other {# Dokumente gelöscht}}, {kept, plural, one {# ließ sich nicht löschen} other {# ließen sich nicht löschen}}, der Ordner bleibt deshalb bestehen.",
  "service.page.folderDeleteKeptShared": "wird noch in geteilten Beiträgen verwendet. Entferne es zuerst dort:",
  "service.page.folderEmpty": "Ordner ist leer - zieh Dokumente auf die Ordnerkachel.",
  "service.page.hardskillAnalysisTitle": "Hardskill-Analyse",
  "service.page.imports.accountProvisioningHint": "Hinweis: Diese Importe erstellen oder aktualisieren Profile. Es werden keine Zugangsdaten angelegt – importierte Personen können sich danach nicht direkt anmelden.",
  "service.page.inputTitle": "Profil aufbauen",
  "service.page.maxPerFile": "max. 10 MB pro Datei",
  "service.page.moveToFolder": "In Ordner verschieben",
  "service.page.noDocuments": "Keine Dokumente",
  "service.page.noFolders": "Keine Ordner vorhanden",
  "service.page.noMatches": "Keine Treffer",
  "service.page.noMatchesInFolder": "Keine Treffer in diesem Ordner",
  "service.page.onlyRealFilesMovable": "Nur echte Dateien lassen sich in Ordner verschieben, keine CV-Generator-Einträge.",
  "service.page.openBlockingSharedItem": "Geteilten Beitrag {number} öffnen",
  "service.page.orDragAndDrop": "Oder per Drag & Drop",
  "service.page.outputTitle": "Profil exportieren",
  "service.page.powerAnalysisTitle": "Power-Analyse",
  "service.page.removeBlockingSelection": "Verhindernde Auswahl entfernen",
  "service.page.reset": "Zurücksetzen",
  "service.page.selectedCount": "{count} ausgewählt",
  "service.page.sourceCvGenerator": "CV Generator",
  "service.page.sourceUpload": "Dateiupload",
  "service.page.unsorted": "Unsortiert",
  "service.page.uploadFile": "Datei hochladen",
  "service.page.uploading": "Lädt hoch …",
  "service.page.viewCompact": "Kompakt",
  "service.page.viewPreview": "Vorschau",
  "service.tour.filters.desc": "Filtere deine Dokumente nach Name, Quelle oder Dateityp und wechsle zwischen Vorschau- und Kompaktansicht.",
  "service.tour.filters.title": "Suchen & Filtern",
  "service.tour.label": "Save Dokumente",
  "service.tour.list.desc": "{count} Dokumente in {folders} Ordnern. Öffne einen Ordner für seine Dateien, ziehe Dokumente zwischen Ordnern und fahre über eine Zeile, um sie umzubenennen, auszuwählen oder zu löschen.",
  "service.tour.list.title": "Deine Dokumente",
  "service.tour.summary": "Das ist deine Dokumenten-Seite: {count} Dokumente in {folders} Ordnern, von manuellen Uploads bis zu generierten Lebensläufen.",
  "service.tour.upload.desc": "Lade hier Dateien hoch (max. 10 MB pro Datei), oder ziehe sie einfach per Drag & Drop auf einen Ordner oder die Liste darunter.",
  "service.tour.upload.title": "Dateien hochladen",
  "service.yamlExport.documents": "Documents",
  "service.yamlExport.documentsDesc": "Dokumentenordner und Dateien mit Metadaten, Tags und Dateiinhalten. Ohne Profil muss die Person beim Import bereits existieren.",
  "service.yamlExport.download": "YAML herunterladen",
  "service.yamlExport.exporting": "Export wird erstellt…",
  "service.yamlExport.intro": "Wähle aus, welche Bereiche der Export enthalten soll. Die heruntergeladene Datei kannst du mit dem YAML-Importer wieder importieren.",
  "service.yamlExport.profile": "Profil",
  "service.yamlExport.profileDesc": "Persönliche Daten, Profilbilder, Berufserfahrung, Ausbildung, Fachkompetenzen, Sprachen und Zertifikate",
  "service.yamlExport.selectionRequired": "Wähle mindestens einen Bereich aus.",
  "service.yamlExport.title": "YAML-Export",
  "settings.account.delete.button": "Konto löschen",
  "settings.account.delete.confirm": "Endgültig löschen",
  "settings.account.delete.desc": "Deine Profildaten, Dokumente, Kontakte und Gruppen werden gelöscht und dein Zugang wird gesperrt. Das kann nicht rückgängig gemacht werden.",
  "settings.account.delete.dialogTitle": "Konto endgültig löschen?",
  "settings.account.delete.placeholder": "Vollständiger Name",
  "settings.account.delete.prompt": "Gib zur Bestätigung deinen vollständigen Namen ein:",
  "settings.account.delete.retained": "Manches bleibt bestehen: Chat-Nachrichten, Gesprächsverläufe, veröffentlichte Beiträge sowie Match- und Assessment-Ergebnisse bleiben erhalten – ohne Bezug zu deinem Namen.",
  "settings.account.delete.title": "Konto löschen",
  "settings.account.delete.zone": "Gefahrenzone",
  "settings.eyebrow": "Plattform-Konfiguration",
  "settings.heading": "Admin",
  "settings.intro": "Branding, verwaltete Stammdaten, Fragebögen und Darstellung.",
  "settings.sectionAI": "KI",
  "settings.sectionAccessManagement": "Zugriffsverwaltung",
  "settings.sectionBranding": "Branding",
  "settings.sectionEmailTemplates": "E-Mail-Vorlagen",
  "settings.sectionFragebogen": "Fragebögen",
  "settings.sectionHrPrompt": "HR-Prompt",
  "settings.sectionLoginAssignment": "Login-Zuordnung",
  "settings.sectionRoster": "Import",
  "settings.sectionStammdaten": "Stammdaten",
  "settings.sectionStyleguide": "Styleguide",
  "settings.styleguide.buttons.specimen.combined": "Kombiniert",
  "settings.styleguide.modal.intro": "Alle drei Größen teilen Scrim, ESC/Backdrop-Schließen und die Titel-/Footer-Zeilen. Der Scrim bleibt immer weichgezeichnet und lässt einen Rand stehen – die Plattform bleibt hinter dem Dialog sichtbar.",
  "settings.styleguide.modal.openFill": "fillViewport öffnen",
  "settings.styleguide.modal.openLarge": "Large öffnen",
  "settings.styleguide.modal.openWindowed": "Standard öffnen",
  "settings.styleguide.section.modal": "Modal",
  "settings.upload.appearance.area": "Einstellungen",
  "settings.upload.appearance.limit": "bis 5 MB",
  "settings.upload.appearance.note": "wird auf 640 × 160 zugeschnitten und inline gespeichert",
  "settings.upload.appearance.what": "Logo",
  "settings.upload.docs.area": "Save · Dokumente",
  "settings.upload.docs.limit": "10 MB pro Datei",
  "settings.upload.docs.what": "Datei-Upload (PDF, DOCX, …)",
  "settings.upload.generalNote": "Alle Uploads laufen base64-kodiert über das BFF, das pro Anfrage max. 16 MB erlaubt. Da base64 die Größe um rund 33 % erhöht, liegen die tatsächlichen Dateigrenzen etwas darunter.",
  "settings.upload.profile.area": "Profil",
  "settings.upload.profile.limit": "5 MB",
  "settings.upload.profile.what": "Profilbild / Avatar",
  "settings.upload.shareAttach.area": "Share · Anhänge",
  "settings.upload.shareAttach.limit": "bis 16 MB",
  "settings.upload.shareAttach.note": "technische Obergrenze (BFF)",
  "settings.upload.shareAttach.what": "Datei-Anhänge an Projekte",
  "settings.upload.shareImage.area": "Share · Projekte",
  "settings.upload.shareImage.limit": "5 MB pro Bild",
  "settings.upload.shareImage.what": "Titelbild",
  "share.comment.saveFailed": "Der Kommentar konnte nicht gespeichert werden.",
  "share.create.actingAsCompany": "Du postest als {company}. Verlasse den Unternehmenskontext, um als du selbst zu posten.",
  "share.create.attachmentsLabel": "Anhänge",
  "share.create.authorLabel": "Autor",
  "share.create.commentsAfterPublish": "Nach dem Veröffentlichen verfügbar.",
  "share.create.commentsLabel": "Kommentare",
  "share.create.createHeading": "{type, select, POST {Neuer Post} other {Neues Projekt}}",
  "share.create.descriptionLabel": "Beschreibung",
  "share.create.descriptionPlaceholder": "{type, select, POST {Beschreibe deinen Post …} other {Beschreibe dein Projekt …}}",
  "share.create.markdownHint": "Markdown funktioniert: **fett**, _kursiv_, Listen und Links. Eine eingefügte URL wird anklickbar.",
  "share.create.markdownHintTitle": "Formatierung",
  "share.create.editHeading": "{type, select, POST {Post bearbeiten} other {Projekt bearbeiten}}",
  "share.create.existingAttachment": "Anhang {n}",
  "share.create.existingImage": "Bild {n}",
  "share.create.eyebrowCreate": "Erstellen",
  "share.create.entryChoice.eyebrow": "SHARE · Neu",
  "share.create.entryChoice.listingTitle": "Eine Ausschreibung erstellen",
  "share.create.entryChoice.listingDesc": "Stelle, Programm oder Aufruf ausschreiben, Bewerbungen sammeln.",
  "share.create.entryChoice.title": "Was möchtest du erstellen?",
  "share.create.entryChoice.postTitle": "Einen Post machen",
  "share.create.entryChoice.postDesc": "Einfach berichten, keine Team-Suche nötig.",
  "share.create.entryChoice.projectTitle": "Ein Projekt erstellen",
  "share.create.entryChoice.projectDesc": "Team finden, Timeline führen, Fortschritt dokumentieren.",
  "share.create.eyebrowEdit": "Bearbeiten",
  "share.create.eyebrowPreview": "Vorschau",
  "share.create.fromDocuments": "Aus meinen Dokumenten",
  "share.create.imagesLabel": "Bilder",
  "share.create.loadingFiles": "lädt…",
  "share.create.mainImageBadge": "Vorschau",
  "share.create.mainImageHint": "Als Vorschaubild festlegen",
  "share.create.noDescription": "Keine Beschreibung.",
  "share.create.previewButton": "Vorschau",
  "share.create.previewHeading": "So sieht's aus",
  "share.create.publish": "Veröffentlichen",
  "share.create.publishedAtLabel": "Veröffentlicht am",
  "share.create.ratingLabel": "Bewertung",
  "share.create.shortDescriptionLabel": "Kurzbeschreibung",
  "share.create.shortDescriptionPlaceholder": "In einem Satz: worum geht's?",
  "share.create.statComments": "Kommentare",
  "share.create.statInterested": "Interessenten",
  "share.create.statPins": "Pins",
  "share.create.statRatings": "Bewertungen",
  "share.create.statViews": "Views",
  "share.create.titleLabel": "Titel",
  "share.create.titlePlaceholder": "{type, select, POST {Titel des Posts} other {Titel des Projekts}}",
  "share.create.tooLarge": "Zu groß (max. {max} MB pro Datei): {names}",
  "share.create.typeLabel": "Typ",
  "share.create.typePost": "Post",
  "share.create.typeProject": "Projekt",
  "share.create.unsupportedType": "Nicht unterstützter Dateityp: {names}",
  "share.create.untitled": "Unbenannt",
  "share.docPicker.confirm": "{count} übernehmen",
  "share.docPicker.empty": "Noch keine Dokumente in deinem Vault.",
  "share.docPicker.emptyImages": "Noch keine Bilder in deinen Dokumenten.",
  "share.docPicker.hint": "Ausgewählte Dokumente werden dem Beitrag als Kopie angehängt.",
  "share.docPicker.loadFailed": "Dokumente konnten nicht geladen werden.",
  "share.docPicker.noMatches": "Keine Treffer",
  "share.docPicker.search": "Dokumente durchsuchen",
  "share.docPicker.title": "Aus meinen Dokumenten hinzufügen",
  "share.docPicker.unnamedDocument": "Unbenanntes Dokument",
  "share.itemDetail.alreadyRated": "Du hast bereits bewertet, erneut tippen zum Ändern.",
  "share.itemDetail.attachmentDownloadFailed": "Download fehlgeschlagen.",
  "share.itemDetail.attachmentOpenFailed": "Öffnen fehlgeschlagen.",
  "share.itemDetail.attachmentUnnamed": "Anhang",
  "share.itemDetail.attachments": "Anhänge",
  "share.itemDetail.author": "Autor",
  "share.itemDetail.commentAsCompany": "Du kommentierst als {company}. Verlasse den Unternehmenskontext, um als du selbst zu kommentieren.",
  "share.itemDetail.commentEditedBy": "Bearbeitet von {editor} am {when}",
  "share.itemDetail.commentPlaceholder": "Kommentar schreiben…",
  "share.itemDetail.commentPublishedBy": "Veröffentlicht von {company}",
  "share.itemDetail.comments": "Kommentare",
  "share.itemDetail.deleteConfirm": "Löschen?",
  "share.itemDetail.downloadAttachment": "{name} herunterladen",
  "share.itemDetail.error": "Fehler: {message}",
  "share.itemDetail.expressInterest": "Interesse zeigen",
  "share.itemDetail.imageN": "Bild {n}",
  "share.itemDetail.linkedMatchTitle": "Neues Match starten und mit diesem Share-Item verknüpfen",
  "share.itemDetail.loading": "lädt…",
  "share.itemDetail.more": "Mehr",
  "share.itemDetail.newMatch": "Neues Match ↗",
  "share.itemDetail.no": "Nein",
  "share.itemDetail.noComments": "Noch keine Kommentare, sei der/die Erste.",
  "share.itemDetail.noDescription": "Keine Beschreibung",
  "share.itemDetail.noDescriptionHint": "kein Inhalt hinterlegt",
  "share.itemDetail.notFound": "Beitrag nicht gefunden",
  "share.itemDetail.openAttachment": "{name} öffnen",
  "share.itemDetail.postedByOperator": "Gepostet von {name}",
  "share.itemDetail.publishedBy": "Veröffentlicht von",
  "share.itemDetail.publishedOn": "Veröffentlicht am",
  "share.itemDetail.rateYourselfTitle": "Klicken, um selbst zu bewerten",
  "share.itemDetail.rating": "Bewertung",
  "share.itemDetail.ratingClose": "schließen",
  "share.itemDetail.ratingOpen": "bewerten ›",
  "share.itemDetail.ratingsCount": "({count} Bewertungen)",
  "share.itemDetail.send": "Senden",
  "share.itemDetail.share": "Teilen",
  "share.itemDetail.shareWithIcon": "↗ Teilen",
  "share.itemDetail.signedUpWithdraw": "✓ Interesse gezeigt - zurückziehen",
  "share.itemDetail.starsAriaLabel": "{n} von 5 Sternen",
  "share.itemDetail.starsTitle": "{n, plural, one {# Stern} other {# Sterne}}",
  "share.itemDetail.statInterested": "Interessenten",
  "share.itemDetail.statPins": "Pins",
  "share.itemDetail.statViews": "Views",
  "share.itemDetail.thanks": "Danke!",
  "share.itemDetail.tour.actions.desc": "Beobachte den Eintrag, um ihm zu folgen, oder starte ein neues Match, das damit verknüpft ist.",
  "share.itemDetail.tour.actions.projectDesc": "Beobachte den Eintrag, um ihm zu folgen, bekunde Interesse, um dich als Teilnehmer einzutragen, oder starte ein neues Match zu diesem Projekt.",
  "share.itemDetail.tour.actions.title": "Mitmachen",
  "share.itemDetail.tour.content.desc": "Titel, Bildergalerie und vollständige Beschreibung von „{name}“. Klicke die Vorschaubilder, um durch die Galerie zu blättern.",
  "share.itemDetail.tour.content.title": "Der Inhalt",
  "share.itemDetail.tour.label": "Share Beitrag",
  "share.itemDetail.tour.stats.desc": "Die bisherige Reichweite: {views} Aufrufe, {pins} Pins und {signUps} Interessierte.",
  "share.itemDetail.tour.stats.title": "So läuft es",
  "share.itemDetail.tour.summary": "Du schaust dir „{name}“ an, ein {type} aus der Share-Community.",
  "share.itemDetail.unwatch": "✓ Beobachtet - entfernen",
  "share.itemDetail.watch": "Beobachten",
  "share.itemDetail.yes": "Ja",
  "share.itemDetail.commentEmpty": "Ein leerer Kommentar kann nicht gespeichert werden.",
  "share.landing.carouselDiscussed": "Meiste Kommentare",
  "share.landing.carouselInterest": "Meiste Interessenten",
  "share.landing.carouselNew": "Neueste",
  "share.landing.carouselTop": "Top bewertet",
  "share.landing.discoverAllPosts": "Alle Beiträge entdecken ↗",
  "share.landing.discoverEyebrow": "Entdecken",
  "share.landing.error": "Fehler: {message}",
  "share.landing.heroBody": "Veröffentliche Projekte und Posts, sammle Interessenten, Feedback und Reichweite. Und entdecke, woran die Community gerade baut.",
  "share.landing.heroCta": "Erstellen ↗",
  "share.landing.heroSubtitleLine1": "Zeig, woran du arbeitest.",
  "share.landing.heroSubtitleLine2": "Finde, wer mitmacht.",
  "share.landing.loading": "lädt…",
  "share.landing.myActivity": "Meine Aktivität",
  "share.landing.myProjectsSection": "Meine Projekte & Posts",
  "share.landing.next": "Nächstes",
  "share.landing.noOwnPosts": "Noch keine eigenen Beiträge",
  "share.landing.noOwnPostsHint": "erstelle ein Projekt oder einen Post",
  "share.landing.noSharedItems": "Keine geteilten Items vorhanden.",
  "share.landing.noShortDescription": "Keine Kurzbeschreibung.",
  "share.landing.nothingWatched": "Noch nichts beobachtet oder beteiligt",
  "share.landing.nothingWatchedHint": "Beobachte Projekte & Posts oder beteilige dich.",
  "share.landing.open": "Öffnen ↗",
  "share.landing.previous": "Vorheriges",
  "share.landing.share": "↗ Teilen",
  "share.landing.slide": "Slide {number}",
  "share.landing.statComments": "Kommentare",
  "share.landing.statInterested": "Interessenten",
  "share.landing.statRatings": "Ratings",
  "share.landing.statViews": "Views",
  "share.landing.tour.activity.desc": "Die {count} Einträge, die du beobachtest oder für die du dich eingetragen hast. So kommst du schnell wieder dorthin zurück.",
  "share.landing.tour.activity.emptyDesc": "Einträge, die du beobachtest oder für die du dich einträgst, sammeln sich hier; noch ist nichts da. Öffne einen Eintrag und drücke Beobachten oder Interesse bekunden.",
  "share.landing.tour.activity.title": "Beobachtet & Beteiligt",
  "share.landing.tour.activity.unknownDesc": "Einträge, die du beobachtest oder für die du dich einträgst, sammeln sich hier. So kommst du schnell wieder dorthin zurück.",
  "share.landing.tour.carousel.desc": "Vier kuratierte Top-5-Listen: am besten bewertet, am neuesten, meiste Interessenten, meiste Kommentare. Wechsle die Listen über die Tabs; gerade läuft „{featured}“. Klicke Öffnen, um in einen Eintrag zu springen.",
  "share.landing.tour.carousel.title": "Entdecken",
  "share.landing.tour.create.desc": "Veröffentliche hier dein eigenes Projekt oder deinen Beitrag. Beschreibe es, füge Bilder hinzu und sammle Interessierte.",
  "share.landing.tour.create.title": "Etwas erstellen",
  "share.landing.tour.emptySummary": "Das ist Share, der Community-Feed, in dem Menschen Projekte und Beiträge veröffentlichen, Interessierte gewinnen und Feedback sammeln.",
  "share.landing.tour.label": "Share",
  "share.landing.tour.mine.desc": "Deine eigenen {count} veröffentlichten Einträge. „Alle ansehen“ öffnet die vollständige Liste, in der du sie verwaltest.",
  "share.landing.tour.mine.emptyDesc": "Deine eigenen veröffentlichten Einträge erscheinen hier. Du hast noch keine erstellt.",
  "share.landing.tour.mine.title": "Meine Projekte & Beiträge",
  "share.landing.tour.mine.unknownDesc": "Deine eigenen veröffentlichten Einträge erscheinen hier. „Alle ansehen“ öffnet die vollständige Liste, in der du sie verwaltest.",
  "share.landing.tour.summary": "Das ist Share, der Community-Feed, in dem Menschen Projekte und Beiträge veröffentlichen, Interessierte gewinnen und Feedback sammeln. Gerade steht „{name}“ im Rampenlicht.",
  "share.landing.viewAll": "Alle ansehen ↗",
  "share.landing.watchedSection": "Beobachtet & Beteiligt",
  "share.landing.openListingsSection": "Offene Ausschreibungen",
  "share.landing.applicationsSection": "Meine Bewerbungen",
  "share.mine.emptyHint": "erstelle ein Projekt oder einen Post",
  "share.mine.emptyLabel": "Noch keine eigenen Beiträge",
  "share.mine.error": "Fehler: {message}",
  "share.mine.eyebrow": "SHARE · Meine Beiträge",
  "share.mine.filterAll": "Alle",
  "share.mine.filterPosts": "Posts",
  "share.mine.filterProjects": "Projekte",
  "share.mine.subtitle": "Alle deine Projekte und Posts.",
  "share.mine.title": "Meine Beiträge",
  "share.mine.tour.filters.desc": "Grenze die Liste auf Projekte oder Beiträge ein und ändere rechts die Sortierung.",
  "share.mine.tour.filters.title": "Filtern & Sortieren",
  "share.mine.tour.items.desc": "{count} Einträge. Klicke einen an, um ihn zu öffnen; als Besitzer kannst du ihn auf der Detailseite bearbeiten oder löschen.",
  "share.mine.tour.items.emptyDesc": "Noch nichts hier. Erstelle ein Projekt oder einen Beitrag, dann taucht er in diesem Raster auf.",
  "share.mine.tour.items.title": "Deine Einträge",
  "share.mine.tour.label": "Share Meine",
  "share.mine.tour.summary": "Das sind deine eigenen Beiträge: alles, was du auf Share veröffentlicht hast. Gerade sind es {count} Einträge.",
  "share.person.emptyLabel": "Keine Beiträge zu sehen",
  "share.person.eyebrow": "SHARE · Beiträge",
  "share.person.loadFailed": "Profil konnte nicht geladen werden",
  "share.person.notFound": "Profil nicht gefunden",
  "share.person.notFoundHint": "Dieses Profil existiert nicht oder wurde nicht mit dir geteilt.",
  "share.person.subtitle": "Projekte und Posts von {name}, die du sehen kannst.",
  "share.person.title": "Beiträge von {name}",
  "share.person.titleUnknown": "Beiträge",
  "share.person.tour.items.desc": "{count} Einträge. Klicke einen an, um ihn zu öffnen.",
  "share.person.tour.items.title": "Ihre Einträge",
  "share.person.tour.label": "Share Person",
  "share.person.tour.summary": "Was {name} auf Share veröffentlicht hat und du sehen kannst. Gerade sind es {count} Einträge.",
  "share.listings.title": "Ausschreibungen",
  "share.listings.subtitle": "Stellen, Programme und Aufrufe, die du verwaltest oder lesen darfst.",
  "share.listings.settings.title": "Mitglieder und Berechtigungen",
  "share.listings.filterAll": "Alle",
  "share.listings.create": "Neue Ausschreibung",
  "share.listings.createScreen.sub": "Titel genügt. Frist, Bilder, Leserschaft und Mitglieder ergänzt du danach in der Ausschreibung.",
  "share.listings.createScreen.submit": "Ausschreibung anlegen",
  "share.listings.createScreen.descPlaceholder": "Was wird ausgeschrieben, und wen sucht ihr?",
  "share.listings.empty": "Noch keine Ausschreibung",
  "share.listings.emptyFiltered": "Keine Ausschreibung in diesem Zustand",
  "share.listings.emptyHint": "lege eine neue Ausschreibung an",
  "share.listings.untitled": "Ohne Titel",
  "share.listings.deadlineOn": "Frist {date}",
  "share.listings.dashboard.badge": "Ausschreibung",
  "share.listings.dashboard.readOnly": "Du kannst diese Ausschreibung nur ansehen.",
  "share.listings.dashboard.rename": "Ausschreibung umbenennen",
  "share.listings.dashboard.untitled": "Unbenannte Ausschreibung",
  "share.listings.noDeadline": "Keine Frist",
  "share.listings.state.draft": "Entwurf",
  "share.listings.state.open": "Offen",
  "share.listings.state.closed": "Geschlossen",
  "share.listings.state.concluded": "Abgeschlossen",
  "share.listings.action.publish": "Veröffentlichen",
  "share.listings.action.reopen": "Wieder öffnen",
  "share.listings.action.close": "Schließen",
  "share.listings.action.conclude": "Abschließen",
  "share.listings.action.withdraw": "Zurückziehen",
  "share.listings.confirm.withdraw": "Die Ausschreibung wird wieder zum Entwurf. Gruppen und Öffentlichkeit sehen sie sofort nicht mehr, Inhalt und Mitglieder bleiben.",
  "share.listings.confirm.close": "Es gehen keine neuen Bewerbungen mehr ein. Du kannst die Ausschreibung später wieder öffnen.",
  "share.listings.confirm.conclude": "Das Verfahren ist beendet. Ab jetzt läuft die Aufbewahrungsfrist.",
  "share.listings.deadlineDialog.title": "Neue Frist",
  "share.listings.deadlineDialog.body": "Die Frist ist abgelaufen. Lege eine neue Frist in der Zukunft fest, sonst schlösse sie die Ausschreibung sofort wieder.",
  "share.listings.deadlineDialog.future": "Die Frist muss in der Zukunft liegen.",
  "share.listings.notFound": "Ausschreibung nicht gefunden",
  "share.listings.description": "Beschreibung",
  "share.listings.noDescription": "Keine Beschreibung.",
  "share.listings.categories": "Kategorien",
  "share.listings.status": "Zustand",
  "share.listings.field.deadline": "Frist",
  "share.listings.field.publishedOn": "Veröffentlicht am",
  "share.listings.field.concludedOn": "Abgeschlossen am",
  "share.listings.field.retention": "Aufbewahrung",
  "share.listings.delete": "Ausschreibung löschen",
  "share.listings.deleteMessage": "Löscht die Ausschreibung mit Mitgliedern, Leserschaft und Kategorien. Verknüpfte Matches bleiben bestehen.",
  "share.listings.role": "Rolle",
  "share.listings.rolesHint": "Bearbeiter:innen ändern Inhalt und Kandidaten und dürfen veröffentlichen und schließen. Admins verwalten zusätzlich Mitglieder und Rechte; zu Admins ernennt nur die Person, die die Ausschreibung angelegt hat.",
  "share.listings.area.applications": "Bewerbungen",
  "share.listings.level.read": "Lesen",
  "share.listings.level.write": "Bearbeiten",
  "share.listings.readership": "Leserschaft",
  "share.listings.readershipPublic": "Alle dürfen die Ausschreibung lesen.",
  "share.listings.readershipMembers": "Nur die Mitglieder.",
  "share.listings.readershipHint": "Gruppen und Öffentlichkeit erreichen die Ausschreibung nur, solange sie offen ist.",
  "share.listings.form.titlePlaceholder": "Stelle, Programm oder Aufruf",
  "share.listings.form.deadlineHint": "Ab der Frist gilt die Ausschreibung als geschlossen. Leer heißt ohne Frist.",
  "share.listings.form.retentionDays": "Aufbewahrung in Tagen",
  "share.listings.form.retentionInvalid": "Bitte eine ganze Zahl von 1 bis 180 eingeben.",
  "share.listings.form.retentionHint": "Zählt ab dem Abschluss.",
  "share.listings.form.retentionDefaultHint": "Zählt ab dem Abschluss. Leer lassen für den Standard.",
  "share.listings.form.noCategories": "Es sind keine Kategorien angelegt.",
  "share.listings.form.categoriesHint": "Kategorien ordnen die Ausschreibung für Bewerbende ein und geben keinen Zugriff.",
  "share.listings.form.readershipTitle": "Wer darf die Ausschreibung lesen?",
  "share.listings.form.images": "Bilder",
  "share.listings.form.imagesHint": "PNG, JPEG, GIF, BMP, TIFF oder WebP, je Bild höchstens {max}",
  "share.listings.images.tooLarge": "Ein Bild ist größer als {max}. Bitte wähle eine kleinere Datei.",
  "share.listings.images.unsupported": "Ein Bild ist kein PNG, JPEG, GIF, BMP, TIFF oder WebP. Bitte wähle eine andere Datei.",
  "share.listings.images.notSaved": "Die Ausschreibung ist gespeichert, {count, plural, one {ein Bild fehlt} other {# Bilder fehlen}} aber noch. {reason}",
  "share.listings.images.none": "Noch keine Bilder.",
  "share.listings.reference.label": "Kennziffer",
  "share.listings.reference.inline": "Kennziffer {reference}",
  "share.listings.reference.copy": "Kennziffer kopieren",
  "share.listings.reference.copied": "Kennziffer kopiert",
  "share.listings.referenceSearch.label": "Nach Kennziffer suchen",
  "share.listings.referenceSearch.placeholder": "Kennziffer, z. B. {example}",
  "share.listings.referenceSearch.empty": "Keine Ausschreibung mit dieser Kennziffer",
  "share.listings.referenceSearch.emptyFiltered": "Keine Ausschreibung mit dieser Kennziffer in diesem Zustand",
  "share.listings.referenceSearch.clear": "Suche leeren",
  "share.openListings.title": "Offene Ausschreibungen",
  "share.openListings.subtitle": "Stellen, Programme und Aufrufe, auf die du dich gerade bewerben kannst.",
  "share.openListings.empty": "Gerade ist keine Ausschreibung offen",
  "share.openListings.notFound": "Diese Ausschreibung ist nicht offen oder nicht für dich sichtbar",
  "share.openListings.applicationBox": "Bewerbung",
  "share.openListings.yourApplication": "Deine Bewerbung",
  "share.openListings.yourApplicationValue": "{state}, eingegangen am {date}",
  "share.openListings.apply": "Bewerben",
  "share.openListings.toMyApplications": "Meine Bewerbungen",
  "share.openListings.referenceSearch.empty": "Keine offene Ausschreibung mit dieser Kennziffer",
  "share.applications.title": "Meine Bewerbungen",
  "share.applications.subtitle": "Deine Bewerbungen auf Ausschreibungen und wie weit sie sind.",
  "share.applications.empty": "Noch keine Bewerbung",
  "share.applications.toOpenListings": "Offene Ausschreibungen",
  "share.applications.receivedOn": "Eingegangen am {date}",
  "share.applications.decidedOn": "Entschieden am {date}",
  "share.applications.withdrawnOn": "Zurückgezogen am {date}",
  "share.applications.withdraw": "Zurückziehen",
  "share.applications.withdrawTitle": "Bewerbung zurückziehen",
  "share.applications.withdrawMessage": "Der Rückzug ist endgültig. Eingereichte Dokumente bleiben beim Unternehmen. Solange die Ausschreibung offen ist, kannst du dich neu bewerben.",
  "share.applications.state.received": "Eingegangen",
  "share.applications.state.inReview": "In Prüfung",
  "share.applications.state.accepted": "Angenommen",
  "share.applications.state.rejected": "Abgelehnt",
  "share.applications.state.withdrawn": "Zurückgezogen",
  "share.applications.dialog.title": "Bewerbung auf {name}",
  "share.applications.dialog.submit": "Bewerbung absenden",
  "share.applications.dialog.sending": "Wird gesendet…",
  "share.applications.dialog.done": "Deine Bewerbung ist eingegangen.",
  "share.applications.dialog.doneHint": "Den Stand siehst du unter Meine Bewerbungen. Solange nicht entschieden ist, kannst du die Bewerbung dort zurückziehen.",
  "share.applications.dialog.toMyApplications": "Zu meinen Bewerbungen",
  "share.applications.contact.title": "Kontaktdaten",
  "share.applications.contact.hint": "Was schon in deinem Profil steht, bleibt unverändert und ist hier fest eingetragen. Leere Felder kannst du ergänzen, sie werden in dein Profil übernommen.",
  "share.applications.contact.givenName": "Vorname",
  "share.applications.contact.familyName": "Nachname",
  "share.applications.documents.title": "Dokumente",
  "share.applications.documents.cv": "Lebenslauf",
  "share.applications.documents.more": "Weitere Dokumente",
  "share.applications.documents.limits": "PDF, Word, Excel, Text oder Bild. Höchstens {count} Dateien, je bis {perFile}, zusammen bis {total}.",
  "share.applications.documents.tooLarge": "{name} ist größer als {max}.",
  "share.applications.documents.unsupportedType": "{name}: Dieses Format wird nicht angenommen.",
  "share.applications.documents.empty": "{name} ist leer.",
  "share.applications.documents.tooMany": "{name} passt nicht mehr dazu: höchstens ein Lebenslauf und {count} weitere Dokumente.",
  "share.applications.documents.totalTooLarge": "{name} passt nicht mehr dazu: zusammen höchstens {max}.",
  "share.listings.applications.empty": "Noch keine Bewerbung.",
  "share.listings.applications.emptyFiltered": "Keine Bewerbung in diesem Zustand.",
  "share.listings.applications.unnamedPerson": "Person ohne Namen",
  "share.listings.applications.receivedOn": "Eingang {date}",
  "share.listings.applications.decidedOn": "Entschieden {date}",
  "share.listings.applications.withdrawnOn": "Zurückgezogen {date}",
  "share.listings.applications.count": "{count, plural, one {# Bewerbung} other {# Bewerbungen}}",
  "share.listings.applications.noDocuments": "Keine Dokumente eingereicht.",
  "share.listings.applications.action.startReview": "In Prüfung nehmen",
  "share.listings.applications.action.accept": "Annehmen",
  "share.listings.applications.action.reject": "Ablehnen",
  "share.listings.applications.action.reopenReview": "Entscheidung zurücknehmen",
  "share.listings.post.label": "Post",
  "share.listings.post.open": "Post ansehen",
  "share.listings.post.previewLabel": "Vorschau",
  "share.listings.post.manage": "Verwalten",
  "share.listings.post.previewHint": "Bewerbende sehen das erst, wenn die Ausschreibung offen ist.",
  "share.listings.dashboard.activityEmpty": "Noch nichts passiert. Hier landet, was an der Ausschreibung geschieht.",
  "share.listings.matches.linkedTitle": "Matches dieser Ausschreibung",
  "share.listings.matches.noLinked": "Zu dieser Ausschreibung gibt es noch kein Match.",
  "share.listings.matches.unlinkTitle": "Verbindung zur Ausschreibung lösen",
  "share.listings.matches.unlinkBody": "„{name}“ gehört dann nicht mehr zu dieser Ausschreibung. Das Match selbst bleibt mit Kandidaten und Ergebnissen erhalten.",
  "share.listings.matches.wayDesc": "Direkt in MATCH, mit den Anforderungen aus dieser Ausschreibung.",
  "share.listings.toMatch.sub": "Das Match startet nicht bei null. Wähle, was aus der Ausschreibung mitgeht.",
  "share.listings.toMatch.copyNote": "Fachkompetenzen und Powers kommen aus den Anforderungen dieser Ausschreibung. Geänderte Anforderungen werden mit einer neuen Match-Version übernommen.",
  "share.listings.toMatch.orphaned": "Das Match ist angelegt, ließ sich aber nicht mit der Ausschreibung verknüpfen. Du findest es unter MATCH.",
  "share.listings.toMatch.partial": "Das Match ist angelegt und mit der Ausschreibung verknüpft, aber {missing, select, people {die Bewerbenden ließen sich nicht übernehmen. Du kannst sie im Match nachtragen} autoMatch {die automatische Bewertung ließ sich nicht einschalten. Du kannst sie in den Match-Einstellungen einschalten} other {weder ließen sich die Bewerbenden übernehmen noch die automatische Bewertung einschalten. Du kannst beides im Match nachholen}}.",
  "share.listings.toMatch.applicants": "Bewerbende",
  "share.listings.toMatch.applicantsDetail": "{total, plural, =0 {Keine Bewerbung, die eingegangen, in Prüfung oder angenommen ist} other {{count, plural, =0 {Niemand geht mit} one {Eine Person aus den Bewerbungen} other {# Personen aus den Bewerbungen}}}}",
  "share.listings.toMatch.noApplicationAccess": "Ohne Leserecht auf Bewerbungen gehen keine Bewerbenden mit und neue Bewerbungen werden nicht automatisch bewertet. Zugriff vergibt, wer die Zugriffe dieser Ausschreibung verwaltet.",
  "share.landing.noProjects": "Noch kein Projekt",
  "share.landing.noProjectsHint": "lege eines über den Erstellen-Knopf an",
  "share.landing.projectBadge": "Projekt",
  "share.landing.projectsCount": "{count, plural, one {# Projekt} other {# Projekte}}",
  "share.landing.projectsSection": "Meine Projekte",
  "skill.catAwareness": "Bewusstsein & Lernen",
  "skill.catImpact": "Wirkung & Einfluss gestalten",
  "skill.catPractical": "Praktische Anwendung & Kompetenzsicherheit",
  "skill.desc.1": "Du kennst grundlegende Konzepte dieser Kompetenz und hast erste Berührungspunkte damit, nutzt sie aber noch nicht praktisch.",
  "skill.desc.2": "Du baust aktiv Grundlagen in dieser Kompetenz auf und kannst erste einfache Aufgaben mit Unterstützung und Vorgaben bearbeiten.",
  "skill.desc.3": "Du nutzt die Kompetenz bereits in ersten praktischen Situationen und kannst einfache Aufgaben selbstständig umsetzen.",
  "skill.desc.4": "Du setzt die Kompetenz regelmäßig ein und kannst typische Aufgaben zuverlässig und selbstständig lösen.",
  "skill.desc.5": "Du verfügst über tiefgehende praktische Erfahrung und setzt die Kompetenz souverän in unterschiedlichen komplexen und anspruchsvollen Situationen ein.",
  "skill.desc.6": "Du bist eine anerkannte Referenz für diese Kompetenz und stärkst andere in der Anwendung, indem du wirksam Best Practices im Team oder in der Organisation etablierst.",
  "skill.desc.7": "Du entwickelst zukunftsweisende Ansätze für diese Kompetenz und gibst richtungsweisende Impulse, die zu neuen Standards führen.",
  "skill.infoLabel": "Levelbeschreibung",
  "skill.levelName.1": "Explorer",
  "skill.levelName.2": "Builder",
  "skill.levelName.3": "Contributor",
  "skill.levelName.4": "Practitioner",
  "skill.levelName.5": "Specialist",
  "skill.levelName.6": "Multiplier",
  "skill.levelName.7": "Pioneer",
  "skill.levelTitle.1": "Kennenlernen & erste Berührungspunkte",
  "skill.levelTitle.2": "Gezieltes Entwickeln",
  "skill.levelTitle.3": "Erste Praxisanwendungen",
  "skill.levelTitle.4": "Regelmäßige & sichere Praxisanwendungen",
  "skill.levelTitle.5": "Souveräner Einsatz in anspruchsvollen Kontexten",
  "skill.levelTitle.6": "Andere befähigen & entwickeln",
  "skill.levelTitle.7": "Neues prägen & Innovation vorantreiben",
  "sort.az": "A–Z",
  "sort.label": "Sortieren",
  "sort.nameAz": "Name A–Z",
  "sort.nameZa": "Name Z–A",
  "sort.new": "Neueste",
  "sort.old": "Älteste",
  "sort.top": "Top bewertet",
  "stammdaten.agents": "KI-Agenten",
  "stammdaten.teamprofil": "Power-Scorecards",
  "stammdaten.values": "Auswahlwerte",
  "studio.back": "← Alle Notizbücher",
  "studio.deleteNotebook": "Notizbuch löschen?",
  "studio.deleteNotebookMessage": "Das Notizbuch wird mit allen Notizen gelöscht.",
  "studio.description": "Ein Platz für lose Gedanken, Namen und Rechercheergebnisse.",
  "studio.emptyNotebook": "Alles fängt mit einer ersten Notiz an. Trag ein, was du hast, vollständig muss es nicht sein.",
  "studio.emptyPreview": "Platz für deine nächste Idee.",
  "studio.localNotice": "Notizbücher werden automatisch gespeichert und sind nur für dich sichtbar. Als Markdown exportieren kannst du jedes jederzeit.",
  "studio.textDone": "Fertig",
  "studio.namePlaceholder": "Was sammelst du hier?",
  "studio.newNotebook": "Neues Notizbuch",
  "studio.notFound": "Dieses Notizbuch gibt es nicht (mehr).",
  "studio.export": "Exportieren",
  "studio.notePlaceholder": "Namen, Links, Suchergebnisse oder eigene Gedanken hier einfügen…",
  "studio.thought.inProgress": "In Bearbeitung",
  "studio.compose": "Notiz schreiben oder den Assistenten fragen",
  "studio.addToNotebook": "Zum Notizbuch hinzufügen",
  "studio.askAssistant": "Assistenten fragen",
  "studio.editText": "Text bearbeiten",
  "studio.exportTitle": "Notizbuch exportieren",
  "studio.exportWithAnswers": "Mit den Antworten des Assistenten",
  "studio.exportWithAnswersHint": "Deine Notizen und die Fragen mit ihren Antworten, in der Reihenfolge des Notizbuchs.",
  "studio.exportNotesOnly": "Nur meine Notizen",
  "studio.exportNotesOnlyHint": "Nur, was du geschrieben hast, ohne den Assistenten.",
  "studio.exportFinal": "Finalen Notizenstand mit dem Assistenten erstellen",
  "studio.exportFinalHint": "Der Assistent fasst deine Notizen zusammen. Das Ergebnis erscheint im Notizbuch, dort exportierst du es.",
  "studio.exportFinalFile": "Als Datei exportieren",
  "studio.finalPrompt": "Schreib aus allem, was in diesem Notizbuch steht, einen finalen Stand als Markdown: meine Notizen, die eingebrachten Dokumente und die behaltenen Antworten, Doppeltes zusammengefasst, nach Themen geordnet, nichts weggelassen, was sie sagen, und nichts hinzugefügt. Antworte nur mit dem Markdown.",
  "studio.proposalLabel": "Vorschlag",
  "studio.documentLabel": "Dokument",
  "studio.noteEdit": "Notiz bearbeiten",
  "studio.text": "Text des Notizbuchs",
  "studio.notebooks": "Notizbücher",
  "studio.open": "Studio öffnen",
  "studio.renameNotebook": "Notizbuch umbenennen",
  "studio.storageError": "Deine Notizbücher konnten nicht gespeichert oder geladen werden. Bitte sichere deinen Text und versuche es erneut.",
  "studio.title": "Studio",
  "studio.toRecords": "In echte Daten übernehmen",
  "studio.toRecordsPrompt": "Schlag mir Datensätze aus diesem Notizbuch vor.",
  "studio.proposal.title": "Übernehmen aus dem Notizbuch",
  "studio.proposal.createHint": "Legt sie an und vermerkt die Herkunft jeweils in der Organisationsakte.",
  "studio.proposal.provenanceNoted": "Die Herkunft ist in der Organisationsakte vermerkt.",
  "studio.proposal.provenanceFailed": "Herkunft nicht in der Organisationsakte vermerkt: {reason}",
  "studio.provenance.title": "Aus dem Studio übernommen",
  "studio.provenance.intro": "Angelegt aus dem Studio-Notizbuch „{notebook}“ am {date}.",
  "studio.provenance.introUnnamed": "Angelegt aus dem Studio am {date}.",
  "studio.provenance.sources": "Die Stellen, aus denen es stammt",
  "studio.provenance.noSources": "Die Karte hat keine Stellen zum Zitieren festgehalten.",
  "studio.proposal.persons": "Personen",
  "studio.proposal.companies": "Unternehmen",
  "studio.proposal.forbidden": "Du darfst diesen Datensatz nicht anlegen.",
  "studio.proposal.issueMandatory": "{field} fehlt",
  "studio.proposal.issueFormat": "{field} hat ein ungültiges Format",
  "studio.proposal.issueExists": "{field} ist bereits vergeben",
  "studio.proposal.issueOther": "{field} wurde nicht angenommen",
  "studio.proposal.possibleDuplicates": "Möglicherweise schon da:",
  "studio.proposal.create": "Anlegen",
  "studio.proposal.creating": "Wird angelegt…",
  "studio.proposal.created": "Angelegt.",
  "studio.proposal.rowNotTaken": "Nicht übernommen: {reason}",
  "studio.proposal.rowFailed": "Ein Eintrag konnte nicht übernommen werden.",
  "studio.proposal.keepToCreate": "Füge die Karte dem Notizbuch hinzu, um sie anzulegen.",
  "studio.proposal.noPersonRight": "Du darfst keine Personen anlegen.",
  "studio.proposal.noCompanyRight": "Du darfst keine Unternehmen anlegen.",
  "studio.proposal.field.email": "E-Mail",
  "studio.proposal.field.jobTitle": "Jobtitel",
  "studio.proposal.field.currentEmployer": "Arbeitgeber",
  "studio.proposal.field.city": "Ort",
  "studio.proposal.field.website": "Website",
  "studio.proposal.field.phone": "Telefon",
  "studio.proposal.field.summary": "Beschreibung",
  "studio.proposal.field.employeeCount": "Mitarbeitende",
  "studio.proposal.field.experiences": "Berufserfahrung",
  "studio.proposal.field.educations": "Ausbildung",
  "studio.proposal.today": "heute",
  "studio.proposal.until": "bis {date}",
  "suggestions.activities": "Aufgaben vorschlagen",
  "suggestions.add": "Tippen zum Hinzufügen",
  "suggestions.addTask": "+ Aufgabe",
  "suggestions.empty": "Keine Vorschläge gefunden",
  "suggestions.loading": "Vorschläge werden geladen…",
  "suggestions.needJobTitle": "Erst Stellenbezeichnung eingeben",
  "suggestions.retry": "Erneut versuchen",
  "suggestions.unavailable": "Vorschläge derzeit nicht verfügbar",
  "teamProfile.confirmDelete.message": "Das Profil wird endgültig entfernt und steht beim Entwerfen eines Matches nicht mehr zur Auswahl.",
  "teamProfile.confirmDelete.title": "„{label}“ löschen?",
  "teamProfile.copyName.english": "{name} (copy)",
  "teamProfile.copyName.german": "{name} (Kopie)",
  "teamProfile.create.source": "Werte aus bestehender Scorecard",
  "teamProfile.create.sourceNone": "Keine (gleich gewichtet)",
  "teamProfile.create.sub": "Startet mit gleich gewichteten Powers. Öffne das Profil danach, um Gewichte zu justieren.",
  "teamProfile.create.subFrom": "Startet mit den Gewichten von „{name}“. Öffne das Profil danach, um Gewichte zu justieren.",
  "teamProfile.create.submit": "Profil anlegen",
  "teamProfile.create.title": "Neues Profil",
  "teamProfile.delete": "Profil löschen",
  "teamProfile.duplicate": "Ein Profil mit diesem Namen gibt es bereits.",
  "teamProfile.duplicateAction": "Duplizieren",
  "teamProfile.empty": "Noch keine Profile.",
  "teamProfile.loading": "Lädt…",
  "teamProfile.nameDe": "Name (Deutsch)",
  "teamProfile.nameEn": "Name (Englisch)",
  "teamProfile.presetBadge": "Vorlage",
  "teamProfile.presetHint": "Name und Gewichte dieser Vorlage sind von Smycles vorgegeben und nicht änderbar. Leg ein eigenes Profil an, wenn du andere Gewichte brauchst.",
  "teamProfile.reset": "Änderungen verwerfen",
  "teamProfile.save": "Speichern",
  "teamProfile.saveFailed": "Das Profil konnte nicht gespeichert werden.",
  "teamProfile.sub": "Benannte Gewichtungen über die 30 Powers, auswählbar beim Entwerfen eines Matches. Explore, Exploit und Ausgewogen sind Vorlagen von Smycles: Name und Gewichte liegen fest.",
  "teamProfile.title": "Power-Scorecards",
  "teamProfile.truncated": "Es werden die ersten {shown} von {total} Profilen angezeigt. Lösche oder benenne Profile um, die du nicht mehr brauchst.",
  "teamProfile.weights": "Gewichtung",
  "topbar.help.choiceNews": "Zeig mir was neu ist",
  "topbar.help.choiceTour": "Starte die Tour",
  "topbar.help.hint": "Neu hier? Starte mit diesem Button die geführte Tour durch die App.",
  "topbar.help.hintDismiss": "Ausblenden",
  "topbar.help.hintNews": "Seit deiner Tour hat sich etwas getan. Dieser Button zeigt dir, was neu ist.",
  "topbar.help.label": "Starte die geführte Tour",
  "unsavedGuard.body": "Du hast Änderungen, die noch nicht gespeichert wurden. Wenn du die Seite verlässt, gehen sie verloren.",
  "unsavedGuard.discard": "Verwerfen",
  "unsavedGuard.leave": "Verlassen",
  "unsavedGuard.save": "Speichern",
  "unsavedGuard.stay": "Hier bleiben",
  "unsavedGuard.title": "Ungespeicherte Änderungen",
  "unsavedGuard.unsentBody": "Dein Text ist noch nicht gesendet. Wenn du die Seite verlässt, geht er verloren.",
  "userSettings.claude.adminInstallLink": "Vorausgefüllten Dialog für Organisations-Owner öffnen",
  "userSettings.claude.appDesc": "Füge Smycles einmal als Connector in deinem Claude-Konto hinzu, dann funktioniert es in der Claude-Desktop-App, der Web-App und mobil.",
  "userSettings.claude.appInternalHint": "Hinweis: Claude verbindet sich aus der eigenen Cloud, daher funktioniert das vorerst nicht auf internen Systemen. Der Smycles-Server muss aus dem öffentlichen Internet erreichbar sein. Claude Code (unten) funktioniert heute schon auf internen Systemen.",
  "userSettings.claude.appStep1": "Öffne in Claude die Einstellungen und dann Connectors.",
  "userSettings.claude.appStep2": "Wähle „Add custom connector“ und füge die obige Server-URL ein.",
  "userSettings.claude.appStep3": "Öffne die erweiterten Einstellungen, trage die obige Client-ID ein und lass das Client-Secret leer.",
  "userSettings.claude.appStep4": "Füge den Connector hinzu, klicke dann auf Connect und melde dich mit deinem Smycles-Konto an.",
  "userSettings.claude.appTeamNote": "In Team- und Enterprise-Plänen fügt ein Organisations-Owner den Connector einmalig hinzu; alle anderen klicken nur auf Connect und melden sich an.",
  "userSettings.claude.appTitle": "Claude-App (Desktop, Web und Mobil)",
  "userSettings.claude.clientIdLabel": "Client-ID",
  "userSettings.claude.codeDesc": "Führe diesen Befehl aus, starte dann Claude Code, führe /mcp aus, wähle smycles und dann Authentifizieren. Ein Browserfenster öffnet sich für die Smycles-Anmeldung.",
  "userSettings.claude.codeTitle": "Claude Code (für Entwickler)",
  "userSettings.claude.commandLabel": "Befehl",
  "userSettings.claude.detailsTitle": "Verbindungsdaten",
  "userSettings.claude.eyebrow": "Claude",
  "userSettings.claude.installAudience": "Der Button ist für persönliche Claude-Konten (Free, Pro und Max) und für Organisations-Owner in Team- und Enterprise-Plänen. In einem Team- oder Enterprise-Plan ohne Owner-Rechte brauchst du ihn nicht: Der Owner fügt den Connector einmalig hinzu, danach erscheint Smycles in Claude unter Einstellungen → Connectors – dort einfach auf Connect klicken.",
  "userSettings.claude.installButton": "Zu Claude hinzufügen",
  "userSettings.claude.installHint": "Der Button öffnet Claude mit bereits ausgefülltem Namen und Server-URL – einfach bestätigen. Danach mit Schritt 3 unten fortfahren: die Client-ID in den erweiterten Einstellungen eintragen.",
  "userSettings.claude.intro": "Nutze deine Smycles-Daten und -Werkzeuge direkt in Claude. Claude sieht genau das, was du sehen kannst; du meldest dich mit deinem gewohnten Smycles-Konto an. Das ist unabhängig vom Assistenten in Smycles.",
  "userSettings.claude.noSecret": "Es wird kein Client-Secret benötigt. Lass das Secret-Feld leer.",
  "userSettings.claude.title": "Claude verbinden",
  "userSettings.claude.urlLabel": "Server-URL",
  "userSettings.data.desc": "Exportiere deine Profil- und Grow-Daten als JSON-Datei (DSGVO Art. 20). Den Datentransfer findest du im Profil unter „Service\".",
  "userSettings.data.link": "Zum Datentransfer ↗",
  "userSettings.data.title": "Datenexport",
  "userSettings.email": "E-Mail",
  "userSettings.eyebrow": "Konto · Präferenzen",
  "userSettings.heading": "Einstellungen",
  "userSettings.identityTitle": "Identität",
  "userSettings.intro": "Verwalte dein Konto, Benachrichtigungen und Datenschutz.",
  "userSettings.language": "Sprache",
  "userSettings.languageHint": "Auch für die AI-Generierung.",
  "userSettings.mcpApp.appsTitle": "Apps",
  "userSettings.mcpApp.callbackHostLabel": "Callback-Host",
  "userSettings.mcpApp.callbackPortLabel": "Callback-Port",
  "userSettings.mcpApp.desktopStep1": "Verbinde dich mit dem Unternehmens-VPN. Aktiviere in Claude Desktop Help → Troubleshooting → Enable Developer Mode und öffne dann Developer → Configure Third-Party Inference.",
  "userSettings.mcpApp.desktopStep2": "Wähle im Abschnitt Connection „Anthropic API“ als Inference-Provider und hinterlege deinen Anthropic-API-Key. Überspringe den Schritt, wenn Claude Desktop bereits im Third-Party-Modus läuft.",
  "userSettings.mcpApp.desktopStep3": "Füge unter Connectors einen Server hinzu: Transport Streamable HTTP, URL aus der Liste oben.",
  "userSettings.mcpApp.desktopStep4": "Wähle unter OAuth „Bring your own client“ und trage die Client ID von oben sowie Callback-Host und Callback-Port von unten ein. Das Client-Secret bleibt leer.",
  "userSettings.mcpApp.desktopStep5": "Übernimm die Änderungen und starte Claude Desktop neu. Öffne dann Settings → Connectors, verbinde dich und melde dich im Browserfenster mit deinem Smycles-Konto an.",
  "userSettings.mcpApp.externalDesc": "Ist die Umgebung aus dem Internet erreichbar, wird jede App in Claude als eigener Custom Connector hinzugefügt, getrennt vom eigentlichen Smycles-Connector; verwende ihre URL aus der Liste oben.",
  "userSettings.mcpApp.externalTitle": "Externe Umgebungen – Claude-App (Desktop, Web und Mobile)",
  "userSettings.mcpApp.internalDesc": "In Intranet-Umgebungen (z. B. trunk) können claude.ai und die normalen Claude-Apps keine Verbindung aufbauen: Sie verbinden sich aus Anthropics Cloud, nicht von deinem Gerät. Nutze stattdessen Claude Desktop im Third-Party-Inference-Modus im VPN. Jede App ist ihr eigener Connector; verwende ihre URL aus der Liste oben.",
  "userSettings.mcpApp.internalTitle": "Interne Umgebungen – Claude Desktop im VPN",
  "userSettings.mcpApp.intro": "Interaktive Smycles-Apps direkt in deinen Claude-Unterhaltungen. Du meldest dich mit deinem gewohnten Smycles-Konto an; jede App sieht genau das, was du sehen kannst.",
  "userSettings.mcpApp.oauthDesc": "Connectoren authentifizieren sich per OAuth: Beim Verbinden öffnet Claude die Smycles-Anmeldung, und die App agiert danach mit genau deinen Berechtigungen. Alle Apps nutzen den öffentlichen Client unten.",
  "userSettings.mcpApp.oauthTitle": "Anmeldung (OAuth)",
  "userSettings.mcpApp.title": "Apps in Claude",
  "userSettings.name": "Name",
  "userSettings.sectionAccount": "Konto",
  "userSettings.sectionConnections": "Verknüpfungen",
  "userSettings.sectionData": "Daten & Export",
  "userSettings.tour.content.accountDesc": "Deine Identität (Name und E-Mail), die Oberflächensprache (auch für KI-Generierung genutzt) und ganz unten die Kontolöschung.",
  "userSettings.tour.content.dataDesc": "Exportiere dein Profil und deine Grow-Daten als JSON-Datei (DSGVO Art. 20). Der Button übergibt dich an den Datentransfer.",
  "userSettings.tour.content.title": "Der aktive Bereich",
  "userSettings.tour.label": "Einstellungen",
  "userSettings.tour.nav.desc": "Wechsle zwischen Konto (Identität, Sprache, Löschung) und Daten & Export (dein DSGVO-Datenexport).",
  "userSettings.tour.nav.title": "Die Bereiche",
  "userSettings.tour.summary": "Das sind deine Kontoeinstellungen: Identität, Oberflächensprache, Datenexport und Kontolöschung.",
  "whatsNew.v0_1": "Neu in Smycles: Verbinde die Claude Apps mit deinen Daten. Diese Einstellungsseite zeigt dir wie, mit MCP Endpoint, Client-ID und einer Schritt-für-Schritt-Anleitung.",
  "agent.webSearch.unavailable": "Websuche ist für den aktuellen Anbieter nicht verfügbar oder deaktiviert. Es wurde keine Online-Suche ausgeführt. Schalte die Websuche aus, um intern zu suchen.",
  "agent.webSearch.failed": "Die Websuche konnte nicht ausgeführt werden. Bitte versuche es erneut.",
  "agent.pubmed.unavailable": "Die PubMed-Suche ist hier nicht verfügbar oder deaktiviert. Es wurde nicht in PubMed gesucht. Schalte PubMed aus, um ohne PubMed zu antworten.",
  "agent.turn.stopped": "Du hast diese Antwort gestoppt. Die Frage steht weiterhin hier: frag erneut oder präzisiere sie.",
  "agent.webSearch.label": "Websuche",
  "agent.webSearch.on": "Websuche an: Deine nächste Nachricht wird im Web gesucht, danach ist sie wieder aus.",
  "agent.webSearch.onPubmed": "PubMed-Suche an: Deine nächste Nachricht wird in PubMed gesucht, danach ist sie wieder aus.",
  "agent.webSearch.off": "Websuche aus. Zum Online-Suchen einschalten.",
  "agent.companyRoute.label": "Unternehmenssuche",
  "agent.companyRoute.title": "Unternehmenssuche: {mode}",
  "agent.labelThreshold.label": "Trennschärfe",
  "agent.labelThreshold.autoShort": "auto",
  "agent.labelThreshold.example": "Beispiel: {word}",
  "agent.labelThreshold.floor": "Unter {floor} trifft jedes Fachgebiet: ähnlicher als das sind sich alle Fachgebiete ohnehin.",
  "agent.companyRoute.auto": "Automatisch",
  "agent.studioNotebook.chip": "Notizbuch „{name}“",
  "save.community.types": "Community-Inhalte",
  "save.community.companies": "Unternehmen",
  "save.community.companiesDescription": "Entdecke Unternehmen und öffne ihre Profile.",
  "save.community.companyCount": "{count, plural, one {# Unternehmen} other {# Unternehmen}}",
  "save.community.companiesEmpty": "Keine Unternehmen gefunden.",
  "admin.groups.deleteBlocked.department": "Diese Personengruppe gehört zu einer Organisationseinheit und wird dort verwaltet.",
  "admin.groups.deleteBlocked.system": "Diese Personengruppe wird für automatische Zuweisungen benötigt und kann nicht gelöscht werden.",
  "admin.groups.deleteBlocked.references": "Diese Personengruppe wird noch verwendet. Zum Löschen müssen alle Mitgliedschaften, Rollenzuordnungen und Verweise auf die Gruppe in Freigaben oder Geltungsbereichen entfernt sein.",
  "admin.inspection.target": "Art der Auswertung",
  "admin.inspection.person": "Person",
  "admin.inspection.group": "Personengruppe",
  "admin.inspection.compare": "Vergleich",
  "admin.inspection.first": "Erste Person",
  "admin.inspection.second": "Zweite Person",
  "admin.inspection.pickBoth": "Wähle zwei unterschiedliche Personen für den Vergleich.",
  "admin.inspection.differences": "Unterschiede",
  "admin.inspection.all": "Alle Berechtigungen",
  "admin.inspection.compareSummary": "{total, plural, one {# Berechtigung} other {# Berechtigungen}} · {differences, plural, one {# Unterschied} other {# Unterschiede}}",
  "admin.inspection.onlyFirst": "Nur erste Person",
  "admin.inspection.onlySecond": "Nur zweite Person",
  "admin.inspection.scopeDifference": "Unterschiedlicher Geltungsbereich",
  "admin.inspection.personRelative": "Personenabhängiger Umfang",
  "admin.inspection.same": "Gleiche Zuweisung",
  "admin.inspection.originDifference": "Gleicher Geltungsbereich, andere Herkunft",
  "admin.inspection.notAssigned": "Nicht über Rollen zugewiesen",
  "admin.inspection.noDifferences": "Keine Unterschiede bei den zugewiesenen Berechtigungen, Geltungsbereichen und ihrer Herkunft.",
  "admin.inspection.openGroup": "Personengruppe öffnen",
  "admin.inspection.groupHint": "Diese Rollen gelten für Mitglieder der Personengruppe. Der Verantwortungsbereich wird für jede handelnde Person einzeln ermittelt. Weitere Rollen aus anderen Gruppen kommen hinzu.",
  "admin.inspection.title": "Zugriffsprüfung",
  "admin.inspection.intro": "Prüfe eine Person, die Rollen einer Personengruppe oder vergleiche zwei Personen.",
  "admin.inspection.search": "Person suchen",
  "admin.inspection.searchHint": "Mindestens zwei Zeichen eingeben. Es werden nur Personen angezeigt, deren Profile du lesen darfst.",
  "admin.inspection.select": "Zugriff prüfen",
  "admin.inspection.changePerson": "Andere Person wählen",
  "admin.inspection.unavailable": "Die Auswertung ist nicht verfügbar.",
  "admin.inspection.summary": "{groups, plural, one {# Personengruppe} other {# Personengruppen}} · {roles, plural, one {# Rolle} other {# Rollen}} · {permissions, plural, one {# Berechtigung} other {# Berechtigungen}}",
  "admin.inspection.refresh": "Aktualisieren",
  "admin.inspection.view": "Auswertung anzeigen",
  "admin.inspection.permissions": "Berechtigungen",
  "admin.inspection.groupsRoles": "Personengruppen & Rollen",
  "admin.inspection.filter": "Berechtigungen filtern",
  "admin.inspection.global": "Systemweit vorhanden",
  "admin.inspection.scoped": "Auf die aufgeführten Geltungsbereiche beschränkt",
  "admin.inspection.noPermissions": "Keine Berechtigungen über Rollen zugewiesen.",
  "admin.inspection.noRoles": "Keine Rollen zugewiesen.",
  "admin.inspection.noGroups": "Keine Personengruppen zugeordnet.",
  "admin.inspection.limits": "Diese Auswertung zeigt den aktuellen Zugriff über Gruppen und Rollen. Eigene Inhalte, persönliche Freigaben, einzelne Projekte, Bewerbungen und Match-Aktionen haben zusätzliche Regeln. Eine aufgeführte Berechtigung bedeutet daher keinen uneingeschränkten Zugriff auf alle Inhalte.",
  "admin.groups.title": "Personengruppen",
  "admin.groups.create": "Personengruppe erstellen",
  "admin.groups.edit": "Gruppe bearbeiten",
  "admin.groups.empty": "Erstelle eine Gruppe, um ihre Mitglieder zu verwalten.",
  "admin.groups.deleteTitle": "Leere Gruppe löschen?",
  "admin.groups.members": "Mitglieder",
  "admin.groups.organization": "Organisatorische Zuordnung",
  "admin.groups.department": "Automatische Abteilungsgruppe",
  "admin.groups.departmentHint": "Enthält direkt dieser Abteilung zugeordnete Personen. Ändere deren Abteilung, um die Mitgliedschaft anzupassen. Nutze für Ausnahmen eine andere Gruppe.",
  "admin.groups.sourcesHint": "Manuelle und identitätsbasierte Mitgliedschaften sind unabhängig. Ändere identitätsbasierte Mitgliedschaften im Quellsystem.",
  "admin.groups.manual": "Manuell",
  "admin.groups.identity": "Identität",
  "admin.groups.removeManual": "Manuelle Mitgliedschaft entfernen",
  "admin.groups.noMembers": "Diese Gruppe hat noch keine Mitglieder.",
  "admin.groups.addMember": "Mitglied hinzufügen",
  "admin.groups.searchPeople": "Nach Namen suchen",
  "admin.groups.noPeople": "Keine sichtbaren Personen gefunden.",
  "admin.groups.refineSearch": "Grenze den Namen ein, um weitere Personen zu finden.",
  "admin.groups.removeHint": "Eine Mitgliedschaft aus der Identitätssynchronisierung bleibt bestehen.",
  "admin.groups.name": "Gruppenname",
  "admin.groups.nameRequired": "Gib einen Gruppennamen ein.",
  "admin.groups.roles": "Rollen und Geltungsbereiche",
  "admin.groups.role": "Rolle",
  "admin.groups.scope": "Geltungsbereich",
  "admin.groups.scopeGroup": "Personen in Gruppe",
  "admin.groups.assignRole": "Rolle zuweisen",
  "admin.groups.noRoles": "Keine Rollen zugewiesen. Wähle eine Rolle und ihren Geltungsbereich, um dieser Gruppe Zugriff zu geben.",
  "admin.groups.removeRole": "Rollenzuweisung entfernen",
  "admin.groups.removeRoleHint": "Andere Zuweisungen können denselben Zugriff weiterhin gewähren.",
  "admin.groups.scope.GLOBAL": "Systemweit",
  "admin.groups.scope.GROUP_MEMBERS": "Mitglieder einer Gruppe",
  "admin.groups.scope.MANAGED_PEOPLE": "Personen im Verantwortungsbereich der handelnden Person",
  "profile.sharing.groupCount": "{count, plural, one {# Gruppe} other {# Gruppen}}",
  "profile.sharing.chooseGroups": "Mit Personengruppen teilen",
  "profile.sharing.noRecipients": "Derzeit stehen keine Gruppen für neue Freigaben zur Verfügung.",
  "profile.sharing.retired": "Diese Gruppen sind nicht mehr auswählbar. Bestehende Freigaben bleiben aktiv, bis du sie entfernst.",
  "admin.groups.sharingEligible": "Dürfen Personen diese Gruppe auswählen, wenn sie persönliche Informationen teilen?",
  "admin.groups.sharingHint": "Entfernen aus der Auswahl erhält bestehende Freigaben.",
  "profile.sharing.sameAsBaseline": "Wie Grundeinstellung",
  "profile.sharing.requiredGroup": "Diese Personengruppe ist als Standardfreigabe festgelegt.",
  "profile.sharing.allReaders": "Alle",
  "profile.sharing.legacyPublic": "Diese Angaben sind bisher allgemein lesbar – auch ohne Gruppenzugehörigkeit. Die Freigabe bleibt bestehen, bis du sie ausdrücklich auf Personengruppen beschränkst.",
  "profile.sharing.legacyPublicMixed": "Einige dieser Angaben sind bisher allgemein lesbar – auch ohne Gruppenzugehörigkeit. Die Freigaben bleiben bestehen, bis du sie ausdrücklich auf Personengruppen beschränkst.",
  "profile.sharing.restrictToGroups": "Auf Personengruppen beschränken",
  "profile.sharing.allGroups": "Mit allen Personengruppen teilen",
  "profile.sharing.entries": "Grundeinstellung:",
  "profile.sharing.mixed": "Unterschiedliche Gruppen",
  "profile.sharing.publiclyReadable": "Alle dürfen diesen Inhalt lesen",
  "share.create.readershipTitle": "Wer darf diesen Inhalt lesen?",
  "share.create.publiclyReadableHint": "Jede Person darf diesen Inhalt lesen, auch wer später dazukommt – unabhängig von Personengruppen. Smycles setzt derzeit eine Anmeldung voraus.",
  "share.create.requiredGroup": "Diese Personengruppe ist als Standardfreigabe festgelegt.",
  "profile.sharing.publiclyReadableHint": "Jede Person darf diesen Inhalt lesen, auch wer später dazukommt – unabhängig von Personengruppen. Smycles setzt derzeit eine Anmeldung voraus.",
  "share.create.requiredGroups": "Beim Ändern der Gruppenfreigabe werden die festgelegten Standardgruppen ergänzt.",
  "share.create.titleRequired": "Gib einen Titel ein, bevor du speicherst.",
  "share.create.recipientsUnavailable": "Die Empfänger sind noch nicht verfügbar, deshalb kann nicht gespeichert werden.",
  "common.retry": "Erneut versuchen",
  "profile.sharing.mixedVisibility": "Unterschiedliche Sichtbarkeit",
  "organizationalPower.running": "Die Dokumente werden analysiert. Das Profil bleibt bis zur Übernahme unverändert.",
  "organizationalPower.failed": "Die Power-Analyse ist fehlgeschlagen. Bitte versuche es erneut.",
  "organizationalPower.review": "Prüfe die vorgeschlagenen Power-Werte. Mit der Übernahme werden diese Werte im Profil aktualisiert.",
  "organizationalPower.empty": "In den ausgewählten Dokumenten konnten keine Power-Werte ermittelt werden.",
  "organizationalPower.applied": "Die Power-Werte wurden ins Profil übernommen.",
  "organizationalPower.apply": "Ins Profil übernehmen",
  "organizationalPower.new": "Neue Analyse",
  "organizationalPower.fromRecord": "Aus der Organisationsakte",
  "organizationalPower.uploadDestination": "Neue Dateien werden in dieser Organisationsakte gespeichert.",
  "organizationalPower.uploading": "Wird hochgeladen …",
  "organizationalPower.guidePerson": "Es geht um die Person dieser Akte. Berücksichtigt werden Belege, die die Analyse dieser Person zuordnen kann. Du prüfst die Ergebnisse, bevor du sie in ihr Profil übernimmst.",
  "organizationalPower.guideConcrete": "Die Dokumente beschreiben, wie die Person arbeitet: Zeugnisse, Beurteilungen, Feedback, Projekt- und Rollenbeschreibungen. Eine Jobbezeichnung oder eine reine Skill-Liste liefert keine verwertbaren Belege.",
  "organizationalPower.background": "Die Analyse läuft weiter, wenn du diesen Dialog schließt.",
  "agent.progress.searchingPubmed": "Durchsuche PubMed nach \"{query}\"",
  "agent.progress.searchingPubmedAll": "Durchsuche PubMed",
  "model.sources.usage": "Im Studio durchsucht der Assistent diese Quellen zusätzlich, wenn der Globus an ist. Der Suchbegriff geht dann an den Anbieter der Quelle.",
  "studio.sources.instead": "{source} statt des Webs für diese Frage durchsuchen",
  "studio.sources.onlySource": "Der aktive KI-Anbieter bietet keine Websuche: Diese Frage durchsucht {source}",
  "studio.proposal.field.givenName": "Vorname",
  "studio.proposal.field.familyName": "Nachname",
  "studio.proposal.field.name": "Name",
  "studio.proposal.field.degree": "Abschluss",
  "studio.proposal.field.subject": "Fach",
  "studio.proposal.field.institution": "Hochschule",
  "studio.proposal.field.from": "Von",
  "studio.proposal.field.to": "Bis",
  "studio.proposal.done": "Fertig",
  "studio.proposal.nothing": "Nichts davon ist im Notizbuch belegt, deshalb gibt es nichts zu übernehmen.",
  "studio.orgRecord.title": "Für die Organisationsakte",
  "studio.orgRecord.person": "Person",
  "studio.orgRecord.company": "Unternehmen",
  "studio.orgRecord.noHit": "{subject, select, company {Kein Unternehmen} other {Keine Person}} unter diesem Namen gefunden. Passe den Namen an.",
  "studio.orgRecord.pickCount": "{subject, select, company {Welches Unternehmen?} other {Welche Person?}} {count} gefunden",
  "studio.orgRecord.pickFirst": "{subject, select, company {Wähle zuerst das Unternehmen.} other {Wähle zuerst die Person.}}",
  "studio.orgRecord.kind": "Art",
  "studio.orgRecord.kindNote": "Notiz",
  "studio.orgRecord.kindReport": "Bericht",
  "studio.orgRecord.entryTitle": "Titel",
  "studio.orgRecord.text": "Text",
  "studio.orgRecord.attach": "Notizbuch als Dokument anhängen",
  "studio.orgRecord.attachFile": "Notizbuch als Dokument: {fileName}",
  "studio.orgRecord.entry": "Eintrag",
  "studio.orgRecord.filed": "In der Organisationsakte von {name} abgelegt.",
  "studio.orgRecord.open": "Akte öffnen",
  "studio.orgRecord.noRight": "Du darfst keine Organisationsakten führen.",
  "studio.orgRecord.file": "In Akte ablegen",
  "studio.shortcut.enter": "Eingabetaste",
  "studio.shortcut.modEnter": "Cmd/Strg + Eingabetaste",
  "studio.composePlaceholder": "Notiz eingeben. Enter legt ab. Innerhalb von 30 Sekunden fragt ein zweites Enter damit den Assistenten, Pfeil hoch holt sie zum Bearbeiten zurück.",
  "studio.askInsteadHint": "Enter fragt den Assistenten mit der gerade abgelegten Notiz, Pfeil hoch holt sie zum Bearbeiten zurück",
  "studio.key.enter": "Enter",
  "studio.tools": "Werkzeuge",
  "studio.tools.emptyHint": "Bring zuerst etwas ins Notizbuch: eine Notiz, ein Dokument oder eine Antwort",
  "studio.document.bring": "Dokument einbringen",
  "studio.document.bringHint": "Aus deinen Dokumenten, per OCR gelesen, als Kontext",
  "studio.document.brought": "„{name}“ ist im Notizbuch.",
  "studio.document.pickTitle": "Dokument einbringen",
  "studio.document.pickHint": "Aus deinen Dokumenten. Der Text wird gelesen (OCR bei PDFs und Bildern) und kommt als Kontext ins Notizbuch.",
  "studio.document.reading": "„{name}“ wird gelesen …",
  "studio.document.noText": "Aus diesem Dokument ließ sich kein Text lesen.",
  "studio.document.open": "Dokument öffnen",
  "studio.toRecordsHint": "Personen und Unternehmen vorschlagen",
  "studio.toOrgRecord": "In Organisationsakte ablegen",
  "studio.toOrgRecordHint": "Als Notiz zu einer Person",
  "studio.toOrgRecordPrompt": "Leg den Inhalt dieses Notizbuchs als Notiz in einer Organisationsakte ab. Frag mich, für welche Person, wenn es nicht eindeutig ist.",
  "studio.finalVersion": "Endfassung erstellen",
  "studio.finalVersionHint": "Zusammengeführt und geordnet, als Markdown",
  "studio.proposal.field.expertises": "Fachkompetenzen",
  "admin.access.workflow.intro": "Lege fest, welche Gruppen welche Aufgaben übernehmen dürfen.",
  "admin.access.workflow.assign": "Rolle zuweisen",
  "admin.access.workflow.members": "Mitglieder verwalten",
  "admin.access.workflow.sharing": "Gruppenmitgliedschaft teilt keine persönlichen Daten. Die Empfänger persönlicher Freigaben werden separat gewählt.",
  "admin.groups.sections": "Gruppenverwaltung",
  "admin.groups.sharingTab": "Freigaben",
  "admin.roles.sections": "Rollenansicht",
  "admin.roles.permissionDetails": "Details zu „{permission}“",
  "admin.roles.catalog": "Berechtigungskatalog",
  "admin.roles.catalogHint": "Wähle Berechtigungen für eine neue Rolle. Unter jeder Berechtigung siehst du die Rollen, die sie bereits enthalten.",
  "admin.roles.createFromSelection": "Rolle aus Auswahl erstellen",
  "admin.roles.manageGroup": "Zuordnungen für {name} verwalten",
  "admin.permission.read": "Freigegebene Inhalte lesen",
  "admin.permission.read.person": "Profile anderer Personen lesen",
  "admin.permission.write.person": "Profile anderer Personen bearbeiten",
  "admin.permission.read.person-reference": "Personenreferenzen lesen",
  "admin.permission.read.public-content": "Öffentliche Inhalte lesen",
  "admin.permission.read.external-information": "Informationen externer Personen lesen",
  "admin.permission.read.managed-information": "Informationen im Verantwortungsbereich lesen",
  "admin.permission.create.company": "Unternehmen anlegen",
  "admin.permission.provision.invitee": "Personen einladen",
  "admin.permission.write.access-config": "Zugriff verwalten",
  "admin.permission.write.import": "Daten importieren",
  "admin.permission.write.questionnaire": "Fragebögen verwalten",
  "admin.permission.write.reference-data": "Stammdaten verwalten",
  "admin.permission.write.self-assessment": "Selbsteinschätzungen verwalten",
  "admin.permission.read.organizational-record": "Organisationsakten lesen",
  "admin.permission.write.organizational-record": "Organisationsakten bearbeiten",
  "admin.permission.feature.grow": "GROW nutzen",
  "admin.permission.feature.search": "Suche nutzen",
  "admin.permission.feature.match": "MATCH nutzen",
  "admin.permission.feature.grow.map": "MAP nutzen",
  "admin.permission.feature.save.community": "Community öffnen",
  "admin.permission.feature.share": "SHARE nutzen",
  "admin.permission.feature.share.listings": "Ausschreibungen nutzen",
  "admin.permission.feature.share.applications": "Auf Ausschreibungen bewerben",
  "admin.permission.feature.share.projects": "Projekte in SHARE anlegen",
  "admin.permission.feature.grow.watch": "WATCH nutzen",
  "admin.permission.feature.grow.play": "PLAY nutzen",
  "admin.permission.feature.grow.play.self-assessments": "Selbstbewertungen je Power in PLAY zeigen",
  "admin.permission.feature.grow.play.games": "Spiele in PLAY zeigen",
  "admin.permission.feature.grow.play.games.toplist": "Top 10 in PLAY zeigen",
  "admin.permission.feature.grow.play.games.roleplay": "Rollenspiel in PLAY zeigen",
  "admin.permission.feature.save.profile": "Profil öffnen",
  "admin.permission.feature.save.documents": "Dokumente öffnen",
  "admin.permission.feature.save.pins": "Pins öffnen",
  "admin.permission.feature.save": "SAVE nutzen",
  "admin.permission.feature.assistant": "Assistenten nutzen",
  "admin.permission.feature.chat": "Chat nutzen",
  "admin.permission.feature.save.profile.powers-source": "Quellen der Power-Analyse öffnen",
  "admin.permission.feature.save.profile.powers-source.self": "Selbstbewertung in der Powers-Box zeigen",
  "admin.permission.feature.save.profile.powers-source.smart": "Smart Analyse in der Powers-Box zeigen",
  "admin.permission.feature.save.profile.powers-source.combined": "Kombinierten Wert in der Powers-Box zeigen",
  "admin.permission.delete.roleplay-session": "Rollenspiel-Sitzungen löschen",
  "admin.permission.read.roleplay-session": "Alle Rollenspiel-Sitzungen auflisten",
  "admin.permission.pause.game": "Spiele für alle pausieren",
  "admin.permission.report.roleplay-session": "Rollenspiel-Ergebnisse melden (Dienstkonto)",
  "admin.groups.rolesTab": "Rollen",
  "admin.groups.anonymous.title": "Anonym",
  "admin.groups.anonymous.fixed": "Systemseitig festgelegt",
  "admin.groups.anonymous.intro": "Besucher ohne Anmeldung – auch Menschen, die ein Konto haben, aber gerade ausgeloggt sind.",
  "admin.groups.anonymous.visitors": "Besucher",
  "admin.groups.anonymous.visibility": "Sichtbarkeit",
  "admin.groups.anonymous.members": "Beim anonymen Besuch ist kein Konto identifiziert. Deshalb gibt es keine Personenliste. Mitglieder können weder hinzugefügt noch entfernt werden.",
  "admin.groups.anonymous.publicContent": "Anonyme Besucher dürfen ausdrücklich öffentliche Projekte lesen, einschließlich ihrer öffentlichen Beschreibungen und Bilder.",
  "admin.groups.anonymous.privateContent": "Profile, persönliche Angaben, Dateianhänge und interne Inhalte sind über diesen öffentlichen Zugang nicht lesbar.",
  "admin.groups.anonymous.roles": "Anonyme Besucher haben keine Gruppenmitgliedschaften und keine zugewiesenen Rollen. Ihr öffentlicher Zugriff ist lesend und systemseitig festgelegt. Er lässt sich hier nicht durch eine Rollenzuordnung erweitern.",
  "admin.groups.anonymous.sparkLogin": "Der Schalter steuert den öffentlichen Share-Zugang. Weitere Funktionen erfordern eine Anmeldung.",
  "admin.roles.personUnavailable": "Personendaten nicht verfügbar",
  "admin.role.access-config-admin.name": "Zugriffsverwaltung",
  "admin.role.access-config-admin.description": "Verwaltet Gruppen, Rollen und Berechtigungen sowie administrative Importe.",
  "admin.role.company-creator.name": "Unternehmen anlegen",
  "admin.role.company-creator.description": "Erlaubt das Anlegen von Unternehmen. Die Verwaltung eines bestehenden Unternehmens wird separat zugewiesen.",
  "admin.role.invitee-provisioner.name": "Eingeladene Personen anlegen",
  "admin.role.invitee-provisioner.description": "Erlaubt das Anlegen eingeladener Personen.",
  "admin.role.organizational-record-manager.name": "Organisationsakten verwalten",
  "admin.role.organizational-record-manager.description": "Erlaubt das Lesen und Bearbeiten von Organisationsakten. Der Zugriff gilt organisationsweit.",
  "admin.role.person-administrator.name": "Personenverwaltung",
  "admin.role.person-administrator.description": "Bündelt die Verwaltung von Personendaten und Organisationsakten. Die enthaltenen Berechtigungen stehen unten.",
  "admin.role.questionnaire-administrator.name": "Fragebögen verwalten",
  "admin.role.questionnaire-administrator.description": "Verwaltet Fragebögen und Selbsteinschätzungen sowie deren administrative Importe.",
  "admin.role.reader.name": "Inhalte lesen",
  "admin.role.reader.description": "Ermöglicht das Lesen von Inhalten innerhalb der zugewiesenen Zugriffsregeln. Persönliche Freigaben bleiben separat.",
  "admin.role.reference-data-administrator.name": "Kataloge verwalten",
  "admin.role.reference-data-administrator.description": "Verwaltet Referenzdaten und deren administrative Importe.",
  "admin.groups.verified": "Verifiziert",
  "admin.groups.registered": "Registriert",
  "admin.groups.systemGroups": "Systemseitig bereitgestellt",
  "admin.groups.manualGroups": "Manuell gepflegt",
  "admin.groups.details": "Details",
  "admin.groups.verifiedHint": "Die automatische Zuordnung erfolgt bei der Anmeldung über eine bestätigte interne Identität oder eine verifizierte E-Mail-Adresse mit einer freigegebenen Domain. Eine Registrierung allein reicht dafür nicht aus.",
  "admin.groups.registeredHint": "Angemeldete Personen ohne die Voraussetzungen für „Verifiziert“ werden automatisch dieser Gruppe zugeordnet. Verifizierte Personen gehören nicht automatisch zusätzlich dazu.",
  "admin.groups.identityMembershipHint": "Manuelle Zuordnungen können zusätzlich bestehen. In der Mitgliederliste erkennst du die Quelle jeder Zuordnung. Eine manuelle Zuordnung bleibt unabhängig von der automatischen bestehen.",
  "admin.groups.manualHint": "Die Mitglieder dieser Gruppe werden hier ausdrücklich zugeordnet. Rollen und persönliche Freigaben werden separat verwaltet.",
  "admin.membershipPolicy.title": "Automatische Zuweisung",
  "admin.membershipPolicy.activeDomains": "Für „Verifiziert“ konfigurierte Domains:",
  "admin.membershipPolicy.disabled": "Aktuell sind keine Domains konfiguriert. Die Vergabe über E-Mail-Domains ist deaktiviert. „Verifiziert“ wird weiterhin über die interne Anmeldung vergeben.",
  "admin.membershipPolicy.unavailable": "Die aktuelle Domain-Konfiguration konnte nicht geladen werden. Ob die Domain-Vergabe aktiv ist, ist deshalb unbekannt.",
  "admin.membershipPolicy.readOnly": "Diese Konfiguration wird aus Smycles gelesen. Änderungen daran erfolgen in der Systemkonfiguration. Die automatische Zuordnung wird bei der nächsten Verarbeitung einer Anmeldung aktualisiert.",
  "admin.groups.sourceFilter": "Mitgliedschaften filtern",
  "admin.groups.allSources": "Alle",
  "admin.groups.memberSort": "Sortierung",
  "admin.groups.nameAscending": "Name A–Z",
  "admin.groups.nameDescending": "Name Z–A",
  "admin.groups.manualFirst": "Manuell zuerst",
  "admin.groups.identityFirst": "Identität zuerst",
  "admin.groups.noMatchingMembers": "Keine Mitglieder mit dieser Zuordnungsquelle.",
  "admin.groups.loadingAllMembers": "Weitere Mitglieder werden geladen. Filter und Sortierung sind danach vollständig.",
  "admin.access.shortcuts.title": "Shortcuts",
  "admin.access.shortcuts.personGroups": "Personengruppen",
  "admin.agents.confirmDelete.message": "Der KI-Agent wird endgültig entfernt und steht in Matches nicht mehr zur Auswahl. Matches, die ihn schon nennen, behalten ihre gespeicherte Kurzfassung.",
  "admin.agents.confirmDelete.title": "„{name}“ löschen?",
  "admin.agents.delete": "KI-Agenten löschen",
  "admin.agents.empty": "Noch keine KI-Agenten.",
  "admin.agents.english": "Englisch",
  "admin.agents.german": "Deutsch",
  "admin.agents.model": "Modell",
  "admin.agents.name": "Name",
  "admin.agents.new": "Neuer KI-Agent",
  "admin.agents.problem.name": "Der Name fehlt.",
  "admin.agents.problem.controlCharacters": "Ein Feld enthält unsichtbare Steuerzeichen. Entferne sie und speichere erneut.",
  "admin.agents.problem.role": "Die Rolle fehlt. Eine Sprache genügt.",
  "admin.agents.problem.toolDescription": "Jedes Tool braucht eine Beschreibung, in mindestens einer Sprache.",
  "admin.agents.problem.toolName": "Jedes Tool braucht einen Namen.",
  "admin.agents.problem.vendor": "Der Anbieter fehlt.",
  "admin.agents.problem.url": "Die Produktseite muss eine Webadresse sein (http oder https, ohne Leerzeichen, höchstens 128 Zeichen).",
  "admin.agents.removeRow": "Zeile entfernen",
  "admin.agents.role": "Rolle",
  "admin.agents.saveFailed": "Der KI-Agent konnte nicht gespeichert werden.",
  "admin.agents.toolDescription": "Beschreibung",
  "admin.agents.toolName": "Name des Tools",
  "admin.agents.url": "Produktseite",
  "admin.agents.vendor": "Anbieter",
  "admin.inspection.compare.rightsCount": "{count, plural, one {# Recht} other {# Rechte}}",
  "admin.inspection.compare.rolesCount": "{count, plural, one {# Rolle} other {# Rollen}}",
  "admin.inspection.compare.groupsCount": "{count, plural, one {# Personengruppe} other {# Personengruppen}}",
  "admin.inspection.compare.shared": "{count} gemeinsame Rechte",
  "admin.inspection.compare.only": "{count} Rechte nur {name}",
  "admin.inspection.compare.sight": "Sicht",
  "admin.inspection.compare.capabilities": "Funktionen",
  "admin.inspection.compare.notGranted": "Nicht vergeben",
  "admin.inspection.compare.nothingSelected": "Wähle Rechte, Rollen oder Personengruppen für die Auswertung.",
  "admin.inspection.compare.refresh": "Neu prüfen",
  "admin.inspection.compare.differences": "Nur Unterschiede",
  "admin.inspection.compare.all": "Alle Rechte",
  "admin.groups.primaryEmail": "Primäre E-Mail-Adresse",
  "admin.roles.layout.features": "Bereiche & Funktionen",
  "admin.roles.layout.actions": "Daten & Aktionen",
  "admin.roles.layout.featureHint": "Legt fest, welche Funktionen diese Rolle freischaltet. Datenzugriff wird separat vergeben.",
  "admin.roles.layout.featureHint.powersSource": "Ohne Auswahl: Kombiniert",
  "admin.roles.layout.people": "Personen",
  "admin.roles.layout.records": "Organisationsakten",
  "admin.roles.layout.companies": "Unternehmen",
  "admin.roles.layout.content": "Inhalte",
  "admin.roles.layout.administration": "Administration",
  "admin.roles.layout.other": "Weitere Aktionen",
  "admin.roles.layout.feature.save": "SAVE",
  "admin.roles.layout.feature.grow": "GROW",
  "admin.roles.layout.feature.share": "SHARE",
  "admin.roles.layout.feature.share.listings": "Ausschreibungen",
  "admin.roles.layout.feature.share.applications": "Bewerben",
  "admin.roles.layout.feature.share.projects": "Projekte anlegen",
  "admin.roles.layout.feature.match": "MATCH",
  "admin.roles.layout.feature.tools": "TOOLS",
  "admin.roles.layout.feature.grow.map": "MAP",
  "admin.roles.layout.feature.grow.play": "PLAY",
  "admin.roles.layout.feature.grow.play.self-assessments": "Selbstbewertungen",
  "admin.roles.layout.feature.grow.play.games": "Spiele",
  "admin.roles.layout.feature.grow.play.games.toplist": "Top 10",
  "admin.roles.layout.feature.grow.play.games.roleplay": "Rollenspiel",
  "admin.roles.layout.feature.grow.watch": "WATCH",
  "admin.roles.layout.feature.save.profile": "Profil",
  "admin.roles.layout.feature.save.profile.powers-source": "Quellen der Power-Analyse",
  "admin.roles.layout.feature.save.documents": "Dokumente",
  "admin.roles.layout.feature.save.community": "Community",
  "admin.roles.layout.feature.save.pins": "Pins",
  "admin.roles.layout.feature.search": "Suche",
  "admin.roles.layout.feature.assistant": "Assistent",
  "admin.roles.layout.feature.chat": "Chat",
  "admin.groups.chooseRole": "Rolle auswählen",
  "admin.groups.chooseRoleFirst": "Zuerst eine Rolle auswählen",
  "admin.groups.noSupportedScope": "Keine gültige Zuweisung möglich",
  "admin.groups.scopeHint.GLOBAL": "Gilt für Mitglieder dieser Gruppe systemweit. Fachliche Einschränkungen der einzelnen Berechtigungen bleiben bestehen.",
  "admin.groups.scopeHint.GROUP_MEMBERS": "Die Berechtigungen gelten gegenüber Personen in der ausgewählten Zielgruppe.",
  "admin.groups.scopeHint.MANAGED_PEOPLE": "Die Berechtigungen gelten gegenüber Personen im jeweiligen Verantwortungsbereich des handelnden Gruppenmitglieds.",
  "admin.roles.layout.view": "Ansicht:",
  "admin.roles.layout.simple": "Einfach",
  "admin.roles.layout.expert": "Experte",
  "admin.roles.manageAssignment": "Zuordnungen verwalten",
  "admin.roles.managedScopeHint": "Nur mit Geltungsbereich „Geführte Personen“. Für zusätzliche Rechte eine separate Rolle zuweisen. Rechte mehrerer Rollen ergänzen sich.",
  "admin.roles.managedChecking": "Geltungsbereiche der bestehenden Zuweisungen werden geprüft …",
  "admin.roles.managedCheckFailed": "Die Vereinbarkeit konnte nicht geprüft werden. Öffne die Rolle erneut, um die Prüfung zu wiederholen.",
  "admin.roles.managedIncompatible": "Für diese Rollenzuweisungen nicht verfügbar. Diese Berechtigung benötigt eine separate Rolle mit Geltungsbereich „Geführte Personen“.",
  "admin.groups.sharingSelectionHint": "<on>An: Die Gruppe wird beim Teilen persönlicher Informationen zur Auswahl angeboten.</on> <off>Aus: Sie wird nicht mehr angeboten.</off> Bestehende Freigaben bleiben erhalten. Das Einschalten allein gibt der Gruppe keinen Zugriff.",
  "admin.groups.administratorsHint": "Systemseitige Administratorengruppe mit manuell vergebenen Mitgliedschaften. Mindestens eine aktive Person und eine Rolle mit „Zugriff verwalten“ müssen erhalten bleiben. Weise zuerst eine weitere aktive Person zu, bevor du den letzten Administrator entfernst.",
  "admin.groups.lastAdministrator": "Mindestens ein aktiver Administrator muss bleiben. Füge zuerst eine weitere aktive Person hinzu.",
  "admin.groups.lastAdministratorRole": "Mindestens eine Rolle mit „Zugriff verwalten“ muss dieser Systemgruppe zugewiesen bleiben.",
  "admin.role.standard-administrators.name": "Administratoren",
  "admin.role.standard-administrators.description": "Von Smycles als Standard für die Administration bereitgestellt. Persönliche Freigaben und fachliche Zuständigkeiten gelten weiterhin.",
  "admin.role.standard-verified.name": "Verifiziert",
  "admin.role.standard-verified.description": "Von Smycles als Standard für Grundfunktionen bereitgestellt.",
  "admin.role.standard-registered.name": "Registriert",
  "admin.role.standard-registered.description": "Von Smycles als Standard für Grundfunktionen bereitgestellt.",
  "match.connections.title": "Verknüpft mit",
  "match.connections.listing": "Ausschreibung",
  "match.connections.project": "Projekt",
  "match.connections.share": "Share-Inhalt",
  "match.connections.latestResult": "Aktuelles Ergebnis",
  "share.listings.ranking.title": "Match dieser Ausschreibung",
  "share.listings.ranking.select": "Anforderungsprofil auswählen",
  "share.listings.ranking.openMatch": "Match öffnen",
  "share.listings.ranking.waiting": "Noch kein Ergebnis. Hier erscheint die Rangliste nach der ersten erfolgreichen Bewertung.",
  "share.listings.ranking.unavailable": "Dieses Ergebnis ist nicht mehr verfügbar.",
  "share.listings.ranking.management": "Verknüpfung verwalten",
  "share.listings.ranking.poolHint": "Automatisch bewertete Bewerbende sind bereits im Kandidatenpool dieses Matches. Hier kannst du gemeinsam mit ihnen weiterarbeiten und Anforderungen anpassen.",
  "share.listings.ranking.continue": "Mit allen Kandidaten weiterarbeiten",
  "share.listings.ranking.requirements": "Anforderungen öffnen",
  "share.listings.versions.rankAll": "Alle Kandidaten neu bewerten",
  "share.listings.versions.edit": "Neue Version vorbereiten",
  "share.listings.versions.running": "Version {number} wird bewertet. Neue Bewerbungen werden anschließend ergänzt.",
  "share.listings.versions.failed": "Version {number} konnte nicht bewertet werden. Die bisherige Version bleibt aktiv.",
  "share.listings.versions.retry": "Erneut versuchen",
  "share.listings.versions.changed": "Stand weicht vom Match ab",
  "share.listings.versions.current": "Version {number} · Aktuell",
  "share.listings.versions.history": "Version {number} · Abgeschlossen",
  "share.listings.versions.requirementsLink": "Anforderungen",
  "share.listings.versions.requirementsSnapshot": "Die neue Version übernimmt die aktuellen Anforderungen. Bisherige Ergebnisse bleiben erhalten.",
  "share.listings.applications.personColumn": "Bewerbende",
  "share.listings.applications.documentsColumn": "Unterlagen",
  "share.listings.applications.reviewColumn": "Bearbeitung",
  "match.autoMatch.infoLabel": "Automatische Bewertung erklären",
  "match.autoMatch.details": "Das erste Ergebnis wird automatisch gespeichert. Geänderte Anforderungen benötigen eine neue Match-Version.",
  "share.listings.match.needsRequirements": "Zuerst Anforderungen festlegen",
  "share.listings.match.needsRequirementsHint": "Lege fest, welche Fachkompetenzen oder Powers gesucht werden. Danach kannst du Bewerbende vergleichen und automatisch bewerten lassen.",
  "share.listings.match.needsRequirementsReadOnly": "Für diese Ausschreibung fehlen noch Anforderungen. Eine Person mit Bearbeitungsrecht muss sie zuerst festlegen.",
  "grow.about.approach": "Das Smycles-Modell greift Forschung zu Persönlichkeit und menschlichem Verhalten auf, darunter etablierte Modelle wie die Big Five und HEXACO sowie weit verbreitete Persönlichkeitstests wie MBTI und DISC. Diese Ansätze dienen als Bezugspunkte; die 30 Powers und ihre Einteilung in sechs Cluster sind jedoch spezifisch für Smycles. Das Modell berücksichtigt, wie individuelle Eigenschaften mit Umständen, Erfahrungen und erlernten Verhaltensweisen zusammenwirken.",
  "grow.about.approachTitle": "Forschung und Weiterentwicklung",
  "grow.about.author": "Dr. Bernhard Zünkeler",
  "grow.about.authorName": "Bernhard Zünkeler",
  "grow.about.attribution": "Das <concept>Powers-Konzept</concept> von Smycles greift die Arbeit von {author} auf.",
  "grow.about.book.atlas": "Juicy Gray – Atlas der Kreativität",
  "grow.about.book.innovation": "Innovationskraft in Unternehmen – Impulse für mehr Innovationsfähigkeit, Performanz und Zukunftsfähigkeit",
  "grow.about.book.newWork": "New Work: Auf dem Weg zur neuen Arbeitswelt – Management-Impulse, Praxisbeispiele, Studien",
  "grow.about.coAuthor": "Mitautor",
  "grow.about.contributor": "Mitwirkung",
  "grow.about.development": "Forschung zu Aufmerksamkeit, Empathie und Improvisation fließt in die Entwicklung der Power-Beschreibungen und der Aussagen in den Fragebögen ein. Smycles verbindet außerdem Perspektiven aus Psychologie, Biologie, Neurowissenschaft, Philosophie und praktischer Erfahrung, um menschliche Kreativität und Zusammenarbeit zu erkunden. Weitere Studien sind geplant, um die Zuverlässigkeit der Einschätzung und ihren möglichen Nutzen für das Verständnis von Teamarbeit zu prüfen.",
  "grow.about.intro": "Menschen bringen unterschiedliche Arten des Denkens, Handelns und des Umgangs mit anderen in ein Team ein. Smycles betrachtet diese Unterschiede anhand von 30 Powers, einem Konzept zum Verständnis individueller Arbeitsweisen und ihres Zusammenspiels. Die Powers ordnen Menschen nicht festen Persönlichkeitstypen zu, sondern bieten eine gemeinsame Sprache zum Verständnis von Teamchemie.",
  "grow.about.origins": "Das Konzept baut auf der Arbeit von {author} zu Kreativität und Teamzusammenstellung auf. Smycles entwickelt diese Ideen zu Power-Beschreibungen, Aussagen in Fragebögen und einem Konzept zum Verständnis von Zusammenarbeit weiter.",
  "grow.about.originsTitle": "Ursprünge des Konzepts",
  "grow.about.structure": "Das Smycles-Modell ordnet 30 Powers in sechs Cluster mit jeweils fünf Powers ein. Diese Cluster beschreiben unterschiedliche Aspekte davon, wie Menschen auf Herausforderungen reagieren, Ziele verfolgen, Ideen erkunden und zusammenarbeiten.",
  "grow.about.structureTitle": "30 Powers, sechs Cluster",
  "grow.about.title": "Powers und Teamchemie",
  "grow.assess.documentsCountHint": "Für dein gesamtes Power-Profil, jedes Dokument zählt einmal. Gezählt werden Dokumente mit gespeicherten Power-Belegen; reine Uploads und Analysen ohne Fund zählen nicht mit.",
  "grow.assess.introQuestionnaires": "Lerne deine <concept>Powers</concept> mit Fragebögen kennen. Wähle, wo du starten oder weitermachen möchtest.",
  "grow.assess.introSelf": "Lerne deine <concept>Powers</concept> mit Fragebögen und Selbsteinschätzungen kennen. Wähle, wo du starten oder weitermachen möchtest.",
  "grow.assess.powerQuizDescription": "Ein guter Einstieg, um deine Powers kennenzulernen. Beantworte {count} Aussagen über dich.",
  "grow.assess.powerQuizEyebrow": "Geführte Selbsteinschätzung",
  "grow.assess.powerQuizReview": "Power Quiz ansehen",
  "grow.powerDetail.selfScoreSources": "Dieser Wert nutzt deine vorhandenen Antworten aus dem Power Quiz, weiteren Fragebögen und der vertiefenden Selbsteinschätzung.",
  "grow.powerDetail.quiz.done": "Power Quiz abgeschlossen",
  "grow.powerDetail.quiz.inProgress": "Power Quiz begonnen",
  "grow.powerDetail.quiz.missing": "Power Quiz offen",
  "grow.powerDetail.quiz.complete": "Power Quiz abgeschlossen.",
  "grow.powerDetail.quiz.incomplete": "Power Quiz noch nicht abgeschlossen.",
  "grow.powerDetail.quiz.includedHint": "Deine Power Quiz Antworten zu dieser Power fließen in die Selbstbewertung ein.",
  "grow.powerDetail.quiz.notIncludedHint": "Für diese Power liegen noch keine bewerteten Power Quiz Antworten vor.",
  "grow.powerDetail.quiz.start": "Power Quiz starten",
  "grow.powerDetail.quiz.continue": "Power Quiz fortsetzen",
  "grow.about.cluster.Re": "Belastbarkeit beschreibt, wie Menschen ihren Fokus aufrechterhalten, sich an Veränderungen anpassen und auf Druck oder Rückschläge reagieren.",
  "grow.about.cluster.Ro": "Ergebnisorientierung beschreibt, wie Menschen Ziele setzen, ihre Arbeit planen, Verantwortung übernehmen und Aufgaben konsequent umsetzen, um Ergebnisse zu erzielen.",
  "grow.about.cluster.Fo": "Zukunftsorientierung beschreibt, wie Menschen sich Möglichkeiten vorstellen, über aktuelle Umstände hinausdenken und unsicheren Situationen mit Mut und Überzeugung begegnen.",
  "grow.about.cluster.In": "Erfindungsstärke beschreibt, wie Menschen Fragen erkunden, Ideen entwickeln und kreativ und eigenständig auf ungewohnte Situationen reagieren.",
  "grow.about.cluster.Ts": "Teamfähigkeit beschreibt, wie Menschen andere verstehen, Unterschiede respektieren und Beziehungen aufbauen, die auf Vertrauen, Verbindlichkeit und Fairness beruhen.",
  "grow.about.cluster.Co": "Kommunikationsfähigkeit beschreibt, wie Menschen eigene Gefühle und die Signale anderer erkennen, sich ausdrücken und ein gemeinsames Verständnis entwickeln.",
  "grow.about.workingStyles": "Eine Person bevorzugt zum Beispiel ungestörte Zeit für konzentriertes Arbeiten, während eine andere schnell auf veränderte Prioritäten reagiert. Das Erkennen dieser Unterschiede kann Teammitgliedern helfen, ihre Bedürfnisse zu kommunizieren, ihre Arbeit abzustimmen und Beziehungen zu stärken.",
  "grow.about.publications": "Zu den Veröffentlichungen und Buchbeiträgen von {authorName} zählen:",
  "match.teamContext.chooseMembers": "Personen auswählen",
  "match.teamContext.enable": "Teamkontext berücksichtigen",
  "match.teamContext.incomplete": "Unvollständig",
  "match.teamContext.missingMembers": "Ohne Bestandsteam wird kein Team-Fit berechnet.",
  "match.teamContext.missingScorecard": "Ohne Power-Scorecard wird kein Team-Fit berechnet.",
  "match.teamContext.missingWeights": "Gewichte mindestens eine Power, um Team-Fit zu berechnen.",
  "match.teamContext.title": "Team-Fit",
  "match.teamContext.toggleHint": "Jeder Kandidat bekommt zusätzlich einen Team-Beitrag: wie viel von dem, was diesem Team noch fehlt, er abdeckt. Gemessen an der Power-Scorecard des Teams, wobei Powers, auf denen das Team dünn besetzt ist, stärker zählen. Wird für alle Kandidaten automatisch berechnet.",
  "match.teamFit.add": "Hinzufügen",
  "match.teamFit.added": "Hinzugefügt",
  "match.teamFit.badgeTooltip": "Team-Beitrag: was diese Person dem Bestandsteam hinzufügt, nicht wie stark sie selbst ist.",
  "match.teamFit.contributionScore": "Deckt {score} % dessen ab, was diesem Team noch fehlt",
  "match.teamFit.elementDelta": "Team {from} → {to}",
  "match.teamFit.measuredMembers": "Grundlage: {measured} von {total} Mitgliedern mit nutzbaren Power-Werten",
  "match.teamFit.pickerTitle": "Bestandsteam",
  "match.teamFit.remove": "{name} entfernen",
  "match.teamFit.resultTitle": "Team-Fit",
  "match.teamFit.roleScorecardLabel": "Power-Scorecard der Rolle",
  "match.teamFit.savedSets": "Gruppen und Pins",
  "match.teamFit.scorecardLabel": "Power-Scorecard des Teams",
  "match.teamFit.scorecardPlaceholder": "Auswählen",
  "match.teamFit.searchPlaceholder": "Nach Namen suchen",
  "match.teamFit.sortHint": "Bei dieser Sortierung richten sich A/B/C nach Team-Fit. Die Muss-Kriterien der Rolle gelten weiterhin.",
  "match.teamFit.summary": "Bestandsteam: {count} Personen · Power-Scorecard des Teams: {scorecard}",
  "match.teamFit.unavailable": "Team-Beitrag nicht bewertbar: Es fehlen vergleichbare Power-Bewertungen, oder das Bestandsteam ist bereits am oberen Rand.",
  "match.teamFit.sortUnavailable": "Kein Bestandsteam ausgewählt – Team-Fit wird für dieses Match nicht berechnet. Das Bestandsteam wird im ersten Schritt gewählt.",
  "common.sortable.cancelled": "{item}: abgebrochen, wieder auf Platz {position} von {total}.",
  "common.sortable.dropped": "{item} abgelegt auf Platz {position} von {total}.",
  "common.sortable.handle": "{item} verschieben",
  "common.sortable.moved": "{item}: Platz {position} von {total}",
  "common.sortable.picked": "{item} aufgenommen, Platz {position} von {total}. Mit den Pfeiltasten verschieben, mit Enter ablegen, mit Escape abbrechen.",
  "grow.games.toplist.discover.changeTags": "Rubriken ändern",
  "grow.games.toplist.discover.picks": "Deine Auswahl",
  "grow.games.toplist.discover.progress": "{count} von {keep}",
  "grow.games.toplist.discover.progressLabel": "Auswahl für deine Top {keep}",
  "grow.games.toplist.discover.skip": "{genus, select, m {Keiner davon} f {Keine davon} n {Keins davon} other {Keine davon}}",
  "grow.games.toplist.next": "Weiter",
  "grow.games.toplist.ownEntry": "Eigener Eintrag",
  "grow.games.toplist.remove": "{title} entfernen",
  "grow.games.toplist.result.full": "{genus, select, m {Für einen weiteren nimm erst einen aus deiner Liste.} f {Für eine weitere nimm erst eine aus deiner Liste.} n {Für ein weiteres nimm erst eins aus deiner Liste.} other {Für einen weiteren Eintrag nimm erst einen aus deiner Liste.}}",
  "grow.games.toplist.result.hint": "Zum Umsortieren ziehen, oder antippen und auf den neuen Platz tippen.",
  "grow.games.toplist.result.missing": "Noch {missing} bis zu deinen Top {keep}",
  "grow.games.toplist.result.moreRounds": "Weitere Vorschläge",
  "grow.games.toplist.result.passed": "Nicht gewählt",
  "grow.games.toplist.result.placeHint": "Tipp auf den neuen Platz für {item}.",
  "grow.games.toplist.result.showAll": "Alle {count} zeigen",
  "grow.games.toplist.search.label": "{genus, select, m {Fehlt einer?} f {Fehlt eine?} n {Fehlt eins?} other {Fehlt jemand?}}",
  "grow.games.toplist.search.noMatch": "Nichts gefunden.",
  "grow.games.toplist.search.placeholder.BOOK": "Buchtitel suchen",
  "grow.games.toplist.search.placeholder.CITY": "Städte suchen",
  "grow.games.toplist.search.placeholder.DISH": "Gerichte suchen",
  "grow.games.toplist.search.placeholder.HOBBY": "Hobbys suchen",
  "grow.games.toplist.search.placeholder.MOVIE": "Filmtitel suchen",
  "grow.games.toplist.search.placeholder.MUSIC_ARTIST": "Künstler oder Band suchen",
  "grow.games.toplist.search.placeholder.SERIES": "Serientitel suchen",
  "grow.games.toplist.search.placeholder.SPORT": "Sportarten suchen",
  "grow.games.toplist.search.takeOwn": "„{title}“ als eigenen Eintrag nehmen",
  "grow.games.toplist.tag.BOOK.CHILDREN": "Kinder & Jugend",
  "grow.games.toplist.tag.BOOK.CLASSIC": "Klassiker",
  "grow.games.toplist.tag.BOOK.CRIME": "Krimi",
  "grow.games.toplist.tag.BOOK.FANTASY": "Fantasy",
  "grow.games.toplist.tag.BOOK.HISTORY": "Geschichte",
  "grow.games.toplist.tag.BOOK.NONFICTION": "Sachbuch",
  "grow.games.toplist.tag.BOOK.NOVEL": "Roman",
  "grow.games.toplist.tag.BOOK.PHILOSOPHY": "Philosophie",
  "grow.games.toplist.tag.BOOK.PLAY": "Drama (Bühne)",
  "grow.games.toplist.tag.BOOK.POETRY": "Lyrik & Epos",
  "grow.games.toplist.tag.BOOK.SCIENCE_FICTION": "Science-Fiction",
  "grow.games.toplist.tag.CITY.AFRICA": "Afrika",
  "grow.games.toplist.tag.CITY.ASIA": "Asien",
  "grow.games.toplist.tag.CITY.EUROPE": "Europa",
  "grow.games.toplist.tag.CITY.NORTH_AMERICA": "Nordamerika",
  "grow.games.toplist.tag.CITY.OCEANIA": "Ozeanien",
  "grow.games.toplist.tag.CITY.SOUTH_AMERICA": "Südamerika",
  "grow.games.toplist.tag.DISH.AMERICAN": "Nordamerikanisch",
  "grow.games.toplist.tag.DISH.BRITISH": "Britisch & Irisch",
  "grow.games.toplist.tag.DISH.CHINESE": "Chinesisch",
  "grow.games.toplist.tag.DISH.EASTERN_EUROPEAN": "Osteuropäisch",
  "grow.games.toplist.tag.DISH.FRENCH": "Französisch",
  "grow.games.toplist.tag.DISH.GERMAN": "Deutschsprachig",
  "grow.games.toplist.tag.DISH.GREEK": "Griechisch",
  "grow.games.toplist.tag.DISH.INDIAN": "Indisch",
  "grow.games.toplist.tag.DISH.INTERNATIONAL": "International",
  "grow.games.toplist.tag.DISH.ITALIAN": "Italienisch",
  "grow.games.toplist.tag.DISH.JAPANESE": "Japanisch",
  "grow.games.toplist.tag.DISH.KOREAN": "Koreanisch",
  "grow.games.toplist.tag.DISH.LATIN_AMERICAN": "Lateinamerikanisch",
  "grow.games.toplist.tag.DISH.MIDDLE_EASTERN": "Nahost & Nordafrika",
  "grow.games.toplist.tag.DISH.SOUTHEAST_ASIAN": "Südostasiatisch",
  "grow.games.toplist.tag.DISH.SPANISH": "Spanisch",
  "grow.games.toplist.tag.DISH.TURKISH": "Türkisch",
  "grow.games.toplist.tag.HOBBY.COLLECTING": "Sammeln",
  "grow.games.toplist.tag.HOBBY.CRAFT": "Handwerk",
  "grow.games.toplist.tag.HOBBY.CREATIVE": "Kreativ",
  "grow.games.toplist.tag.HOBBY.DIGITAL": "Digital",
  "grow.games.toplist.tag.HOBBY.MIND": "Denken & Knobeln",
  "grow.games.toplist.tag.HOBBY.OUTDOOR": "Draußen",
  "grow.games.toplist.tag.HOBBY.SOCIAL": "Gesellig",
  "grow.games.toplist.tag.MOVIE.ACTION": "Action",
  "grow.games.toplist.tag.MOVIE.ADVENTURE": "Abenteuer",
  "grow.games.toplist.tag.MOVIE.ANIMATION": "Animation",
  "grow.games.toplist.tag.MOVIE.BIOGRAPHY": "Biografie",
  "grow.games.toplist.tag.MOVIE.COMEDY": "Komödie",
  "grow.games.toplist.tag.MOVIE.CRIME": "Krimi",
  "grow.games.toplist.tag.MOVIE.DRAMA": "Drama",
  "grow.games.toplist.tag.MOVIE.FAMILY": "Familie",
  "grow.games.toplist.tag.MOVIE.FANTASY": "Fantasy",
  "grow.games.toplist.tag.MOVIE.HISTORY": "Geschichte",
  "grow.games.toplist.tag.MOVIE.HORROR": "Horror",
  "grow.games.toplist.tag.MOVIE.MUSICAL": "Musikfilm",
  "grow.games.toplist.tag.MOVIE.MYSTERY": "Mystery",
  "grow.games.toplist.tag.MOVIE.ROMANCE": "Romantik",
  "grow.games.toplist.tag.MOVIE.SCIENCE_FICTION": "Science-Fiction",
  "grow.games.toplist.tag.MOVIE.THRILLER": "Thriller",
  "grow.games.toplist.tag.MOVIE.WAR": "Krieg",
  "grow.games.toplist.tag.MOVIE.WESTERN": "Western",
  "grow.games.toplist.tag.MUSIC_ARTIST.BLUES": "Blues",
  "grow.games.toplist.tag.MUSIC_ARTIST.CLASSICAL": "Klassik",
  "grow.games.toplist.tag.MUSIC_ARTIST.COUNTRY": "Country",
  "grow.games.toplist.tag.MUSIC_ARTIST.ELECTRONIC": "Elektronische Musik",
  "grow.games.toplist.tag.MUSIC_ARTIST.FOLK": "Folk",
  "grow.games.toplist.tag.MUSIC_ARTIST.HIP_HOP": "Hip-Hop",
  "grow.games.toplist.tag.MUSIC_ARTIST.JAZZ": "Jazz",
  "grow.games.toplist.tag.MUSIC_ARTIST.METAL": "Metal",
  "grow.games.toplist.tag.MUSIC_ARTIST.POP": "Pop",
  "grow.games.toplist.tag.MUSIC_ARTIST.REGGAE": "Reggae",
  "grow.games.toplist.tag.MUSIC_ARTIST.ROCK": "Rock",
  "grow.games.toplist.tag.MUSIC_ARTIST.SOUL_RNB": "Soul & R&B",
  "grow.games.toplist.tag.SERIES.ACTION": "Action",
  "grow.games.toplist.tag.SERIES.ADVENTURE": "Abenteuer",
  "grow.games.toplist.tag.SERIES.ANIMATION": "Animation",
  "grow.games.toplist.tag.SERIES.COMEDY": "Komödie",
  "grow.games.toplist.tag.SERIES.CRIME": "Krimi",
  "grow.games.toplist.tag.SERIES.DRAMA": "Drama",
  "grow.games.toplist.tag.SERIES.FAMILY": "Familie",
  "grow.games.toplist.tag.SERIES.FANTASY": "Fantasy",
  "grow.games.toplist.tag.SERIES.HISTORY": "Geschichte",
  "grow.games.toplist.tag.SERIES.HORROR": "Horror",
  "grow.games.toplist.tag.SERIES.MUSICAL": "Musik",
  "grow.games.toplist.tag.SERIES.ROMANCE": "Romantik",
  "grow.games.toplist.tag.SERIES.SCIENCE_FICTION": "Science-Fiction",
  "grow.games.toplist.tag.SERIES.THRILLER": "Thriller",
  "grow.games.toplist.tag.SPORT.BALL": "Ballsport",
  "grow.games.toplist.tag.SPORT.COMBAT": "Kampfsport",
  "grow.games.toplist.tag.SPORT.ENDURANCE": "Ausdauersport",
  "grow.games.toplist.tag.SPORT.INDIVIDUAL": "Einzelsport",
  "grow.games.toplist.tag.SPORT.MIND": "Denksport",
  "grow.games.toplist.tag.SPORT.MOTORSPORT": "Motorsport",
  "grow.games.toplist.tag.SPORT.RACKET": "Rückschlagsport",
  "grow.games.toplist.tag.SPORT.TEAM": "Mannschaftssport",
  "grow.games.toplist.tag.SPORT.WATER": "Wassersport",
  "grow.games.toplist.tag.SPORT.WINTER": "Wintersport",
  "grow.games.toplist.tags.all": "Alles",
  "grow.games.toplist.tags.hint": "Wähl so viele Rubriken, wie du magst, oder alles.",
  "grow.games.toplist.tags.question.BOOK": "Was liest du am liebsten?",
  "grow.games.toplist.tags.question.CITY": "Wohin zieht es dich?",
  "grow.games.toplist.tags.question.DISH": "Was isst du am liebsten?",
  "grow.games.toplist.tags.question.HOBBY": "Was machst du am liebsten?",
  "grow.games.toplist.tags.question.MOVIE": "Welche Filme schaust du am liebsten?",
  "grow.games.toplist.tags.question.MUSIC_ARTIST": "Was hörst du am liebsten?",
  "grow.games.toplist.tags.question.SERIES": "Welche Serien schaust du am liebsten?",
  "grow.games.toplist.tags.question.SPORT": "Welcher Sport begeistert dich?",
  "grow.games.toplist.genus.BOOK": "n",
  "grow.games.toplist.genus.CITY": "f",
  "grow.games.toplist.genus.DISH": "n",
  "grow.games.toplist.genus.HOBBY": "n",
  "grow.games.toplist.genus.MOVIE": "m",
  "grow.games.toplist.genus.MUSIC_ARTIST": "other",
  "grow.games.toplist.genus.SERIES": "f",
  "grow.games.toplist.genus.SPORT": "f",
  "common.progressCount": "{done, number} / {total, number}",
  "settings.styleguide.section.stateCues": "Zustandshinweise",
  "settings.styleguide.selectedExample": "Ausgewählte Karte",
  "settings.styleguide.dropExample": "Ablageziel",
  "settings.styleguide.pressedExample": "Gedrücktes Symbol",
  "settings.styleguide.pillsPurpose": "Eine Option wählen. Die Auswahl nutzt einen neutralen 6-%-Schleier der Spurtinte, einen kleinen Schatten und eine halbfette Beschriftung mit reservierter Breite.",
  "admin.permission.compare.profiles": "Profile vergleichen",
  "profile.compare.addPerson": "Person zum Vergleich hinzufügen",
  "profile.compare.title": "Profile vergleichen",
  "profile.compare.tools": "Profilwerkzeuge",
  "profile.compare.selectDescription": "Wähle dieses Profil aus, um zwei Profile nebeneinander zu vergleichen.",
  "profile.compare.removeDescription": "Entferne dieses Profil aus deiner Auswahl für den Vergleich.",
  "profile.compare.select": "Zum Vergleich selektieren",
  "profile.compare.remove": "Aus Vergleich entfernen",
  "profile.compare.removeName": "{name} aus Vergleich entfernen",
  "profile.compare.count": "Vergleich {count}/2",
  "profile.compare.unnamed": "Profil ohne Namen",
  "profile.compare.full": "Zwei Profile ausgewählt. Entferne zuerst eines aus dem Vergleich.",
  "profile.compare.empty": "Wähle auf zwei Profilen über das Werkzeugicon „Zum Vergleich selektieren“.",
  "profile.compare.unavailable": "Dieses Profil ist nicht verfügbar.",
  "profile.compare.noData": "Keine sichtbaren Angaben",
  "profile.compare.loading": "Profile werden geladen …",
  "profile.compare.retry": "Erneut versuchen",
  "profile.compare.profile": "Profil öffnen",
  "profile.compare.search": "Profile suchen",
  "profile.compare.overview": "Visitenkarte",
  "profile.compare.bio": "Über mich",
  "profile.compare.experience": "Berufserfahrung",
  "profile.compare.education": "Ausbildung",
  "profile.compare.expertise": "Fachkompetenzen",
  "profile.compare.certificates": "Zertifikate",
  "profile.compare.languages": "Sprachen",
  "profile.compare.powers": "Powers",
  "profile.compare.denied": "Für den Profilvergleich fehlt dir die Berechtigung.",
  "documents.preview.open": "Vorschau",
  "documents.preview.zoomOut": "Verkleinern",
  "documents.preview.zoomIn": "Vergrößern",
  "documents.preview.unavailable": "Für dieses Format ist keine Vorschau verfügbar. Du kannst die Originaldatei herunterladen.",
  "documents.preview.original-missing": "Originaldatei nicht verfügbar",
  "documents.preview.original-access": "Originaldatei kann hier nicht abgerufen werden",
  "share.listings.contactPerson": "Ansprechpartner",
  "share.listings.searchTarget": "Gesucht werden",
  "share.listings.searchTarget.people": "Menschen",
  "share.listings.searchTarget.companies": "Unternehmen",
  "share.listings.searchTarget.locked": "Mit Bewerbungen oder verknüpften Matches bleibt der Suchtyp fest.",
  "share.applications.company.checkbox": "Ich bewerbe mich als Unternehmen",
  "share.applications.company.name": "Unternehmensname",
  "share.applications.company.required": "Bitte bestätige die Bewerbung als Unternehmen und gib den Unternehmensnamen ein.",
  "share.applications.company.profile": "Unternehmensprofil",
  "share.listings.companyMatch.importHint": "{count, plural, =0 {Noch keine Bewerbungen von Unternehmen. Unternehmen kannst du im Match ergänzen.} one {Ein Unternehmen aus den Bewerbungen wird übernommen.} other {# Unternehmen aus den Bewerbungen werden übernommen.}}",
  "share.listings.companyMatch.copyNote": "Die Unternehmensanforderungen werden ins Match übernommen. Geänderte Anforderungen übernimmst du mit einer neuen Version.",
  "share.listings.companyMatch.manual": "Neue Bewerbungen von Unternehmen kannst du hier übernehmen. Die Bewertung startest du im Unternehmens-Match.",
  "share.listings.companyMatch.transfer": "Bewerbungen von Unternehmen übernehmen und Match öffnen ({count})",
  "share.listings.searchCompanies": "Unternehmen suchen",
  "share.listings.retentionUnit": "Tage ab Abschluss",
  "share.listings.metadata.unavailable": "Gespeicherter Wert nicht mehr verfügbar",
  "share.listings.overview.autoOn": "Automatische Bewertung an",
  "share.listings.overview.autoOff": "Automatische Bewertung aus",
  "share.listings.overview.matchDetails": "Zum Match-Bereich",
  "share.listings.overview.matchSetup": "Match einrichten",
  "share.listings.tags.empty": "Freie Schlagworte zur Ausschreibung.",
  "adminSettings.emailTemplates.kind.LISTING_APPLICATION_CONFIRMATION": "Bewerbung bestätigen",
  "adminSettings.emailTemplates.applicationConfirmationHint": "Diese E-Mail bestätigt die E-Mail-Adresse bei einer Bewerbung ohne Login. Erst nach dem Bestätigungslink geht die Bewerbung ein.",
  "adminSettings.emailTemplates.powerQuizHint": "Diese Vorlage wird verwendet, wenn du eine freiwillige Power-Quiz-Anfrage zu einer Bewerbung versendest.",
  "adminSettings.emailTemplates.applicationReceiptHint": "Diese E-Mail geht automatisch an die bestätigte Adresse, sobald eine Bewerbung ohne Login über den Bestätigungslink eingegangen ist. Sie bestätigt nur den Eingang: schreibe keine Entscheidung, keine Frist und keinen Link hinein.",
  "match.listing.requirementsReadOnly": "Die Anforderungen dieser Match-Version sind schreibgeschützt. Ändere sie in der {listing} und bereite dort im Match-Tab eine neue Version vor.",
  "project.toMatch.criteriaDetail": "{count, plural, =0 {Noch nichts hinterlegt} one {Eine Anforderung} other {# Anforderungen}}",
  "match.autoMatch.unnamedCompany": "Unternehmen ohne Namen",
  "share.listings.requirements.heading": "Anforderungen",
  "share.listings.requirements.peoplePrompt": "Schlag mir Anforderungen für diese Ausschreibung aus ihrer Beschreibung und den hinterlegten Dokumenten vor. Zeige mir die Änderungen vor dem Übernehmen.",
  "share.listings.requirements.companyPrompt": "Schlag mir Unternehmens-Anforderungen für diese Ausschreibung aus ihrer Beschreibung und den hinterlegten Dokumenten vor. Zeige mir die Änderungen vor dem Übernehmen.",
  "share.listings.versions.diff.direction": "Unterschiede",
  "share.listings.versions.diff.absent": "Nicht enthalten",
  "share.listings.versions.diff.ai": "KI: {value}",
  "share.listings.versions.diff.off": "aus",
  "share.listings.versions.diff.on": "an",
  "share.listings.versions.diff.power": "Power-Gewichtung {name}",
  "share.listings.versions.diff.before": "Gespeichertes Match",
  "share.listings.versions.diff.after": "Ausschreibung",
  "share.listings.versions.diff.active": "aktiv",
  "share.listings.access.resend": "Login-Einladung erneut senden",
  "loginAssignment.dialog.resendHeading": "Login-Einladung erneut senden",
  "share.listings.access.changed": "Die Zugriffe wurden inzwischen geändert. Bitte schließen und neu öffnen, dann erneut ändern.",
  "share.listings.access.delegationRefused": "Nur die Person, die die Ausschreibung angelegt hat, ernennt Verwaltende und ändert deren Rechte.",
  "share.listings.access.notManaged": "Du darfst die Zugriffe dieser Ausschreibung nicht (mehr) verwalten.",
  "share.listings.level.none": "Kein Zugriff",
  "share.listings.applicationsHint": "Bewerbungen sieht nur, wer dort Lesen oder Bearbeiten hat. Neue Mitglieder beginnen ohne Zugriff.",
  "share.listings.applicationsLimit": "Bei Bewerbungen vergibst du höchstens deine eigene Stufe ({level}). Höhere Einträge kannst du stehen lassen oder senken.",
  "share.listings.access.applicationsGrantRefused": "Bei Bewerbungen kannst du höchstens deine eigene Stufe vergeben. Höhere Rechte vergibt die Person, die die Ausschreibung angelegt hat.",
  "share.listings.applications.noAccess": "Kein Zugriff auf Bewerbungen",
  "share.listings.applications.noAccessHint": "Bewerbungen sieht nur, wer sie ausdrücklich lesen darf. Zugriff vergibt, wer die Zugriffe dieser Ausschreibung verwaltet.",
  "communicationLanguage.de": "Deutsch",
  "communicationLanguage.en": "Englisch",
  "adminSettings.emailTemplates.instanceLanguage": "Standardsprache für E-Mails",
  "adminSettings.emailTemplates.instanceLanguageHint": "Jede E-Mail wird in dieser Sprache geschrieben, außer an Bewerbende, deren Bewerbungsformular eine Sprache festgehalten hat. Die Einladung ist davon nicht betroffen.",
  "adminSettings.emailTemplates.languageLabel": "Sprache der Vorlage",
  "adminSettings.emailTemplates.languagePreviewHint": "So wird diese E-Mail auf {language} versendet. Ausschreibung, Kennziffer und Link sind Beispielwerte.",
  "adminSettings.emailTemplates.legacy.notice": "Für diese Vorlage gibt es noch eine zweisprachige Fassung aus der Zeit vor der Sprachtrennung. Sie wird unverändert und unübersetzt für jede Sprache ohne eigene Fassung versendet.",
  "adminSettings.emailTemplates.legacy.title": "Zweisprachige Fassung",
  "adminSettings.emailTemplates.legacy.discard": "Zweisprachige Fassung verwerfen",
  "adminSettings.emailTemplates.legacy.discardHint": "Danach erhält jede Sprache ohne eigene Fassung den Standardtext. Die zweisprachige Fassung lässt sich nicht wiederherstellen.",
  "adminSettings.emailTemplates.source.CUSTOM": "Eigene Fassung",
  "adminSettings.emailTemplates.source.LEGACY": "Bisherige zweisprachige Fassung",
  "adminSettings.emailTemplates.source.DEFAULT": "Standardtext",
  "adminSettings.emailTemplates.sourceLine": "Derzeit versendet: {source}",
  "share.listings.quiz.requestLanguage": "Sprache: {language}",
  "share.listings.quiz.languageHint": "Die E-Mail wird auf {language} verfasst, in der Sprache, die für diese Bewerbung gilt.",
  "adminSettings.emailTemplates.instanceLanguageInvalid": "Die gespeicherte Standardsprache ist ungültig. E-Mails, die sie brauchen, werden erst versendet, wenn du eine Sprache wählst.",
  "share.listings.quiz.languageUnknown": "Die Sprache der E-Mail lässt sich nicht bestimmen, weil die Standardsprache für E-Mails falsch eingestellt ist. Der Versand wird abgelehnt.",
  "share.listings.quiz.failed": "Quiz-Anfrage vom {date} wurde nicht versendet. Du kannst sie erneut anfragen.",
  "share.listings.mail.title": "E-Mail an die bewerbende Person",
  "share.listings.mail.open": "E-Mail senden",
  "share.listings.mail.history": "E-Mails zu dieser Bewerbung",
  "share.listings.mail.send": "Senden",
  "share.listings.mail.editTemplate": "Vorlage in Admin-Einstellungen bearbeiten ↗",
  "share.listings.mail.templateHint": "Der Text wird in den Admin-Einstellungen unter E-Mail-Vorlagen gepflegt.",
  "share.listings.mail.appointmentDetails": "Termin und Link ergänzen (optional)",
  "share.listings.mail.refreshPreview": "Vorschau aktualisieren",
  "share.listings.mail.uncertainBefore": "Ob die letzte E-Mail dieser Art angekommen ist, ist unklar. Genesis wiederholt sie nie automatisch. Prüfe vor dem erneuten Senden, ob die bewerbende Person sie schon erhalten hat.",
  "share.listings.mail.discardEdits": "Deine Änderungen am Text gehen verloren.",
  "share.listings.mail.discardConfirm": "Änderungen verwerfen",
  "share.listings.mail.appointment": "Termin",
  "share.listings.mail.appointmentPlaceholder": "z. B. Dienstag, 21. Oktober, 14:00 Uhr",
  "share.listings.mail.meetingLink": "Link zum Termin (optional)",
  "share.listings.mail.meetingLinkInvalid": "Der Link muss mit https:// beginnen und darf keine Zugangsdaten enthalten.",
  "share.listings.mail.redraft": "Entwurf neu erstellen",
  "share.listings.mail.subject": "Betreff",
  "share.listings.mail.body": "Text",
  "share.listings.mail.textProblem.subject": "Der Betreff braucht eine einzige Zeile mit höchstens 200 Zeichen.",
  "share.listings.mail.textProblem.body": "Der Text braucht 1 bis 5000 Zeichen ohne Steuerzeichen.",
  "share.listings.mail.textProblem.placeholder": "Platzhalter der Vorlage in geschweiften Klammern werden in einer bearbeiteten E-Mail nicht ersetzt. Bitte schreibe den Text aus.",
  "share.listings.mail.previewRegion": "E-Mail-Vorschau",
  "share.listings.mail.previewStale": "Der Text wurde geändert. Aktualisiere die Vorschau, bevor du sendest.",
  "share.listings.mail.unavailable": "An diese Bewerbung kann keine E-Mail gesendet werden.",
  "share.listings.mail.recipient": "An {recipient}, {source}. Sprache: {language}.",
  "share.listings.mail.expires": "Diese Vorschau gilt bis {date}.",
  "share.listings.mail.sentBy": "{date}, von {name}",
  "share.listings.mail.sentOn": "{date}",
  "share.listings.mail.automatic": "{date}, automatische Nachricht",
  "share.listings.mail.acceptedHint": "Der Mailserver hat die E-Mail angenommen. Ob sie zugestellt wurde, ist nicht bekannt.",
  "share.listings.mail.showText": "Text anzeigen",
  "share.listings.mail.hideText": "Text ausblenden",
  "share.listings.mail.resend": "Erneut senden",
  "share.listings.mail.kind.interview": "Einladung zum Gespräch",
  "share.listings.mail.kind.offer": "Angebot",
  "share.listings.mail.kind.rejection": "Absage",
  "share.listings.mail.kind.receipt": "Eingangsbestätigung",
  "share.listings.mail.status.queued": "Wartet auf Versand",
  "share.listings.mail.status.sending": "Wird gesendet",
  "share.listings.mail.status.smtpAccepted": "Vom Mailserver angenommen",
  "share.listings.mail.status.failedBeforeSend": "Nicht gesendet",
  "share.listings.mail.status.deliveryUnknown": "Versand unklar",
  "share.listings.mail.status.cancelled": "Abgebrochen",
  "share.listings.mail.problem.notConfigured": "Der E-Mail-Versand ist auf diesem Server nicht eingerichtet.",
  "share.listings.mail.problem.smtpUnavailable": "Der Mailserver war auch nach mehreren Versuchen nicht erreichbar.",
  "share.listings.mail.problem.requesterWithoutAccess": "Wer die E-Mail gesendet hat, darf sie inzwischen nicht mehr senden.",
  "share.listings.mail.problem.applicationState": "Der Stand der Bewerbung erlaubt diese E-Mail nicht mehr.",
  "share.listings.mail.problem.recipientChanged": "Die bestätigte Empfängeradresse hat sich geändert.",
  "share.listings.mail.problem.outcomeUnknown": "Die Verbindung brach während der Übergabe ab. Genesis sendet die E-Mail nicht automatisch erneut.",
  "share.listings.mail.problem.interrupted": "Der Versand wurde während der Übergabe unterbrochen. Genesis sendet die E-Mail nicht automatisch erneut.",
  "share.listings.mail.problem.checkFailed": "Die Prüfung vor dem Versand war nicht möglich.",
  "share.listings.mail.problem.recipientOptedOut": "Die Benachrichtigung wurde inzwischen ausgeschaltet.",
  "share.listings.mail.problem.recipientWithoutAccess": "Die empfangende Person darf die Bewerbungen nicht mehr lesen.",
  "share.listings.mailNotification.title": "E-Mail an mich",
  "share.listings.mailNotification.applications": "Neue Bewerbungen",
  "share.listings.mailNotification.results": "Match-Ergebnisse",
  "share.listings.mailNotification.infoLabel": "Was diese E-Mails enthalten",
  "share.listings.mailNotification.info": "Nur für dich und nur für diese Ausschreibung. Match-Ergebnisse: eine E-Mail je neuer Match-Version, sobald deren erstes Ergebnis vorliegt und nur wenn du das Match sehen darfst. Spätere Ergänzungen derselben Version lösen keine weitere E-Mail aus. Jede E-Mail nennt die Ausschreibung und enthält einen Link, keine Bewerberdaten. Sie kommt nur, solange du die Bewerbungen lesen darfst.",
  "share.listings.mail.source.formConfirmation": "im Bewerbungsformular bestätigte Adresse",
  "share.listings.mail.source.verifiedLogin": "bestätigte Login-Adresse",
  "share.listings.mail.unavailable.noProvenAddress": "Es gibt keine bestätigte Adresse: Die Bewerbung kam weder über einen Bestätigungslink noch über einen Login mit bestätigter Adresse.",
  "share.listings.mail.unavailable.loginNotVerified": "Die Adresse des Logins ist nicht bestätigt.",
  "share.listings.mail.unavailable.loginUnavailable": "Der Login ist deaktiviert oder nicht mehr vorhanden.",
  "share.listings.mail.unavailable.personInactive": "Die bewerbende Person ist nicht mehr aktiv.",
  "share.listings.mail.error.stale": "Empfänger, Sprache, Vorlage oder Bewerbung haben sich seit der Vorschau geändert. Es wurde nichts gesendet. Bitte aktualisiere die Vorschau.",
  "share.listings.mail.error.gone": "Die Vorschau ist abgelaufen oder wurde schon gesendet. Bitte aktualisiere die Vorschau.",
  "share.listings.mail.error.requestUsed": "Diese Anfrage gehört schon zu einer anderen E-Mail. Bitte aktualisiere die Vorschau und sende erneut.",
  "share.listings.mail.error.notConfigured": "Der E-Mail-Versand ist auf diesem Server nicht eingerichtet. Bitte wende dich an die Administration.",
  "share.listings.mail.error.notAllowed": "Der Stand der Bewerbung erlaubt diese E-Mail nicht mehr.",
  "adminSettings.emailTemplates.kind.LISTING_INTERVIEW": "Einladung zum Gespräch",
  "adminSettings.emailTemplates.kind.LISTING_OFFER": "Angebot",
  "adminSettings.emailTemplates.kind.LISTING_REJECTION": "Absage",
  "adminSettings.emailTemplates.kind.LISTING_APPLICATION_RECEIPT": "Eingangsbestätigung",
  "adminSettings.emailTemplates.kind.LISTING_APPLICATION_RECEIVED_NOTICE": "Hinweis: neue Bewerbung",
  "adminSettings.emailTemplates.kind.LISTING_MATCH_RESULT_NOTICE": "Hinweis: Match-Ergebnis",
  "adminSettings.emailTemplates.listingNoticeHint": "Diese E-Mail geht automatisch an Lesende der Bewerbungen, die sie in der Ausschreibung für sich eingeschaltet haben. Sie muss den Link enthalten, aber keine Bewerberdaten: schreibe keine Namen, Ergebnisse oder Bewertungen hinein.",
  "adminSettings.emailTemplates.applicationMessageHint": "Diese Vorlage ist der Entwurf, wenn jemand aus einer Bewerbung heraus diese E-Mail sendet. Vor dem Senden lässt er sich bearbeiten. Ein Status- oder Phasenwechsel sendet nie eine E-Mail.",
  "share.listings.mail.appointmentChanged": "Termin oder Link wurden geändert. Aktualisiere die Vorschau vor dem Senden.",
  "share.applications.mailLanguage.label": "Sprache der E-Mails zu dieser Bewerbung",
  "share.applications.mailLanguage.default": "Standardsprache der Plattform",
  "share.applications.mailLanguage.de": "Deutsch",
  "share.applications.mailLanguage.en": "English",
  "profile.compare.addItem": "Person zum Vergleich hinzufügen",
  "company.compare.title": "Unternehmen vergleichen",
  "company.compare.tools": "Unternehmenswerkzeuge",
  "company.compare.selectDescription": "Dieses Unternehmen für den direkten Vergleich auswählen.",
  "company.compare.removeDescription": "Dieses Unternehmen aus der Vergleichsauswahl entfernen.",
  "company.compare.select": "Zum Vergleich selektieren",
  "company.compare.remove": "Aus Vergleich entfernen",
  "company.compare.removeName": "{name} aus Vergleich entfernen",
  "company.compare.count": "Vergleich {count}/2",
  "company.compare.full": "Es sind bereits zwei Unternehmen ausgewählt.",
  "company.compare.empty": "Wähle zwei Unternehmen für den Vergleich aus.",
  "company.compare.unavailable": "Dieses Unternehmen ist nicht verfügbar.",
  "company.compare.noData": "Keine sichtbaren Angaben",
  "company.compare.loading": "Unternehmen werden geladen …",
  "company.compare.retry": "Erneut versuchen",
  "company.compare.profile": "Unternehmen öffnen",
  "company.compare.search": "Unternehmen suchen",
  "company.compare.overview": "Überblick",
  "company.compare.expertise": "Fachkompetenzen",
  "company.compare.denied": "Für den Unternehmensvergleich fehlt dir die Berechtigung.",
  "company.compare.addItem": "Unternehmen hinzufügen",
  "admin.permission.compare.companies": "Unternehmen vergleichen",
  "company.compare.summary": "Über uns",
  "company.compare.noResults": "Keine weiteren Unternehmen gefunden.",
  "company.compare.loadMore": "Mehr laden",
  "company.compare.loadMoreFailed": "Weitere Unternehmen konnten nicht geladen werden. Bitte erneut versuchen.",
  "share.public.login": "Anmelden",
  "share.public.retry": "Erneut versuchen",
  "share.public.listingUnavailable": "Diese Ausschreibung ist nicht öffentlich oder nicht mehr offen",
  "share.public.openListings.subtitle": "Stellen, Programme und Aufrufe, auf die du dich auch ohne Konto bewerben kannst.",
  "share.public.apply.asCompany": "Als Unternehmen bewerben",
  "share.public.apply.loginHint": "Ohne Konto möglich. Du hast schon eines? {login}",
  "share.public.apply.accountHint": "Bereits ein Konto? {login}.",
  "share.public.apply.accountLogin": "Anmelden und bewerben",
  "share.public.apply.companyTitle": "Unternehmen",
  "share.public.apply.companyHint": "Diese Ausschreibung sucht Unternehmen. Es bewirbt sich das Unternehmen, du bist seine Kontaktperson.",
  "share.public.apply.contactPerson": "Kontaktperson",
  "share.public.apply.contactHint": "An diese E-Mail-Adresse schicken wir den Link zur Bestätigung. Ein Konto entsteht dabei nicht.",
  "share.public.apply.email": "E-Mail",
  "share.public.apply.required": "Bitte gib mindestens Vorname und E-Mail an.",
  "share.public.apply.consent": "Ich willige ein, dass meine Angaben und Unterlagen wie oben beschrieben gespeichert und verarbeitet werden. Erst nach der Bestätigung per E-Mail werden sie Teil einer Bewerbung; unbestätigte Angaben werden gelöscht.",
  "share.public.apply.consentRequired": "Ohne Einwilligung können wir die Bewerbung nicht annehmen.",
  "share.public.apply.sent": "Bitte prüfe dein E-Mail-Postfach, um fortzufahren.",
  "share.public.apply.sentHint": "Der Link gilt 72 Stunden. Kommt keine Mail, prüfe den Spam-Ordner.",
  "share.public.apply.unknown": "Wir wissen nicht, ob deine Bewerbung angekommen ist. Sieh bitte zuerst in deinem Postfach nach einer Bestätigungsmail und sende sie erst erneut, wenn keine kommt.",
  "share.public.apply.busy": "Gerade gehen sehr viele Bewerbungen ein. Deine wurde nicht angenommen; bitte versuche es in einigen Minuten noch einmal.",
  "share.public.apply.refused": "Die Bewerbung wurde nicht angenommen. Bitte prüfe deine Angaben und lade die Seite neu, bevor du es noch einmal versuchst.",
  "share.public.confirm.title": "Bewerbung bestätigen",
  "share.public.confirm.explain": "Mit diesem Schritt bestätigst du deine E-Mail-Adresse und schickst die Bewerbung ab.",
  "share.public.confirm.submit": "Bewerbung bestätigen",
  "share.public.confirm.sending": "Wird bestätigt…",
  "share.public.confirm.missing": "Dieser Seite fehlt der Bestätigungslink. Öffne bitte den Link aus deiner E-Mail noch einmal.",
  "share.public.confirm.done": "Wir haben deine Bestätigung verarbeitet. Wenn die Bewerbung erfolgreich eingegangen ist, erhältst du eine Eingangsbestätigung.",
  "share.public.confirm.failed": "Wir konnten das Ergebnis der Bestätigung nicht prüfen. Du kannst es erneut versuchen.",
  "share.public.confirm.confirmed": "Danke, deine Bewerbung ist eingegangen.",
  "share.public.confirm.alreadyApplied": "Du hast dich auf diese Ausschreibung bereits beworben.",
  "share.public.confirm.notConfirmable": "Dieser Link ist abgelaufen oder wurde bereits verwendet.",
  "share.public.confirm.retryLater": "Das hat gerade nicht geklappt. Bitte versuche es in einem Moment erneut.",
  "share.public.confirm.loginRequired": "Zu dieser E-Mail-Adresse gibt es bereits ein Konto. Bitte melde dich an, um deine Bewerbung abzuschließen.",
  "share.public.confirm.login": "Anmelden und fortfahren",
  "share.public.confirm.account": "Zu dieser E-Mail-Adresse gibt es ein Konto. Schließe die Bewerbung mit deinem Konto ab; deine Angaben und Unterlagen aus dem Formular werden übernommen.",
  "share.public.confirm.claim": "Bewerbung abschließen",
  "share.public.confirm.wrongAccount": "Du bist mit einem anderen Konto angemeldet. Bitte melde dich mit dem Konto zu dieser E-Mail-Adresse an.",
  "share.public.confirm.switchAccount": "Mit anderem Konto anmelden",
  "share.public.apply.companyRequired": "Bitte gib den Namen des Unternehmens an.",
  "admin.permission.use.microsoft-connection": "Microsoft-Verknüpfung verwenden",
  "microsoft.signIn": "Mit Microsoft anmelden",
  "microsoft.title": "Microsoft-Verknüpfung",
  "microsoft.intro": "Verbinde je ein persönliches und ein Unternehmenskonto für E-Mails, Kalender und Teams-Einladungen.",
  "microsoft.notConfigured": "Die Microsoft-Anbindung ist noch nicht eingerichtet. Bitte wende dich an den Betreiber dieser Instanz.",
  "microsoft.disconnected": "Noch kein Microsoft-Konto verbunden.",
  "microsoft.connected": "E-Mails und Teams-Termine verfügbar",
  "microsoft.teamsUnavailable": "Konto verbunden. Teams-Besprechungen sind für diesen Kalender nicht verfügbar. Prüfe die Microsoft-Lizenz oder verbinde ein anderes Arbeitskonto.",
  "microsoft.reconnectRequired": "Die Microsoft-Verbindung muss erneuert werden. Bitte verbinde das Konto erneut.",
  "microsoft.success": "Microsoft-Konto erfolgreich verbunden.",
  "microsoft.cancelled": "Die Verbindung wurde bei Microsoft abgebrochen.",
  "microsoft.expired": "Die Anmeldung ist abgelaufen. Bitte starte die Verbindung erneut.",
  "microsoft.failed": "Das Konto konnte nicht verbunden werden. Versuche es erneut oder prüfe mit deiner IT die Microsoft-Freigabe.",
  "microsoft.loading": "Verbindung wird geladen …",
  "microsoft.changeAccount": "Konto verbinden / wechseln",
  "microsoft.check": "Verbindung prüfen",
  "microsoft.disconnect": "Verbindung trennen",
  "microsoft.disconnectMessage": "Du kannst dieses Konto anschließend nicht mehr in Smycles verwenden. Bereits erstellte Microsoft-Termine werden nicht gelöscht.",
  "microsoft.checkedAt": "Zuletzt geprüft: {time}",
  "microsoft.checked": "Prüfung abgeschlossen. Der Verbindungsstatus wurde aktualisiert.",
  "microsoft.retry": "Erneut versuchen",
  "microsoft.replaceMessage": "Neue Termine werden über das neu verbundene Konto erstellt. Bestehende Termine bleiben beim bisherigen Organisator und können über das neue Konto nicht verwaltet werden.",
  "microsoft.compose.title": "E-Mail senden",
  "microsoft.compose.from": "Absender: {email}",
  "microsoft.compose.recipients": "Empfänger",
  "microsoft.compose.subject": "Betreff",
  "microsoft.compose.message": "Nachricht",
  "microsoft.compose.teams": "Teams-Termin hinzufügen",
  "microsoft.compose.start": "Beginn",
  "microsoft.compose.end": "Ende",
  "microsoft.compose.timezone": "Zeitzone: {zone}",
  "microsoft.compose.invalidRecipients": "Bitte 1 bis 20 unterschiedliche E-Mail-Adressen eingeben.",
  "microsoft.compose.invalidTime": "Bitte einen gültigen zukünftigen Beginn und ein späteres Ende wählen.",
  "microsoft.compose.review": "Versand prüfen",
  "microsoft.compose.send": "Jetzt senden",
  "microsoft.compose.confirmTitle": "E-Mail versenden?",
  "microsoft.compose.meetingNotice": "Microsoft erstellt einen Teams-Termin und verschickt deine Nachricht als native Kalendereinladung an die angegebenen Empfänger.",
  "microsoft.compose.mailNotice": "Die Nachricht wird jetzt an die angegebenen Empfänger gesendet.",
  "microsoft.compose.sending": "Wird an Microsoft übergeben …",
  "microsoft.compose.retry": "Versandstatus prüfen",
  "microsoft.compose.retryHint": "Die Antwort konnte nicht bestätigt werden. Prüfe den Status dieses Versands, bevor du eine weitere Nachricht erstellst.",
  "microsoft.compose.meetingAccepted": "Teams-Termin erstellt. Microsoft hat die Einladung zum Versand übernommen.",
  "microsoft.compose.mailAccepted": "Microsoft hat die E-Mail zum Versand übernommen.",
  "microsoft.compose.unknown": "Der Versandstatus ist unklar. Bitte zuerst im Outlook-Kalender bzw. unter „Gesendete Elemente“ prüfen. Diese Anfrage wird nicht erneut versendet.",
  "microsoft.compose.join": "Teams-Link öffnen",
  "microsoft.compose.outlook": "Termin in Outlook öffnen",
  "microsoft.compose.new": "Neue Nachricht",
  "microsoft.agenda.title": "Woche auswählen",
  "microsoft.agenda.load": "Termine laden",
  "microsoft.agenda.refresh": "Aktualisieren",
  "microsoft.agenda.account": "Hauptkalender · {email}",
  "microsoft.agenda.loading": "Termine werden geladen …",
  "microsoft.agenda.truncated": "Die Ansicht ist unvollständig. Bitte prüfe weitere Termine in Outlook.",
  "microsoft.agenda.conflicts": "{count, plural, one {# Überschneidung} other {# Überschneidungen}} mit deinem geplanten Termin in dieser Woche.",
  "microsoft.agenda.noConflicts": "Keine Überschneidung mit deinem geplanten Termin in dieser Woche.",
  "microsoft.agenda.empty": "Keine Termine in dieser Woche.",
  "microsoft.agenda.private": "Privater Termin",
  "microsoft.agenda.untitled": "Termin ohne Titel",
  "microsoft.agenda.free": "Frei",
  "microsoft.agenda.tentative": "Mit Vorbehalt",
  "microsoft.agenda.busy": "Beschäftigt",
  "microsoft.agenda.oof": "Abwesend",
  "microsoft.agenda.workingElsewhere": "An anderem Ort tätig",
  "microsoft.agenda.unknown": "Verfügbarkeit unbekannt",
  "microsoft.agenda.allDay": "Ganztägig",
  "microsoft.agenda.overlap": "Überschneidet sich mit deinem geplanten Termin",
  "microsoft.agenda.outlook": "In Outlook öffnen",
  "microsoft.agenda.checked": "Stand {time} · {zone}. Die Ansicht reserviert keinen Zeitraum.",
  "microsoft.agenda.weekView": "Wochenkalender",
  "microsoft.agenda.previousWeek": "Vorherige Woche",
  "microsoft.agenda.nextWeek": "Nächste Woche",
  "microsoft.agenda.today": "Heute",
  "microsoft.agenda.draft": "Geplanter Teams-Termin",
  "microsoft.agenda.now": "Aktuelle Uhrzeit",
  "datePicker.chooseDate": "Datum wählen",
  "datePicker.chooseDateTime": "Datum und Uhrzeit wählen",
  "datePicker.previousMonth": "Vorheriger Monat",
  "datePicker.nextMonth": "Nächster Monat",
  "datePicker.month": "Monat",
  "datePicker.year": "Jahr",
  "datePicker.hours": "Stunden",
  "datePicker.minutes": "Minuten",
  "datePicker.today": "Heute",
  "datePicker.clear": "Datum entfernen",
  "datePicker.apply": "Übernehmen",
  "datePicker.invalidTime": "Gib eine gültige Uhrzeit im erlaubten Zeitraum ein.",
  "settings.styleguide.section.datePicker": "Datumsauswahl",
  "microsoft.compose.duration": "Dauer",
  "microsoft.compose.duration30": "30 Min.",
  "microsoft.compose.duration60": "1 Std.",
  "microsoft.compose.duration120": "2 Std.",
  "microsoft.compose.teamsUnavailable": "Teams-Termine sind mit diesem Konto nicht verfügbar.",
  "microsoft.compose.schedule": "Termin",
  "microsoft.agenda.availability": "Verfügbarkeit",
  "microsoft.agenda.notLoaded": "Lade deinen Kalender, um freie Zeiten und Überschneidungen zu sehen.",
  "microsoft.continueToMicrosoft": "Weiter zu Microsoft",
  "microsoft.complete": "Verbindung vervollständigen",
  "microsoft.completeHint": "Verbinde dein Microsoft-Konto noch einmal, um E-Mails und Termine gemeinsam freizugeben.",
  "microsoft.completeMessage": "Bestätige bei Microsoft den Zugriff auf Kalender und E-Mail-Versand gemeinsam. Wähle dazu dasselbe Konto. Deine bestehenden Termine bleiben erhalten.",
  "microsoft.accountKind": "Microsoft-Konto",
  "microsoft.personal": "Persönlich",
  "microsoft.company": "Unternehmen",
  "microsoft.accountSelectionHint": "Wähle das Konto für Absender und Kalender. Beide Verbindungen gehören zu deinem Smycles-Nutzer.",
  "microsoft.switchTitle": "Konto wechseln?",
  "microsoft.switchDraft": "Dein nicht gesendeter Entwurf wird beim Wechsel verworfen.",
  "microsoft.switchConfirm": "Entwurf verwerfen und wechseln",
  "microsoft.compose.removeRecipient": "{email} entfernen",
  "microsoft.compose.recipientPlaceholder": "E-Mail-Adresse hinzufügen",
  "microsoft.compose.recipientHint": "Mit Enter oder Komma übernehmen. Mehrere Adressen kannst du auch einfügen.",
  "microsoft.status.connected": "Verbunden",
  "microsoft.status.disconnected": "Nicht verbunden",
  "microsoft.status.incomplete": "Freigabe prüfen",
  "microsoft.status.reconnect": "Erneut verbinden",
  "microsoft.status.limited": "Eingeschränkt verbunden",
  "microsoft.status.checking": "Wird geprüft",
  "microsoft.status.unconfirmed": "Verbindung nicht bestätigt",
  "microsoft.connectionSelectionHint": "Verwalte hier dein persönliches und dein Unternehmenskonto.",
  "microsoft.compose.connectionRequired": "Verbinde dieses Microsoft-Konto in deinen Einstellungen und gib E-Mails und Kalender frei.",
  "microsoft.compose.manageConnection": "Verknüpfung verwalten",
  "share.public.empty": "Zurzeit sind keine öffentlichen Stellenausschreibungen verfügbar.",
  "admin.groups.anonymous.publicShareEnabled": "Share ohne Anmeldung erlauben",
  "admin.groups.anonymous.publicShareHint": "Gilt für die gesamte Instanz. Sichtbar bleiben ausschließlich ausdrücklich öffentliche Inhalte; Rollen und Freigaben ändern sich dadurch nicht.",
  "share.public.disabled": "Share ist hier nur nach Anmeldung erreichbar.",
  "share.applications.dataNotice.records": "Deine Angaben und Unterlagen werden in der Personen- bzw. Unternehmensakte gespeichert. Personen mit Zugriff auf diese Akten können sie auch außerhalb des Bewerbungsteams lesen. Eingereichte Dateien kannst du über die Bewerbungsansicht nicht wieder abrufen. Ein Rückzug löscht die Dateien in der Akte nicht.",
  "share.applications.dataNotice.profile": "Ein hochgeladener Lebenslauf kann dein Smycles-Profil ergänzen. Diese Angaben sind entsprechend den bestehenden Profilfreigaben sichtbar.",
  "share.applications.dataNotice.contact": "Für Änderungen oder einen Rückzug ohne Konto wende dich an die in der Ausschreibung genannte Ansprechperson. Gib dabei die Kennziffer der Ausschreibung an.",
  "share.listings.ranking.applicationStatusUnavailable": "Der aktuelle Bewerbungsstatus konnte nicht geladen werden.",
  "match.gapListings.open": "Aus Lücken Stellen planen",
  "match.gapListings.title": "Aus Lücken Stellen planen",
  "match.gapListings.intro": "Ordne Lücken per Klick einer Rolle zu. Angelegt werden nur Entwürfe, veröffentlicht wird nichts.",
  "match.gapListings.roles": "Rollen",
  "match.gapListings.rolePlaceholder": "z. B. Backend-Entwicklung",
  "match.gapListings.removeRole": "Rolle {n} entfernen",
  "match.gapListings.addRole": "Rolle hinzufügen",
  "match.gapListings.needsRequirement": "Ordne dieser Rolle per Klick eine Lücke zu.",
  "match.gapListings.roleRequirements": "Anforderungen dieser Rolle",
  "match.gapListings.roleNumber": "Rolle {n}",
  "match.gapListings.notAssigned": "Keiner Rolle zugeordnet",
  "match.gapListings.chooseRole": "Rolle für {label} wählen",
  "match.gapListings.removeAssignment": "{label} aus {role} entfernen",
  "match.gapListings.unassigned": "{count, plural, one {Eine gewählte Lücke ist} other {# gewählte Lücken sind}} keiner Rolle zugeordnet: {labels}. Ordne sie einer Rolle zu.",
  "match.gapListings.hintLabel": "Mit KI aufteilen",
  "match.gapListings.hintPlaceholder": "Optional: Aufteilung oder gewünschte Stellenbezeichnungen, z. B. „Backend-Entwickler und UX-Designer“",
  "match.gapListings.suggest": "Rollenaufteilung vorschlagen",
  "match.gapListings.suggesting": "Rollenaufteilung wird vorgeschlagen",
  "match.gapListings.undoSuggestion": "Vorschlag verwerfen",
  "match.gapListings.suggestEmpty": "Kein brauchbarer Vorschlag. Deine Rollen bleiben, wie sie sind.",
  "match.gapListings.suggestUnavailable": "Gerade kein Vorschlag möglich. Deine Rollen bleiben, wie sie sind.",
  "match.gapListings.descriptionLabel": "Beschreibung aus dem Match",
  "match.gapListings.noDescription": "Das Match hat keine Beschreibung. Die Entwürfe bleiben ohne.",
  "match.gapListings.unverified": "nicht nachgewiesen: {count, plural, one {# Person} other {# Personen}} ohne Bewertung",
  "match.gapListings.overshoot": "zu viele Träger, eine weitere Stelle schließt das nicht",
  "match.gapListings.create": "{count, plural, one {Entwurf anlegen} other {# Entwürfe anlegen}}",
  "match.gapListings.toListings": "Zur Verwaltung",
  "match.gapListings.created": "Entwurf angelegt.",
  "match.gapListings.openDraft": "Öffnen",
  "match.gapListings.uncertain": "Die Verbindung brach ab. Ob der Entwurf angelegt wurde, ist unklar. Er wird nicht noch einmal gesendet.",
  "match.gapListings.checkListings": "In der Verwaltung prüfen",
  "esco.loading": "ESCO wird durchsucht…",
  "esco.unavailable": "ESCO ist gerade nicht erreichbar. Eigene Bezeichnungen bleiben möglich.",
  "esco.empty": "Kein passender ESCO-Begriff. Suche verfeinern oder eigene Bezeichnung behalten.",
  "esco.refine": "Weitere Treffer vorhanden. Bitte die Suche verfeinern.",
  "esco.confirm": "Zuordnung bestätigen",
  "esco.search": "ESCO durchsuchen",
  "esco.unlinkNamed": "Zuordnung von {name} lösen",
  "esco.addOccupation": "Weiteres Berufsbild",
  "esco.assignOccupation": "Berufsbild zuordnen",
  "esco.assignSkill": "ESCO zuordnen",
  "esco.chooseOccupation": "Berufsbild auswählen",
  "esco.chooseSkill": "Fachkompetenz auswählen",
  "esco.keepWording": "Deine eigene Bezeichnung bleibt erhalten.",
  "esco.details": "Beschreibung",
  "esco.more": "Mehr anzeigen",
  "esco.source": "Quelle: ESCO · Europäische Kommission",
  "esco.suggestSkills": "Kompetenzen vorschlagen",
  "esco.filterSkills": "Kompetenzen filtern",
  "esco.searchLanguage": "Suchsprache",
  "esco.searchDisclosure": "Suchtext und Sprache werden an ESCO (Europäische Kommission) gesendet.",
  "esco.hideSuggestions": "Vorschläge ausblenden",
  "esco.addedUnrated": "{name} unter „Unbewertet“ hinzugefügt.",
  "esco.addUnrated": "Unbewertet hinzufügen",
  "esco.addedAtLevel": "{name} auf Stufe {level} hinzugefügt.",
  "esco.chooseSkillLevelHint": "Wähle eine Kompetenz und anschließend ihre Stufe.",
  "profile.skills.preview": "Vorschau",
  "profile.skills.previewNamed": "Vorschau: {name}",
  "esco.results": "ESCO-Suchergebnisse",
  "agent.companyRoute.description": "Nur Beschreibungen",
  "agent.companyRoute.descriptionAndLabel": "Fachgebiete und Beschreibungen",
  "agent.companyRoute.labelOnly": "Nur Fachgebiete",
  "agent.progress.searchingGraph": "Suche im Unternehmensgraph \"{graph}\" nach \"{terms}\"",
  "companyGraph.anyRelation": "beliebig",
  "companyGraph.build": "Einen bauen …",
  "companyGraph.coarser": "Eine Stufe gröber",
  "companyGraph.activate": "Aktiv setzen",
  "companyGraph.isActive": "Aktiv",
  "companyGraph.delete": "Löschen",
  "companyGraph.groupingLost": "Der Gruppierungslauf dauert zu lange, um ihn weiter zu verfolgen. Er kann trotzdem fertig werden – lade die Seite neu, um zu sehen, wie weit er gekommen ist.",
  "graphBuild.lost": "Dieser Build kann von hier aus nicht weiter verfolgt werden. Er läuft möglicherweise noch – lade die Seite neu, um ihn wieder aufzunehmen.",
  "companyGraph.activateFailed": "Dieser Graph konnte nicht aktiviert werden. Es wurde nichts geändert.",
  "companyGraph.deleteFailed": "Dieser Graph konnte nicht gelöscht werden. Es wurde nichts entfernt.",
  "companyGraph.listFailed": "Die Liste der Graphen konnte nicht gelesen werden; Aktivieren und Löschen stehen deshalb nicht zur Verfügung.",
  "companyGraph.deleteAsk": "{name} wirklich löschen?",
  "companyGraph.deleteNo": "Behalten",
  "companyGraph.deleteYes": "Löschen",
  "companyGraph.edgeCount": "{edges} Kanten · {companies} Unternehmen",
  "companyGraph.failed": "Der Unternehmensgraph konnte nicht geladen werden. Er gehört zum agent-service; meist ist dieser Dienst gerade nicht erreichbar.",
  "companyGraph.figure": "Ein Knoten-Kanten-Diagramm: aussen die Dinge, auf die sich Unternehmen beziehen, innen die Unternehmen, verbunden durch je eine Kurve pro Beziehung.",
  "companyGraph.finer": "Eine Stufe feiner",
  "companyGraph.grouping": "Oberbegriffe werden gebildet …",
  "companyGraph.inactive": "Kein Graph ist aktiv, es gibt also nichts zu zeichnen. Wähle einen aus, um ihn anzusehen.",
  "companyGraph.companies": "Unternehmen",
  "companyGraph.eachCompany": "einzeln",
  "companyGraph.otherCompanies": "die übrigen",
  "companyGraph.noRelations": "ohne Beziehungen",
  "companyGraph.activateWhy": "Alle Fragen aus diesem Graphen beantworten",
  "companyGraph.isActiveWhy": "Alle Fragen gehen an diesen Graphen",
  "companyGraph.layout": "Als",
  "companyGraph.layout.band": "Reihen",
  "companyGraph.layout.columns": "Spalten",
  "companyGraph.layout.radial": "Ring",
  "companyGraph.level": "Stufe {level}",
  "companyGraph.loading": "Unternehmensgraph wird geladen …",
  "companyGraph.none": "Es gibt noch keinen Unternehmensgraphen. Baue einen, dann wird er hier gezeichnet.",
  "companyGraph.noRuns": "Noch keine Graph-Suche. Frage nach Unternehmen: Die Fragen, die dieser Graph beantwortet, erscheinen hier.",
  "companyGraph.only": "Unternehmen",
  "companyGraph.onlyFind": "Unternehmen suchen",
  "companyGraph.onlyFindThing": "Ding suchen",
  "companyGraph.onlyThings": "Dinge",
  "companyGraph.openHint": "Doppelklick zum Öffnen",
  "companyGraph.order": "Sortiert",
  "companyGraph.order.companies": "Unternehmen A–Z",
  "companyGraph.order.companies-desc": "Unternehmen Z–A",
  "companyGraph.order.relations": "nach Beziehungen",
  "companyGraph.order.things": "Dinge A–Z",
  "companyGraph.order.things-desc": "Dinge Z–A",
  "companyGraph.relation": "Beziehung",
  "companyGraph.source": "Quelle",
  "companyGraph.sourceSummary": "Selbstbeschreibung",
  "companyGraph.sourceLabel": "Kompetenz-Label",
  "companyGraph.sourceRecord": "Organisationsakte",
  "companyGraph.resetFilter": "Filter zurücksetzen",
  "companyGraph.runs": "Letzte Graph-Suchen",
  "companyGraph.showing": "Angezeigt",
  "companyGraph.size": "{companies} Unternehmen · {nodes} Dinge · {edges} Beziehungen",
  "companyGraph.title": "Unternehmensgraph",
  "companyGraph.zoom": "{percent}%",
  "companyGraph.zoomFit": "Alles zeigen",
  "companyGraph.zoomIn": "Näher heran",
  "companyGraph.zoomOut": "Weiter weg",
  "graphBuild.alreadyIn": "schon drin",
  "graphBuild.base": "Ausgehend von",
  "graphBuild.chosenCount": "{count} ausgewählt",
  "graphBuild.clear": "Leeren",
  "graphBuild.companies": "Unternehmen",
  "graphBuild.companiesFailed": "Die Unternehmen konnten nicht gelesen werden: {error}",
  "graphBuild.count.coined": "Neu benannt",
  "graphBuild.count.texts": "Befragte Texte",
  "graphBuild.count.recordItems": "Aus der Organisationsakte",
  "graphBuild.count.labelsRead": "Gelesene Kompetenz-Labels",
  "graphBuild.count.labelEdges": "Beziehungen aus Labels",
  "graphBuild.recordUnreadable": "{count, plural, one {# abgelegtes Dokument war nicht lesbar} other {# abgelegte Dokumente waren nicht lesbar}}",
  "graphBuild.count.dangling": "Kunden außerhalb der Auswahl",
  "graphBuild.count.edges": "Neue Beziehungen",
  "graphBuild.count.fetched": "Beschreibungen gelesen",
  "graphBuild.count.nodes": "Dinge im Graph",
  "graphBuild.count.proposed": "Vorgeschlagene Beziehungen",
  "graphBuild.count.rescued": "Von uns zusammengeführt",
  "graphBuild.count.reused": "Vom Modell übernommen",
  "graphBuild.count.spellings": "Genannte Bezeichnungen",
  "graphBuild.count.unfaithful": "Ohne Beleg verworfen",
  "graphBuild.count.unreadable": "Unbrauchbare Antworten",
  "graphBuild.failedAt": "Fehlgeschlagen bei {stage}: {error}",
  "graphBuild.fromNothing": "Nichts",
  "graphBuild.id": "Id: {id}",
  "graphBuild.loadingCompanies": "Unternehmen werden gelesen …",
  "graphBuild.name": "Name",
  "graphBuild.namePlaceholder": "Extrahiert, 150",
  "graphBuild.namedACompany": "Als Dinge genannt, hier aber Unternehmen. Verworfen:",
  "graphBuild.noCompanies": "Keine Unternehmen passen dazu.",
  "graphBuild.notFound": "Nicht im Korpus: {names}",
  "graphBuild.open": "öffnen",
  "graphBuild.openCompany": "{name} öffnen",
  "graphBuild.replace": "Ein Graph mit diesem Namen existiert. Ersetze ihn, dann bekommt jeder, der ihn gerade durchsucht, den neuen.",
  "graphBuild.search": "Nach Namen filtern …",
  "graphBuild.selectShown": "Alle angezeigten auswählen",
  "graphBuild.silent": "Gefragt, aber ohne Ergebnis:",
  "graphBuild.start": "Bauen",
  "graphBuild.suspicious": "Neue Dinge, die wie schon vorhandene aussehen:",
  "graphBuild.title": "Graph bauen",
  "graphBuild.toGraph": "Zurück zum Graph",
  "graphBuild.openBuilt": "‘{graph}’ öffnen",
  "settings.sectionCompanyGraph": "Unternehmensgraph",
  "settings.sectionCompanyGraphBuild": "Graph erstellen"
}
